(function ()
{
    'use strict';

    angular
        .module('app.pages.teacher', [
            'app.dialogs.lesson-request',
            'ngAnimate',
            'ui.bootstrap',
            'app.dialogs.register-student'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_teacher', {
            url      : '/teacher/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/teacher/teacher.html',
                    controller : 'TeacherController as vm'
                }
            },
            resolve  : {
                teacher: function ($auth, $stateParams, apiResolver, constRoles) {
                    var payload = $auth.getPayload();

                    if ($auth.isAuthenticated() &&
                        payload.role == constRoles.TEACHER &&
                        payload.id == $stateParams.id) {
                        return apiResolver.resolve('teacher.byToken@get');
                    }

                    return apiResolver.resolve('teacher.byId@get', { id: $stateParams.id });
                },
                reviews: function ($stateParams, apiResolver) {
                    return apiResolver.resolve('review.byTeacher@get', { teacherId: $stateParams.id });
                },
                reservedEvents: function ($stateParams, apiResolver) {
                    var startDate = new Date();
                    var endDate = new Date();
                    var day = startDate.getDay();
                    if(day == 0) {
                        endDate.setDate(endDate.getDate()+6);
                    }
                    else{
                        startDate.setDate(startDate.getDate()-day);
                        endDate.setDate(endDate.getDate()+(6-day));
                    }
                    function dateFormat(date) {
                        if(date < new Date() ) {
                            date.setHours(0,0,0);
                        }else {
                            date.setHours(24,0,0);
                        }
                        return date;
                    }
                    startDate = moment(dateFormat(startDate)).utc().format();
                    endDate = moment(dateFormat(endDate)).utc().format();
                    return apiResolver.resolve('publicCourseTimes.byTeacher@get', { teacherId: $stateParams.id ,startDate: startDate, endDate: endDate, status: 2});
                    // return apiResolver.resolve('schedule.byTeacher@get', { teacherId: $stateParams.id ,startDate: startDate, endDate: endDate});
                },
                pendingEvents: function ($stateParams, apiResolver) {
                    var startDate = new Date();
                    var endDate = new Date();
                    var day = startDate.getDay();
                    if(day == 0) {
                        endDate.setDate(endDate.getDate()+6);
                    }
                    else{
                        startDate.setDate(startDate.getDate()-day);
                        endDate.setDate(endDate.getDate()+(6-day));
                    }
                    function dateFormat(date) {
                        if(date < new Date() ) {
                            date.setHours(0,0,0);
                        }else {
                            date.setHours(24,0,0);
                        }
                        return date;
                    }
                    startDate = moment(dateFormat(startDate)).utc().format();
                    endDate = moment(dateFormat(endDate)).utc().format();
                    return apiResolver.resolve('publicCourseTimes.byTeacher@get', { teacherId: $stateParams.id ,startDate: startDate, endDate: endDate, status: 1});
                    // return apiResolver.resolve('pendingEvents.byTeacher@get', { teacherId: $stateParams.id ,startDate: startDate, endDate: endDate});
                },
                specificHours: function ($stateParams, apiResolver) {
                    var startDate = new Date();
                    var endDate = new Date();
                    var day = startDate.getDay();
                    if(day == 0) {
                        endDate.setDate(endDate.getDate()+6);
                    }
                    else{
                        startDate.setDate(startDate.getDate()-day);
                        endDate.setDate(endDate.getDate()+(6-day));
                    }
                    function dateFormat(date) {
                        if(date < new Date() ) {
                            date.setHours(0,0,0);
                        }else {
                            date.setHours(24,0,0);
                        }
                        return date;
                    }
                    startDate = moment(dateFormat(startDate)).utc().format();
                    endDate = moment(dateFormat(endDate)).utc().format();
                    return apiResolver.resolve('specificHours.byTeacher@get', { teacherId: $stateParams.id ,startDate: startDate, endDate: endDate});
                },
                regularHours: function ($stateParams, apiResolver) {
                    var startDate = new Date();
                    var endDate = new Date();
                    var day = startDate.getDay();
                    if(day == 0) {
                        endDate.setDate(endDate.getDate()+6);
                    }
                    else{
                        startDate.setDate(startDate.getDate()-day);
                        endDate.setDate(endDate.getDate()+(6-day));
                    }
                    function dateFormat(date) {
                        if(date < new Date() ) {
                            date.setHours(0,0,0);
                        }else {
                            date.setHours(24,0,0);
                        }
                        return date;
                    }
                    startDate = moment(dateFormat(startDate)).utc().format();
                    endDate = moment(dateFormat(endDate)).utc().format();
                    return apiResolver.resolve('regularHours.byTeacher@get', { teacherId: $stateParams.id ,startDate: startDate, endDate: endDate});
                },
            },
            bodyClass: 'teacher',
            params: {
                id: null,
                rebook: null
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/teacher');
    }

})();

(function ()
{
    'use strict';

    angular.module('app.pages.teacher')
        .controller('MessageDialogController', MessageDialogController);

    /** @ngInject */
    function MessageDialogController($mdDialog, api, teacher, defaultMessage)
    {
        var vm = this;

        // Data
        vm.message = {
            content: defaultMessage,
            receiverId: teacher.info.userId,
        };


        // Methods
        vm.closeDialog = closeDialog;
        vm.sendMessage = sendMessage;


        // Functions
        function closeDialog() {
            $mdDialog.hide();
        }

        function sendMessage() {
            api.messages.list.post(vm.message, function (response) {
                alert('Successfully sent!');
                $mdDialog.hide();
            }, function (response) {
                console.log('error: ', response);
            })
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller($filter)
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller($filter)
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.message', [
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, apiUrl)
    {

        // State
        $stateProvider.state('app.pages_message', {
            url    : '/message',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/pages/chat/chat.html',
                    controller : 'ChatController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('chat.contacts@get');
                },
                User    : function (msApi)
                {
                    return msApi.resolve('chat.user@get');
                }
            },
            requireLogin: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/chat');

        // Api
        // Contacts data must be alphabatically ordered.
        //msApiProvider.register('chat.contacts', ['/api/contacts']);
        //msApiProvider.register('chat.chats', ['/api/messages']);
        //msApiProvider.register('chat.user', ['/api/users']);
        msApiProvider.register('chat.contacts', [apiUrl + 'contacts']);
        msApiProvider.register('chat.chats', [apiUrl + 'messages']);
        msApiProvider.register('chat.user', [apiUrl + 'users']);

        //msApiProvider.register('chat.contacts', ['http://localhost:8088/api/contacts']);
        //msApiProvider.register('chat.chats', ['http://localhost:8088/api/messages']);
        //msApiProvider.register('chat.user', ['http://localhost:8088/api/users']);
        // msApiProvider.register('chat.contacts', ['app/data/chat/contacts.json']);
        // msApiProvider.register('chat.chats', ['app/data/chat/chats/:id.json']);
        // msApiProvider.register('chat.user', ['app/data/chat/user.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.chat', {
            title : 'Chat',
            icon  : 'icon-hangouts',
            state : 'app.chat',
            badge : {
                content: 13,
                color  : '#09d261'
            },
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.message')
        .factory('ChatsService', ChatsService);

    /** @ngInject */
    function ChatsService($q, msApi)
    {
        
        var service = {
            chats         : {},
            contacts      : [],
            getContactChat: getContactChat,
            postMessage   : postMessage,
            refreshContacts: refreshContacts,
        };

        /**
         * Get contact chat from the server
         *
         * @param contactId
         * @returns {*}
         */
        function getContactChat(contactId)
        {

            // Create a new deferred object
            var deferred = $q.defer();

            // If contact doesn't have lastMessage, create a new chat
            if ( !service.contacts.getById(contactId).lastMessage)
            {
                service.chats[contactId] = [];

                deferred.resolve(service.chats[contactId]);
            }

            // If the chat exist in the service data, do not request
            /*
            if ( service.chats[contactId] )
            {
                deferred.resolve(service.chats[contactId]);
                
                return deferred.promise;
            }
            */

            // Request the chat with the contactId
            msApi.request('chat.chats@get', { contactId: contactId },

                // SUCCESS
                function (response)
                {
                    // Attach the chats
                    service.chats[contactId] = response.data;

                    // Resolve the promise
                    deferred.resolve(service.chats[contactId]);
                },

                // ERROR
                function (response)
                {
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Create message
         *
         * @param receiverId
         * @param content
         * @returns {*}
         */
        function postMessage(receiverId, content)
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Create message
            msApi.request('chat.chats@save', {
                receiverId: receiverId,
                content: content,
            },

            // SUCCESS
            function (response)
            {
                // Resolve the promise
                deferred.resolve(response);
            },

            // ERROR
            function (response)
            {
                deferred.reject(response);
            });

            return deferred.promise;
        }

         /**
         * Refresh contacts
         *
         * @returns {*}
         */
        function refreshContacts(){
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('chat.contacts@get', {},

            function(response){
                // Resolve the promise
                deferred.resolve(response);
            },
            
            // ERROR
            function (response)
            {
                deferred.reject(response);
            });     
            return deferred.promise;       
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/password/reset/:token',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password',
            useGuestMenu: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
            title : 'Reset Password',
            state : 'app.pages_auth_reset-password',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController($auth, $state, $stateParams, api, $filter)
    {
        var vm = this;

        // Data
        vm.isError = false;
        vm.errorMessage = {};

        // Methods
        vm.resetPassword = resetPassword;

        function resetPassword() {
            var credential = {
                token: $stateParams.token,
                email: vm.form.email,
                password: vm.form.password,
                password_confirmation: vm.form.passwordConfirm,
            }

            api.auth.resetPassword.save(credential, function(response) {
                _login(credential);
            }, function(response) {
                console.error(response);
                
                vm.isError = true;
                vm.errorMessage = (response.data.error.email) ? 
                                       response.data.error.email[0]:
                                       response.data.error;
            });
        }

        function _login(user) {
            $auth.login(user).then(function(data) {
                $state.go('app.pages_teacher-list');
            }).catch(function(response) {
                console.log(response);
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [
            'ngMaterial', 
            'ngMessages',
            'app.dialogs.terms-n-conditions',
        ])
        .config(config)
        .directive('passwordConfirmation', passwordConfirmation);
	

    /** @ngInject */
    function config(
        $authProvider,
        $stateProvider,
        $translatePartialLoaderProvider,
        msNavigationServiceProvider,
        apiUrl)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/register',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register',
            useGuestMenu: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register', {
            title : 'Register',
            state : 'app.pages_auth_register',
            weight: 3
        });

        // Sign up
        //$authProvider.signupUrl = '/api/auth/register/student';
        //$authProvider.signupUrl = 'http://localhost:8088/api/auth/register/student';
        $authProvider.signupUrl = apiUrl + 'auth/register/student';
    }

    function passwordConfirmation() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$validators.passwordConfirmation = function(modelValue) {
                    return modelValue === attrs.passwordConfirmation;
                };

                attrs.$observe('passwordConfirmation', function(value) {
                    ngModel.$validate();
                });
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);


    /** @ngInject */
    function RegisterController($auth, $state, $document, $mdDialog, $rootScope, $scope, $filter)
    {
        var vm = this;





        // Data


        // Methods
        vm.signup = signup;
        vm.openDialog = openDialog;
        vm.toPartners = toPartners;
        vm.toFree = toFree;
	//vm.isTeacherIntroPage=isTeacherIntroPage; //new add
        vm.isTeacher = isTeacher;//new add

        // Functions
        function signup() {
            var user = _mappingUser();

            $auth.signup(user).then(function(response) {
                _login(user);
            }).catch(function(response) {
                if (response.data.error.email) {
                    $scope.registerForm.email.$invalid = true;
                    vm.emailHasRegister = response.data.error.email[0];
                }
            });
        }

        function openDialog() {
            $mdDialog.show({
                controller         : 'TermsConditionsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/terms-n-conditions/terms-n-conditions.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            });
        }

        function _mappingUser() {
            var free_lesson = "0";
            if(vm.form.likeFreeLessonAndConsulation != null && vm.form.interestedINConversationPartner != null){
                free_lesson = "1,2";
            }
            if(vm.form.likeFreeLessonAndConsulation !=null && vm.form.interestedINConversationPartner == null){
                free_lesson = "1";
            }
            if(vm.form.likeFreeLessonAndConsulation ==null && vm.form.interestedINConversationPartner != null){
                free_lesson = "2";
            }
            return {
                name: vm.form.username,
                email: vm.form.email,
                password: vm.form.password,
                password_confirmation: vm.form.passwordConfirm,
                free_lesson: free_lesson,
            }
        }

        function _login(user) {
            $auth.login(user)
                .then(successCallback)
                .catch(errorCallback);
        }

        function successCallback(data) {
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            $rootScope.userRole = 'student';
            //$state.go('app.pages_student-dashboard');
            //$state.go('app.pages_teacher-list');
            if (sessionStorage.backUrl != null){
                history.go(-1);
            }else{
                $state.go('app.pages_student-dashboard');
            }

        }

        function errorCallback(response) {
            vm.invalidLogin = true;
        }

        function toPartners() {
            $state.go('app.pages_find-cp-form');
        }

        function toFree() {
            $state.go('app.pages_free');
        }

         function isTeacher() {
            return payload ? (payload.role == constRoles.TEACHER) : null;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', ['satellizer'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider,
                    $authProvider,
                    msNavigationServiceProvider,
                    apiUrl)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/login',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login',
            useGuestMenu: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth', {
            title : 'Authentication',
            icon  : 'icon-lock',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('pages.auth.login', {
            title : 'Login',
            state : 'app.pages_auth_login',
            weight: 1
        });

        // Login
        $authProvider.loginUrl = '/api/auth/login';
        $authProvider.loginUrl = apiUrl + "auth/login";
        //$authProvider.loginUrl = 'http://localhost/api/auth/login';
        $authProvider.withCredentials = false;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($auth, $state, $rootScope, $filter, $mdSidenav, api)
    {
        var vm = this;

        // Data
        vm.invalidLogin = false;

        // Methods
        vm.logIn = logIn;


        // Functions
        function logIn() {
            var credentials = {
                email: vm.form.email,
                password: vm.form.password,
            };

            $auth.login(credentials)
                .then(successCallback)
                .catch(errorCallback);
        }

        function successCallback(data) {
            var payload = $auth.getPayload();
            window.localStorage.setItem("email",data.config.data.email);
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            if(!sessionStorage.getItem("backUrl")) {
                switch(payload.role) {
                    case 0:
                        $rootScope.userRole = 'admin';
                        $state.go('app.pages_admin-dashboard');
                        break;

                    case 1:
                        $rootScope.userRole = 'teacher';
                        $state.go('app.pages_teacher-dashboard');
                        break;

                    case 2:
                        $rootScope.userRole = 'student';
                        $state.go('app.pages_student-dashboard');
                        break;

                    default:
                        console.error("Invalid Role");
                        break;
                }
            }else {
                api.auth.switchRole.post({token:$auth.getToken(),role:'student'},function(response) {             
                    $auth.setToken(response.token);
                    var payload = $auth.getPayload();
                    $rootScope.isAuthenticated = $auth.isAuthenticated();
                    $rootScope.userRole = 'student';
                    
                    window.location.href = sessionStorage.getItem("backUrl");  
                    sessionStorage.setItem("backUrl",'');                
                });               
            }
        }

        function errorCallback(response) {
            vm.invalidLogin = true;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/forgot-password',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password',
            useGuestMenu: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
            title : 'Forgot Password',
            state : 'app.pages_auth_forgot-password',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController(api)
    {
        var vm = this;

        // Data
        vm.isError = false;
        vm.isSentResetLink = false;
        vm.errorMessage = {};

        // Methods
        vm.sendResetLink = sendResetLink;


        // Functions
        function sendResetLink() {
            api.auth.forgotPassword.save({
                email: vm.form.email
            }, function(response) {
                vm.isError = false;
                vm.isSentResetLink = true;
            }, function(response) {
                console.error(response);

                vm.isError = true;
                vm.errorMessage = (response.data.error.email) ? 
                                   response.data.error.email[0]:
                                   response.data.error;
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.view-essay', ['app.dialogs.edit-file'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_view-essay', {
            url      : '/view-essay/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/view-essay/view-essay.html',
                    controller : 'ViewEssayController as vm'
                }
            },
            bodyClass: 'view-essay',
            params: {
                id: null
            },
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/view-essay');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.view-essay')
        .controller('ViewEssayController', ViewEssayController);

    /** @ngInject */
    function ViewEssayController(
        $rootScope,
        $q,
        $auth,
        $state,
        $stateParams,
        $scope,
        $location,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver)
    {
        var vm = this;
        var db = new AWS.DynamoDB.DocumentClient({accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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', region: 'us-east-1'});
        var payload = $auth.getPayload();
        
        // Data
        vm.essayText = "Please copy and paste your essay here.";
        vm.essayRequestId = $stateParams.id;
        vm.teacherInfo = {};
        vm.user = {};
        vm.files = [];
        vm.docs = [];
        vm.isLoading = true;
        vm.reviewKeys = [];

        // Methods
        vm.addFile = addFile;
        vm.keyToLink = keyToLink;
        vm.upload = upload;
        vm.goToDashboard = goToDashboard;
        _init();
        
        // Functions
        function _init(){
            _checkAuth();
            $q.all([
                _getEssayInfo(),
                _getCurrentUser(),
            ]).then(function (response) {
                vm.essayRequestInfo = response[0].data;
                vm.user = response[1].data;
                _switchRoleIfNecessary();
            }, _errorHandler);
        }

        function _loadpage(){
            // if ($rootScope.userRole == 'student') {
            //     if (vm.essayRequestInfo.essayType == '2') {
            //         for (var i = 0; i < vm.essayRequestInfo.docs.length; i++) {
            //             if (vm.essayRequestInfo.docs[i].status == '2') {
            //                 vm.docs.push(vm.essayRequestInfo.docs[i]);
            //             }
            //         }
            //     }
            //     else {
            //         vm.;
            //         vm.docs.push(vm.essayRequestInfo.docs[1]);
            //     }
            // }
            // else {
                vm.docs = vm.essayRequestInfo.docs;
            // }
            console.log(vm.docs);
            // docsHandler(vm.essayRequestInfo.essayType);
            vm.isLoading = false;
        }

        function _getEssayInfo(){
            return apiResolver.resolve('essayRequest.byId@get', {id: vm.essayRequestId});
        }

        function _getCurrentUser() {
            return apiResolver.resolve('user.list@get');
        }

        function addFile(){
            $mdDialog.show({
                controller         : 'EditFileController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/edit-file/edit-file.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false,
                locals             : {
                    user: vm.user,
                },
                onRemoving: function(element, removePromise){
                    _getFiles().then(function(data){
                        console.log('promise succeeded');
                        console.log(data);
                        $scope.files = data;
                        console.log($scope.files);
                    }).catch(function(error) {
                        console.log('promise failed');
                        console.error(error);
                    });
                }
            });
        }

        function _errorHandler(response) {
            console.error(response);
        }

        function keyToLink(awsKey, role) {
            if (role == 'teacher'){
                return 'https://testdb-userfiles-mobilehub-864203888.s3.amazonaws.com/public/user_' + vm.essayRequestInfo.teacherUserId + '/Files/' + awsKey;
            }

            else {
                return 'https://testdb-userfiles-mobilehub-864203888.s3.amazonaws.com/public/user_' + vm.essayRequestInfo.studentUserId + '/Files/' + awsKey;
            }
            
        }

        function _checkAuth() {
            if (!$auth.isAuthenticated()){
                console.log('not auth');
                sessionStorage.setItem("backUrl",$location.absUrl());
                $state.go('app.pages_auth_register');
            }
            _updatePayload(payload.role);
        }

        function _switchRoleIfNecessary() {
            var isRequestTeacher = (vm.essayRequestInfo.teacherUserId == vm.user.id);
            var isRequestStudent = (vm.essayRequestInfo.studentUserId == vm.user.id);

            if (isRequestTeacher && payload.canSwitch && $rootScope.userRole == 'student') {
                _switchRole('teacher');
            }

            else if (isRequestStudent && payload.canSwitch && $rootScope.userRole == 'teacher') {
                _switchRole('student');
            }

            else {
                _loadpage();
            }
        }

        function _switchRole(newRole){
            console.log('switching roles');
            api.auth.switchRole.post({token: $auth.getToken(), role: newRole },
                function(response) {
                    _updateToken(response.token);
                    _loadpage();
                },

                function(response) {
                    alert("Sorry, you don't have permission to visit this page.");
                    history.back();
                }
            );
        }

        function _updateToken(token) {
            $auth.setToken(token);
            var payload = $auth.getPayload();
            _updatePayload(payload.role);
        }

        function _updatePayload(role) {
            switch(role) {
                case 0:
                    $rootScope.userRole = 'admin';
                    break;

                case 1:
                    $rootScope.userRole = 'teacher';
                    break;

                case 2:
                    $rootScope.userRole = 'student';
                    break;

                default:
                    console.error("Invalid Role");
                    break;
            }
            console.log($rootScope.userRole);
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Essay Review Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        // function docsHandler(essayType) {
        //     if (essayType == 2) {
        //         vm.reviewDocs = [{
        //             essayTitle: 'College Essay Final Review',
        //             awsKey: null,
        //             essayText: null

        //         },
        //         {
        //             essayTitle: 'Recommendation Letter 1',
        //             awsKey: null,
        //             essayText: null
        //         },
        //         {
        //             essayTitle: 'Recommendation Letter 2',
        //             awsKey: null,
        //             essayText: null
        //         },
        //         {
        //             essayTitle: 'CV',
        //             awsKey: null,
        //             essayText: null
        //         }];
        //     } else {
        //         var title;
        //         switch (essayType) {
        //             case '1': 
        //                 title = 'College Essay Review';
        //                 break; 
        //             case '3': 
        //                 title = 'TOEFL/IELFTS Essay';
        //                 break;
        //             case '4': 
        //                 title = 'SAT Essay';
        //                 console.log(title);
        //                 break;
        //             case '5': 
        //                 title = 'Academic Writing Essay';
        //         }
        //         vm.reviewDocs = [{
        //             essayTitle: title,
        //             awsKey: null,
        //             essayText: null
        //         }];
        //     }
        //     console.log(vm.reviewDocs);
        // }

        function _createFileID() {
            var d = new Date();
            var n = d.getTime();
            console.log("Get a file at time: " + n);
            var newFileName =  n.toString();
            return newFileName;
        }

        function _uploadS3AndDynamoDB(category, extension, file, index) {
            var bucket = new AWS.S3({ params: { Bucket: 'testdb-userfiles-mobilehub-864203888/public/user_' + vm.user.id + '/Files'} });
            var fileId = _createFileID();
            var uniqueFileName = fileId + extension;
            console.log("uploadS3");
            console.log(index);
            vm.reviewKeys.push(uniqueFileName);
            var params = { Key: uniqueFileName, ContentDisposition: 'attachment; filename=' + file.name, ContentType: file.type, Body: file, ServerSideEncryption: 'AES256' };
            console.log(params);
            bucket.putObject(params, function(err, data) {
                if(err) {
                    $rootScope.overlayMessage = null;
                    console.error(err.message,err.code);
                    return false;
                } else {
                    var item = {};
                    // update in the database;
                    item.ownerId = vm.user.id;
                    item.ownerName = vm.user.name;
                    item.location = 'public/user_' + vm.user.id + '/Files/' + fileId + extension;
                    item.accessId = vm.user.id.toString();
                    item.created = (new Date().getTime() / 1000);
                    item.updated = item.created;
                    item.access = 'rw';
                    item.fileId = fileId;
                    item.extension = extension;
                    item.fileName = file.name;
                    
                    AWS.config.update({region:'us-east-1'});
                    db.put({
                        'TableName': 'testdb-mobilehub-864203888-FileDB',
                        'Item': item,
                        'ConditionExpression': 'attribute_not_exists(id)'
                    }).promise().then(function(data) {
                        // Upload Successfully Finished
                        if (index > (vm.docs.length - 2)) {
                            var params = {
                                id: vm.essayRequestId,
                                reviewKeys: vm.reviewKeys,
                                reviewTime: moment().utc().format('MMM DD, YYYY hh:mm a')
                            };
                            console.log(params);
                            api.essayRequest.review.put(params, _successCreateRequestCallback, _errorHandler);
                        }
                        console.log(data);
                    }).catch(function(err)  {
                        console.log("ERROR: " + err);
                    });
                }
            });
        }

        function upload() {
            console.log("upload");
            waitForResponse();
            AWS.config.update({ accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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'});
            AWS.config.region = 'us-east-1';

            if(vm.files) {
                console.log(vm.files);
                console.log(vm.files.length);
                for (var i = 0; i <= vm.files.length - 1; i++) {
                    console.log(vm.files[i]);
                    if (vm.files[i].type == 'application/msword' && vm.files[i].name.endsWith('.doc')) {
                        _uploadS3AndDynamoDB('document', '.doc', vm.files[i], i);
                    } else if(vm.files[i].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && vm.files[i].name.endsWith('.docx') ) {
                        _uploadS3AndDynamoDB('document', '.docx', vm.files[i], i);
                    } else if(vm.files[i].type == 'text/plain' && vm.files[i].name.endsWith('.txt') ) {
                        _uploadS3AndDynamoDB('document', '.txt', vm.files[i], i);
                    } else {
                        $rootScope.overlayMessage = null;
                        alert('Please select a doc, docx, txt, file to upload');
                    }
                }
            } else {
                $rootScope.overlayMessage = null;
                alert('Please select a file to upload');
            }
        }

        function goToDashboard() {
            $state.go('app.pages_student-dashboard');
        }

        function _successCreateRequestCallback() {
            $mdDialog.hide();
            $mdDialog.show(
              $mdDialog.alert()
                .title('Your essay review has been sent!')
                .textContent('')
                .ariaLabel('essay request')
                .ok('HOME DASHBOARD')
                .parent(angular.element(document.body))
            ).then(function() {
                $state.go('app.pages_teacher-dashboard');
            });
        }

        function _errorHandler(response) {
            $mdDialog.hide();
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.tzuchi', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_tzuchi', {
            url      : '/tzuchi',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/tzuchi/tzuchi.html',
                    controller : 'TzuchiController as vm'
                }
            },
            resolve  : {
                subjects: function (apiResolver) {
                    return apiResolver.resolve('subject.list@get', { isCovid: 1 });
                }
            },
            bodyClass: 'tzuchi',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/tzuchi');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.tzuchi')
        .controller('TzuchiController', TzuchiController);

    /** @ngInject */
    function TzuchiController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail,
        subjects)
    {
        var vm = this;
        var db = new AWS.DynamoDB.DocumentClient({accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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', region: 'us-east-1'});

        // Data

        vm.subjects = Object.values(subjects.data);
        console.log(vm.subjects);
        vm.grades = ['5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18'];

        // Methods

        vm.submit = submit;
        vm.goToCovid = goToCovid;

        // Functions

        function submit() {
            console.log('submit clicked');
            _upload(vm.params);
        }

        function _createFileID() {
            var d = new Date();
            var n = d.getTime();
            var newFileName =  n.toString();
            return newFileName;
        }

        function _uploadS3AndDynamoDB(category, extension, file) {
            console.log("uploadS3");
            var bucket = new AWS.S3({ params: { Bucket: 'testdb-userfiles-mobilehub-864203888/public/hw-help/files'} });
            var fileId = _createFileID();
            var uniqueFileName = fileId + extension;
            var params = { Key: uniqueFileName, ContentDisposition: 'attachment; filename=' + file.name, ContentType: file.type, Body: file, ServerSideEncryption: 'AES256' };
            console.log(params);
            bucket.putObject(params, function(err, data) {
                if(err) {
                    $rootScope.overlayMessage = null;
                    _errorHandler(err.code);
                    return false;
                } else {
                    var item = {};
                    // update in the database

                    item.location = 'public/hw-help/files' + fileId + extension;
                    item.accessId = '0';
                    item.created = (new Date().getTime() / 1000);
                    item.updated = item.created;
                    item.access = 'rw';
                    item.fileId = fileId;
                    item.extension = extension;
                    item.fileName = file.name;
                    
                    AWS.config.update({region:'us-east-1'});
                    db.put({
                        'TableName': 'testdb-mobilehub-864203888-FileDB',
                        'Item': item,
                        'ConditionExpression': 'attribute_not_exists(id)'
                    }).promise().then(function(data) {
                        // Upload Successfully Finished

                        var params = {
                            name: vm.form.username,
                            email: vm.form.email,
                            grade: vm.form.grade,
                            description: vm.form.description,
                            subject: vm.form.subject,
                            otherSubject: vm.form.otherSubject,
                            awsKey: uniqueFileName
                        };

                        api.hwRequest.save.post(params, _successCallback, _errorHandler);
                        console.log('SUCCESSFULLY UPLOADED FILE');
                        console.log(params);
                        console.log(data);
                    }).catch(function(err)  {
                        console.log('FAILED UPLOAD');
                        console.log("ERROR: " + err);
                    });
                }
            });
        }

        function _upload() {
            console.log("upload");
            _waitForResponse();
            AWS.config.update({ accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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'});
            AWS.config.region = 'us-east-1';

            if (vm.file) {
                if (vm.file.type == 'application/msword' && vm.file.name.endsWith('.doc')) {
                    _uploadS3AndDynamoDB('document', '.doc', vm.file);
                } else if(vm.file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && vm.file.name.endsWith('.docx') ) {
                    _uploadS3AndDynamoDB('document', '.docx', vm.file);
                } else if(vm.file.type == 'text/plain' && vm.file.name.endsWith('.txt') ) {
                    _uploadS3AndDynamoDB('document', '.txt', vm.file);
                } else if(vm.file.type == 'application/pdf' && vm.file.name.endsWith('.pdf') ) {
                    _uploadS3AndDynamoDB('presentation', '.pdf', vm.file);
                } else if(vm.file.type == 'image/png' && vm.file.name.endsWith('.png') ) {
                    _uploadS3AndDynamoDB('image', '.png', vm.file);
                } else if(vm.file.type == 'image/jpeg' && vm.file.name.endsWith('.jpg') ) {
                    _uploadS3AndDynamoDB('image', '.jpeg', vm.file);
                } else if(vm.file.type == 'image/jpeg' && vm.file.name.endsWith('.jpeg') ) {
                    _uploadS3AndDynamoDB('image', '.jpeg', vm.file);
                }
                 else {
                    $rootScope.overlayMessage = null;
                    alert('Please select a doc, docx, pdf, png, jpg, or txt file to upload');
                }
            }

            else {
                var params = {
                    name: vm.form.username,
                    email: vm.form.email,
                    grade: vm.form.grade,
                    description: '',
                    subject: 3,
                    otherSubject: null,
                    awsKey: null,
                };
                api.hwRequest.save.post(params, _successCallback, _errorHandler);
            }

        }

        function _waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">處理中。。。</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function _successCallback() {
            var successContent =
            ' \
            <md-dialog> \
                <md-content> \
                    <div class="dialog-title"> \
                        <p>Your request has been sent!</p> \
                    </div> \
                    <div class="dialog-intro"> \
                        <p>成功了！</p> \
                        <p style="color:black;"><b>發給你的朋友</b><br></p> \
                        <md-input-container md-no-float class="md-block" flex-gt-sm> \
                            <input type="text" class="input-content" ng-model="sharableLink"> \
                        </md-input-container> \
                    </div> \
                </md-content> \
                <md-dialog-actions> \
                    <md-button ng-click="goToLanding()" class="md-primary"> \
                      Okay \
                    </md-button> \
                </md-dialog-actions> \
            </md-dialog> \
            ';

            $mdDialog.hide();
            $mdDialog.show({
                template            : successContent,
                clickOutsideToClose : false,
                parent              : angular.element('#tzuchi'),
                controller          : SuccessController,
            });

            function SuccessController($scope, $state, $mdDialog) {
                $scope.sharableLink = "https://www.nesuku.com/tzuchi";
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
                $scope.goToLanding = function() {
                    $state.go('app.pages_landing');
                }
            }
            
        }

        function goToCovid() {
            $state.go('app.pages_covid');
        }


        function _errorHandler(response) {
            $mdDialog.hide();
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.teacher-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_teacher-list', {
            url      : '/teacher-list/:is_conversation_partner',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/teacher-list/teacher-list.html',
                    controller : 'TeacherListController as vm'
                }
            },
            resolve: {
                is_conversation_partner: function ($auth, $stateParams, apiResolver, constRoles) {
                    return $stateParams.is_conversation_partner;
                },
                subjects: function (apiResolver) {
                    return apiResolver.resolve('subject.list@get');
                }
            },
            bodyClass: 'teacher-list',
            params: {
                lang: null
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/teacher-list');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.teacher-list')
        .controller('TeacherListController', TeacherListController);

    /** @ngInject */
    function TeacherListController($auth, $q, $state, $stateParams, $rootScope, $filter, api, apiResolver, constRoles, is_conversation_partner, subjects)
    {
        var vm = this;
        var payload = $auth.getPayload();
        var isStudent = null;

        if (payload) {
            isStudent = payload.role == constRoles.STUDENT;
        }

        $rootScope.currentNavItem = 'Teacher List';

        
        // Data
        vm.teacherList = [];
        vm.languageOption = [];
        vm.subjects = Object.values(subjects.data);
        vm.student = false;
        vm.timezone = 'UTC';
        vm.isLoading = true;
        vm.isStudent = isStudent;
        vm.learn = '';
        vm.preferToLearn = '';
        vm.isAuthenticated = $auth.isAuthenticated();
        vm.is_conversation_partner = is_conversation_partner == 'cp' ? true : false;
        vm.goToConversationPartners = goToConversationPartners;
        vm.goToTeachers = goToTeachers;
        vm.goToFindATutor = goToFindATutor;

        // Pagination
        vm.pagination = {
            totalItems: null,
            currentPage: null,
            itemsPerPage: 10,
            maxSize: 5,
            // setPage: setPage,
        };


        // Init
        _switchRoleIfNecessary();


        // Methods
        vm.goToDashboard = goToDashboard;
        vm.refreshTeacherList = refreshTeacherList;


        // Functions

        function _switchRoleIfNecessary() {
            var payload = $auth.getPayload();

            if (vm.isAuthenticated){

                if(payload.role != 2) {
                    api.auth.switchRole.post({token: $auth.getToken(), role: 'teacher'},
                        function(response) {
                            _updateToken(response.token);
                            _init();
                        },

                        function(response) {
                            alert("Sorry, you don't have permission to visit this page.");
                            history.back();
                        }
                    );
                }
                else {
                    _init();
                }
            }
            else {
                _init();
            }
        }

        function _updateToken(token) {
            $auth.setToken(token);
            var payload = $auth.getPayload();
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            switch(payload.role) {
                case 0:
                    $rootScope.userRole = 'admin';
                    break;

                case 1:
                    $rootScope.userRole = 'teacher';
                    break;

                case 2:
                    $rootScope.userRole = 'student';
                    break;

                default:
                    console.error("Invalid Role");
                    break;
            }
        }

        function goToDashboard() {
                $state.go('app.pages_student-dashboard');
        }

        function _init() {
            _languageToNumber($stateParams.lang);

            $q.all([
                _getTeacherList(),
                _getLanguageOption(),
                _getStudent()
            ]).then(function (response) {    
                vm.teacherList = response[0].data;
                vm.languageOption = angular.merge({0: "All"}, response[1].data);
                vm.student = response[2].data;
                vm.isLoading = false;
                vm.pagination.totalItems = response[0].total;
                vm.pagination.currentPage = response[0].currentPage;
            }, _errorHandler);
        }

        function _languageToNumber(language){
            if (language == null ){
                 vm.learn = '';
            }else{
                var languages = ["Fitness", "Mandarin", "English", "French", "German", "Hindi", "Italian", "Japanese", "Korean", "Portuguese", "Russian", "Spanish", "Norwegian","Danish", "Thai", "Swedish", "Vietnamese", "Farsi", "Arabic", "Physics", "Math", "Voice", "Computer Programming", "English Writing"];
                var number = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25];
                for (var i = 0; i <25; i++) {
                    if (language == languages[i]){
                        vm.learn = number[i];
                        break;
                    }
                }
            }
        }

        function refreshTeacherList() {
            // if(vm.learn == 0){
            //     vm.learn = '';
            // }
            api.teacher.list.get({
                subject: vm.learn,
                page: vm.pagination.currentPage,
                is_conversation_partner: vm.is_conversation_partner ? 1 : 0,
            }, function (response) {
                vm.teacherList = response.data;
                vm.pagination.totalItems = response.total;
                vm.pagination.currentPage = response.currentPage;
            });
        }

        function _getTeacherList() {
            if(vm.is_conversation_partner) {
                return apiResolver.resolve('teacher.list@get', {
                    learn: vm.learn,
                    preferToLearn: vm.preferToLearn,
                    is_conversation_partner: 1,
                });
            }
            else {
                return apiResolver.resolve('teacher.list@get', {
                    learn: vm.learn,
                    preferToLearn: vm.preferToLearn,
                    is_conversation_partner: 0,
                });
            }
        }

        function _getLanguageOption() {
            return apiResolver.resolve('option.language@get');
        }

        function _getStudent() {
            if (vm.isStudent) {
                return apiResolver.resolve('student.byToken@get');
            } else {
                return {data: false};
            }
        }

        function goToConversationPartners() {
            $state.go('app.pages_teacher-list', {is_conversation_partner: 'cp'});
        }

        function goToTeachers() {
            $state.go('app.pages_teacher-list', {is_conversation_partner: 'teacher'});
        }

        function goToFindATutor() {
            $state.go('app.pages_find-a-tutor');
        }

        function _errorHandler(response) {
            console.error(response);
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.teacher-dashboard', [
            'ui.calendar',
            'app.dialogs.edit-profile-pic',
            'app.dialogs.change-password',
            'app.dialogs.set-price',
            'app.dialogs.message',
            'app.dialogs.calendar-dialog',
            'app.dialogs.create-package',
            'app.dialogs.makeup-payment'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_teacher-dashboard', {
            url      : '/teacher-dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/teacher-dashboard/teacher-dashboard.html',
                    controller : 'TeacherDashboardController as vm'
                }
            },
            bodyClass: 'teacher-dashboard',
            requireLogin: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/teacher-dashboard');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.teacher-dashboard')
        .controller('TeacherDashboardController', TeacherDashboardController);

    /** @ngInject */
    function TeacherDashboardController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        scheduleMapper,
        specificAvailabilityMapper,
        constDefaultAvatar,
        constNesukuEmail,
        $scope)
    {
        var vm = this;
        var isSaved = 0;

        var payload = $auth.getPayload();
        //change calendar view by screen
        if(screen.width < 640) {
            var calendarUiConfig = {
                editable          : true,
                eventDurationEditable: false,
                eventClick        : _eventClick,
                eventDrop         : _eventChange,
                eventResize       : _eventChange,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M/D'
                },
                selectable        : true,
                selectHelper      : true,
                defaultView       : 'agendaDay',
                timezone          : 'local',
                minTime           : '06:00:00',
                maxTime           : '24:00:00',
                select            : _select
            };
            var regularCalendarUiConfig = {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M/D'
                },
                selectable        : true,
                selectHelper      : true,
                defaultView       : 'agendaDay',
                eventClick        : eventDetailRegular,
                select            : selectRegular,
                eventDrop         : changeEventRegular,
                eventResize       : resizeEventRegular,
                timezone          : 'local',
                minTime           : '06:00:00',
                maxTime           : '24:00:00'
            };
            var specificCalendarUiConfig = {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M/D'
                },
                selectable        : true,
                selectHelper      : true,
                defaultView       : 'agendaDay',
                eventClick        : eventDetailSpecific,
                select            : selectSpecific,
                eventDrop         : changeEventSpecific,
                eventResize       : resizeEventSpecific,
                timezone          : 'local',
                minTime           : '06:00:00',
                maxTime           : '24:00:00'
            };
            var isAgendaDay = false;
        }
        else {
            var calendarUiConfig = {
                editable          : true,
                eventDurationEditable: false,
                eventClick        : _eventClick,
                eventDrop         : _eventChange,
                eventResize       : _eventChange,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M/D'
                },
                selectable        : true,
                selectHelper      : true,
                defaultView       : 'agendaWeek',
                timezone          : 'local',
                minTime           : '06:00:00',
                maxTime           : '24:00:00',
                select            : _select
            };
            var regularCalendarUiConfig = {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M/D'
                },
                selectable        : true,
                selectHelper      : true,
                defaultView       : 'agendaWeek',
                eventClick        : eventDetailRegular,
                select            : selectRegular,
                eventDrop         : changeEventRegular,
                eventResize       : resizeEventRegular,
                timezone          : 'local',
                minTime           : '06:00:00',
                maxTime           : '24:00:00',
            };
            var specificCalendarUiConfig = {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M/D'
                },
                selectable        : true,
                selectHelper      : true,
                defaultView       : 'agendaWeek',
                eventClick        : eventDetailSpecific,
                select            : selectSpecific,
                eventDrop         : changeEventSpecific,
                eventResize       : resizeEventSpecific,
                timezone          : 'local',
                minTime           : '06:00:00',
                maxTime           : '24:00:00',
            };
            var isAgendaDay = false;
        };

        $rootScope.currentNavItem = 'Teacher Dashboard';
        $rootScope.viewWeek = moment().format('YYYY-MM-DD');

        // Data
        vm.isLoading = true;
        vm.defaultAvatar = constDefaultAvatar;
        vm.teacher = [];
        vm.reviews = [];
        vm.courseRequests = [];
        vm.upcomingClasses = [];
        vm.previousClasses = [];
        vm.calendarUiConfig = calendarUiConfig;
        vm.regularCalendarUiConfig = regularCalendarUiConfig;
        vm.specificCalendarUiConfig = specificCalendarUiConfig;
        vm.timezone = moment().format('Z');
        vm.dateFormat = 'MMM d';
        vm.datetimeFormat = 'MMM d, hh:mm a';
        vm.dayDateFormat = 'EEEE, MMM d,';
        vm.timeFormat= 'h:mm a';
        vm.isExpand = false;
        vm.isAgendaDay = isAgendaDay;
        vm.isAvailability = false;
        vm.isSpecific = false;
        vm.switchTitle = 'Default Weekly Schedule';
        vm.packages;
        vm.packageIndex = [];
        vm.packageStudents = {};

        // The structure of schedule must be {events: []} or [[]]. First one will lead array reduce error but still can work
        vm.schedule = [[]];
        vm.regularSchedule = [[]];
        vm.specificSchedule = [[]];

        // Methods
        vm.viewPublicProfile = viewPublicProfile;
        vm.dropDownControl = dropDownControl;
        // vm.editProfilePic = editProfilePic;
        // vm.changePassword = changePassword;
        vm.contactNesuku = contactNesuku;
        vm.makeupPayment = makeupPayment;
        // vm.openSetPriceDialog = openSetPriceDialog;
        vm.acceptRequest = acceptRequest;
        vm.cancelRequest = cancelRequest;
        vm.cancelCourse = cancelCourse;
        vm.beginLesson = beginLesson;
        vm.notImplement = notImplement;
        vm.showMore = showMore;
        vm.showOrHideAllTime = showOrHideAllTime;
        vm.DayOrWeekly = DayOrWeekly;
        vm.toggleAvailability = toggleAvailability;
        vm.toggleSpecific = toggleSpecific;
        vm.prev = prev;
        vm.next = next;
        vm.prevSpecific = prevSpecific;
        vm.nextSpecific = nextSpecific;
        vm.createPackage = createPackage;
        vm.deletePackage = deletePackage;
        vm.goToEssay = goToEssay;

        // Functions
        function initPackageHours() {
            var params = {
              token: $auth.getToken()
            };
            api.packages.teacher_remain.get(params,
                function(response) {
                    // create packages
                    var packages = {};
                    console.log(response);
                    for (var i = 0; i < response.data["resultPackages"].length; ++i) {
                        var teacherPackage = response.data["resultPackages"][i];
                        var curBuildingTeacherPackage = [];

                        // teacherPackage: [name, array of studentPackages]
                        for (var j = 0; j < teacherPackage[1].length; ++j) {
                            var studentPackage = teacherPackage[1][j];
                            // studentPackage: [studentName, remainHours]
                            curBuildingTeacherPackage.push([studentPackage[0],studentPackage[1]]);

                        };
                        packages[teacherPackage[0]] = curBuildingTeacherPackage;
                    }
                    vm.packageStudents = packages;
                },
                function(err) {
                    console.log(err);
                }
            );
        }

        function dropDownControl(index) {
            for (var i = 0; i < vm.packageIndex.length; ++i) {
                if (vm.packageIndex[i] == index) {
                    vm.packageIndex.splice(i, 1);
                    return;
                }
            }
            vm.packageIndex.push(index);
        }


        function notImplement() {
            alert('This feature not implement yet');
        }

        function viewPublicProfile() {
            $state.go('app.pages_teacher', {id: payload.id});
        }

        function makeupPayment() {
            console.log('makeupPayment() called')
            // 创建一个类似lesson-request的窗口
            var calendarEvent = {
                start: moment(),
                end:moment(),
            }
            console.log("calendarEvent")
            console.log(calendarEvent)
            _openMakeupPaymentDialog(calendarEvent);
        }

        function _openMakeupPaymentDialog(calendarEvent) {
            $mdDialog.show({
                controller         : 'MakeupPaymentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/makeup-payment/makeup-payment.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false,
                locals: {
                    teacher: vm.teacher,
                    calendarEvent: calendarEvent
                },
            })
        }

        function contactNesuku() {
            location.href = constNesukuEmail;
        }

        function createPackage() {
            _openCreatePackageDialog();
        }

        function deletePackage(id) {
            console.log(id);
            // var params = {
            //   token: $auth.getToken(),
            //   id: id
            // }
            // api.packages.destroy.delete(params,
            //     function(response) {
            //         console.log(response)
            //     },
            //     function(err) {
            //         console.log(err);
            //     }
            // );
        }

        function _getPackages() {
            var params = {
              token: $auth.getToken()
            }
            api.packages.list.get(params,
                function(response) {
                    vm.packages = response.data;
                    initPackageHours();
                },
                function(err) {
                    console.log(err);
                }
            );
        }

        function _openCreatePackageDialog() {
            $mdDialog.show({
                controller         : 'CreatePackageController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/create-package/create-package.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false,
                locals             : {
                    teacher: vm.teacher,
                    // calendarEvent: calendarEvent
                },
            }).then(function() {
                console.log('create package controller closed.');
                _refreshSchedule();
            });
        }



        function acceptRequest(index, courseRequest) {
            var confirm = $mdDialog.confirm()
                  .title($filter('translate')('TEACHER_DASHBOARD.ACCEPT_LESSON_REQUEST'))
                  .textContent($filter('translate')('TEACHER_DASHBOARD.ACCEPT_LESSON_REQUEST_CONFIRM'))
                  .ariaLabel($filter('translate')('TEACHER_DASHBOARD.ACCEPT_LESSON_REQUEST'))
                  .clickOutsideToClose(true)
                  .parent(angular.element(document.body))
                  .ok('Yes')
                  .cancel('No');

            $mdDialog.show(confirm).then(function() {
                $mdDialog.hide();
                waitForResponse();
                var params = {
                    id: courseRequest.id
                };

                vm.courseRequests.splice(index, 1);

                _removePendingEvent(courseRequest.id);

                api.courseRequest.confirm.put(params, _successAcceptHandler, _failAcceptHandler);

                function _successAcceptHandler(response) {
                    $q.all([
                        _getTeacher(),
                        _getCourseRequests(),
                        _getUpcomingClasses(),
                    ]).then(function (response) {
                        vm.teacher = response[0].data;
                        vm.courseRequests = response[1].data;
                        vm.hasMoreRequest = response[1].hasMore;
                        vm.upcomingClasses = _pipeUpcomingClasses(response[2].data);
                        vm.hasMoreUpcoming = response[2].hasMore;
                    }, _errorHandler);
                    _refreshSchedule();
                    $mdDialog.hide();
                    $mdDialog.show(
                      $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .title('You have successfully accepted the lesson request.')
                        .textContent('')
                        .ariaLabel('')
                        .ok('OK')

                        .title('You have successfully accepted the lesson request.')
                        .textContent('')
                        .ariaLabel('')
                        .ok('OK')
                    );
                }

                function _failAcceptHandler(response) {
                    $mdDialog.hide();
                    alert('Oh! Something unexpected happened!');
                    console.error(response);
                }
            });
        }

        function cancelRequest(index, courseRequest) {
            var cancelRequestContent = ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px;" aria-label="Category saved"> \
                    <md-toolbar class="md-accent md-hue-2" style="background-color:#fff;"> \
                        <div class="md-toolbar-tools" layout="row" layout-align="space-between center">\
                            <span class="dialog-title" style="color:black;font-weight:bold;">Cancel Lesson?</span>\
                            <md-button class="md-icon-button" ng-click="closeDialog()" aria-label="Close dialog">\
                                <md-icon md-font-icon="icon-close" style="color:black;"></md-icon>\
                            </md-button>\
                        </div>\
                    </md-toolbar>\
                    <md-dialog-content ms-scroll> \
                        <p>Send a message to the student (optional)</p> \
                        <md-input-container class="md-block" > \
                            <input type="text" style="font-size: 12px;" name="message" ng-model="message"> \
                        </md-input-container> \
                        <section style="text-align: right;"> \
                            <md-button ng-click="closeDialog()" class="md-primary md-raised"> \
                                No \
                            </md-button> \
                            <md-button ng-click="cancelRequestAPI()" class="md-primary md-raised"> \
                                Yes \
                            </md-button> \
                        </section> \
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : cancelRequestContent,
                locals              : {message: vm.message},
                bindToController    : true,
                clickOutsideToClose : true,
                parent              : angular.element(document.body),
                controller          : CancelRequestController,
            });

            function CancelRequestController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
                $scope.cancelRequestAPI = function() {
                    $mdDialog.hide();
                    waitForResponse();

                    var params = {
                        id: courseRequest.id,
                        message: $scope.message,
                    };

                    vm.courseRequests.splice(index, 1);

                    _removePendingEvent(courseRequest.id);

                    api.courseRequest._cancel.put(params, _successCancelHandler, _failCancelHandler);

                    function _successCancelHandler(response) {


                        // update package hours

                        // response.data = { packageName: [ [studentName1, hours], [studentName1, hours] ], ... }


                        if (vm.packageStudents[response.data.package_name] != null ) {
                            for (var i = 0; i < vm.packageStudents[response.data.package_name].length; ++i) {
                                if (vm.packageStudents[response.data.package_name][i][0] == response.data.student_name) {
                                    vm.packageStudents[response.data.package_name][i][1] += response.data.package_increament;
                                }
                            }
                        }

                        // for (var i = 0; i < vm.packageTeachers.length; ++i) {
                        //     if (vm.packageTeachers[i].teacherName == response.data.teacher_name) {
                        //
                        //         for (var j = 0; j < vm.packageTeachers[i].packages.length; ++j) {
                        //             if (vm.packageTeachers[i].packages[j].packageName == response.data.package_name) {
                        //                 vm.packageTeachers[i].packages[j].remainingHours += response.data.package_increament;
                        //             }
                        //         }
                        //     }
                        // }

                        _getCourseRequests().then(function (response) {
                            vm.courseRequests = response.data;
                            vm.hasMoreRequest = response.hasMore;
                        },
                        function(response) {
                            console.error(response);
                        });
                        _refreshSchedule();
                        $mdDialog.hide();
                        $mdDialog.show(
                          $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .parent(angular.element(document.body))
                            .title('You have successfully declined the lesson request.')
                            .textContent('')
                            .ariaLabel('')
                            .ok('OK')

                            .title('You have successfully declined the lesson request.')
                            .textContent('')
                            .ariaLabel('')
                            .ok($filter('translate')('LESSON_REQUEST.OK'))
                        );
                    }

                    function _failCancelHandler(response) {
                        $mdDialog.hide();
                        alert('Oh! Something unexpected happened!');
                        console.error(response);
                    }
                }
            }
        }

        function cancelCourse(index, course) {
            var cancelCourseContent = ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px;" aria-label="Category saved"> \
                    <md-toolbar class="md-accent md-hue-2" style="background-color:#fff;"> \
                        <div class="md-toolbar-tools" layout="row" layout-align="space-between center">\
                            <span class="dialog-title" style="color:black;font-weight:bold;">Cancel Lesson?</span>\
                            <md-button class="md-icon-button" ng-click="closeDialog()" aria-label="Close dialog">\
                                <md-icon md-font-icon="icon-close" style="color:black;"></md-icon>\
                            </md-button>\
                        </div>\
                    </md-toolbar>\
                    <md-dialog-content ms-scroll> \
                        <p>Send a message to the student (optional)</p> \
                        <md-input-container class="md-block" > \
                            <input type="text" style="font-size: 12px;" name="message" ng-model="message"> \
                        </md-input-container> \
                        <section style="text-align: right;"> \
                            <md-button ng-click="closeDialog()" class="md-primary md-raised"> \
                                No \
                            </md-button> \
                            <md-button ng-click="cancelCourseAPI()" class="md-primary md-raised"> \
                                Yes \
                            </md-button> \
                        </section> \
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : cancelCourseContent,
                locals              : {message: vm.message},
                bindToController    : true,
                clickOutsideToClose : true,
                parent              : angular.element(document.body),
                controller          : CancelCourseController,
            });

            function CancelCourseController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
                $scope.cancelCourseAPI = function() {
                    $mdDialog.hide();
                    waitForResponse();

                    var params = {
                        id: course.id,
                        message: $scope.message,
                    };

                    vm.upcomingClasses.splice(index, 1);

                    api.courseTimes._cancel.put(params, _successCancelHandler, _failCancelHandler);

                    // Remove schedule from view model
                    _removeReservedEvent(course.id);

                    function _successCancelHandler(response) {
                        _getUpcomingClasses().then(
                        function(response) {
                            // Refresh view model
                            vm.upcomingClasses = _pipeUpcomingClasses(response.data);
                            vm.hasMoreUpcoming = response.hasMore;
                        },
                        function(response) {
                            console.error(response);
                        });
                        _refreshSchedule();
                        $mdDialog.hide();
                        $mdDialog.show(
                          $mdDialog.alert()
                            .clickOutsideToClose(true)
                            .parent(angular.element(document.body))
                            .title('Your lesson has been cancelled.')
                            .textContent('')
                            .ariaLabel('')
                            .ok('OK')

                            .title('Your lesson has been cancelled.')
                            .textContent('')
                            .ariaLabel('')
                            .ok($filter('translate')('LESSON_REQUEST.OK'))
                        );
                    }

                    function _failCancelHandler(response) {
                        $mdDialog.hide();
                        alert('Oh! Something unexpected happened!');
                        console.error(response);
                    }
                }
            }
        }


        function beginLesson() {
            location.href = vm.teacher.videoLink;
        }

        function _setTimezone(teacher) {
            var params = {
                id: teacher.userId,
                timezone: vm.timezone
            };
            apiResolver.resolve('timezone.setTimezone@post', params);
        }

        function _switchRoleIfNecessary() {
            var payload = $auth.getPayload();
            if(payload.role != 1) {
                api.auth.switchRole.post({token: $auth.getToken(), role: 'teacher'},
                    function(response) {
                        _updateToken(response.token);
                        _init();
                        _refreshRegularSchedule();
                        _refreshSpecificSchedule();
                    },
                    function(response) {
                        alert("Sorry, you don't have permission to visit this page.");
                        history.back();
                    }
                );
            } else {
                _init();
                _refreshRegularSchedule();
                _refreshSpecificSchedule();
            }
        }

        function _updateToken(token) {
            $auth.setToken(token);
            var payload = $auth.getPayload();
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            switch(payload.role) {
                case 0:
                    $rootScope.userRole = 'admin';
                    break;

                case 1:
                    $rootScope.userRole = 'teacher';
                    break;

                case 2:
                    $rootScope.userRole = 'student';
                    break;

                default:
                    console.error("Invalid Role");
                    break;
            }
        }

        function _init() {

            $q.all([
                _getTeacher(),
                _getReviews(),
                _getCourseRequests(),
                _getUpcomingClasses(),
                _getPreviousClasses(),
                _getReservedEvents(),
                _getPendingEvents(),
                _getSpecificHours(),
                _getRegularHours(),
                _getPackages(),
                _getEssayRequests()
            ]).then(function (response) {
                vm.teacher = response[0].data;
                vm.reviews = response[1].data;
                vm.courseRequests = $filter('orderBy')(response[2].data, 'start');
                vm.upcomingClasses = _pipeUpcomingClasses(response[3].data);
                vm.previousClasses = _pipePreviousClasses(response[4].data);
                vm.essayRequests = response[10].data;
                vm.isLoading = false;
                vm.hasMoreRequest = response[2].hasMore;
                vm.hasMoreUpcoming = response[3].hasMore;
                vm.hasMorePrevious = response[4].hasMore;
                vm.hasMoreEssayRequest = response[10].hasMore;
                _setTimezone(vm.teacher);

                if(vm.schedule.length) {
                    vm.schedule[0].splice(0, vm.schedule[0].length);
                    angular.forEach(scheduleMapper.mapForTeacher(response[5].data, response[6].data, response[7].data, response[8].data), function (schedule) {
                        vm.schedule[0].push(schedule);
                    });
                } else {
                    vm.schedule = [scheduleMapper.mapForTeacher(response[5].data, response[6].data, response[7].data, response[8].data)];
                }

            }, _errorHandler);

            readNotification();
        }

        function readNotification() {
            api.notifications.list.post({
                type: 1
            }, successReadHandler, _errorHandler);
        }

        function successReadHandler(response) {
            $rootScope.notifications = response.data;
        }

        function _getTeacher() {
            return apiResolver.resolve('teacher.byToken@get');
        }

        function _getReviews(type) {
            var number = 3;
            if(type) {

                number = vm.reviews.length + number;
                return apiResolver.resolve('review.list@get', {
                    limit: 5,
                    orderBy: 'created_at',
                    number: number
                });
            }
            else {
                return apiResolver.resolve('review.list@get', {
                    limit: 5,
                    orderBy: 'created_at',
                    number: number
                });
            }
        }

        function _getCourseRequests(type) {
            var number = 3;
            if(type) {

                number = vm.courseRequests.length + number;

                return apiResolver.resolve('statusCourseRequest.list@get' , { number: number, status: 1 } );

            }else {

                return apiResolver.resolve('statusCourseRequest.list@get' , { number: number, status: 1 } );

            }
        }

        function _getEssayRequests(type){
            var number = 3;
            if(type) {

                number = vm.essayRequests.length + number;
                return apiResolver.resolve('statusEssayRequest.list@get' , { number: number, status: 1 } );

            } else {

                return apiResolver.resolve('statusEssayRequest.list@get' , { number: number, status: 1 } );

            }
        }

        function _getReservedEvents() {
            var startDate = moment($rootScope.viewWeek).day("Sunday").subtract(2, 'days').format("YYYY-MM-DD");
            var endDate = moment($rootScope.viewWeek).day("Saturday").add(2, 'days').format("YYYY-MM-DD");
            return apiResolver.resolve('statusCourseTimes.list@get',{ startDate: startDate, endDate: endDate, status: 2 });
            // return apiResolver.resolve('schedule.list@get');
        }

        function _getPendingEvents() {
            var startDate = moment($rootScope.viewWeek).day("Sunday").subtract(2, 'days').format("YYYY-MM-DD");
            var endDate = moment($rootScope.viewWeek).day("Saturday").add(2, 'days').format("YYYY-MM-DD");
            return apiResolver.resolve('statusCourseTimes.list@get',{ startDate: startDate, endDate: endDate, status: 1 });
            // return apiResolver.resolve('pendingEvents.list@get');
        }

        function _getUpcomingClasses(type) {
            var number = 3;

            if(type) {
                number = vm.upcomingClasses.length + number;
            }

            var params = {
                startDate: moment().utc().format(),
                endDate: null,
                number: number,
                status: "2"
            };

            return apiResolver.resolve('statusCourseTimes.list@get', params);

        }

        function _getPreviousClasses(type) {

            var number = 3;

            if(type) {
                number = vm.previousClasses.length + number;
            }

            var params = {
                startDate: null,
                endDate: moment().utc().format(),
                number: number,
            };

            return apiResolver.resolve('statusCourseTimes.list@get', params);
        }

        function _getRegularHours() {
            var startDate = moment($rootScope.viewWeek).day("Sunday").subtract(2, 'days').format("YYYY-MM-DD");
            var endDate = moment($rootScope.viewWeek).day("Saturday").add(2, 'days').format("YYYY-MM-DD");

            return apiResolver.resolve('regularHours.list@get',{
                startDate: startDate,
                endDate: endDate,
            });
        }

        function _getSpecificHours() {
            var startDate = moment($rootScope.viewWeek).day("Sunday").subtract(2, 'days').format("YYYY-MM-DD");
            var endDate = moment($rootScope.viewWeek).day("Saturday").add(2, 'days').format("YYYY-MM-DD");

            return apiResolver.resolve('specificHours.list@get',{
                startDate: startDate,
                endDate: endDate,
            });
        }

        function _pipeUpcomingClasses(upcomingClasses) {
            angular.forEach(upcomingClasses, function(upcomingClass) {
                // Add startsIn property
                upcomingClass.startsIn = moment(upcomingClass.start).fromNow();
            });

            return $filter('orderBy')(upcomingClasses, 'start');
        }

        function _pipePreviousClasses(previousClasses) {
            angular.forEach(previousClasses, function(previousClass) {

                // Append startedAt property
                previousClass.startedAt = moment(previousClass.start).fromNow();
            });

            return $filter('orderBy')(previousClasses, '-start');
        }

        function _errorTimeHandler(response) {
            $mdDialog.hide();
            alert("Time format error");
            console.error(response);
        }

        function _errorHandler(response) {
            console.error(response);
        }

        function _removeReservedEvent(courseId) {
            angular.forEach(vm.schedule[0], function (schedule, index) {
                if (schedule.courseId == courseId) {
                    vm.schedule[0].splice(index, 1);
                }
            });
        }

        function _removePendingEvent(courseRequestId) {
            angular.forEach(vm.schedule[0], function (schedule, index) {
                if (schedule.lessonRequestId == courseRequestId) {
                    vm.schedule[0].splice(index, 1);
                }
            });
        }

        $scope.$on('newRequest', function(event){
            if ($rootScope.state.current.name == "app.pages_teacher-dashboard"){
                _getCourseRequests().then(
                    function(response) {
                        // Refresh view model
                        vm.courseRequests = response.data;
                        vm.hasMoreRequest = response.hasMore;
                    },
                    _errorHandler
                );
            }
        });

        function _eventClick(date, e, view) {
            console.log(date);
            $mdDialog.show(
                $mdDialog.confirm()
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title(date.studentName)
                    .textContent(date.start.utc().local().format('dddd, MMM DD, hh:mm A')+' - '+date.end.utc().local().format('hh:mm A'))
                    .ariaLabel('Start-End')
                    .cancel('Close')
                    .ok('Send Meesage')
            ).then(function() {
                $mdDialog.hide();
                api.teacher.byToken.get(null, function (response) {
                    $mdDialog.show({
                        controller         : 'MessageController',
                        controllerAs       : 'vm',
                        templateUrl        : 'app/main/dialogs/message/message.html',
                        parent             : angular.element($document.body),
                        clickOutsideToClose: true,
                        locals             : {
                            // student: date.studenId,
                            studentUserId: date.studentUserId,
                            studentName: date.studentName,
                            defaultMessage: ''
                        },
                    }).then(function() {
                        _refreshSchedule();
                    });
                });
            });
        }


        function _eventChange(lessontime, delta, revert, e, view) {
            var event = angular.copy(lessontime);
            revert(lessontime);
            event.actionType = 'drop';
            $mdDialog.show({
                controller         : 'CalendarDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/calendar-dialog/calendar-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent: event,
                },
            }).then(function (event) {
                if (event.actionType != 'cancel') {
                    _eventupdate(event);
                }
            });
        }

        function _eventupdate(lessontime) {
            // change the database here to update the class time similar to change of regular hours.
            waitForResponse();
            api.courseTimes.edit.put({
                id: lessontime.id,
                startTime: lessontime.start.toISOString(),
                endTime: lessontime.end.toISOString(),
            }, function (response) {
                $mdDialog.hide();
                _refreshSchedule();
                _getCourseRequests()
                .then(function(response) {
                    vm.courseRequests = $filter('orderBy')(response.data, 'start');
                    vm.hasMoreRequest = response.hasMore;
                });
                _getUpcomingClasses().then(
                function(response) {
                    // Refresh view model
                    vm.upcomingClasses = _pipeUpcomingClasses(response.data);
                    vm.hasMoreUpcoming = response.hasMore;
                },
                function(response) {
                    console.error(response);
                });
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .title('Your lesson has been modified.')
                        .textContent('')
                        .ariaLabel('')
                        .ok('OK')
                );
            }, _errorTimeHandler);
        }


        function _select(start, end, e) {
            var calendarEvent = {
                start: start,
                end: end,
            };
            _openLessonRequestDialog(e, calendarEvent);
        }

        function _openLessonRequestDialog(e, calendarEvent) {
            $mdDialog.show({
                controller         : 'LessonRequestController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/lesson-request/lesson-request.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false,
                locals             : {
                    teacher: vm.teacher,
                    calendarEvent: calendarEvent
                },
            }).then(function() {
                _refreshSchedule();
            });
        }

        $rootScope.$watch('isCreateRequestTeacher', function(newValue, oldValue) {
            if(newValue) {
                _getUpcomingClasses().then(
                    function(response) {
                        // Refresh view model
                        vm.upcomingClasses = _pipeUpcomingClasses(response.data);
                        vm.hasMoreUpcoming = response.hasMore;
                    },
                    function(response) {
                        console.error(response);
                    });
                _refreshSchedule();

            }
        });

        function _refreshSchedule() {
            $q.all([
                _getTeacher(),
                _getReservedEvents(),
                _getPendingEvents(),
                _getSpecificHours(),
                _getRegularHours(),
                _getPackages(),
            ]).then(function (response) {
                vm.teacher = response[0].data;
                vm.schedule[0].splice(0, vm.schedule[0].length);
                angular.forEach(scheduleMapper.mapForTeacher(response[1].data, response[2].data, response[3].data, response[4].data), function (schedule) {
                    vm.schedule[0].push(schedule);
                });
                vm.isLoading = false;
                _setTimezone(vm.teacher);
                $rootScope.isCreateRequestTeacher = false;

            }, _errorHandler);

            readNotification();
        }

        function eventDetailRegular(calendarEvent, e) {
            var event = angular.copy(calendarEvent);
            event.actionType = 'update';
            showEventDialogRegular(e, event);
        }

        function selectRegular(start, end, e) {
            var calendarEvent = {
                start: start,
                end: end,
                actionType: 'create',
            };

            showEventDialogRegular(e, calendarEvent);
        }

        function showEventDialogRegular(e, calendarEvent) {
            $mdDialog.show({
                controller         : 'CalendarDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/calendar-dialog/calendar-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent: calendarEvent,
                },
            }).then(function (regularHour) {
                switch (regularHour.actionType) {
                    case 'create':
                        createRegularHour(regularHour);
                        break;
                    case 'update':
                        updateRegularHour(regularHour);
                        break;
                    case 'destroy':
                        destroyRegularHour(regularHour);
                        break;
                }
                isSaved += 1;
            });
        }

        function _refreshRegularSchedule() {
            $q.all([
                _getRegularHours(),
            ]).then(function (response) {
                if (vm.regularSchedule.length) {
                    vm.regularSchedule[0].splice(0, vm.regularSchedule[0].length);
                    angular.forEach(specificAvailabilityMapper.mapForTeacher([], response[0].data, false), function (regularSchedule) {
                        vm.regularSchedule[0].push(regularSchedule);
                    });
                } else {
                    vm.regularSchedule = [specificAvailabilityMapper.mapForTeacher([], response[0].data, false)];
                }
            }, _errorHandler);

            readNotification();
        }

        function createRegularHour(regularHour) {
            var startDate = moment().day("Sunday").subtract(2, 'days').format("YYYY-MM-DD");
            var endDate = moment().day("Saturday").add(2, 'days').format("YYYY-MM-DD");
            api.regularHours.list.post({
                startTime: regularHour.start,
                endTime: regularHour.end,
                startDate: startDate,
                endDate: endDate,
            }, function (response) {
                _refreshRegularSchedule();
            }, _errorTimeHandler);
        }

        function changeEventRegular(regularHour, delta, revert) {
            if (confirm("Are you sure to drop on "+regularHour.start.toString()+"?")) {
                updateRegularHour(regularHour);
            }
            else {
                revert(regularHour);
            }
        }

        function resizeEventRegular(regularHour, delta, revert) {
            if (confirm("Are you sure to change the end time to "+regularHour.end.toString()+"?")) {
                updateRegularHour(regularHour);
            }
            else {
                revert(regularHour);
            }
        }

        function updateRegularHour(regularHour) {
            var startDate = moment().day("Sunday").subtract(2, 'days').format("YYYY-MM-DD");
            var endDate = moment().day("Saturday").add(2, 'days').format("YYYY-MM-DD");

            api.regularHours.byId.put({
                id: regularHour.id,
                startTime: regularHour.start.toISOString(),
                endTime: regularHour.end.toISOString(),
                startDate: startDate,
                endDate: endDate,
                isAvailable: true
            }, function (response) {
                _refreshRegularSchedule();
            }, _errorTimeHandler);

        }

        function destroyRegularHour(regularHour) {
            angular.forEach(vm.regularSchedule[0], function (event, key) {
                if (event.id == regularHour.id) {
                    vm.regularSchedule[0].splice(key, 1);
                }
            });

            api.regularHours.byId.delete({
                id: regularHour.id,
            }, function (response) {
                _refreshRegularSchedule();
            }, _errorHandler);
    }

        function eventDetailSpecific(calendarEvent, e) {
            var event = angular.copy(calendarEvent);
            event.actionType = 'update';
            showEventDialogSpecific(e, event);
        }

        function selectSpecific(start, end, e) {
            var calendarEvent = {
                start: start,
                end: end,
                actionType: 'create',
            };

            showEventDialogSpecific(e, calendarEvent);
        }

        function showEventDialogSpecific(e, calendarEvent) {
            $mdDialog.show({
                controller         : 'CalendarDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/calendar-dialog/calendar-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent: calendarEvent,
                },
            }).then(function (specificHour) {
                switch (specificHour.actionType) {
                    case 'create':
                        createSpecificHour(specificHour);
                        break;
                    case 'update':
                        updateSpecificHour(specificHour);
                        break;
                    case 'destroy':
                        destroySpecificHour(specificHour);
                        break;
                }
                isSaved += 1;
            });
        }

        function _refreshSpecificSchedule() {
            $q.all([
                _getSpecificHours(),
                _getRegularHours(),
            ]).then(function (response) {
                if(vm.specificSchedule.length) {
                    vm.specificSchedule[0].splice(0, vm.specificSchedule[0].length);
                    angular.forEach(specificAvailabilityMapper.mapForTeacher(response[0].data, response[1].data, true), function (specificSchedule) {
                        vm.specificSchedule[0].push(specificSchedule);
                    });
                } else {
                    vm.specificSchedule = [specificAvailabilityMapper.mapForTeacher(response[0].data, response[1].data, true)];
                }
            }, _errorHandler);

            readNotification();
        }

        function createSpecificHour(specificHour) {
            var regularHoursId = specificHour.id ? specificHour.id : null;

            api.specificHours.list.post({
                start: moment(specificHour.start),
                end: moment(specificHour.end),
                regularHoursId: regularHoursId,
                isAvailable: true
            }, function (response) {
                _refreshSpecificSchedule();
            }, _errorTimeHandler);
        }

        function changeEventSpecific(specificHour, delta, revert) {
            if (confirm("Are you sure to drop on "+specificHour.start.toString()+"?")) {
                updateSpecificHour(specificHour);
            }
            else {
                revert(specificHour);
            }
        }

        function resizeEventSpecific(specificHour, delta, revert) {
            if (confirm("Are you sure to change the end time to "+specificHour.end.toString()+"?")) {
                updateSpecificHour(specificHour);
            }
            else {
                revert(specificHour);
            }
        }

        function updateSpecificHour(specificHour) {
            if (specificHour.hasOwnProperty('regularHoursId')) {    // specificHour is not regular
                angular.forEach(vm.specificSchedule[0], function (event, key) {
                    if (event.id == specificHour.id) {
                        event.start = specificHour.start;
                        event.end = specificHour.end;
                    }
                });
                api.specificHours.byId.put({
                    id: specificHour.id,
                    start: specificHour.start.toISOString(),
                    end: specificHour.end.toISOString(),
                    regularHoursId: specificHour.regularHoursId,
                    isAvailable: true
                }, function (response) {
                    _refreshSpecificSchedule();
                }, _errorTimeHandler);
            } else {
                createSpecificHour(specificHour);
            }
        }

        function destroySpecificHour(specificHour) {

            if (specificHour.hasOwnProperty('regularHoursId')) {    // specificHour is not regular
                angular.forEach(vm.specificSchedule[0], function (event, key) {
                    if (event.id == specificHour.id) {
                        vm.specificSchedule[0].splice(key, 1);
                    }
                });
                api.specificHours.byId.delete({
                    id: specificHour.id,
                }, function (response) {
                    _refreshSpecificSchedule();
                }, _errorHandler);
            } else if (specificHour.id) {                           // specificHour is regular
                var regularHoursId = specificHour.id ? specificHour.id : null;
                angular.forEach(vm.regularSchedule[0], function (event, key) {
                    if (event.id == specificHour.id) {
                        vm.regularSchedule[0].splice(key, 1);
                    }
                });
                api.specificHours.list.post({
                    start: specificHour.start,
                    end: specificHour.end,
                    regularHoursId: regularHoursId,
                    isAvailable: false
                }, function (response) {
                    _refreshSpecificSchedule();
                }, _errorHandler);
            }
        }

        //show more 3 lesson request
        function showMore(type) {
            if(type == 'essayRequest') {
                _getCourseRequests(true)
                .then(function(response) {
                    vm.courseRequests = $filter('orderBy')(response.data, 'start');
                    vm.hasMoreRequest = response.hasMore;
                });
            }

            if(type == 'upcoming') {
                _getUpcomingClasses(true)
                .then(function(response) {
                    vm.upcomingClasses = _pipeUpcomingClasses(response.data);
                    vm.hasMoreUpcoming = response.hasMore;
                });
            }

            if(type == 'previous') {
                _getPreviousClasses(true)
                .then(function(response) {
                    vm.previousClasses = _pipePreviousClasses(response.data);
                    vm.hasMorePrevious = response.hasMore;
                });
            }

            if(type == 'reviews') {
                _getReviews(true)
                .then(function(response) {
                    vm.reviews = response.data;
                    vm.hasMoreReview = response.hasMore;
                });
            }

            if(type == 'essayRequest') {
                _getEssayRequests(true)
                .then(function(response) {
                    vm.essayRequests = $filter('orderBy')(response.data, 'submitTime');
                    vm.hasMoreEssayRequest = response.hasMore;
                });
            }
        }

        function dateFormatNoTime(date) {
            var year = date.getFullYear();
            var month = date.getMonth()+1;
            var day = date.getDate();
            if (month.toString().length === 1) {
                month = '0'+ month;
            }
            if (day.toString().length === 1) {
                day = '0' + day;
            }
            return year+"-"+month+"-"+day;
        }

         /**
         * Go to next on current view (week, month etc.)
         */
        function next() {
            vm.calendar.next();
            $rootScope.viewWeek = moment(vm.calendar.getDate()).format('YYYY-MM-DD');
            _refreshSchedule();
        }
        function nextSpecific() {
            vm.calendar.next();
            $rootScope.viewWeek = moment(vm.calendar.getDate()).format('YYYY-MM-DD');
            _refreshSpecificSchedule();
        }
        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev() {
            vm.calendar.prev();
            $rootScope.viewWeek = moment(vm.calendar.getDate()).format('YYYY-MM-DD');
            _refreshSchedule();
        }
        function prevSpecific() {
            vm.calendar.prev();
            $rootScope.viewWeek = moment(vm.calendar.getDate()).format('YYYY-MM-DD');
            _refreshSpecificSchedule();
        }

        //click button to show or hide 0am -6am
        function showOrHideAllTime(event) {
            var target = event.target;
            var curDate = dateFormatNoTime(vm.calendar.getCalendar().getDate()._d);
            vm.calendarUiConfig.defaultDate = curDate;
            if(target.getAttribute('name') == 'expand') {
                vm.calendarUiConfig.minTime = '00:00:00';
                vm.isExpand = true;
            }
            else {
                vm.calendarUiConfig.minTime = '06:00:00';
                vm.isExpand = false;
            }
            vm.regularCalendarUiConfig.defaultDate = curDate;
            if(target.getAttribute('name') == 'expand') {
                vm.regularCalendarUiConfig.minTime = '00:00:00';
                vm.isExpand = true;
            }
            else {
                vm.regularCalendarUiConfig.minTime = '06:00:00';
                vm.isExpand = false;
            }
            vm.specificCalendarUiConfig.defaultDate = curDate;
            if(target.getAttribute('name') == 'expand') {
                vm.specificCalendarUiConfig.minTime = '00:00:00';
                vm.isExpand = true;
            }
            else {
                vm.specificCalendarUiConfig.minTime = '06:00:00';
                vm.isExpand = false;
            }
        }

        // click button to show one day or one week schedule
        function DayOrWeekly(event) {
            var target = event.target;
            var curDate = dateFormatNoTime(vm.calendar.getCalendar().getDate()._d);
            vm.calendarUiConfig.defaultDate = curDate;
            if (target.getAttribute('name') == 'weekly') {
                vm.calendarUiConfig.defaultView = 'agendaWeek';
                vm.isAgendaDay = false;
            } else {
                vm.calendarUiConfig.defaultView = 'agendaDay';
                vm.isAgendaDay = true;
            }
            vm.regularCalendarUiConfig.defaultDate = curDate;
            if (target.getAttribute('name') == 'weekly') {
                vm.regularCalendarUiConfig.defaultView = 'agendaWeek';
                vm.isAgendaDay = false;
            } else {
                vm.regularCalendarUiConfig.defaultView = 'agendaDay';
                vm.isAgendaDay = true;
            }
            vm.specificCalendarUiConfig.defaultDate = curDate;
            if (target.getAttribute('name') == 'weekly') {
                vm.specificCalendarUiConfig.defaultView = 'agendaWeek';
                vm.isAgendaDay = false;
            } else {
                vm.specificCalendarUiConfig.defaultView = 'agendaDay';
                vm.isAgendaDay = true;
            }
        }

        //click button to show or hide availability
        function toggleAvailability(event) {
            var target = event.target;
            if(target.getAttribute('name') == 'availability') {
                var curDate = dateFormatNoTime(vm.calendar.getCalendar().getDate()._d);
                $rootScope.viewWeek = moment(vm.calendar.getDate()).format('YYYY-MM-DD');
                vm.regularCalendarUiConfig.defaultDate = curDate;
                vm.specificCalendarUiConfig.defaultDate = curDate;
                _refreshRegularSchedule();
                _refreshSpecificSchedule();
                vm.isAvailability = true;
            }
            else {
                var curDate = dateFormatNoTime(vm.calendar.getCalendar().getDate()._d);
                vm.calendarUiConfig.defaultDate = curDate;
                _refreshSchedule();
                vm.isAvailability = false;
            }
        }

        //switch to show or hide availability
        function toggleSpecific() {
            if(vm.switchTitle == 'Specific Weekly Schedule') {
                var curDate = dateFormatNoTime(vm.calendar.getCalendar().getDate()._d);
                $rootScope.viewWeek = moment(vm.calendar.getDate()).format('YYYY-MM-DD');
                vm.specificCalendarUiConfig.defaultDate = curDate;
                _refreshSpecificSchedule();
                vm.isSpecific = true;
            } else {
                vm.calendar.today();
                var curDate = dateFormatNoTime(vm.calendar.getCalendar().getDate()._d);
                vm.regularCalendarUiConfig.defaultDate = curDate;
                $rootScope.viewWeek = moment(vm.calendar.getDate()).format('YYYY-MM-DD');
                _refreshRegularSchedule();
                vm.isSpecific = false;
            }
        }

        function goToEssay(index){
            $state.go('app.pages_view-essay', { id: index });
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        _switchRoleIfNecessary();
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.teacher')
        .controller('TeacherController', TeacherController);

    /** @ngInject */
    function TeacherController(
        $auth,
        $mdDialog,
        $document,
        $sce,
        $rootScope,
        $state,
        $filter,
        $anchorScroll,
        $location,
        $q,
        $mdSidenav,
        $timeout,
        $stateParams,
        api,
        apiResolver,
        teacher,
        reviews,
        reservedEvents,
        pendingEvents,
        specificHours,
        regularHours,
        scheduleMapper,
        StripeService,
        constRoles,
        constPackageTransaction)
    {
        var vm = this;
        _switchRoleIfNecessary();
        var payload;
        vm.packages = [];

        // methods
        vm.purchasePackage = purchasePackage;

        // Functions
        function _init(){

            // Check if teacher's profile is public
            if (!teacher.data) {
                $state.go($rootScope.previousState);

                $mdDialog.show(
                     $mdDialog.confirm()
                         .clickOutsideToClose(true)
                         .parent(angular.element(document.body))
                         .title('Oops!')
                         .textContent($filter('translate')('TEACHER.NO_PUBLIC_PROFILE'))
                         .ariaLabel($filter('translate')('TEACHER.NO_PUBLIC_PROFILE'))
                         .ok('OK')
                );

                // goToLandingPage();
                // $mdDialog.show(
                //     $mdDialog.confirm()
                //         .clickOutsideToClose(true)
                //         .parent(angular.element(document.body))
                //         .title('WARNING')
                //         .textContent('This teacher does not turn on public profile, yet')
                //         .ariaLabel('This teacher does not turn on public profile, yet')
                //         .ok('Okay')
                // )
                // .then(goToLandingPage);
            }

            // TODO: REFACTOR IT WHEN TIME IS ENOUGH
            else {

                var videoUrl = teacher.data.introVideo;
                var videoUrlYouku = teacher.data.introVideoYouku;
                payload = $auth.getPayload();
                //change calendar view by screen
                if(screen.width < 640) {
                    var calendarUiConfig = {
                        editable          : false,
                        // eventClick        : _eventClick,
                        eventLimit        : true,
                        header            : '',
                        handleWindowResize: false,
                        aspectRatio       : 1,
                        height: 1130,
                        dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                        dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                        viewRender        : function (view)
                        {
                            vm.calendarView = view;
                            vm.calendar = vm.calendarView.calendar;
                        },
                        columnFormat      : {
                            month: 'ddd',
                            week : 'ddd D',
                            day  : 'ddd M/D'
                        },
                        selectable        : ! isTeacher(),
                        selectHelper      : true,
                        selectOverlap     :  function(event) {
                            return event.rendering === 'background';
                        },
                        defaultView       : 'agendaDay',
                        timezone          : 'local',
                        select            : _select,
                        minTime           : '06:00:00',
                        maxTime           : '24:00:00',
                        longPressDelay    : 300
                    },
                    isAgendaDay = true;
                }
                else {
                    var calendarUiConfig = {
                        editable          : false,
                        // eventClick        : _eventClick,
                        eventLimit        : true,
                        header            : '',
                        handleWindowResize: false,
                        aspectRatio       : 1,
                        height: 1130,
                        dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                        dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                        viewRender        : function (view)
                        {
                            vm.calendarView = view;
                            vm.calendar = vm.calendarView.calendar;
                        },
                        columnFormat      : {
                            month: 'ddd',
                            week : 'ddd D',
                            day  : 'ddd M/D'
                        },
                        selectable        : ! isTeacher(),
                        selectHelper      : true,
                        selectOverlap     :  function(event) {
                            return event.rendering === 'background';
                        },
                        defaultView       : 'agendaWeek',
                        timezone          : 'local',
                        select            : _select,
                        minTime           : '06:00:00',
                        maxTime           : '24:00:00',
                        longPressDelay    : 500
                    },
                    isAgendaDay = false;
                }
                // The structure of schedule must be {events: []} or [[]]. First one will lead array reduce error but still can work
                var schedule = [scheduleMapper.mapForGuest(reservedEvents.data, pendingEvents.data, specificHours.data, regularHours.data)];

                // Data
                vm.calendarUiConfig = calendarUiConfig;
                vm.timezone = moment().format('ZZ');
                vm.teacher = {
                    info: teacher.data,
                    reviews: reviews.data,
                    schedule: schedule,
                };

                vm.teacher.info.introVideo = videoUrl ? videoUrlHandling(videoUrl) : null;
                vm.teacher.info.introVideoYouku = videoUrlYouku ? $sce.trustAsResourceUrl(videoUrlYouku) : null;
                vm.teacher.info.schedulePolicy = vm.teacher.info.schedulePolicy ? vm.teacher.info.schedulePolicy : '0.00';
                vm.teacher.info.cancelPolicy = vm.teacher.info.cancelPolicy ? vm.teacher.info.cancelPolicy : '0.00';

                vm.pagination = {
                    totalItems: reviews.data.length,
                    currentPage: 1,
                    itemsPerPage: 5,
                    maxSize: 5,
                    setPage: _setPage,
                };

                //check status collapse/expand
                vm.isExpand = false;

                // check status daily/weekly
                vm.isAgendaDay = isAgendaDay;
                // Check if it's preview mode
                if (payload) {
                    $rootScope.isPreviewMode = isCurrentTeacher() && isTeacherIntroPage();
                }

                // Methods
                vm.isGuest = isGuest;
                vm.isTeacher = isTeacher;
                vm.isCurrentTeacher = isCurrentTeacher;
                vm.isTeacherIntroPage = isTeacherIntroPage;
                vm.openMessageDialog = openMessageDialog;
                vm.goToSchedule = goToSchedule;
                vm.goToEssayReview = goToEssayReview;
                vm.goToSignup = goToSignup;
                vm.openRightMenu = toggleMenu;
                vm.next = next;
                vm.prev = prev;
                vm.showOrHideAllTime = showOrHideAllTime;
                vm.DayOrWeekly = DayOrWeekly;
                vm.registerStudent = registerStudent;

                getPackageInfo();
            }

            if ($stateParams.rebook){
                $timeout(function() {
                    $location.hash('anchor-schedule');
                    $anchorScroll();
                }, 400);
            }
        }

        // Functions
        function getPackageInfo() {
            var params = {
                token: $auth.getToken(),
                id: vm.teacher.info.id
            }
            api.packages.check.get(params,
                function(response) {
                    console.log(response.data);
                    vm.packages = response.data;
                },
                function(error) {
                  console.log(error);
                }
            );
        }

        function purchasePackage(id, name, packagePrice, hours) {
          StripeService.openPopup({
              name: name,
              description: "Purchase Package: " + name,
              amount: packagePrice * 100,
              currency: 'usd'
          }, function (token) {
              waitForResponse();
              var params = {
                  token: $auth.getToken(),
                  token_id: token.id,
                  price: packagePrice,
                  package_id: id,
                  hours: hours,
                  transaction_type: constPackageTransaction.CREDIT_CARD_PURCHASE
              };

              api.packages.purchase.post(params,
                  function(response) {
                      _successsPurchasePackageCallback();
                  },
                  function(error) {
                      _errorHandler(error);
                  }
              );
          });
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function _successsPurchasePackageCallback() {
            $mdDialog.hide();
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('You have successfully purchased the package.')
                .textContent('')
                .ariaLabel('')
                .ok('OK')
            );
        }

        function _switchRoleIfNecessary() {
            var payload = $auth.getPayload();

            if ($auth.isAuthenticated()){

                if(payload.role != 2) {
                    api.auth.switchRole.post({token: $auth.getToken(), role: 'student'},
                        function(response) {
                            _updateToken(response.token);
                            _init();
                        },

                        function(response) {
                            alert("Sorry, you don't have permission to visit this page.");
                            history.back();
                        }
                    );
                }
                else {
                    _init();
                }
            }
            else {
                _init();
            }
        }

        function _updateToken(token) {
            $auth.setToken(token);
            var payload = $auth.getPayload();
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            switch(payload.role) {
                case 0:
                    $rootScope.userRole = 'admin';
                    break;

                case 1:
                    $rootScope.userRole = 'teacher';
                    break;

                case 2:
                    $rootScope.userRole = 'student';
                    break;

                default:
                    console.error("Invalid Role");
                    break;
            }
        }

        function isGuest() {
            return payload === undefined;
        }

        function isTeacher() {
            return payload ? (payload.role == constRoles.TEACHER) : null;
        }

        function isCurrentTeacher() {
            var isCurrentUser = (payload.id == vm.teacher.info.id);

            return payload ? (isTeacher() && isCurrentUser) : null;
        }

        function isTeacherIntroPage() {
            return $rootScope.state.current.name === 'app.pages_teacher';
        }

        function openMessageDialog() {
            api.student.byToken.get(null, function (response) {
                $mdDialog.show({
                    controller         : 'MessageDialogController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/pages/teacher/dialogs/message/message-dialog.html',
                    parent             : angular.element($document.body),
                    clickOutsideToClose: true,
                    locals             : {
                        teacher: vm.teacher,
                        defaultMessage: response.data.interestedField
                    },
                });
            });
        }

        function goToSchedule() {
            $location.hash('anchor-schedule');
            $anchorScroll();
        }

        function _addStyle(element) {
            if (element.rendering === "background") {
                element.backgroundColor = '#fff3e0';
            } else {
                element.backgroundColor = 'rgba(255, 183, 77, 0.8)';
                element.borderColor = '#ffb74d';
            }
        }

        function _setPage() {
            vm.pagination.begin = ((vm.pagination.currentPage - 1) * vm.pagination.itemsPerPage);
        }

        // Only support YouTube
        function videoUrlHandling(url) {
            var videoBaseUrl = 'https://www.youtube.com/embed/';
            var videoId = url.slice(url.lastIndexOf('=') + 1);

            return $sce.trustAsResourceUrl(videoBaseUrl + videoId);
        }

        function goToLandingPage() {
            $state.go('app.pages_landing');
        }

        function goToEssayReview() {
            if (payload) {
                $state.go('app.pages_essay-review', {id: vm.teacher.info.id});
            }
            else {
                registerStudent();
            }
        }

        function goToSignup() {
            sessionStorage.setItem("backUrl",$location.absUrl());
            $state.go('app.pages_auth_register');
        }

        function registerStudent(){
            $mdDialog.show({
                controller         : 'RegisterStudentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/register-student/register-student.html',
                parent             : angular.element($document.body),
                fullscreen: true,
            });
        }

        function _eventClick(date, jsEvent, view) {
            $mdDialog.show(
                 $mdDialog.confirm()
                     .clickOutsideToClose(true)
                     .parent(angular.element(document.body))
                     .title(date.title+' class with '+date.studentName)
                     .textContent(date.start.utc().format('MMM DD, hh:mm A')+' - '+date.end.utc().format('MMM DD, hh:mm A'))
                     .ariaLabel('Start-End')
                     .ok('OK')
            );
        }

        function _select(start, end, e) {
            var calendarEvent = {
                start: start,
                end: end,
            };
            _openLessonRequestDialog(e, calendarEvent);
        }

        function _openLessonRequestDialog(e, calendarEvent) {
            $mdDialog.show({
                controller         : 'LessonRequestController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/lesson-request/lesson-request.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false,
                fullscreen         : true,
                locals             : {
                    teacher: vm.teacher,
                    calendarEvent: calendarEvent
                },
            }).then(function() {
                var today = new Date();
                if(today.getMonth() == vm.calendar.getCalendar().getDate()._d.getMonth() && today.getDate() == vm.calendar.getCalendar().getDate()._d.getDate()) {
                    var startDate = vm.calendar.getCalendar().getDate()._d;
                    var startDate = new Date();
                    var endDate = new Date();
                    var day = startDate.getDay();
                    if(day == 0) {
                        endDate.setDate(endDate.getDate()+6);
                    }
                    else{
                        startDate.setDate(startDate.getDate()-day);
                        endDate.setDate(endDate.getDate()+(6-day));
                    }
                    function dateFormat(date) {
                        if(date < new Date() ) {
                            date.setHours(0,0,0);
                        }else {
                            date.setHours(24,0,0);
                        }
                        return date;
                    }
                    startDate = moment(dateFormat(startDate)).utc().format();
                    endDate = moment(dateFormat(endDate)).utc().format();
                }
                else {
                    var startDate = vm.calendar.getCalendar().getDate()._d;
                    var endDate = vm.calendar.getCalendar().getDate()._d;
                    startDate.setHours(0,0,0);
                    endDate.setHours(24,0,0);
                    endDate.setDate(endDate.getDate()+6);
                    startDate = moment(startDate).utc().format();
                    endDate = moment(endDate).utc().format();
                }
                _refreshSchedule(startDate,endDate);
            });
        }

        $rootScope.$watch('isCreateRequest', function(newValue, oldValue) {
            if(newValue) {

                var today = new Date();
                if(today.getMonth() == vm.calendar.getCalendar().getDate()._d.getMonth() && today.getDate() == vm.calendar.getCalendar().getDate()._d.getDate()) {
                    var startDate = vm.calendar.getCalendar().getDate()._d;
                    var startDate = new Date();
                    var endDate = new Date();
                    var day = startDate.getDay();
                    if(day == 0) {
                        endDate.setDate(endDate.getDate()+6);
                    }
                    else{
                        startDate.setDate(startDate.getDate()-day);
                        endDate.setDate(endDate.getDate()+(6-day));
                    }
                    function dateFormat(date) {
                        if(date < new Date() ) {
                            date.setHours(0,0,0);
                        }else {
                            date.setHours(24,0,0);
                        }
                        return date;
                    }
                    startDate = moment(dateFormat(startDate)).utc().format();
                    endDate = moment(dateFormat(endDate)).utc().format();
                }
                else {
                    var startDate = vm.calendar.getCalendar().getDate()._d;
                    var endDate = vm.calendar.getCalendar().getDate()._d;
                    startDate.setHours(0,0,0);
                    endDate.setHours(24,0,0);
                    endDate.setDate(endDate.getDate()+6);
                    startDate = moment(startDate).utc().format();
                    endDate = moment(endDate).utc().format();
                }
                _refreshSchedule(startDate,endDate);

            }
        });

        function _refreshSchedule(startDate,endDate) {
            $q.all([_getReservedEvents(startDate,endDate),
                    _getPendingEvents(startDate,endDate),
                    _getSpecificHours(startDate,endDate),
                    _getRegularHours(startDate,endDate)
            ]).then(function (response) {
                // This is workaround. We can’t replace Ui Calendar events source. Only we can do is empty event and re-push it.
                vm.teacher.schedule[0].splice(0, vm.teacher.schedule[0].length);
                angular.forEach(scheduleMapper.mapForGuest(response[0].data, response[1].data, response[2].data, response[3].data), function (schedule) {
                    vm.teacher.schedule[0].push(schedule);
                });
                $rootScope.isCreateRequest = false;
            }, _errorHandler);
        }

        function _getReservedEvents(startDate,endDate) {
            return apiResolver.resolve('publicCourseTimes.byTeacher@get', { teacherId: teacher.data.id ,startDate: startDate , endDate: endDate, status: 2 });
            // return apiResolver.resolve('schedule.byTeacher@get', { teacherId: teacher.data.id ,startDate: startDate , endDate: endDate });
        }

        function _getPendingEvents(startDate,endDate) {
            return apiResolver.resolve('publicCourseTimes.byTeacher@get',{ teacherId: teacher.data.id, startDate: startDate, endDate: endDate, status: 1 });
            // return apiResolver.resolve('pendingEvents.byTeacher@get', { teacherId: teacher.data.id ,startDate: startDate , endDate: endDate });
        }

        function _getSpecificHours(startDate,endDate) {
            return apiResolver.resolve('specificHours.byTeacher@get', { teacherId: teacher.data.id ,startDate: startDate , endDate: endDate });
        }

        function _getRegularHours(startDate,endDate) {
            return apiResolver.resolve('regularHours.byTeacher@get', { teacherId: teacher.data.id ,startDate: startDate , endDate: endDate });
        }

        function _errorHandler(response) {
            $mdDialog.hide();
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

        function toggleMenu() {
            $mdSidenav('right').toggle();
        }

        function next() {
            vm.calendar.next();
            var startDate = vm.calendar.getCalendar().getDate()._d;
            var endDate = vm.calendar.getCalendar().getDate()._d;
            startDate.setHours(0,0,0);
            endDate.setHours(24,0,0);
            endDate.setDate(endDate.getDate()+6);
            startDate = moment(startDate).utc().format();
            endDate = moment(endDate).utc().format();
            _refreshSchedule(startDate,endDate);
        }

        function prev() {
            vm.calendar.prev();
            var startDate = vm.calendar.getCalendar().getDate()._d;
            var endDate = vm.calendar.getCalendar().getDate()._d;
            startDate.setHours(0,0,0);
            endDate.setHours(24,0,0);
            endDate.setDate(endDate.getDate()+6);
            startDate = moment(startDate).utc().format();
            endDate = moment(endDate).utc().format();
            _refreshSchedule(startDate,endDate);
        }

        function dateFormat(date) {
            var year = date.getFullYear();
            var month = date.getMonth()+1;
            var day = date.getDate();
            return year+"-"+month+"-"+day+" "+"00:00:00";
        }

        function dateFormatNoTime(date) {
            var year = date.getFullYear();
            var month = date.getMonth()+1;
            var day = date.getDate();
            if (month.toString().length === 1) {
                month = '0'+ month;
            }
            if (day.toString().length === 1) {
                day = '0' + day;
            }
            return year+"-"+month+"-"+day;
        }
        //click button to show or hide 0am -6am
        function showOrHideAllTime(event) {
            var target = event.target;
            var curDate = dateFormatNoTime(vm.calendar.getCalendar().getDate()._d);
            vm.calendarUiConfig.defaultDate = curDate;
            if(target.getAttribute('name') == 'expand') {
                vm.calendarUiConfig.minTime = '00:00:00';
                vm.isExpand = true;
            }
            else {
                vm.calendarUiConfig.minTime = '06:00:00';
                vm.isExpand = false;
            }
        }

        // click button to show one day or one week schedule
        function DayOrWeekly(event) {
            var target = event.target;
            var curDate = dateFormatNoTime(vm.calendar.getCalendar().getDate()._d);
            vm.calendarUiConfig.defaultDate = curDate;
            if (target.getAttribute('name') == 'weekly') {
                vm.calendarUiConfig.defaultView = 'agendaWeek';
                vm.isAgendaDay = false;
            } else {
                vm.calendarUiConfig.defaultView = 'agendaDay';
                vm.isAgendaDay = true;

            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.teach-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_teach-form', {
            url      : '/teach-form',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/teach-form/teach-form.html',
                    controller : 'TeachFormController as vm'
                }
            },
            bodyClass: 'teach-form',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/teach-form');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.teach-form')
        .controller('TeachFormController', TeachFormController);

    /** @ngInject */
    function TeachFormController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku = contactNesuku;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.student-dashboard', [
            'ui.calendar',
            'app.dialogs.edit-profile-pic',
            'app.dialogs.change-password',
            'app.dialogs.rate'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_student-dashboard', {
            url      : '/student-dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/student-dashboard/student-dashboard.html',
                    controller : 'StudentDashboardController as vm'
                }
            },
            bodyClass: 'student-dashboard',
            requireLogin: true,
            params: {
                id: null,
                rebook: null
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/student-dashboard');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.student-dashboard')
        .controller('StudentDashboardController', StudentDashboardController);

    /** @ngInject */
    function StudentDashboardController(
        $rootScope,
        $q,
        $auth,
        $filter,
        $state,
        $stateParams,
        $mdDialog,
        $document,
        api,
        apiResolver,
        scheduleMapper,
        StripeService,
        constNesukuEmail,
        $scope)
    {
        var vm = this;
        var payload = $auth.getPayload();
        var calendarUiConfig = {
            editable          : false,
            eventLimit        : true,
            header            : '',
            handleWindowResize: false,
            aspectRatio       : 1,
            dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
            dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            viewRender        : function (view)
            {
                vm.calendarView = view;
                vm.calendar = vm.calendarView.calendar;
            },
            columnFormat      : {
                month: 'ddd',
                week : 'ddd D',
                day  : 'ddd M'
            },
            selectable        : false,
            selectHelper      : true,
            defaultView       : 'agendaWeek',
            timezone          : 'local'
        };

        $rootScope.currentNavItem = 'Student Dashboard';
        $rootScope.overlayMessage = null;


        // Data
        vm.isLoading = true;
        vm.defaultAvatar = '/assets/images/avatars/profile.jpg';
        vm.user = {};
        vm.student = {};
        vm.courseRequests = [];
        vm.upcomingClasses = [];
        vm.previousClasses = [];
        vm.calendarUiConfig = calendarUiConfig;
        vm.timezone = moment().format('Z');
        vm.dateFormat = 'MMM d';
        vm.dayDateFormat = 'EEEE, MMM d,';
        vm.timeFormat= 'h:mm a';
        vm.isRebook = false;

        // The structure of schedule must be {events: []} or [[]]. First one will lead array reduce error but still can work
        vm.schedule = [];
        vm.balance = 0;
        vm.openBalance = false;
        vm.openPackage = false;

        // packageTeachers sample
        // {
        //     teacherName: "TestTeacher A",
        //     packages: [
        //         {
        //             packageName: "Package 1",
        //             remainingHours: 15
        //         },
        //         {
        //             packageName: "Package 2",
        //             remainingHours: 12
        //         }
        //     ],
        //     openTab: false,
        // }
        vm.packageTeachers = [];


        // Methods
        vm.contactNesuku = contactNesuku;
        vm.openAvatarDialog = openAvatarDialog;
        vm.openPasswordDialog = openPasswordDialog;
        vm.openRateDialog = openRateDialog;
        vm.saveIntroductoryMessage = saveIntroductoryMessage;
        vm.cancelRequest = cancelRequest;
        vm.beginLesson = beginLesson;
        vm.cancelCourse = cancelCourse;
        vm.viewProfile = viewProfile;
        vm.report = report;
        vm.rebook = rebook;
        vm.showMore = showMore;
        vm.checkPolicy = checkPolicy;
        vm.walletDeposit = walletDeposit;
        vm.goToEssay = goToEssay;
        vm.goToAccountSettings = goToAccountSettings;


        // Functions
        function _successWalletSaveCallBack(){
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Success!')
                .textContent('')
                .ariaLabel('')
                .ok('OK')
            );
        }

        function initPackage() {
            var params = {
              token: $auth.getToken()
            };
            api.packages.list.get(params,
                function(response) {
                    // create packages
                    var packages = {};
                    response.data.forEach(function (value, index, data){
                        var curPackage = {
                            packageName: value['packageName'],
                            remainingHours: value['remainingHours']
                        };
                        if (value.teacherName in packages) {
                            packages[value.teacherName].push(curPackage);
                        }
                        else {
                            packages[value.teacherName] = [curPackage];
                        }
                    });

                    for (var item in packages) {
                        var curPackages = {teacherName: item, packages: []};
                        packages[item].forEach(function (curPackage, index, data) {
                            curPackages.packages.push({packageName: curPackage.packageName, remainingHours: curPackage.remainingHours});
                        });
                        vm.packageTeachers.push(curPackages);
                    }
                },
                function(err) {
                    console.log(err);
                }
            );
        }

        function goToAccountSettings() {
            $state.go('app.pages_account-settings');
        }

        function walletDeposit() {
            var walletDepositContent = ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px;" aria-label="Deposit"> \
                    <md-toolbar class="md-accent md-hue-2" style="background-color:#fff;"> \
                        <div class="md-toolbar-tools" layout="row" layout-align="space-between center">\
                            <span class="dialog-title" style="color:black;font-weight:bold;">Deposit</span>\
                            <md-button class="md-icon-button" ng-click="closeDialog()" aria-label="Close dialog">\
                                <md-icon md-font-icon="icon-close" style="color:black;"></md-icon>\
                            </md-button>\
                        </div>\
                    </md-toolbar>\
                    <md-dialog-content ms-scroll> \
                        <p>Enter the amount you want to deposit:</p> \
                        <md-input-container class="md-block" > \
                            <input type="number" style="font-size: 25px;" name="depositAmount" ng-model="depositAmount" min=1> \
                        </md-input-container> \
                        <section style="text-align: right;"> \
                            <md-button ng-click="closeDialog()" class="md-primary md-raised"> \
                                Cancel \
                            </md-button> \
                            <md-button ng-click="walletDepositAPI()" class="md-primary md-raised" ng-disabled="!depositAmount"> \
                                Confirm \
                            </md-button> \
                        </section> \
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : walletDepositContent,
                locals              : {depositAmount: vm.depositAmount},
                bindToController    : true,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WalletDepositController,
            });

            function WalletDepositController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    vm.openBalance = false;
                    $mdDialog.hide();
                }
                $scope.walletDepositAPI = function() {
                    $mdDialog.hide();
                    StripeService.openPopup({
                        name: "Nesuku",
                        description: "Wallet Deposit",
                        amount: ($scope.depositAmount * 100).toFixed(2),
                        currency: 'usd'
                    }, function (token) {
                        var params = {
                            amount: $scope.depositAmount,
                            token: $auth.getToken(),
                            token_id: token.id
                        };
                        waitForResponse();
                        api.wallet.deposit.post(params,
                            function(response) {
                                console.log(response);
                                vm.balance = response.data.balance;
                                _successWalletSaveCallBack();
                            },
                            function(error) {
                                _errorCallback(error);
                            }
                        );
                    });
                    vm.openBalance = false;
                }
            }
        }

        function contactNesuku() {
            location.href = constNesukuEmail;
        }

        function openAvatarDialog() {
            $mdDialog.show({
                controller         : 'EditProfilePicController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/edit-profile-pic/edit-profile-pic.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {
                    teacher: vm.user,
                },
            });
        }

        function openPasswordDialog() {
            $mdDialog.show({
                controller         : 'ChangePasswordController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/change-password/change-password.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {},
            });
        }

        function openRateDialog(index) {
            $mdDialog.show({
                controller         : 'RateController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/rate/rate.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {
                    lesson: vm.previousClasses[index],
                },
            });
        }

        function saveIntroductoryMessage() {
            var params = {
                'interestedField': vm.student.interestedField
            };

            api.student.introMessage.put(params, _successSaveIntroCallback, _errorCallback);
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function checkPolicy(course, index) {
            console.log('checkPolicy');
            console.log(course);
            console.log(index);
            var courseTime = moment(course.start);
            var policyHours = course.teacherCancelPolicy ? course.teacherCancelPolicy : '0.00';
            console.log(courseTime);
            console.log(policyHours);
            var fromNowHours = courseTime.diff(moment(), 'hours', true);
            console.log(fromNowHours);
            if(fromNowHours > policyHours) {
                console.log('PASS checkPolicy');
                cancelCourse(index, course); //cancelCourse(index) -> cancelCourse(index, course)
            } else {
                console.log('FAIL checkPolicy');
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .title($filter('translate')('STUDENT_DASHBOARD.CANCEL_CLASS'))
                        .textContent('Student must cancel ' + policyHours + ' hours before the lesson start time')
                        .ariaLabel('')
                        .ok('OK')
                  );
            }
        }

        function cancelRequest(index, courseRequest) {
            var cancelRequestContent = ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px;" aria-label="Category saved"> \
                    <md-toolbar class="md-accent md-hue-2" style="background-color:#fff;"> \
                        <div class="md-toolbar-tools" layout="row" layout-align="space-between center">\
                            <span class="dialog-title" style="color:black;font-weight:bold;">Cancel Lesson?</span>\
                            <md-button class="md-icon-button" ng-click="closeDialog()" aria-label="Close dialog">\
                                <md-icon md-font-icon="icon-close" style="color:black;"></md-icon>\
                            </md-button>\
                        </div>\
                    </md-toolbar>\
                    <md-dialog-content ms-scroll> \
                        <p>Send a message to the teacher (optional)</p> \
                        <md-input-container class="md-block" > \
                            <input type="text" style="font-size: 12px;" name="message" ng-model="message"> \
                        </md-input-container> \
                        <section style="text-align: right;"> \
                            <md-button ng-click="closeDialog()" class="md-primary md-raised"> \
                                No \
                            </md-button> \
                            <md-button ng-click="cancelRequestAPI()" class="md-primary md-raised"> \
                                Yes \
                            </md-button> \
                        </section> \
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : cancelRequestContent,
                locals              : {message: vm.message},
                bindToController    : true,
                clickOutsideToClose : true,
                parent              : angular.element(document.body),
                controller          : CancelRequestController,
            });

            function CancelRequestController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
                $scope.cancelRequestAPI = function() {


                    var params = {
                        id: courseRequest.id,
                        message: $scope.message,
                    };

                    vm.courseRequests.splice(index, 1);

                    _removePendingEvent(courseRequest.id);

                    waitForResponse();

                    api.courseRequest._cancel.put(params, _successCancelRequestHandler, _errorCallback);
                }
            }
        }

        function _successCancelRequestHandler(response) {

            vm.balance = parseFloat(vm.balance) + parseFloat(response.data.wallet_increament);

            // update package hours
            for (var i = 0; i < vm.packageTeachers.length; ++i) {
                console.log(vm.packageTeachers[i]);
                if (vm.packageTeachers[i].teacherName == response.data.teacher_name) {

                    for (var j = 0; j < vm.packageTeachers[i].packages.length; ++j) {
                        if (vm.packageTeachers[i].packages[j].packageName == response.data.package_name) {
                            vm.packageTeachers[i].packages[j].remainingHours += response.data.package_increament;
                        }
                    }
                }
            }

            _getCourseRequests().then(
              function (response) {
                vm.courseRequests = response.data;
                vm.hasMoreCourseRequest = response.hasMore;
              },
              _errorCallback
            );
            $mdDialog.hide();
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('You have successfully cancelled the lesson request.')
                .textContent('')
                .ariaLabel('')
                .ok('OK')

                .title('You have successfully cancelled the lesson request.')
                .textContent('')
                .ariaLabel('')
                .ok($filter('translate')('LESSON_REQUEST.OK'))
            );
        }

        function beginLesson (link) {
            location.href = link;
        }

        function cancelCourse(index, course) {
            var cancelCourseContent = ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px;" aria-label="Category saved"> \
                    <md-toolbar class="md-accent md-hue-2" style="background-color:#fff;"> \
                        <div class="md-toolbar-tools" layout="row" layout-align="space-between center">\
                            <span class="dialog-title" style="color:black;font-weight:bold;">Cancel Lesson?</span>\
                            <md-button class="md-icon-button" ng-click="closeDialog()" aria-label="Close dialog">\
                                <md-icon md-font-icon="icon-close" style="color:black;"></md-icon>\
                            </md-button>\
                        </div>\
                    </md-toolbar>\
                    <md-dialog-content ms-scroll> \
                        <p>Send a message to the teacher (optional)</p> \
                        <md-input-container class="md-block" > \
                            <input type="text" style="font-size: 12px;" name="message" ng-model="message"> \
                        </md-input-container> \
                        <section style="text-align: right;"> \
                            <md-button ng-click="closeDialog()" class="md-primary md-raised"> \
                                No \
                            </md-button> \
                            <md-button ng-click="cancelCourseAPI()" class="md-primary md-raised"> \
                                Yes \
                            </md-button> \
                        </section> \
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : cancelCourseContent,
                locals              : {message: vm.message},
                bindToController    : true,
                clickOutsideToClose : true,
                parent              : angular.element(document.body),
                controller          : CancelCourseController,
            });

            function CancelCourseController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
                $scope.cancelCourseAPI = function() {

                    var params = {
                        id: course.id,
                        message: $scope.message,
                    };

                    vm.upcomingClasses.splice(index, 1);
                    // Send remove class request

                    waitForResponse();

                    api.courseTimes._cancel.put(params, _successCancelCourseHandler, _errorCallback);

                    // Remove schedule from view model
                    _removeReservedEvent(course.id);
                }
            }
        }

        function _successCancelCourseHandler(response) {

            vm.balance = parseFloat(vm.balance) + parseFloat(response.data.wallet_increament);

            console.log(response);

            // update package hours
            for (var i = 0; i < vm.packageTeachers.length; ++i) {
                console.log(vm.packageTeachers[i]);
                if (vm.packageTeachers[i].teacherName == response.data.teacher_name) {

                    for (var j = 0; j < vm.packageTeachers[i].packages.length; ++j) {
                        if (vm.packageTeachers[i].packages[j].packageName == response.data.package_name) {
                            vm.packageTeachers[i].packages[j].remainingHours += response.data.package_increament;
                        }
                    }
                }
            }

            _getUpcomingClasses().then(
              function(response) {

                  // Refresh view model
                  vm.upcomingClasses = _pipeUpcomingClasses(response.data);
                  vm.hasMoreUpcoming = response.hasMore;
              },
              _errorCallback
            );
            $mdDialog.hide();
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Your lesson has been cancelled.')
                .textContent('')
                .ariaLabel('')
                .ok('OK')

                .title('Your lesson has been cancelled.')
                .textContent('')
                .ariaLabel('')
                .ok($filter('translate')('LESSON_REQUEST.OK'))
            );
        }

        function viewProfile(teacherId) {
            $state.go('app.pages_teacher', { id: teacherId });
        }

        function report() {
            location.href = constNesukuEmail;
        }

        function notImplement() {
            alert('This feature not implement yet');
        }

        function _removeReservedEvent(courseId) {
            angular.forEach(vm.schedule[0], function (schedule, index) {
                if (schedule.courseId == courseId) {
                    vm.schedule[0].splice(index, 1);
                }
            });
        }

        function _removePendingEvent(courseRequestId) {
            angular.forEach(vm.schedule[0], function (schedule, index) {
                if (schedule.lessonRequestId == courseRequestId) {
                    vm.schedule[0].splice(index, 1);
                }
            });
        }

        function _getCourseRequests(type) {
            var number = 3;
            if(type) {

                number = vm.courseRequests.length + number;
                return apiResolver.resolve('statusCourseRequest.list@get' , { number: number, status: 1 } );

            }else {

                return apiResolver.resolve('statusCourseRequest.list@get' , { number: number, status: 1 } );

            }
        }

        function _getUpcomingClasses(type) {
            var number = 3;

            if(type) {
                number = vm.upcomingClasses.length + number;
            }

            var params = {
                startDate: moment().utc().format(),
                endDate: null,
                number: number,
                status: "2"
            };

            return apiResolver.resolve('statusCourseTimes.list@get', params);
        }

        function _getPreviousClasses(type) {

            var number = 3;

            if(type) {
                number = vm.previousClasses.length + number;
            }

            var params = {
                startDate: null,
                endDate: moment().utc().format(),
                number: number,
            };

            return apiResolver.resolve('statusCourseTimes.list@get', params);
        }

        function _getCurrentUser() {
            return apiResolver.resolve('user.list@get');
        }

        function _getStudent() {
            return apiResolver.resolve('student.introMessage@get');
        }

        function _getReservedEvents() {
            return apiResolver.resolve('schedule.list@get');
        }

        function _getPendingEvents() {
            return apiResolver.resolve('pendingEvents.list@get');
        }

        function _getWalletBalance(){
            return apiResolver.resolve("wallet.getBalance@get");
        }

        function _getEssayRequests(type){
            var number = 3;
            if(type) {

                number = vm.essayRequests.length + number;
                return apiResolver.resolve('statusEssayRequest.list@get' , { number: number} );

            } else {

                return apiResolver.resolve('statusEssayRequest.list@get' , { number: number} );

            }
        }

        function _pipeUpcomingClasses(upcomingClasses) {
            angular.forEach(upcomingClasses, function(upcomingClass) {

                // Append startsIn property
                // console.log(upcomingClass);
                upcomingClass.startsIn = moment(upcomingClass.start).fromNow();
            });

            return $filter('orderBy')(upcomingClasses, 'start');
        }

        function _pipePreviousClasses(previousClasses) {
            angular.forEach(previousClasses, function(previousClass) {

                // Append startedAt property
                previousClass.startedAt = moment(previousClass.start).fromNow();
            });

            return $filter('orderBy')(previousClasses, '-start');
        }

        function _successSaveIntroCallback() {
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title($filter('translate')('STUDENT_DASHBOARD.INTRODUCTORY_SAVE'))
                    .textContent()
                    .ariaLabel($filter('translate')('STUDENT_DASHBOARD.INTRODUCTORY_SAVE'))
                    .ok($filter('translate')('STUDENT_DASHBOARD.OK'))
            );
        }


        function _errorCallback(response) {
            $mdDialog.hide();
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }


        function _setTimezone(student) {
            var params = {
                id: student.id,
                timezone: vm.timezone
            };
            apiResolver.resolve('timezone.setTimezone@post', params);
        }

        function _switchRoleIfNecessary() {
            var payload = $auth.getPayload();
            if(payload.role != 2) {
                api.auth.switchRole.post({token: $auth.getToken(), role: 'student'},
                    function(response) {
                        _updateToken(response.token);
                        _init();
                    }
                );
            } else {
                _init();
            }
        }

        function _updateToken(token) {
            $auth.setToken(token);
            var payload = $auth.getPayload();
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            switch(payload.role) {
                case 0:
                    $rootScope.userRole = 'admin';
                    break;

                case 1:
                    $rootScope.userRole = 'teacher';
                    break;

                case 2:
                    $rootScope.userRole = 'student';
                    break;

                default:
                    console.error("Invalid Role");
                    break;
            }
        }

        function _init() {

            $q.all([
                _getCourseRequests(),
                _getUpcomingClasses(),
                _getPreviousClasses(),
                _getCurrentUser(),
                _getStudent(),
                _getReservedEvents(),
                _getPendingEvents(),
                _getWalletBalance(),
                _getEssayRequests()
            ]).then(function (response) {
                vm.courseRequests = $filter('orderBy')(response[0].data, 'start');
                vm.upcomingClasses = _pipeUpcomingClasses(response[1].data);
                vm.previousClasses = _pipePreviousClasses(response[2].data);
                vm.user = response[3].data;
                vm.student = response[4].data;
                vm.schedule = [scheduleMapper.mapForStudent(response[5].data, response[6].data)];
                vm.isLoading = false;
                vm.hasMoreCourseRequest = response[0].hasMore;
                vm.hasMoreUpcoming = response[1].hasMore;
                vm.hasMorePrevious = response[2].hasMore;
                vm.hasMoreEssayRequest = response[8].hasMore;
                vm.balance = response[7].data;
                vm.essayRequests = response[8].data
                _setTimezone(vm.student);
                console.log('vm.schedule');
                console.log(vm.schedule);
                console.log(vm.essayRequests);

                console.log(vm.user);
            }, _errorCallback);

            initPackage();
            readNotification();

        }

        function readNotification() {
            api.notifications.list.post({
                type: 1
            }, successReadCallback, _errorCallback);
        }

        function successReadCallback(response) {
            $rootScope.notifications = response.data;
        }

        function rebook(teacherId){
            vm.isRebook = true;
            $state.go('app.pages_teacher', {id: teacherId, rebook: vm.isRebook})
        }

        function goToEssay(index){
            $state.go('app.pages_view-essay', { id: index });
        }


        $scope.$on('newRequest', function(event){
            if ($rootScope.state.current.name == "app.pages_student-dashboard"){
                _getCourseRequests().then(
                    function(response) {
                        // Refresh view model
                        vm.courseRequests = response.data;
                        vm.hasMoreCourseRequest = response.hasMore;
                    },
                    _errorCallback
                );
            }
        });

        //show more 3 lesson request
        function showMore(type) {
            if(type == 'courseRequest') {
                _getCourseRequests(true)
                .then(function(response) {
                    vm.courseRequests = $filter('orderBy')(response.data, 'start');
                    vm.hasMoreCourseRequest = response.hasMore;
                });
            }

            if(type == 'upcoming') {
                _getUpcomingClasses(true)
                .then(function(response) {
                    vm.upcomingClasses = _pipeUpcomingClasses(response.data);
                    vm.hasMoreUpcoming = response.hasMore;
                });
            }

            if(type == 'previous') {
                _getPreviousClasses(true)
                .then(function(response) {
                    vm.previousClasses = _pipePreviousClasses(response.data);
                    vm.hasMorePrevious = response.hasMore;
                });
            }

            if(type == 'essayRequest') {
                _getEssayRequests(true)
                .then(function(response) {
                    vm.essayRequests = $filter('orderBy')(response.data, 'submitTime');
                    vm.hasMoreEssayRequest = response.hasMore;
                });
            }
        }

        _switchRoleIfNecessary();
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.review-essay', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_review-essay', {
            url      : '/review-essay',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/review-essay/review-essay.html',
                    controller : 'ReviewEssayController as vm'
                }
            },
            bodyClass: 'review-essay',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/review-essay');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.review-essay')
        .controller('ReviewEssayController', ReviewEssayController);

    /** @ngInject */
    function ReviewEssayController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver)
    {
        var vm = this;
        
        // Data
        vm.essayText = "Please copy and paste your essay here."

        // Methods
        vm.countOf = countOf;
        
        // Functions
        function countOf(text) {
            var s = text ? text.split(/\s+/) : 0; // it splits the text on space/tab/enter
            return s ? s.length : 0;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.privacy-policy', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_privacy-policy', {
            url      : '/privacy-policy',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/privacy-policy/privacy-policy.html',
                    controller : 'PrivacyPolicyController as vm'
                }
            },
            bodyClass: 'privacy-policy',
        });



        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/privacy-policy');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.privacy-policy')
        .controller('PrivacyPolicyController', PrivacyPolicyController);

    /** @ngInject */
    function PrivacyPolicyController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        $location,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.payment-make-up', [
            'ngAnimate',
            'ui.bootstrap',
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_payment-make-up', {
            url      : '/payment-make-up/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/payment-make-up/payment-make-up.html',
                    controller : 'PaymentMakeUpController as vm'
                }
            },
            resolve  : {
                paymentMakeUpInfo: function ($stateParams, apiResolver) {
                    return apiResolver.resolve('paymentMakeUp.student@get', { id: $stateParams.id }); // The name may be changed
                },
            },
            bodyClass: 'payment-make-up',
            requireLogin: true,
            params: {
                id: null,
                rebook: null
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/payment-make-up');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.payment-make-up')
        .controller('PaymentMakeUpController', PaymentMakeUpController);

    /** @ngInject */
    function PaymentMakeUpController(
        $q,
        $mdDialog,
        $auth,
        $filter,
        $rootScope,
        $state,
        $stateParams,
        api,
        apiResolver,
        paymentMakeUpInfo,
        StripeService)
    {
        var vm = this;
        var payload = $auth.getPayload();
        $rootScope.userRole = getUserRole();
        $rootScope.overlayMessage = "Loading ...";
        if (!paymentMakeUpInfo.success) {
            alert(paymentMakeUpInfo.errorMsg);
            $rootScope.overlayMessage = null;
            if ($rootScope.userRole == 'student') {
                $state.go('app.pages_student-dashboard');
            }
            else {
                $state.go('app.pages_teacher-dashboard');
            }
        } else {
            $rootScope.overlayMessage = null;
        }

        // Data
        vm.paymentMakeUpInfo = paymentMakeUpInfo.data;
        vm.student = vm.paymentMakeUpInfo.student;
        vm.teacher = vm.paymentMakeUpInfo.teacher;
        vm.category = vm.paymentMakeUpInfo.category;
        vm.price = vm.paymentMakeUpInfo.price;
        vm.times = vm.paymentMakeUpInfo.times;
        vm.description = [];
        vm.totalHours = 0;
        vm.categoryHourlyPrice;
        vm.totalPrice = 0;

        //init
        _init();

        // Methods
        vm.closeDialog = closeDialog;
        vm.choosePay = choosePay;
        vm.calculatePrice = calculatePrice;

        // Functions
        function _init() {

            vm.categoryHourlyPrice = vm.category.hourlyPrice;
            getTimes();
            console.log(vm.totalHours);
            console.log(vm.totalPrice);
            console.log(vm.description);

        }

        function _openAlipay() {
            // Get alipay amount, currency and return url
            var params = {
                id: $stateParams.id
            };
            api.paymentMakeUp.student.post(params, function (response) {
                StripeService.alipay({
                    url: response.data.url,
                    amount: response.data.amount,
                    currency: response.data.currency,
                });
            }, _errorAcceptCallback);
            $rootScope.overlayMessage = "We're processing your payment, please wait.";
        }

        function _openStripeDialog() {
            StripeService.openPopup({
                name: vm.teacher.name,
                description: "Make Up Payment",
                amount: vm.totalPrice * 100,
                currency: 'usd'
            }, function (token) {
                var params = {
                    token: token.id,
                    id: $stateParams.id
                };
                api.paymentMakeUp.student.post(params, _successPaymentMakeUpCallback, _errorAcceptCallback);
                $rootScope.overlayMessage = "We're processing your payment, please wait.";
            });
        }

        function _successPaymentMakeUpCallback() {
            $mdDialog.hide();
            $rootScope.isCreateRequest = true;
            $rootScope.overlayMessage = null;
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Your payment has been sent!')
                .textContent('')
                .ariaLabel('')
                .ok('OK')
            );
            $rootScope.userRole = 'student';
            $state.go('app.pages_student-dashboard');
        }

        function _errorAcceptCallback(response) {
            // $mdDialog.hide();
            _errorHandler(response);
            $rootScope.overlayMessage = null;
            $rootScope.userRole = 'student';
            $state.go('app.pages_student-dashboard');
        }

        function getTimes() {
            for(var i=0; i<vm.times.length; i++){
                var start = moment(vm.times[i].startTime).local();
                var end = moment(vm.times[i].endTime).local();
                var hour = end.diff(start, 'hours', true)
                var dateTime = {
                  start: start.format('MMM DD, h:mm A') + ' - ' + end.format('h:mm A'),
                  duration: hour,
                  cost: hour * vm.categoryHourlyPrice,
                }
                vm.totalHours += end.diff(start, 'hours', true);
                vm.description.push(dateTime);
                console.log(start);
                console.log(end);
            }
            calculatePrice();
        }

        function _errorHandler(response) {
            alert('Error');
            console.error(response);
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }

        function choosePay() {
            if(vm.totalPrice > 0) {
                var choosePayContent = ' \
                    <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px;" aria-label="Category saved"> \
                        <md-toolbar class="md-accent md-hue-2" style="background-color:#fff;"> \
                            <div class="md-toolbar-tools" layout="row" layout-align="space-between center">\
                                <span class="dialog-title" style="color:black;font-weight:bold;" translate="STUDENT_DASHBOARD.CHOOSE_PAYMENT_METHOD"></span>\
                                <md-button class="md-icon-button" ng-click="closeDialog()" aria-label="Close dialog">\
                                    <md-icon md-font-icon="icon-close" style="color:black;"></md-icon>\
                                </md-button>\
                            </div>\
                        </md-toolbar>\
                        <md-dialog-content ms-scroll> \
                            <md-button ng-click="aliPay()" class="md-raised md-primary" style="margin-top:6px;margin-left:30%;"> \
                                {{ "STUDENT_DASHBOARD.ALIPAY"|translate }} \
                            </md-button> \
                            <md-button ng-click="creditCard()" class="md-raised md-primary"> \
                                {{ "STUDENT_DASHBOARD.CREDITCARD"|translate }} \
                            </md-button> \
                        </md-dialog-content> \
                    </md-dialog> \
                ';
                $mdDialog.show({
                    template            : choosePayContent,
                    clickOutsideToClose : true,
                    parent              : angular.element(document.body),
                    controller          : ChoosePayController,
                });

                function ChoosePayController($scope, $mdDialog) {
                    $scope.closeDialog = function() {
                        $mdDialog.hide();
                    }
                    $scope.creditCard = function() {
                        $mdDialog.hide();
                        _openStripeDialog();
                    }
                    $scope.aliPay = function() {
                        $mdDialog.hide();
                        _openAlipay();
                    }
                }
            } else {
                console.error('Free Lesson?');
            }
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function calculatePrice() {
            vm.totalPrice = precisionRound(vm.categoryHourlyPrice * vm.totalHours, 2);
        }

        function precisionRound(number, precision) {
            var factor = Math.pow(10, precision);
            return Math.round(number * factor) / factor;
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.meet-teachers', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_meet_teachers', {
            url      : '/meet-teachers',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/meet-teachers/meet-teachers.html',
                    controller : 'MeetTeachersController as vm'
                }
            },
            bodyClass: 'meet-teachers',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/meet-teachers');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.meet-teachers')
        .controller('MeetTeachersController', MeetTeachersController);

    /** @ngInject */
    function MeetTeachersController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku = contactNesuku;
        vm.goToApplyToTeach = goToApplyToTeach;
        vm.goToTeacher = goToTeacher;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }

        function goToApplyToTeach() {
            $state.go('app.pages_apply-to-teach');
        }

        function goToTeacher(TeacherId) {
            var n = TeacherId.toString()
            window.location.href='https://www.nesuku.com/teacher/' + n;
        }
    }

})();
// Andy and Chris: Implement your code here

(function ()
{
    'use strict';

    angular
        .module('app.pages.landing-teach', ['app.dialogs.covid-popup',
                                            'app.dialogs.mailchimp',
                                      'ngCookies'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_landing-teach', {
            url      : '/teach',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_landing-teach': {
                    templateUrl: 'app/main/pages/landing-teach/landing-teach.html',
                    controller : 'LandingTeachController as vm'
                }
            },
            bodyClass: 'landing-teach',
            useGuestMenu: true,
            params: {
                lang: null,
                cp: null
            }
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/landing-teach');
    }

})();
// Andy and Chris: Implement you code here

(function ()
{
    'use strict';

    angular
        .module('app.pages.landing-teach')
        .controller('LandingTeachController', LandingTeachController);

    /** @ngInject */
    function LandingTeachController($state, $auth, $rootScope, $document, $mdDialog, $mdSidenav, $filter, $translate, $cookies, $timeout)
    {
        var vm = this;
        var payload = $auth.getPayload();

        $rootScope.isAuthenticated = $auth.isAuthenticated();
        $rootScope.userRole = getUserRole();

        // Data
        vm.selectedTab;
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            zh: {
                'title'      : 'Mandarin',
                'translation': 'TOOLBAR.MANDARIN',
                'code'       : 'zh',
                'flag'       : 'cn'
            }
        };

        vm.teacher = {
            name : 'kaori'
        };

        vm.showCovidHeader = true;

        // Init
        init();

        // Methods
        vm.goToHomepage = goToHomepage;
        vm.goToFindATutor = goToFindATutor;
        vm.applyToTeach = applyToTeach;
        vm.logIn = logIn;
        vm.goToSignUp = goToSignUp;
        vm.signup = signup;
        vm.goToLanguage = goToLanguage;
        vm.goToCPList = goToCPList;
        vm.goToTeach = goToTeach;
        vm.openDialog = openDialog;
        vm.openRightMenu = toggleMenu;
        vm.changeLanguage = changeLanguage;
        vm.goToStudentHelp = goToStudentHelp;
        vm.toCPForm = toCPForm;
        vm.toFree = toFree;
        vm.goToCovid = goToCovid;
        vm.goToHwHelp = goToHwHelp;


        // Functions
        function init() {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.use()];
            if (vm.selectedLanguage == undefined) {
                vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            }

            // Check login status
            if ($rootScope.isAuthenticated) {
                switch ($rootScope.userRole) {
                    case 'admin':
                        $state.go('app.pages_admin-dashboard');
                        break;

                    case 'teacher':
                        $state.go('app.pages_teacher-dashboard');
                        break;

                    case 'student':
                        $state.go('app.pages_student-dashboard');
                        break;

                    default: 
                        $state.go('app.pages_auth_login');
                        break;
                }
            }

            if (!$cookies.get("viewed-mailchimp") && !$rootScope.isAuthenticated) {
                $timeout(openMailchimp, 10000);
            }
        }

        function openMailchimp() {
            $mdDialog.show({
                controller         : 'MailchimpController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/mailchimp/mailchimp.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            });
            $cookies.put("viewed-mailchimp", true);
        }


        function goToHomepage() {
            if ($rootScope.isAuthenticated) {
                switch ($rootScope.userRole) {
                    case 'admin':
                        $state.go('app.pages_admin-dashboard');
                        break;

                    case 'teacher':
                        $state.go('app.pages_teacher-dashboard');
                        break;

                    case 'student':
                        $state.go('app.pages_student-dashboard');
                        break;

                    default: 
                        $state.go('app.pages_auth_login');
                        break;
                }
            } 
            else {
                $state.go('app.pages_landing');
            }
        }

        function goToTeach() {
            $state.go('app.pages_teach-form');
        }

        function goToFindATutor() {
            $state.go('app.pages_find-a-tutor');
        }

        function toggleMenu() {
            $mdSidenav('right').toggle();
        }

        function applyToTeach() {
            var signupFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSc2GrVzQnAMX4K_ckZKMyZbGNV7_FaGtssCLHdiv763qawaOw/viewform";
            window.open(signupFormUrl, '_blank');
        }

        function logIn() {
            $state.go('app.pages_auth_login');
        }

        function goToSignUp() {
            $state.go('app.pages_auth_register');   
        }

        function _mappingUser() {
            var free_lesson = "0";
            if(vm.form.likeFreeLessonAndConsulation != null && vm.form.interestedINConversationPartner != null){
                free_lesson = "1,2";
            }
            if(vm.form.likeFreeLessonAndConsulation !=null && vm.form.interestedINConversationPartner == null){
                free_lesson = "1";
            }
            if(vm.form.likeFreeLessonAndConsulation ==null && vm.form.interestedINConversationPartner != null){
                free_lesson = "2";
            }            
            return {
                name: vm.form.username,
                email: vm.form.email,
                password: vm.form.password,
                password_confirmation: vm.form.passwordConfirm,
                free_lesson: free_lesson,
            }
        }

        function signup() {
            var user = _mappingUser();

            $auth.signup(user).then(function(response) {
                _login(user);
            }).catch(function(response) {
                console.log(response);
            });
        }

        function _login(user) {
            $auth.login(user).then(function(data) {
                $state.go('app.pages_teacher-list');
            }).catch(function(response) {
                console.log(response);
            });
        }

        function openDialog() {
            $mdDialog.show({
                controller         : 'TermsConditionsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/terms-n-conditions/terms-n-conditions.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            });
        }

        function goToLanguage(){
            if(vm.data === 'I want to learn a language that is not on this list'){
                window.location.href='https://goo.gl/forms/menPHa8tsr388Cpq1';       
            }
            else{
                $state.go('app.pages_teacher-list', {lang: vm.data, is_conversation_partner: 'teacher'});
            }
        }

        function goToCPList(){
            if(vm.data === 'I want to learn a language that is not on this list'){
                window.location.href='https://goo.gl/forms/4vvgEiEo4BH3If3l1';       
            }
            else{
                $state.go('app.pages_teacher-list', {lang: vm.data, is_conversation_partner: 'cp'});
            }
        }

        function goToStudentHelp() {
            $state.go('app.pages_help-center');
        }

        function goToCovid() {
            $state.go('app.pages_covid');
        }

        function goToHwHelp() {
            $state.go('app.pages_hw-help');
        }

        function openCovidPopup() {
            $mdDialog.show({
                controller         : 'CovidPopupController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/covid-popup/covid-popup.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            });
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }

        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */

            $translate.use(lang.code);

            return;
            // Change the language
        }
       
        function toCPForm() {
            $state.go('app.pages_find-cp-form');
        }

        function toFree() {
            $state.go('app.pages_free');
        }

    }

})();
// Andy and Chris: Implement your code here

(function ()
{
    'use strict';

    angular
        .module('app.pages.landing', ['app.dialogs.covid-popup',
                                      'ngCookies',
                                      'app.dialogs.mailchimp'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_landing', {
            url      : '/',
            views    : {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_landing': {
                    templateUrl: 'app/main/pages/landing/landing.html',
                    controller : 'LandingController as vm'
                }
            },
            bodyClass: 'landing',
            useGuestMenu: true,
            params: {
                lang: null,
                cp: null
            }
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/landing');
    }

})();
// Andy and Chris: Implement you code here

(function ()
{
    'use strict';

    angular
        .module('app.pages.landing')
        .controller('LandingController', LandingController);

    /** @ngInject */
    function LandingController($state, $auth, $rootScope, $document, $mdDialog, $mdSidenav, $filter, $translate, $cookies, $timeout)
    {
        var vm = this;
        var payload = $auth.getPayload();

        $rootScope.isAuthenticated = $auth.isAuthenticated();
        $rootScope.userRole = getUserRole();

        // Data
        vm.selectedTab;
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            zh: {
                'title'      : 'Mandarin',
                'translation': 'TOOLBAR.MANDARIN',
                'code'       : 'zh',
                'flag'       : 'cn'
            }
        };

        vm.teacher = {
            name : 'kaori'
        };

        // Init
        init();

        // Methods
        vm.goToHomepage = goToHomepage;
        vm.goToFindATutor = goToFindATutor;
        vm.applyToTeach = applyToTeach;
        vm.logIn = logIn;
        vm.goToSignUp = goToSignUp;
        vm.signup = signup;
        vm.goToLanguage = goToLanguage;
        vm.goToCPList = goToCPList;
        vm.goToTeach = goToTeach;
        vm.openDialog = openDialog;
        vm.openRightMenu = toggleMenu;
        vm.changeLanguage = changeLanguage;
        vm.goToStudentHelp = goToStudentHelp;
        vm.toCPForm = toCPForm;
        vm.toFree = toFree;
        vm.goToCovid = goToCovid;
        vm.goToHwHelp = goToHwHelp;


        // Functions
        function init() {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.use()];
            if (vm.selectedLanguage == undefined) {
                vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            }

            // Check login status
            if ($rootScope.isAuthenticated) {
                switch ($rootScope.userRole) {
                    case 'admin':
                        $state.go('app.pages_admin-dashboard');
                        break;

                    case 'teacher':
                        $state.go('app.pages_teacher-dashboard');
                        break;

                    case 'student':
                        $state.go('app.pages_student-dashboard');
                        break;

                    default: 
                        $state.go('app.pages_auth_login');
                        break;
                }
            }

            if (!$cookies.get("viewed-mailchimp") && !$rootScope.isAuthenticated) {
                $timeout(openMailchimp, 10000);
            }
        }

        function openMailchimp() {
            $mdDialog.show({
                controller         : 'MailchimpController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/mailchimp/mailchimp.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            });
            $cookies.put("viewed-mailchimp", true);
        }

        function goToHomepage() {
            if ($rootScope.isAuthenticated) {
                switch ($rootScope.userRole) {
                    case 'admin':
                        $state.go('app.pages_admin-dashboard');
                        break;

                    case 'teacher':
                        $state.go('app.pages_teacher-dashboard');
                        break;

                    case 'student':
                        $state.go('app.pages_student-dashboard');
                        break;

                    default: 
                        $state.go('app.pages_auth_login');
                        break;
                }
            } 
            else {
                $state.go('app.pages_landing');
            }
        }

        function goToTeach() {
            $state.go('app.pages_teach-form');
        }

        function goToFindATutor(title) {
            $state.go('app.pages_find-a-tutor', {category: title}, { 
                reload: true 
            });
        }

        function toggleMenu() {
            $mdSidenav('right').toggle();
        }

        function applyToTeach() {
            var signupFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSc2GrVzQnAMX4K_ckZKMyZbGNV7_FaGtssCLHdiv763qawaOw/viewform";
            window.open(signupFormUrl, '_blank');
        }

        function logIn() {
            $state.go('app.pages_auth_login');
        }

        function goToSignUp() {
            $state.go('app.pages_auth_register');   
        }

        function _mappingUser() {
            var free_lesson = "0";
            if(vm.form.likeFreeLessonAndConsulation != null && vm.form.interestedINConversationPartner != null){
                free_lesson = "1,2";
            }
            if(vm.form.likeFreeLessonAndConsulation !=null && vm.form.interestedINConversationPartner == null){
                free_lesson = "1";
            }
            if(vm.form.likeFreeLessonAndConsulation ==null && vm.form.interestedINConversationPartner != null){
                free_lesson = "2";
            }            
            return {
                name: vm.form.username,
                email: vm.form.email,
                password: vm.form.password,
                password_confirmation: vm.form.passwordConfirm,
                free_lesson: free_lesson,
            }
        }

        function signup() {
            var user = _mappingUser();

            $auth.signup(user).then(function(response) {
                _login(user);
            }).catch(function(response) {
                console.log(response);
            });
        }

        function _login(user) {
            $auth.login(user).then(function(data) {
                $state.go('app.pages_teacher-list');
            }).catch(function(response) {
                console.log(response);
            });
        }

        function openDialog() {
            $mdDialog.show({
                controller         : 'TermsConditionsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/terms-n-conditions/terms-n-conditions.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            });
        }

        function goToLanguage(){
            if(vm.data === 'I want to learn a language that is not on this list'){
                window.location.href='https://goo.gl/forms/menPHa8tsr388Cpq1';       
            }
            else{
                $state.go('app.pages_teacher-list', {lang: vm.data, is_conversation_partner: 'teacher'});
            }
        }

        function goToCPList(){
            if(vm.data === 'I want to learn a language that is not on this list'){
                window.location.href='https://goo.gl/forms/4vvgEiEo4BH3If3l1';       
            }
            else{
                $state.go('app.pages_teacher-list', {lang: vm.data, is_conversation_partner: 'cp'});
            }
        }

        function goToStudentHelp() {
            $state.go('app.pages_help-center');
        }

        function goToCovid() {
            $state.go('app.pages_covid');
        }

        function goToHwHelp() {
            $state.go('app.pages_hw-help');
        }

        function openCovidPopup() {
            $mdDialog.show({
                controller         : 'CovidPopupController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/covid-popup/covid-popup.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            });
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }

        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */

            $translate.use(lang.code);

            return;
            // Change the language
        }
       
        function toCPForm() {
            $state.go('app.pages_find-cp-form');
        }

        function toFree() {
            $state.go('app.pages_free');
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.hw-list', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_hw-list', {
            url      : '/hw-list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/hw-list/hw-list.html',
                    controller : 'HwListController as vm'
                }
            },
            resolve: {
                subjects: function (apiResolver) {
                    return apiResolver.resolve('subject.list@get', { isCovid: 1 });
                }
            },
            bodyClass: 'hw-list'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/hw-list');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.hw-list')
        .controller('HwListController', HwListController);

    /** @ngInject */
    function HwListController($auth, $q, $state, $stateParams, $rootScope, $filter,$mdDialog, api, apiResolver, subjects)
    {
        var vm = this;
        var payload = $auth.getPayload();
        
        // Data
        vm.hwList = [];
        vm.subjects = Object.values(subjects.data);
        vm.isLoading = true;

        // Pagination
        vm.pagination = {
            totalItems: null,
            currentPage: null,
            itemsPerPage: 10,
            maxSize: 5
        };


        // Init
        _switchRoleIfNecessary();

        // Methods
        vm.refreshHwList = refreshHwList;
        vm.keyToLink = keyToLink;
        vm.goToApplyForm = goToApplyForm;

        // Functions
        function _init() {
            console.log('init');

            $q.all([
                _getHwList()
            ]).then(function (response) {    
                vm.hwList = response[0].data;
                vm.pagination.totalItems = response[0].total;
                vm.pagination.currentPage = response[0].currentPage;
                vm.isLoading = false;
            }, _errorHandler);
        }

        function refreshHwList() {
            // if(vm.subject == 0){
            //     vm.subject = '';
            // }
            api.hwRequest.list.get({
                subjectId: vm.subject,
                page: vm.pagination.currentPage
            }, function (response) {
                vm.hwList = response.data;
                vm.pagination.totalItems = response.total;
                vm.pagination.currentPage = response.currentPage;
            });
        }

        function _getHwList() {
            return apiResolver.resolve('hwRequest.list@get', {
                subject: vm.subject,
                status: '1'
            });
        }

        function keyToLink(awsKey) {
            return 'https://testdb-userfiles-mobilehub-864203888.s3.amazonaws.com/public/hw-help/files/' + awsKey;
        }

        function goToApplyForm($hwRequestId) {
            if ($auth.isAuthenticated()) {
                api.hwRequest.accept.put({id: $hwRequestId}, _successHandler, _errorHandler);
            }
            else {
                $state.go('app.pages_teach-form');
            }
        }

        function _switchRoleIfNecessary() {
            if ($auth.isAuthenticated()) {
                var payload = $auth.getPayload();
                if (payload.role != 1) {
                    console.log('switch roles')
                    api.auth.switchRole.post({token: $auth.getToken(), role: 'teacher'},
                        function(response) {
                            _updateToken(response.token);
                            _init();
                        },
                        function(response) {
                            alert("Sorry, you don't have permission to visit this page.");
                            history.back();
                        }
                    );
                } else {
                    _init();
                }
            } else {
                _init();
            }
        }

        function _updateToken(token) {
            $auth.setToken(token);
            var payload = $auth.getPayload();
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            switch(payload.role) {
                case 0:
                    $rootScope.userRole = 'admin';
                    break;

                case 1:
                    $rootScope.userRole = 'teacher';
                    break;

                case 2:
                    $rootScope.userRole = 'student';
                    break;

                default:
                    console.error("Invalid Role");
                    break;
            }
        }

        function _successHandler() {
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('You have successfully accepted the request.')
                .textContent('')
                .ariaLabel('')
                .ok('OK')
            );
        }

        function _errorHandler(response) {
            console.error(response);
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.hw-help', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_hw-help', {
            url      : '/hw-help',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/hw-help/hw-help.html',
                    controller : 'HWHelpController as vm'
                }
            },
            resolve  : {
                subjects: function (apiResolver) {
                    return apiResolver.resolve('subject.list@get', { isCovid: 1 });
                }
            },
            bodyClass: 'hw-help',
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/hw-help');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.hw-help')
        .controller('HWHelpController', HWHelpController);

    /** @ngInject */
    function HWHelpController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail,
        subjects)
    {
        var vm = this;
        var db = new AWS.DynamoDB.DocumentClient({accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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', region: 'us-east-1'});

        // Data

        vm.subjects = Object.values(subjects.data);
        console.log(vm.subjects);
        vm.grades = ['1st grade', '2nd grade', '3rd grade', '4th grade', '5th grade', '6th grade', '7th grade', '8th grade', '9th grade', '10th grade', '11th grade', '12th grade', 'College', 'Masters'];

        // Methods

        vm.submit = submit;
        vm.goToCovid = goToCovid;

        // Functions

        function submit() {
            console.log('submit clicked');
            _upload(vm.params);
        }

        function _createFileID() {
            var d = new Date();
            var n = d.getTime();
            var newFileName =  n.toString();
            return newFileName;
        }

        function _uploadS3AndDynamoDB(category, extension, file) {
            console.log("uploadS3");
            var bucket = new AWS.S3({ params: { Bucket: 'testdb-userfiles-mobilehub-864203888/public/hw-help/files'} });
            var fileId = _createFileID();
            var uniqueFileName = fileId + extension;
            var params = { Key: uniqueFileName, ContentDisposition: 'attachment; filename=' + file.name, ContentType: file.type, Body: file, ServerSideEncryption: 'AES256' };
            console.log(params);
            bucket.putObject(params, function(err, data) {
                if(err) {
                    $rootScope.overlayMessage = null;
                    _errorHandler(err.code);
                    return false;
                } else {
                    var item = {};
                    // update in the database

                    item.location = 'public/hw-help/files' + fileId + extension;
                    item.accessId = '0';
                    item.created = (new Date().getTime() / 1000);
                    item.updated = item.created;
                    item.access = 'rw';
                    item.fileId = fileId;
                    item.extension = extension;
                    item.fileName = file.name;
                    
                    AWS.config.update({region:'us-east-1'});
                    db.put({
                        'TableName': 'testdb-mobilehub-864203888-FileDB',
                        'Item': item,
                        'ConditionExpression': 'attribute_not_exists(id)'
                    }).promise().then(function(data) {
                        // Upload Successfully Finished

                        var params = {
                            name: vm.form.username,
                            email: vm.form.email,
                            grade: vm.form.grade,
                            description: vm.form.description,
                            subject: vm.form.subject,
                            otherSubject: vm.form.otherSubject,
                            awsKey: uniqueFileName
                        };

                        api.hwRequest.save.post(params, _successCallback, _errorHandler);
                        console.log('SUCCESSFULLY UPLOADED FILE');
                        console.log(params);
                        console.log(data);
                    }).catch(function(err)  {
                        console.log('FAILED UPLOAD');
                        console.log("ERROR: " + err);
                    });
                }
            });
        }

        function _upload() {
            console.log("upload");
            _waitForResponse();
            AWS.config.update({ accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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'});
            AWS.config.region = 'us-east-1';

            if (vm.file) {
                if (vm.file.type == 'application/msword' && vm.file.name.endsWith('.doc')) {
                    _uploadS3AndDynamoDB('document', '.doc', vm.file);
                } else if(vm.file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && vm.file.name.endsWith('.docx') ) {
                    _uploadS3AndDynamoDB('document', '.docx', vm.file);
                } else if(vm.file.type == 'text/plain' && vm.file.name.endsWith('.txt') ) {
                    _uploadS3AndDynamoDB('document', '.txt', vm.file);
                } else if(vm.file.type == 'application/pdf' && vm.file.name.endsWith('.pdf') ) {
                    _uploadS3AndDynamoDB('presentation', '.pdf', vm.file);
                } else if(vm.file.type == 'image/png' && vm.file.name.endsWith('.png') ) {
                    _uploadS3AndDynamoDB('image', '.png', vm.file);
                } else if(vm.file.type == 'image/jpeg' && vm.file.name.endsWith('.jpg') ) {
                    _uploadS3AndDynamoDB('image', '.jpeg', vm.file);
                } else if(vm.file.type == 'image/jpeg' && vm.file.name.endsWith('.jpeg') ) {
                    _uploadS3AndDynamoDB('image', '.jpeg', vm.file);
                }
                 else {
                    $rootScope.overlayMessage = null;
                    alert('Please select a doc, docx, pdf, png, jpg, or txt file to upload');
                }
            }

            else {
                var params = {
                    name: vm.form.username,
                    email: vm.form.email,
                    grade: vm.form.grade,
                    description: vm.form.description,
                    subject: vm.form.subject,
                    otherSubject: vm.form.otherSubject,
                    awsKey: null,
                };
                api.hwRequest.save.post(params, _successCallback, _errorHandler);
            }

        }

        function _waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Processing the request...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function _successCallback() {
            var successContent =
            ' \
            <md-dialog> \
                <md-content> \
                    <div class="dialog-title"> \
                        <p>Your request has been sent!</p> \
                    </div> \
                    <div class="dialog-intro"> \
                        <p>We hope this will help you with your learning during these trying times! Our tutors will contact you within 24 hours to help you via videoconference. Please check your email for details.</p> \
                        <p style="color:black;"><b>Share the link with your friends</b><br></p> \
                        <md-input-container md-no-float class="md-block" flex-gt-sm> \
                            <input type="text" class="input-content" ng-model="sharableLink"> \
                        </md-input-container> \
                    </div> \
                </md-content> \
                <md-dialog-actions> \
                    <md-button ng-click="goToLanding()" class="md-primary"> \
                      Okay \
                    </md-button> \
                </md-dialog-actions> \
            </md-dialog> \
            ';

            $mdDialog.hide();
            $mdDialog.show({
                template            : successContent,
                clickOutsideToClose : false,
                parent              : angular.element('#hw-help'),
                controller          : SuccessController,
            });

            function SuccessController($scope, $state, $mdDialog) {
                $scope.sharableLink = "https://www.nesuku.com/covid/";
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
                $scope.goToLanding = function() {
                    $state.go('app.pages_landing');
                }
            }
            
        }

        function goToCovid() {
            $state.go('app.pages_covid');
        }


        function _errorHandler(response) {
            $mdDialog.hide();
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.help-center-teacher', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_help-center-teacher', {
            url      : '/help-center-teacher',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/help-center-teacher/help-center-teacher.html',
                    controller : 'HelpCenterTeacherController as vm'
                }
            },
            bodyClass: 'help-center-teacher',
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/help-center-teacher');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.help-center-teacher')
        .controller('HelpCenterTeacherController', HelpCenterTeacherController);

    /** @ngInject */
    function HelpCenterTeacherController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver)
    {
        var vm = this;
        
        // data
        vm.currentArticle = "whyNesuku";
        vm.currentNavItem = "teacher";

        // method
        vm.setArticleContent = setArticleContent;
        vm.goToStudentView = goToStudentView;

        function setArticleContent(article){
            vm.currentArticle = article;
        }

        function goToStudentView() {
            $state.go('app.pages_help-center');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.help-center', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_help-center', {
            url      : '/help-center',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/help-center/help-center.html',
                    controller : 'HelpCenterController as vm'
                }
            },
            bodyClass: 'help-center',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/help-center');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.help-center')
        .controller('HelpCenterController', HelpCenterController);

    /** @ngInject */
    function HelpCenterController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver)
    {
        var vm = this;
        
        // data
        vm.currentArticle = "whyNesuku";
        vm.currentNavItem = "teacher";


        // method
        vm.setArticleContent = setArticleContent;
        vm.goToTeacherView = goToTeacherView;

        function setArticleContent(article) {
            vm.currentArticle = article;
        }

        function goToTeacherView() {
            $state.go('app.pages_help-center-teacher');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.find-teacher-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_find-teacher-form', {
            url      : '/find-teacher-form',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/find-teacher-form/find-teacher-form.html',
                    controller : 'BecomeCPFormController as vm'
                }
            },
            bodyClass: 'find-teacher-form',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/find-teacher-form');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.find-teacher-form')
        .controller('FindTeacherFormController', FindTeacherFormController);

    /** @ngInject */
    function FindTeacherFormController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku = contactNesuku;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.free', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_free', {
            url      : '/free',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/free/free.html',
                    controller : 'FreeController as vm'
                }
            },
            bodyClass: 'free',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/free');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.free')
        .controller('FreeController', FreeController);

    /** @ngInject */
    function FreeController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku_freeConsultation = contactNesuku_freeConsultation;
        vm.contactNesuku_freeTrial = contactNesuku_freeTrial;

        // Functions
        function contactNesuku_freeConsultation() {
            location.href = constNesukuEmail+'?subject=Free Consultation';
        }

         function contactNesuku_freeTrial() {
            location.href = constNesukuEmail+'?subject=Free Trial';
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.find-cp-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_find-cp-form', {
            url      : '/find-cp-form',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/find-cp-form/find-cp-form.html',
                    controller : 'FindCPFormController as vm'
                }
            },
            bodyClass: 'find-cp-form',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/find-cp-form');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.find-cp-form')
        .controller('FindCPFormController', FindCPFormController);

    /** @ngInject */
    function FindCPFormController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku = contactNesuku;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.find-a-tutor', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_find-a-tutor', {
            url      : '/find-a-tutor?category',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/find-a-tutor/find-a-tutor.html',
                    controller : 'FindATutorController as vm'
                }
            },
            resolve: {
                category: function ($stateParams) {
                    return $stateParams.category;
                }
            },
            bodyClass: 'find-a-tutor',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/find-a-tutor');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.find-a-tutor')
        .controller('FindATutorController', FindATutorController);

    /** @ngInject */
    function FindATutorController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail,
        category)
    {
        var vm = this;
        vm.category = category;
        _init();

        // Data
        if (category == 'academic') {
            vm.categoryTitle = 'Get matched with our academic tutors';
        }

        else if (category == 'lifestyle') {
            vm.categoryTitle = 'Get matched with our lifestyle instructors';
        }

        else if (category == 'college') {
            vm.categoryTitle = 'Get matched with our college advisors';
        }

        else {
            vm.category = "academic"
            vm.categoryTitle = 'Get matched with our academic tutors';
        }

        // Methods
        vm.contactNesuku = contactNesuku;

        // Functions
        function _init() {
           var qs,js,q,s,d=document, gi=d.getElementById, ce=d.createElement, gt=d.getElementsByTagName, id="typef_orm_share", b="https://embed.typeform.com/"; if(!gi.call(d,id)){ js=ce.call(d,"script"); js.id=id; js.src=b+"embed.js"; q=gt.call(d,"script")[0]; q.parentNode.insertBefore(js,q) } ;
        }

        function contactNesuku() {
            location.href = constNesukuEmail;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.essays', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_essays', {
            url      : '/essay-review',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/essays/essays.html',
                    controller : 'EssaysController as vm'
                }
            },
            bodyClass: 'essays',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/essays');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.essays')
        .controller('EssaysController', EssaysController);

    /** @ngInject */
    function EssaysController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku = contactNesuku;
        vm.goToApplyToTeach = goToApplyToTeach;
        vm.goToTeacher = goToTeacher;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }

        function goToApplyToTeach() {
            $state.go('app.pages_apply-to-teach');
        }

        function goToTeacher(TeacherId) {
            var n = TeacherId.toString()
            window.location.href='https://www.nesuku.com/teacher/' + n + '/essay-review';
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.essay-review', ['app.dialogs.edit-file', 'app.dialogs.essay-payment'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_essay-review', {
            url      : '/teacher/:id/essay-review',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/essay-review/essay-review.html',
                    controller : 'EssayReviewController as vm'
                }
            },
            bodyClass: 'essay-review',
            params: {
                id: null
            },
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/essay-review');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.essay-review')
        .controller('EssayReviewController', EssayReviewController);

    /** @ngInject */
    function EssayReviewController(
        $rootScope,
        $q,
        $auth,
        $state,
        $stateParams,
        $location,
        $scope,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver)
    {
        var vm = this;
        var db = new AWS.DynamoDB.DocumentClient({accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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', region: 'us-east-1'});
        var payload = $auth.getPayload();
        $rootScope.userRole = getUserRole();
        
        // Data
        vm.essayText = "Please copy and paste your essay here."
        vm.teacherId = $stateParams.id;
        vm.teacherInfo = {};
        vm.essayType = 1;
        vm.user = {};

        // Methods
        vm.countOf = countOf;
        vm.goToPayment = goToPayment;
        _init();
        
        // Functions
        function _init(){
            _checkAuth();
            $q.all([
                _getTeacherInfo(),
                _getCurrentUser(),
            ]).then(function (response) {
                vm.teacherInfo = response[0].data;
                vm.user = response[1].data;
                console.log(vm.user);
                console.log(vm.teacherInfo);
                }, _errorHandler);
        }

        function _checkAuth() {
            if (!$auth.isAuthenticated()){
                console.log('not auth');
                sessionStorage.setItem("backUrl",$location.absUrl());
                $state.go('app.pages_auth_register');
            }
        }

        function _getTeacherInfo(){
            return apiResolver.resolve('teacher.byId@get', {id: vm.teacherId});
        }

        function _getCurrentUser() {
            return apiResolver.resolve('user.list@get');
        }

        function goToPayment() {
            console.log(vm.essayType);
            console.log(vm.rec1File);
            docsHandler(vm.essayType);
            priceHandler(vm.essayType);
            if (vm.essayType == 2) {
                vm.files = [vm.rec1File, vm.rec2File, vm.cvFile];
            } else {
                vm.files = null;
            }
            $mdDialog.show({
                controller         : 'EssayPaymentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/essay-payment/essay-payment.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: false,
                locals             : {
                    essayInfo: {
                        user: vm.user,
                        wordCount: countOf(vm.essayText),
                        teacherInfo: vm.teacherInfo,
                        price: vm.price,
                        essayType: vm.essayType,
                        docs: vm.docs,
                        files: vm.files
                    },
                },
            });
        }

        function countOf(text) {
            var s = text ? text.split(/\s+/) : 0; // it splits the text on space/tab/enter
            return s ? s.length : 0;
        }

        function docsHandler(essayType) {
            if (essayType == 2) {
                vm.docs = [{
                    essayTitle: 'College Essay',
                    awsKey: null,
                    essayText: vm.essayText

                },
                {
                    essayTitle: 'Recommendation Letter 1',
                    awsKey: null,
                    essayText: null
                },
                {
                    essayTitle: 'Recommendation Letter 2',
                    awsKey: null,
                    essayText: null
                },
                {
                    essayTitle: 'CV',
                    awsKey: null,
                    essayText: null
                }];
            } else {
                switch (essayType) {
                    case 1: 
                        var title = 'College Essay Final Review';
                        break;
                    case 3: 
                        var title = 'TOEFL/IELFTS Essay';
                        break;
                    case 4: 
                        var title = 'SAT Essay';
                        break;
                    case 5: 
                        var title = 'Academic Writing Essay';
                }
                
                vm.docs = [{
                    essayTitle: title,
                    awsKey: null,
                    essayText: vm.essayText
                }];
            }
        }

        function priceHandler(essayType) {
            switch (essayType) {
                case 1: 
                    vm.price = 2 * countOf(vm.essayText);
                    break;
                case 2: 
                    vm.price = 7000;
                    break;
                case 3: 
                    vm.price = 2 * countOf(vm.essayText);
                    break;
                case 4: 
                    vm.price = 200;
                    break;
                case 5: 
                    vm.price = 0.1 * countOf(vm.essayText); 
            }
        }

        function _errorHandler(response) {
            console.error(response);
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.edit-teacher', [
            'ui.calendar',
            'app.dialogs.prompt',
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_edit-teacher', {
            url      : '/edit-teacher',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/edit-teacher/edit-teacher.html',
                    controller : 'EditTeacherController as vm'
                }
            },
            resolve  : {
                teacher: function (apiResolver) {
                    return apiResolver.resolve('teacher.byToken@get');
                },
                students: function (apiResolver) {
                    return apiResolver.resolve('student.getAllLinked@get');
                },
                categories: function (apiResolver) {
                    return apiResolver.resolve('priceCategories.list@get');
                },
                customPrices: function (apiResolver) {
                    return apiResolver.resolve('customPrices.list@get');
                },
                languageOption: function (apiResolver) {
                    return apiResolver.resolve('option.language@get');
                },
                subjects: function (apiResolver) {
                    return apiResolver.resolve('subject.list@get');
                }
            },
            bodyClass: 'edit-teacher',
            requireLogin: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/edit-teacher');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.edit-teacher')
        .controller('EditTeacherController', EditTeacherController);

    /** @ngInject */
    function EditTeacherController($filter, $mdDialog, $document, api, apiResolver, teacher, students, categories, customPrices, languageOption, subjects, stripe, $location, $rootScope, $state, $auth, $scope, $http)
    {
        var vm = this;
        var isSaved = 0;
        _switchRoleIfNecessary();
        var needPrevent = true;

        // Data
        vm.teacher = teacher.data;
        vm.subjects = Object.values(subjects.data);
        vm.teacher.schedulePolicy = parseInt(vm.teacher.schedulePolicy, 10);
        vm.teacher.cancelPolicy = parseInt(vm.teacher.cancelPolicy, 10);
        vm.teacher.defaultPrice = parseInt(vm.teacher.defaultPrice, 10);
        vm.students = students.data;
        vm.statusOpt = {
            allowClear : true
        };
        vm.categories = categories.data;
        vm.customPrices = customPrices.data;
        angular.forEach(vm.categories, function (category, key) {
            if (category.isActive == 1) category.isActive = true;
            else category.isActive = false;
        });
        // Default price range for teacher
        if (!vm.teacher.minPrice || !vm.teacher.maxPrice){
            vm.teacher.minPrice = 50;
            vm.teacher.maxPrice = 50;
        }
        if (!vm.teacher.data) {
            // vm.teacher.defaultPrice = 20;
        }
        vm.languageOption = languageOption.data;
        vm.stripeClientId = stripe.clientId;
        vm.showAddNewStudent = false;
        vm.searchTerm;

        // Methods
        vm.submit = submit;
        vm.getSharableLink = getSharableLink;
        vm.editProfilePic = editProfilePic;
        vm.changePassword = changePassword;
        vm.updateCategory = updateCategory;
        vm.createCategory = createCategory;
        vm.createCustomPrices = createCustomPrices;
        vm.updateCustomPrices = updateCustomPrices;
        vm.showOrHideExistStudent = showOrHideExistStudent;
        vm.clearSearchTerm = clearSearchTerm;

        // Functions
        function submit() {
            setTeacherDefaultPrice(vm.teacher);
            // change the format of price from string to integer
            vm.teacher.minPrice = parseFloat(vm.teacher.minPrice);
            vm.teacher.maxPrice = parseFloat(vm.teacher.maxPrice);
            if (vm.teacher.minPrice > vm.teacher.maxPrice){
                var tempPrice = vm.teacher.minPrice;
                vm.teacher.minPrice = vm.teacher.maxPrice;
                vm.teacher.maxPrice = tempPrice;
            }

            waitForResponse();

            api.teacher.byToken.put(vm.teacher, function (response) {
                $mdDialog.hide();
                $mdDialog.show(
                    $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .title($filter('translate')('EDIT_TEACHER.SUCCESS'))
                        .textContent($filter('translate')('EDIT_TEACHER.PROFILE_UPDATED'))
                        .ariaLabel($filter('translate')('EDIT_TEACHER.PROFILE_UPDATED'))
                        .ok($filter('translate')('EDIT_TEACHER.OK'))
                );

            },
            function (response) {
                $mdDialog.hide();
                // alert('Oh! Something unexpected happened!');
                // console.error(response);
            });
            isSaved = 1;
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Edit Profile Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function getSharableLink(){
            var sharableDialogContent = ' \
                <md-dialog> \
                    <md-content> \
                        <div class="dialog-title"> \
                            <p>Sharable link to use Nesuku privately</p> \
                        </div> \
                        <div class="dialog-intro"> \
                            <p>This link will allow you to use our system without entering the marketplace.</p> \
                            <p style="color:black;"><b>Simply share this link with your students:</b><br /></p> \
                            <md-input-container md-no-float class="md-block" flex-gt-sm> \
                                <input type="text" class="input-content" ng-model="sharableLink"> \
                            </md-input-container> \
                            <p style="color:red">Note: If you want to find new students through our marketplace, revert your profile back to public.</p> \
                        </div> \
                    </md-content> \
                    <md-dialog-actions> \
                        <md-button ng-click="closeDialog()" class="md-primary"> \
                          Okay \
                        </md-button> \
                    </md-dialog-actions> \
                </md-dialog> \
            ';

            $mdDialog.show({
                template            : sharableDialogContent,
                clickOutsideToClose : true,
                parent              : angular.element('#teacher-edit'),
                controller          : DialogController
            });
            function DialogController($scope, $mdDialog) {
                $scope.sharableLink = "https://www.nesuku.com/teacher/" + vm.teacher.id;
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        // Set default price for current teacher
        function setTeacherDefaultPrice(teacher){
            if (teacher.minPrice.length == 0){
                teacher.minPrice = 50;
            }
            if (teacher.maxPrice.length == 0) {
                teacher.maxPrice = 50;
            }
            if (teacher.defaultPrice.length == 0) {
                teacher.defaultPrice = 20;
            }
        }

        function editProfilePic() {
            $mdDialog.show({
                controller         : 'EditProfilePicController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/edit-profile-pic/edit-profile-pic.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {
                    teacher: vm.teacher,
                },
            });
        }

        function changePassword() {
            $mdDialog.show({
                controller         : 'ChangePasswordController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/change-password/change-password.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {},
            });
        }

        function clearSearchTerm() {
            vm.searchTerm = '';
        }

        function showOrHideExistStudent() {
            vm.isNewStudent = !vm.isNewStudent;
        }

        function createCustomPrices(email, name) {
            api.customPrices.list.post({
                email: email,
                name: name
            }, _successCategoryCallback, _errorCallback);
        }

        function updateCustomPrices(student) {
            api.customPrices.list.put({
                "studentId": student.studentId,
                "customPrices": student.customPrices
            },
            _successCategoryCallback, _errorCallback);
        }

        function createCategory() {
            api.priceCategories.list.post({
                "categoryName": "new category",
                "hourlyPrice": 10,
                "isActive": true
            },
            _successCreateCategoryCallback, _errorCallback);
        }

        function updateCategory(category) {
            api.priceCategories.byId.put({
                "id": category.id,
                "categoryName": category.categoryName,
                "hourlyPrice": category.hourlyPrice,
                "isActive": category.isActive
            },
            _successCategoryCallback, _errorCallback);
        }

        function _successCreateCategoryCallback(response) {
            _refreshCategories();

            if(vm.customPrices.length>0){
                angular.forEach(vm.customPrices, function(student, key) {
                    createCustomPrices(student.studentEmail, student.studentName);
                });
            }
        }

        function _refreshCategories() {
            api.priceCategories.list.get(function(response) {
                vm.categories = response.data;
                angular.forEach(vm.categories, function (category, key) {
                    if (category.isActive == 1) category.isActive = true;
                    else category.isActive = false;
                });
            },_errorCallback);
            api.customPrices.list.get(function(response) {
                vm.customPrices = response.data;
            },_errorCallback);
        }

        function _successCategoryCallback(response) {
            _refreshCategories();
        }
        function _errorCallback(response) {
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

        //路由监听事件
        $rootScope.$on('$stateChangeStart',function(event, toState, toParams, fromState, fromParams) {
            if($state.current.name === 'app.pages_edit-teacher' && needPrevent && isSaved > 1) {
                // console.log("needPrevent: " + needPrevent);
                // console.log("isSaved: " + isSaved);
                event.preventDefault();
                $mdDialog.show({
                    controller         : 'PromptController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/dialogs/prompt/prompt.html',
                    parent             : angular.element($document.body),
                    clickOutsideToClose: false,
                    locals             : {
                        teacher: vm.teacher,
                    },
                }).then(function(response) {
                    if(response) {
                        if(toState.name === 'app.pages_teacher-list') {
                            api.auth.switchRole.post({token:$auth.getToken(),role:'student'},function(response) {
                                $auth.setToken(response.token);
                                var payload = $auth.getPayload();
                                $rootScope.isAuthenticated = $auth.isAuthenticated();
                                $rootScope.userRole = 'student';
                                needPrevent = false;
                                $state.go('app.pages_teacher-list', {is_conversation_partner: toParams.is_conversation_partner});
                            });
                        }
                        else {
                            needPrevent = false;
                            $state.go(toState.name);
                        }
                    }
                });
            }
        });

        $scope.$on('$destroy', function(event){
            window.onbeforeunload = undefined;
        });

        $scope.$watch("vm.teacher",function(newVal, oldVal, scope){
            if (newVal !== oldVal) {
                vm.teacher.scheduleisNull = (isNaN(vm.teacher.schedulePolicy));
                vm.teacher.cancelisNull = (isNaN(vm.teacher.cancelPolicy));
                isSaved += 1;
            }
        },true);

        function _switchRoleIfNecessary() {
            var payload = $auth.getPayload();
            if(payload.role != 1) {
                api.auth.switchRole.post({token: $auth.getToken(), role: 'teacher'},
                    function(response) {
                        _updateToken(response.token);
                    },
                    function(response) {
                        alert("Sorry, you don't have permission to visit this page.");
                        history.back();
                    }
                );
            }
        }

        function _updateToken(token) {
            $auth.setToken(token);
            var payload = $auth.getPayload();
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            switch(payload.role) {
                case 0:
                    $rootScope.userRole = 'admin';
                    break;

                case 1:
                    $rootScope.userRole = 'teacher';
                    break;

                case 2:
                    $rootScope.userRole = 'student';
                    break;

                default:
                    console.error("Invalid Role");
                    break;
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.covid', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_covid', {
            url      : '/covid',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/covid/covid.html',
                    controller : 'CovidController as vm'
                }
            },
            bodyClass: 'covid',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/covid');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.covid')
        .controller('CovidController', CovidController);

    /** @ngInject */
    function CovidController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku = contactNesuku;
        vm.goToApplyForm = goToApplyForm;
        vm.goToHwHelp = goToHwHelp;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }

        function goToApplyForm() {
            $state.go('app.pages_teach-form');
        }

        function goToHwHelp() {
            $state.go('app.pages_hw-help');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.conversation-partners', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_conversation-partners', {
            url      : '/conversation-coaches',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/conversation-partners/conversation-partners.html',
                    controller : 'ConversationPartnersController as vm'
                }
            },
            bodyClass: 'conversation-partners',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/conversation-partners');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.conversation-partners')
        .controller('ConversationPartnersController', ConversationPartnersController);

    /** @ngInject */
    function ConversationPartnersController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku_freeConsultation = contactNesuku_freeConsultation;
        vm.contactNesuku_freeTrial = contactNesuku_freeTrial;
        vm.goToCPForm = goToCPForm;
        vm.goToBecomeCPForm = goToBecomeCPForm;

        // Functions
        function contactNesuku_freeConsultation() {
            location.href = constNesukuEmail+'?subject=Free Consultation';
        }

        function contactNesuku_freeTrial() {
            location.href = constNesukuEmail+'?subject=Free Trial';
        }
        
        function goToCPForm() {
            $state.go('app.pages_teacher-list', {is_conversation_partner: 'cp'});
        }

        function goToBecomeCPForm() {
            $state.go('app.pages_become-cp-form');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.message')
        .controller('ChatController', ChatController);

    /** @ngInject */
    function ChatController(Contacts, ChatsService, $mdSidenav, User, $timeout, $document, $mdMedia, $auth, $rootScope, api, $filter, $scope)
    {

        var vm = this;

        $rootScope.currentNavItem = 'Message';


        // Data
        vm.contacts = ChatsService.contacts = Contacts.data;
        vm.chats = ChatsService.chats;
        vm.user = User.data;
        vm.leftSidenavView = false;
        vm.chat = undefined;
        vm.chatContactId = undefined;


        // Methods
        vm.getChat = getChat;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleLeftSidenavView = toggleLeftSidenavView;
        vm.reply = reply;
        vm.setUserStatus = setUserStatus;
        vm.clearMessages = clearMessages;
        vm.sendMessage = sendMessage;


        // Init
        //readNotification();
        //////////

        /**
         * Get Chat by Contact id
         * @param contactId
         */
        function getChat(contactId, toggleFlag)
        {
            ChatsService.getContactChat(contactId).then(function (response)
            {
                vm.chatContactId = contactId;

                vm.chat = response;

                // Update last message
                if (contactId){
                    vm.contacts.getById(contactId).lastMessage = vm.chat[vm.chat.length - 1];
                }

                refreshContactList();
  
                // Reset the reply textarea
                resetReplyTextarea();

                // Scroll to the last message
                scrollToBottomOfChat();

                if ( !$mdMedia('gt-md') && toggleFlag == true)
                {
                    $mdSidenav('left-sidenav').close();
                }

                // Reset Left Sidenav View
                if (toggleFlag == true)
                    vm.toggleLeftSidenavView(false);
            });
        }

        /**
         * Reply
         */
        function reply($event)
        {
            // If "shift + enter" pressed, grow the reply textarea
            if ( $event && $event.keyCode === 13 && $event.shiftKey )
            {
                vm.textareaGrow = true;
                return;
            }

            // Prevent the reply() for key presses rather than the"enter" key.
            if ( $event && $event.keyCode !== 13 )
            {
                return;
            }

            // Check for empty messages
            if ( vm.replyMessage === '' )
            {
                resetReplyTextarea();
                return;
            }

            // Message
            var message = {
                who    : 'user',
                message: vm.replyMessage,
                time   : new Date().toISOString()
            };

            // Add the message to the chat
            vm.chat.push(message);
            sendMessage();

            // Update Contact's lastMessage
            vm.contacts.getById(vm.chatContactId).lastMessage = message;

            // Reset the reply textarea
            resetReplyTextarea();

            // Scroll to the new message
            scrollToBottomOfChat();

        }

        /**
         * Clear Chat Messages
         */
        function clearMessages()
        {
            vm.chats[vm.chatContactId] = vm.chat = [];
            vm.contacts.getById(vm.chatContactId).lastMessage = null;
        }

        /**
         * Reset reply textarea
         */
        function resetReplyTextarea()
        {
            vm.replyMessage = '';
            vm.textareaGrow = false;
        }

        /**
         * Scroll Chat Content to the bottom
         * @param speed
         */
        function scrollToBottomOfChat()
        {
            $timeout(function ()
            {
                var chatContent = angular.element($document.find('#chat-content'));

                chatContent.animate({
                    scrollTop: chatContent[0].scrollHeight
                }, 400);
            }, 0);

        }

        /**
         * Set User Status
         */
        function setUserStatus(status)
        {
            vm.user.status = status;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle Left Sidenav View
         *
         * @param view id
         */
        function toggleLeftSidenavView(id)
        {
            vm.leftSidenavView = id;
        }

        function sendMessage()
        {
            var payload = $auth.getPayload();
            ChatsService.postMessage(vm.chatContactId, vm.replyMessage);
        }

        /*
        function readNotification() {
            api.notifications.list.post({
                type: 2
            }, successReadHandler, errorHandler);
        }
        */

        function successReadHandler(response) {
            $rootScope.notifications = response.data;
        }

        function errorHandler(response) {
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }


        function refreshContactList() {
            // refresh contact list
            ChatsService.refreshContacts().then(function(response){
                vm.contacts = ChatsService.contacts = response.data;

                var unread = false;
                // If all message are read: clear notification dot
                for (var i = 0; i < vm.contacts.length; i++){
                    if (vm.contacts[i].unread == true){
                        unread = true;
                        break;
                    }
                }
                if (unread == false){
                    // every message is read: clear notification dot
                    $rootScope.notifications.message = false;
                }
            });
        }


        $scope.$on('newMessage', function(event){
            if ($rootScope.notifications.message && $rootScope.state.current.name == "app.pages_message"){  
                if (vm.chatContactId){
                    getChat(vm.chatContactId, false);
                }
                else {
                    refreshContactList();
                }
                
            }
        });

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.apply-to-teach', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_apply-to-teach', {
            url      : '/apply-to-teach',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/apply-to-teach/apply-to-teach.html',
                    controller : 'ApplyToTeachController as vm'
                }
            },
            bodyClass: 'apply-to-teach',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/apply-to-teach');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.apply-to-teach')
        .controller('ApplyToTeachController', ApplyToTeachController);

    /** @ngInject */
    function ApplyToTeachController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        vm.downLoadPDF = downLoadPDF;
        
        // Methods
        vm.contactNesuku = contactNesuku;
        vm.goToApplyForm = goToApplyForm;
        vm.goToCPForm = goToCPForm;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }

        function downLoadPDF() {
            var pdfURL = "/file/20170730_Client_Development_Teacher_Pitch.vSHARED.pdf";
            window.open(pdfURL,'_blank');
        }

        function goToApplyForm() {
            $state.go('app.pages_teach-form')
        }

        function goToCPForm() {
            $state.go('app.pages_become-cp-form');
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.blog', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_blog', {
            url      : '/blog',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/blog/blog.html',
                    controller : 'BlogController as vm'
                }
            },
            bodyClass: 'blog',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/blog');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.blog')
        .controller('BlogController', BlogController);

    /** @ngInject */
    function BlogController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku = contactNesuku;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.become-cp-form', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_become-cp-form', {
            url      : '/become-cp-form',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/become-cp-form/become-cp-form.html',
                    controller : 'BecomeCPFormController as vm'
                }
            },
            bodyClass: 'become-cp-form',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/become-cp-form');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.become-cp-form')
        .controller('BecomeCPFormController', BecomeCPFormController);

    /** @ngInject */
    function BecomeCPFormController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku = contactNesuku;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.app-dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_app-dashboard', {
            url      : '/app-dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/app-dashboard/app-dashboard.html',
                    controller : 'AppDashboardController as vm'
                }
            },
            bodyClass: 'app-dashboard',
            requireLogin: true,
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/app-dashboard');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.app-dashboard')
        .controller('AppDashboardController', AppDashboardController);

    /** @ngInject */
    function AppDashboardController($rootScope, $mdDialog, api, $filter, $q)
    {
        var vm = this;

        // Data
        vm.name = '';
        vm.url = '';
        vm.picUrl = '';
        vm.price = 0;
        vm.description = '';
        vm.youtube = '';

        // Methods
        vm.submit = submit;

        function submit() {
            var data = {
                name: vm.name,
                url: vm.url,
                picUrl: vm.picUrl,
                price: vm.price,
                description: vm.description,
                youtube: vm.youtube
            };

            api.app.create.post(data, _successHandler, _errorHandler);
        }

        function _successHandler() {
            console.log('App created!');
        }

        function _errorHandler(response) {
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.admin-dashboard', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_admin-dashboard', {
            url      : '/admin-dashboard',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/admin-dashboard/admin-dashboard.html',
                    controller : 'AdminDashboardController as vm'
                }
            },
            bodyClass: 'admin-dashboard',
            requireLogin: true,
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/admin-dashboard');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.admin-dashboard')
        .controller('AdminDashboardController', AdminDashboardController);

    /** @ngInject */
    function AdminDashboardController($rootScope, $document, $mdDialog, api, apiResolver, $filter, $auth, $q, $state)
    {
        var vm = this;
        var payload = $auth.getPayload();
        $rootScope.userRole = getUserRole();

        $rootScope.currentNavItem = 'Admin Dashboard';

        // Data
        vm.courses = null;
        vm.unpaidcourses = null;
        vm.teachers = null;
        vm.students = [];
        vm.isLoading = true;
        vm.colors = ["#FF0F00", "#FF6600", "#FF9E01", "#FCD202", "#F8FF01", "#B0DE09", "#04D215", "#0D8ECF"];
        vm.dashboard1 = {};
        vm.dashboard1.level = 1;
        vm.dashboard1.title = [];
        vm.dashboard1.chart = null;
        vm.dashboard1.chartName = "revenueChart";

        vm.dashboard2 = {};
        vm.dashboard2.level = 1;
        vm.dashboard2.title = [];
        vm.dashboard2.chart = null;
        vm.dashboard2.chartName = "incomeChart";

        vm.dashboard3 = {};
        vm.dashboard3.level = 1;
        vm.dashboard3.title = [];
        vm.dashboard3.chart = null;
        vm.dashboard3.chartName = "hourChart";

        vm.dashboard4 = {};
        vm.dashboard4.level = 1;
        vm.dashboard4.title = [];
        vm.dashboard4.chart = null;
        vm.dashboard4.chartName = "courseChart";

        // Methods
        vm.payTeacher = payTeacher;
        vm.remindStudent = remindStudent;
        vm.messageStudent = messageStudent;
        vm.unpaidCourses = unpaidCourses;
        vm.refreshDashboard = refreshDashboard;
        vm.previousLevel = previousLevel;
        vm.getTeacherList = getTeacherList;
        vm.getStudentList = getStudentList;
        vm.getCourseList = getCourseList;

        // Pagination
        vm.studentPagination = {
            totalItems: null,
            currentPage: null,
            itemsPerPage: 100
        };
        vm.teacherPagination = {
            totalItems: null,
            currentPage: null,
            itemsPerPage: 100
        };
        vm.coursePagination = {
            totalItems: null,
            currentPage: null,
            itemsPerPage: 100
        };

        // Functions
        function payTeacher(course) {
            var confirm = $mdDialog.confirm()
                  .title('Transfer Money')
                  .textContent('Are you sure you want to transfer money to this teacher?')
                  .ariaLabel('Transfer Money')
                  .clickOutsideToClose(true)
                  .parent(angular.element(document.body))
                  .ok('Yes')
                  .cancel('No');

            $mdDialog.show(confirm).then(function() {
                api.remittance.byCourseId.post({
                    courseId: course.id,
                }, function (response) {
                    angular.forEach(vm.unpaidcourses, function (specificCourse, index) {
                        if (specificCourse.id == course.id) {
                            vm.unpaidcourses.splice(index, 1);
                        }
                    });
                }, function (response) {
                    alert('Oh! Something unexpected happened!');
                    console.error(response);
                }); 
            });
        }

        // refresh all dashboards
        function refreshDashboard(){
            switch($rootScope.userRole) {
                case 'admin':
                    dashboard1Level1Response();
                    break;
                case 'teacher':
                    dashboard2Level1Response();
                    dashboard4Level1Response()
                    break;
                case 'student':
                    dashboard3Level1Response();
                    break;
                default:
                    console.error("Need to log in!");
            }
        }

        // create amChart
        function initChart(data, chartName){
            var valuefield = Object.keys(data[0])[1];
            var AxesTitle = chartName.slice(0,1).toUpperCase()+chartName.slice(1,-5);
            return AmCharts.makeChart(chartName, {
                "theme": "light",
                "type": "serial",
                "creditsPosition": "top-right",
                "startDuration": 1,
                "dataProvider": data,
                "graphs": [{
                    "balloonText": "[[category]]: <b>[[value]]</b>",
                    "fillColorsField": "color",
                    "labelText": "[[value]]",
                    "fillAlphas": 1,
                    "lineAlpha": 0.1,
                    "type": "column",
                    "valueField": valuefield,
                    "columnWidth" : 0.6
                }],
                "valueAxes": [{
                    "position": "left",
                    "title": AxesTitle
                }],
                "depth3D": 20,
                "angle": 20,
                "chartCursor": {
                    "categoryBalloonEnabled": false,
                    "cursorAlpha": 0,
                    "zoomable": false
                },
                "categoryAxis": {
                    "gridPosition": "start"
                },
                "export": {
                    "enabled": true
                }
            });
        }


        function getAnnuallyRevenue(){
            // TODO: get data from API (get request)
            // Fake data here
            
            // var data = {
            //     "annuallyRevenue": 
            //     [{
            //         "year": 2013,
            //         "revenue": 788
            //     }, {
            //         "year": 2014,
            //         "revenue": 1122
            //     }, {
            //         "year": 2015,
            //         "revenue": 1114
            //     }, {
            //         "year": 2016,
            //         "revenue": 2500
            //     }, {
            //         "year": 2017,
            //         "revenue": 4025
            //     }]
            // };

            
            var deferred = $q.defer();

            api.admin.revenue.get(null, function(response){
                deferred.resolve(response);
            },
            function(response){
                deferred.reject(response);
            })
            console.log(deferred);
            return deferred.promise;
        }

        function getMonthlyRevenue(dashboard){
            var requestYear = dashboard.year;
            // TODO: get data from API (request parameter: year)
            
            // var data = {
            //     "monthlyRevenue": 
            //     [{
            //         "month": 3,
            //         "revenue": 200
            //     }, {
            //         "month": 4,
            //         "revenue": 320
            //     }, {
            //         "month": 7,
            //         "revenue": 168
            //     }]
            // };
            
            var deferred = $q.defer();
            var params = {
                year: requestYear
            };
            api.admin.revenue.get(params, function(response){
                //console.log(response.data);
                deferred.resolve(response);
            },
            function(response){
                deferred.reject(response);
            })

            return deferred.promise;
        }

        function getDailyRevenue(dashboard) {
            var requestYear = dashboard.year;
            var requestMonth = dashboard.month;

            // TODO: get data from API
            
            // var data = {
            //     "dailyRevenue": 
            //     [{
            //         "day": 1,
            //         "revenue": 30
            //     }, {
            //         "day": 2,
            //         "revenue": 37
            //     }, {
            //         "day": 3,
            //         "revenue": 12
            //     }, {
            //         "day": 4,
            //         "revenue": 59
            //     }]
            // };
            
            var deferred = $q.defer();
            var params = {
                year: requestYear,
                month: requestMonth
            };
            api.admin.revenue.get(params, function(response){
                deferred.resolve(response);
            },
            function(response){
                deferred.reject(response);
            })

            return deferred.promise;
        }

        function renderStyle(dashboard){
            var text = dashboard.title.join(' > ');
            // var i = 0;
            // dashboard.title.forEach(function(element) {
            //     if (i==0){
            //         text += element;
            //     }
            //     else{
            //         text += " > " + element;
            //     }
            //     i += 1;
            // });
            if (dashboard.level == 1){

                angular.forEach(dashboard.chart.dataProvider, function(item, index){
                    index = index % vm.colors.length;
                    item.color = vm.colors[index];
                });
                dashboard.chart.titles = [{
                    "text": text
                }];
                dashboard.chart.categoryField = "year";
                dashboard.chart.categoryAxis.title = "Year";
            }
            else if (dashboard.level == 2){

                angular.forEach(dashboard.chart.dataProvider, function(item, index){
                    index = index % vm.colors.length;
                    item.color = vm.colors[vm.colors.length - 1 - index];
                });
                dashboard.chart.titles = [{
                    "text": text
                }];
                dashboard.chart.categoryField = "month";
                dashboard.chart.categoryAxis.title = "Month";
               
            }
            else if (dashboard.level == 3){
                angular.forEach(dashboard.chart.dataProvider, function(item, index){
                    index = (2 * index) % vm.colors.length;
                    item.color = vm.colors[index];
                });
                dashboard.chart.titles = [{
                    "text": text
                }];
                dashboard.chart.categoryField = "day";
                dashboard.chart.categoryAxis.title = "Day";
            }

            // redraw the graph
            dashboard.chart.validateData();
        }


        function dashboard1Level1Response(){
            getAnnuallyRevenue().then(function(response){
                var data = response.data;

                data = data["annuallyRevenue"];

                console.log(data);

                vm.dashboard1.level = 1;
                maketitle(vm.dashboard1);
                vm.dashboard1.title.push("annuallyRevenue");
                vm.dashboard1.chart = initChart(data, vm.dashboard1.chartName);
                console.log(vm.dashboard1);
                // render style
                renderStyle(vm.dashboard1);

                // add click event listener
                vm.dashboard1.chart.addListener("clickGraphItem", function(event){
                    // Angular apply is necessary here, otherwise dashboard.level will not update
                    $rootScope.$apply(function(){
                        vm.dashboard1.year = event.item.dataContext.year;
                        dashboard1Level2Response();
                    });
                });
            });
        }

        function dashboard1Level2Response(){
            getMonthlyRevenue(vm.dashboard1).then(function(response){
                var data = response.data;

                data = data["monthlyRevenue"];

                vm.dashboard1.level = 2;
                vm.dashboard1.title.push("monthlyRevenue");
                vm.dashboard1.chart.clear();
                vm.dashboard1.chart = initChart(data, vm.dashboard1.chartName);
                vm.dashboard1.previousLevel = dashboard1Level1Response;
                // console.log(vm.dashboard1);

                // render style
                renderStyle(vm.dashboard1);

                // add click event listener
                vm.dashboard1.chart.addListener("clickGraphItem", function(event){
                    $rootScope.$apply(function(){
                        vm.dashboard1.month = event.item.dataContext.month;
                        dashboard1Level3Response();
                    });
                });
            });
        }

        function dashboard1Level3Response(){
            getDailyRevenue(vm.dashboard1).then(function(response){
                var data = response.data;
                data = data["dailyRevenue"];

                vm.dashboard1.level = 3;
                vm.dashboard1.title.push("dailyRevenue");
                vm.dashboard1.chart.clear();
                vm.dashboard1.chart = initChart(data, vm.dashboard1.chartName);
                vm.dashboard1.previousLevel = dashboard1Level2Response;

                // render style
                renderStyle(vm.dashboard1);
            });
        }

        function dashboard2Level1Response(){
            // var data = response.data;
            var data = {
                "annuallyIncome": 
                [{
                    "year": 2013,
                    "income": 788
                }, {
                    "year": 2014,
                    "income": 1122
                }, {
                    "year": 2015,
                    "income": 1114
                }, {
                    "year": 2016,
                    "income": 2500
                }, {
                    "year": 2017,
                    "income": 4025
                }]
            };

            data = data["annuallyIncome"];

            console.log(data);

            vm.dashboard2.level = 1;
            maketitle(vm.dashboard2);
            vm.dashboard2.title = ['annuallyIncome'];
            vm.dashboard2.chart = initChart(data, vm.dashboard2.chartName);
            console.log(vm.dashboard2);
            // render style
            renderStyle(vm.dashboard2);

            // add click event listener
            vm.dashboard2.chart.addListener("clickGraphItem", function(event){
                // Angular apply is necessary here, otherwise dashboard.level will not update
                $rootScope.$apply(function(){
                    vm.dashboard2.year = event.item.dataContext.year;
                    dashboard2Level2Response();
                });
            });
            // getAnnuallyRevenue().then(function(response){
            //     var data = response.data;

            //     data = data["annuallyIncome"];

            //     console.log(data);

            //     vm.dashboard2.title.push("annuallyIncome");
            //     vm.dashboard2.level = 1;
            //     vm.dashboard2.chart = initChart(data, vm.dashboard2.chartName);
            //     console.log(vm.dashboard2.chart);
            //     // render style
            //     renderStyle(vm.dashboard2);

            //     // add click event listener
            //     vm.dashboard2.chart.addListener("clickGraphItem", function(event){
            //         // Angular apply is necessary here, otherwise dashboard.level will not update
            //         $rootScope.$apply(function(){
            //             vm.dashboard2.year = event.item.dataContext.year;
            //             dashboard2Level2Response();
            //         });
            //     });
            // });
        }

        function dashboard2Level2Response(){
            var data = {
                "monthlyIncome": 
                [{
                    "month": 3,
                    "income": 200
                }, {
                    "month": 4,
                    "income": 320
                }, {
                    "month": 7,
                    "income": 168
                }]
            };

            data = data["monthlyIncome"];

            vm.dashboard2.level = 2;
            vm.dashboard2.title.push("monthlyIncome");
            vm.dashboard2.chart.clear();
            vm.dashboard2.chart = initChart(data, vm.dashboard2.chartName);
            vm.dashboard2.previousLevel = dashboard2Level1Response;
            // console.log(vm.dashboard2);

            // render style
            renderStyle(vm.dashboard2);

            // add click event listener
            vm.dashboard2.chart.addListener("clickGraphItem", function(event){
                $rootScope.$apply(function(){
                    vm.dashboard2.month = event.item.dataContext.month;
                    dashboard2Level3Response();
                });
            });

            // getMonthlyRevenue(vm.dashboard2).then(function(response){
            //     console.log(response.data);
            //     var data = response.data;


            //     data = data["monthlyIncome"];

            //     vm.dashboard2.title.push("monthlyIncome");
            //     vm.dashboard2.level = 2;
            //     vm.dashboard2.chart.clear();
            //     vm.dashboard2.chart = initChart(data, vm.dashboard2.chartName);

            //     // render style
            //     renderStyle(vm.dashboard2);

            //     // add click event listener
            //     vm.dashboard2.chart.addListener("clickGraphItem", function(event){
            //         $rootScope.$apply(function(){
            //             vm.dashboard2.month = event.item.dataContext.month;
            //             dashboard2Level3Response();
            //         });
            //     });
            // });
        }

        function dashboard2Level3Response(){
            var data = {
                "dailyIncome": 
                [{
                    "day": 1,
                    "income": 30
                }, {
                    "day": 2,
                    "income": 37
                }, {
                    "day": 3,
                    "income": 12
                }, {
                    "day": 4,
                    "income": 59
                }]
            };
            data = data["dailyIncome"];

            vm.dashboard2.level = 3;
            vm.dashboard2.title.push("dailyIncome");
            vm.dashboard2.chart.clear();
            vm.dashboard2.chart = initChart(data, vm.dashboard2.chartName);
            vm.dashboard2.previousLevel = dashboard2Level2Response;

            // render style
            renderStyle(vm.dashboard2);

            // getDailyRevenue(vm.dashboard2).then(function(response){
            //     var data = response.data;
              
            //     data = data["dailyIncome"];

            //     vm.dashboard2.title.push("dailyIncome");
            //     vm.dashboard2.level = 3;
            //     vm.dashboard2.chart.clear();
            //     vm.dashboard2.chart = initChart(data, vm.dashboard2.chartName);

            //     // render style
            //     renderStyle(vm.dashboard2);

            //     // last level does not have listener
            // });
        }

        function dashboard3Level1Response(){
            // var data = response.data;
            var data = {
                "annuallyHour": 
                [{
                    "year": 2013,
                    "studyhour": 788
                }, {
                    "year": 2014,
                    "studyhour": 1122
                }, {
                    "year": 2015,
                    "studyhour": 1114
                }, {
                    "year": 2016,
                    "studyhour": 2500
                }, {
                    "year": 2017,
                    "studyhour": 4025
                }]
            };

            data = data["annuallyHour"];

            console.log(data);

            vm.dashboard3.level = 1;
            maketitle(vm.dashboard3);
            vm.dashboard3.title.push("annuallyHour");
            vm.dashboard3.chart = initChart(data, vm.dashboard3.chartName);
            console.log(vm.dashboard3);
            // render style
            renderStyle(vm.dashboard3);

            // add click event listener
            vm.dashboard3.chart.addListener("clickGraphItem", function(event){
                // Angular apply is necessary here, otherwise dashboard.level will not update
                $rootScope.$apply(function(){
                    vm.dashboard3.year = event.item.dataContext.year;
                    dashboard3Level2Response();
                });
            });
            // getAnnuallyRevenue().then(function(response){
            //     var data = response.data;

            //     data = data["annuallyHour"];

            //     console.log(data);

            //     vm.dashboard3.title.push("annuallyHour");
            //     vm.dashboard3.level = 1;
            //     vm.dashboard3.chart = initChart(data, vm.dashboard3.chartName);
            //     console.log(vm.dashboard3.chart);
            //     // render style
            //     renderStyle(vm.dashboard3);

            //     // add click event listener
            //     vm.dashboard3.chart.addListener("clickGraphItem", function(event){
            //         // Angular apply is necessary here, otherwise dashboard.level will not update
            //         $rootScope.$apply(function(){
            //             vm.dashboard3.year = event.item.dataContext.year;
            //             dashboard3Level2Response();
            //         });
            //     });
            // });
        }

        function dashboard3Level2Response(){
            var data = {
                "monthlyHour": 
                [{
                    "month": 3,
                    "studyhour": 200
                }, {
                    "month": 4,
                    "studyhour": 320
                }, {
                    "month": 7,
                    "studyhour": 168
                }]
            };

            data = data["monthlyHour"];

            vm.dashboard3.level = 2;
            vm.dashboard3.title.push("monthlyHour");
            vm.dashboard3.chart.clear();
            vm.dashboard3.chart = initChart(data, vm.dashboard3.chartName);
            vm.dashboard3.previousLevel = dashboard3Level1Response;
            // console.log(vm.dashboard3);

            // render style
            renderStyle(vm.dashboard3);

            // add click event listener
            vm.dashboard3.chart.addListener("clickGraphItem", function(event){
                $rootScope.$apply(function(){
                    vm.dashboard3.month = event.item.dataContext.month;
                    dashboard3Level3Response();
                });
            });

            // getMonthlyRevenue(vm.dashboard3).then(function(response){
            //     console.log(response.data);
            //     var data = response.data;


            //     data = data["monthlyHour"];

            //     vm.dashboard3.title.push("monthlyHour");
            //     vm.dashboard3.level = 2;
            //     vm.dashboard3.chart.clear();
            //     vm.dashboard3.chart = initChart(data, vm.dashboard3.chartName);

            //     // render style
            //     renderStyle(vm.dashboard3);

            //     // add click event listener
            //     vm.dashboard3.chart.addListener("clickGraphItem", function(event){
            //         $rootScope.$apply(function(){
            //             vm.dashboard3.month = event.item.dataContext.month;
            //             dashboard3Level3Response();
            //         });
            //     });
            // });
        }

        function dashboard3Level3Response(){
            var data = {
                "dailyHour": 
                [{
                    "day": 1,
                    "studyhour": 30
                }, {
                    "day": 2,
                    "studyhour": 37
                }, {
                    "day": 3,
                    "studyhour": 12
                }, {
                    "day": 4,
                    "studyhour": 59
                }]
            };
            data = data["dailyHour"];

            vm.dashboard3.level = 3;
            vm.dashboard3.title.push("dailyHour");
            vm.dashboard3.chart.clear();
            vm.dashboard3.chart = initChart(data, vm.dashboard3.chartName);
            vm.dashboard3.previousLevel = dashboard3Level2Response;

            // render style
            renderStyle(vm.dashboard3);

            // getDailyRevenue(vm.dashboard3).then(function(response){
            //     var data = response.data;
              
            //     data = data["dailyHour"];

            //     vm.dashboard3.title.push("dailyHour");
            //     vm.dashboard3.level = 3;
            //     vm.dashboard3.chart.clear();
            //     vm.dashboard3.chart = initChart(data, vm.dashboard3.chartName);

            //     // render style
            //     renderStyle(vm.dashboard3);

            //     // last level does not have listener
            // });
        }

        function dashboard4Level1Response(){
            var data = {
                "annuallyCourse": 
                [{
                    "year": 2014,
                    "hour": 200
                }, {
                    "year": 2015,
                    "hour": 53
                }, {
                    "year": 2016,
                    "hour": 79
                }, {
                    "year": 2017,
                    "hour": 2
                }]
            };

            data = data["annuallyCourse"];

            console.log(data);

            vm.dashboard4.level = 1;
            vm.dashboard4.title = ['Course'];
            vm.dashboard4.chart = initChart(data, vm.dashboard4.chartName);
            console.log(vm.dashboard4);
            // render style
            renderStyle(vm.dashboard4);
        }


        function previousLevel(dashboard){
            if (dashboard.level > 1){
                dashboard.level = dashboard.level - 1;
                maketitle(dashboard);
                dashboard.previousLevel();
            }
            else{
                dashboard.level = 1;
                refreshDashboard();
            }
        }

        function maketitle(dashboard){
            while (dashboard.title.length > dashboard.level-1){
                dashboard.title.pop();
                console.log(dashboard.title.length);
            }
        } 


        function getUnpaidCourseList() {
            api.unpaidCourse.list.get(null,
            function (response) {
                vm.unpaidcourses = response.data;
                angular.forEach(vm.unpaidcourses, function (course) {
                    course.start = moment(course.start).format('MMM DD, YYYY hh:mm:ss a');
                    course.end = moment(course.end).format('MMM DD, YYYY hh:mm:ss a');
                    course.canTransfer = ( ! course.isPaid) && course.isConnected;
                });
                vm.isLoading = false;
            },
            function (response) {
                alert('Oh! Something unexpected happened!');
                console.error(response);
            });
        }


        function getTeacherList() {
            console.log('getTeacherList');
            api.admin.teacherList.get({page: vm.teacherPagination.currentPage}, 
                function (response) {
                    vm.teachers = response.data;
                    vm.teacherPagination.totalItems = response.total;
                    vm.teacherPagination.currentPage = response.currentPage;
                    angular.forEach(vm.teachers, function (teacher) {
                        teacher.createdAt = moment(teacher.createdAt).format('MMM DD, YYYY hh:mm a');
                    });
                }, 
                function (response) {
                    alert('Oh! Something unexpected happened!');
                    console.error(response);
                }
            );
        }

        function getStudentList() {
            if ($rootScope.userRole == 'teacher'){
                api.student.getAllLinked.get(null, 
                    function (response) {
                        vm.students = response.data;
                        vm.students = $filter('orderBy')(vm.students,'name');
                        // angular.forEach(vm.students, function (student) {
                        //     student.updated = moment(student.updated_at).format('MMM DD, YYYY hh:mm:ss a');
                        //     student.created = moment(student.created_at).format('MMM DD, YYYY hh:mm:ss a');
                        // });
                        // console.log('vm.students');
                        console.log(vm.students);
                    }, 
                    function (response) {
                        alert('Oh! Something unexpected happened!');
                        console.error(response);
                    }
                );
            }

            if ($rootScope.userRole == 'admin'){
                api.admin.studentList.get({page: vm.studentPagination.currentPage}, 
                    function (response) {
                        vm.students = response.data;
                        vm.studentPagination.totalItems = response.total;
                        vm.studentPagination.currentPage = response.currentPage;
                        angular.forEach(vm.students, function (student) {
                            student.createdAt = moment(student.createdAt).format('MMM DD, YYYY hh:mm a');
                        });
                    }, 
                    function (response) {
                        alert('Oh! Something unexpected happened!');
                        console.error(response);
                    }
                );

            }

        }

        function getCourseList() {
            if ($rootScope.userRole == 'admin'){
                api.adminCourseTimes.list.get({page: vm.coursePagination.currentPage}, 
                    function (response) {
                        vm.courses = response.data;
                        vm.coursePagination.totalItems = response.total;
                        vm.coursePagination.currentPage = response.currentPage;
                        angular.forEach(vm.courses, function (course) {
                            course.start = moment(course.start).format('MMM DD, YYYY hh:mm a');
                            course.end = moment(course.end).format('MMM DD, YYYY hh:mm a');
                        });
                    }, 
                    function (response) {
                        console.error(response);
                    }
                );
            }

            if ($rootScope.userRole == 'teacher' || $rootScope.userRole == 'student'){
                api.statusCourseTimes.list.get(null, 
                    function (response) {
                        vm.courses = response.data;
                        angular.forEach(vm.courses, function(course) {
                            // Add startsIn property
                            course.startsIn = moment(course.start).format('YYYY-MM-DD, hh:mm a');
                            // Add startsIn property
                            course.endsIn = moment(course.end).format('YYYY-MM-DD, hh:mm a');
                        });
                        vm.courses = $filter('orderBy')(vm.courses,'start');
                        console.log(vm.courses);
                    }, 
                    function (response) {
                        console.error(response);
                    }
                );
            }
        }

        // can add students in the admin dashboard later if possible.

        function remindStudent(student) {
            console.log('Reminding student...');
            console.log(student);
            api.student.remindStudent.get(student,
                function (response) {
                    console.log('function1');
                },
                function (response) {
                    console.log('function2');
                })
        }

        function messageStudent(student) {
            console.log('Messaging student...');
            console.log(student);
            $state.go('app.pages_message', {id: student.id}); //may use student id to find the chat box.
            // $state.go('app.pages_message');
        }

        function unpaidCourses(student) {
            console.log('Scheduling a course...');
            console.log(student);
            // We can use the dialog/makeup-payment.
            // api.paymentMakeUp.
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }


        function _init() {
            // get unpaid course list
            getUnpaidCourseList();

            // get teacher list
            getTeacherList();

            // get student list
            getStudentList();

            // get course list
            getCourseList();

            // get content of dashboard
            refreshDashboard();
        }
        


        _init();
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.account-settings', [
            'app.dialogs.prompt'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_account-settings', {
            url      : '/student-dashboard/account-settings',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/student-dashboard/account-settings/account-settings.html',
                    controller : 'AccountSettingsController as vm'
                }
            },
            bodyClass: 'account-settings',
            requireLogin: true
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/student-dashboard/account-settings');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.account-settings')
        .controller('AccountSettingsController', AccountSettingsController);

    /** @ngInject */
    function AccountSettingsController(
        $rootScope,
        $q,
        $auth,
        $filter,
        $state,
        $stateParams,
        $mdDialog,
        $document,
        api,
        apiResolver,
        scheduleMapper,
        StripeService,
        constNesukuEmail,
        $scope)
    {
        var vm = this;
        var payload = $auth.getPayload();

        // Data
        vm.isLoading = true;
        vm.defaultAvatar = '/assets/images/avatars/profile.jpg';
        vm.user = {};
        vm.isRebook = false;
        vm.balance = 0;
        vm.openBalance = false;
        vm.openPackage = false;

        // packageTeachers sample
        // {
        //     teacherName: "TestTeacher A",
        //     packages: [
        //         {
        //             packageName: "Package 1",
        //             remainingHours: 15
        //         },
        //         {
        //             packageName: "Package 2",
        //             remainingHours: 12
        //         }
        //     ],
        //     openTab: false,
        // }
        vm.packageTeachers = [];

        // Methods
        vm.contactNesuku = contactNesuku;
        vm.openAvatarDialog = openAvatarDialog;
        vm.openPasswordDialog = openPasswordDialog;
        vm.walletDeposit = walletDeposit;
        vm.editProfilePic = editProfilePic;
        vm.changePassword = changePassword;

        // Init
        _switchRoleIfNecessary();

        // Functions
        function _switchRoleIfNecessary() {
            var payload = $auth.getPayload();
            if(payload.role != 2) {
                api.auth.switchRole.post({token: $auth.getToken(), role: 'student'},
                    function(response) {
                        _updateToken(response.token);
                        _init();
                    }
                );
            } else {
                _init();
            }
        }

        function _init() {

            $q.all([
                _getCurrentUser(),
                _getWalletBalance(),
                _getPackages()
            ]).then(function (response) {
                vm.user = response[0].data;
                vm.isLoading = false;
                vm.balance = response[1].data;
                setPackages(response[2].data);
            }, _errorCallback);
        }

        function setPackages(data) {
            var packages = {};
            data.forEach(function (value, index, data){
                var curPackage = {
                    packageName: value['packageName'],
                    remainingHours: value['remainingHours']
                };
                if (value.teacherName in packages) {
                    packages[value.teacherName].push(curPackage);
                }
                else {
                    packages[value.teacherName] = [curPackage];
                }
            });

            for (var item in packages) {
                var curPackages = {teacherName: item, packages: []};
                packages[item].forEach(function (curPackage, index, data) {
                    curPackages.packages.push({packageName: curPackage.packageName, remainingHours: curPackage.remainingHours});
                });
                vm.packageTeachers.push(curPackages);
            }
        }

        function _successWalletSaveCallBack(){
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Success!')
                .textContent('')
                .ariaLabel('')
                .ok('OK')
            );
        }

        function walletDeposit() {
            var walletDepositContent = ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px;" aria-label="Deposit"> \
                    <md-toolbar class="md-accent md-hue-2" style="background-color:#fff;"> \
                        <div class="md-toolbar-tools" layout="row" layout-align="space-between center">\
                            <span class="dialog-title" style="color:black;font-weight:bold;">Deposit</span>\
                            <md-button class="md-icon-button" ng-click="closeDialog()" aria-label="Close dialog">\
                                <md-icon md-font-icon="icon-close" style="color:black;"></md-icon>\
                            </md-button>\
                        </div>\
                    </md-toolbar>\
                    <md-dialog-content ms-scroll> \
                        <p>Enter the amount you want to deposit:</p> \
                        <md-input-container class="md-block" > \
                            <input type="number" style="font-size: 25px;" name="depositAmount" ng-model="depositAmount" min=1> \
                        </md-input-container> \
                        <section style="text-align: right;"> \
                            <md-button ng-click="closeDialog()" class="md-primary md-raised"> \
                                Cancel \
                            </md-button> \
                            <md-button ng-click="walletDepositAPI()" class="md-primary md-raised" ng-disabled="!depositAmount"> \
                                Confirm \
                            </md-button> \
                        </section> \
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : walletDepositContent,
                locals              : {depositAmount: vm.depositAmount},
                bindToController    : true,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WalletDepositController,
            });

            function WalletDepositController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    vm.openBalance = false;
                    $mdDialog.hide();
                }
                $scope.walletDepositAPI = function() {
                    $mdDialog.hide();
                    StripeService.openPopup({
                        name: "Nesuku",
                        description: "Wallet Deposit",
                        amount: ($scope.depositAmount * 100).toFixed(2),
                        currency: 'usd'
                    }, function (token) {
                        var params = {
                            paymentMethod: 'credit card',
                            amount: $scope.depositAmount,
                            token: token.id
                        };
                        waitForResponse();
                        api.wallet.deposit.post(params,
                            function(response) {
                                console.log(response);
                                vm.balance = response.data.balance;
                                _successWalletSaveCallBack();
                            },
                            function(error) {
                                _errorCallback(error);
                            }
                        );
                    });
                    vm.openBalance = false;
                }
            }
        }

        function contactNesuku() {
            location.href = constNesukuEmail;
        }

        function openAvatarDialog() {
            $mdDialog.show({
                controller         : 'EditProfilePicController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/edit-profile-pic/edit-profile-pic.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {
                    teacher: vm.user,
                },
            });
        }

        function openPasswordDialog() {
            $mdDialog.show({
                controller         : 'ChangePasswordController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/change-password/change-password.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {},
            });
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function _getCurrentUser() {
            return apiResolver.resolve('user.list@get');
        }

        function _getStudent() {
            return apiResolver.resolve('student.introMessage@get');
        }

        function _getWalletBalance(){
            return apiResolver.resolve("wallet.getBalance@get");
        }

        function _getPackages(){
            var params = {
              token: $auth.getToken()
            };
            return apiResolver.resolve("packages.list@get", params)
        }


        function _errorCallback(response) {
            $mdDialog.hide();
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }


        function _setTimezone(student) {
            var params = {
                id: student.id,
                timezone: vm.timezone
            };
            apiResolver.resolve('timezone.setTimezone@post', params);
        }

        function _updateToken(token) {
            $auth.setToken(token);
            var payload = $auth.getPayload();
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            switch(payload.role) {
                case 0:
                    $rootScope.userRole = 'admin';
                    break;

                case 1:
                    $rootScope.userRole = 'teacher';
                    break;

                case 2:
                    $rootScope.userRole = 'student';
                    break;

                default:
                    console.error("Invalid Role");
                    break;
            }
        }

        function editProfilePic() {
            $mdDialog.show({
                controller         : 'EditProfilePicController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/edit-profile-pic/edit-profile-pic.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {
                    teacher: vm.teacher,
                },
            });
        }

        function changePassword() {
            $mdDialog.show({
                controller         : 'ChangePasswordController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/change-password/change-password.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
                locals             : {},
            });
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.about-us', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_about_us', {
            url      : '/about-us',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/about-us/about-us.html',
                    controller : 'AboutUsController as vm'
                }
            },
            bodyClass: 'about-us',
        });

        

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/about-us');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.about-us')
        .controller('AboutUsController', AboutUsController);

    /** @ngInject */
    function AboutUsController(
        $rootScope,
        $q,
        $auth,
        $state,
        $mdDialog,
        $document,
        $filter,
        $location,
        api,
        apiResolver,
        constNesukuEmail)
    {
        var vm = this;
        
        // Methods
        vm.contactNesuku = contactNesuku;

        // Functions
        function contactNesuku() {
            location.href = constNesukuEmail;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dialogs.terms-n-conditions', [])
        .config(config);

    /** @ngInject */
    function config()
    {

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dialogs.terms-n-conditions')
        .controller('TermsConditionsController', TermsConditionsController);

    /** @ngInject */
    function TermsConditionsController($mdDialog)
    {
        var vm = this;

        // Data


        // Methods
        vm.closeDialog = closeDialog;


        // Functions
        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.set-price', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/set-price');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dialogs.set-price')
        .controller('SetPriceController', SetPriceController);

    /** @ngInject */
    function SetPriceController($filter, $mdDialog, $auth, api, lesson, defaultPrice, successCallback)
    {
        var vm = this;

        // Data
        vm.lesson = angular.copy(lesson);
        vm.lesson.price = defaultPrice ? defaultPrice : (defaultPrice == 0 ? 0 : 10);
        vm.timezone = moment().format('ZZ');
        vm.datetimeFormat = 'MMM d, hh:mm a';


        // Methods
        vm.closeDialog = closeDialog;
        vm.send = send;


        // Functions
        function closeDialog() {
            $mdDialog.hide();
        }

        function send() {
            if (vm.lesson.price === 0) {
                api.lessonRequest.free.post({ id: vm.lesson.id }, _successHandler, _errorHandler)
            } else {
                api.lessonRequest.price.post(vm.lesson, _successHandler, _errorHandler);
            }
        }

        function _successHandler() {
            successCallback($mdDialog);
        }

        function _errorHandler(response) {
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.register-teacher', [
            'ngMessages',
        ])
        .config(config)
        .directive('passwordConfirmation', passwordConfirmation);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider,
                    apiUrl)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/register-teacher');
    }

    function passwordConfirmation() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$validators.passwordConfirmation = function(modelValue) {
                    return modelValue === attrs.passwordConfirmation;
                };

                attrs.$observe('passwordConfirmation', function(value) {
                    ngModel.$validate();
                });
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dialogs.register-teacher')
        .controller('RegisterTeacherController', RegisterTeacherController);

    /** @ngInject */
    function RegisterTeacherController($filter, $mdDialog, $auth, api)
    {
        var vm = this;

        // Data

        // Methods
        vm.signup = signup;
        vm.closeDialog = closeDialog;

        // Functions
        function signup() {
            var user = _mappingUser();

            api.register.teacher.post(user, successCallback, errorCallback);
        }

        function closeDialog() {
            $mdDialog.close();
        }

        function _mappingUser() {
            return {
                name: vm.form.username,
                email: vm.form.email,
                password: vm.form.password,
                password_confirmation: vm.form.passwordConfirm,
            }
        }

        function successCallback(data) {
            vm.invalidLogin = true;
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Account created!')
                .textContent('')
                .ariaLabel('')
                .ok('OK')
            );
        }

        function errorCallback(response) {
            if (response.data.error.email) {
                $scope.registerForm.email.$invalid = true;
                vm.emailHasRegister = response.data.error.email[0];
            }

            else {
                $mdDialog.show(
                  $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title('An error occured!')
                    .textContent('')
                    .ariaLabel('')
                    .ok('OK')
                );
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.register-student', [
            'ngMaterial', 
            'ngMessages',
            'app.dialogs.terms-n-conditions',
        ])
        .config(config)
        .directive('passwordConfirmation', passwordConfirmation);

    /** @ngInject */
    function config($stateProvider,
                    $authProvider,
                    $translatePartialLoaderProvider,
                    apiUrl)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/register-student');
        $authProvider.signupUrl = apiUrl + 'auth/register/student';
        $authProvider.loginUrl = apiUrl + "auth/login";
        $authProvider.withCredentials = false;
    }

    function passwordConfirmation() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$validators.passwordConfirmation = function(modelValue) {
                    return modelValue === attrs.passwordConfirmation;
                };

                attrs.$observe('passwordConfirmation', function(value) {
                    ngModel.$validate();
                });
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dialogs.register-student')
        .controller('RegisterStudentController', RegisterStudentController);

    /** @ngInject */
    function RegisterStudentController($filter, $document, $mdDialog, $auth, api, $rootScope, $scope, $state)
    {
        var vm = this;

        // Data
        vm.state = 'register';

        // Methods
        vm.signup = signup;
        vm.closeDialog = closeDialog;
        vm.logIn = logIn;
        vm.openDialog = openDialog;
        vm.switchStates = switchStates;

        // Functions
        function signup() {
            var user = _mappingUser();

            $auth.signup(user).then(function(response) {
                _login(user);

            }).catch(function(response) {
                if (response.data.error.email) {
                    $scope.registerForm.email.$invalid = true;
                    vm.emailHasRegister = response.data.error.email[0];
                }
            });
        }

        function logIn() {
            var credentials = {
                email: vm.form.email,
                password: vm.form.password,
            };

            $auth.login(credentials)
                .then(successCallback)
                .catch(errorCallback);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function openDialog() {
            $mdDialog.show({
                controller         : 'TermsConditionsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/terms-n-conditions/terms-n-conditions.html',
                parent             : angular.element($document.body)
            });
        }

        function switchStates(newState) {
            vm.state = newState;
            console.log(vm.state);
        }

        function _mappingUser() {
            return {
                name: vm.form.username,
                email: vm.form.email,
                password: vm.form.password,
                password_confirmation: vm.form.passwordConfirm,
            }
        }

        function successCallback(data) {
            $rootScope.isAuthenticated = $auth.isAuthenticated();
            $rootScope.userRole = 'student';
            closeDialog();
            $state.reload();
        }

        function _login(user) {
            $auth.login(user)
                .then(successCallback)
                .catch(errorCallback);
        }

        function errorCallback(response) {
            vm.invalidLogin = true;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.rate', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/rate');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dialogs.rate')
        .controller('RateController', RateController);

    /** @ngInject */
    function RateController($filter, $mdDialog, $auth, api, lesson, constNesukuEmail)
    {
        var vm = this;

        // Data
        vm.lesson = lesson;
        vm.lesson.rate = 0;
        vm.lesson.comment = '';


        // Methods
        vm.closeDialog = closeDialog;
        vm.report = report;
        vm.submit = submit;


        // Functions
        function report() {
            location.href = constNesukuEmail;
        }

        function submit() {
            var params = {
                courseTimeId: vm.lesson.id,
                comment: vm.lesson.comment,
                rate: vm.lesson.rate,
            };

            api.review.list.save(params, _successHandler, _errorHandler);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function _successHandler() {
            vm.lesson.isReviewed = true;
            $mdDialog.hide();
        }

        function _errorHandler(response) {
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.prompt', ['ngMessages'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/prompt');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dialogs.prompt')
        .controller('PromptController', PromptController);

    /** @ngInject */
    function PromptController($q, $mdDialog, $auth, api, teacher, constPHPDateTimeFormat, $filter, $rootScope, apiResolver)
    {
        var vm = this;
        var teacherInfo = angular.copy(teacher);

        //action
        vm.yes = yes;
        vm.no = no;
        vm.closeDialog = closeDialog;

        function yes() {
            $mdDialog.hide(true);
            teacherInfo.minPrice = parseFloat(teacher.minPrice);
            teacherInfo.maxPrice = parseFloat(teacher.maxPrice);
            if (teacherInfo.minPrice > teacherInfo.maxPrice){
                var tempPrice = teacherInfo.minPrice;
                teacherInfo.minPrice = teacher.maxPrice;
                teacherInfo.maxPrice = tempPrice;
            }
            teacherInfo.isPublic = teacherInfo.isPublic ? 1 : 0;
            $mdDialog.show(
                $mdDialog.alert()
                    .clickOutsideToClose(true)
                    .parent(angular.element(document.body))
                    .title($filter('translate')('EDIT_TEACHER.SUCCESS'))
                    .textContent($filter('translate')('EDIT_TEACHER.PROFILE_UPDATED'))
                    .ariaLabel($filter('translate')('EDIT_TEACHER.PROFILE_UPDATED'))
                    .ok($filter('translate')('EDIT_TEACHER.OK'))
            );
            api.teacher.byToken.put(teacherInfo, function(response){}, _errorHandler);
        }

        function no() {
            $mdDialog.hide(true);
        }

        function closeDialog() {
            $mdDialog.hide(false);
        }

        function _errorHandler(err) {
            alert('Oh! Something unexpected happened!');
            console.error(err);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.payment', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/payment');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.payment')
        .controller('PaymentController', PaymentController);

    /** @ngInject */
    function PaymentController($q, $mdDialog, $auth, $http, api, paymentInfo, courseRequestInfo, constPHPDateTimeFormat, $filter, $rootScope, apiResolver, StripeService)
    {
        var vm = this;
        var payload = $auth.getPayload();
        $rootScope.userRole = getUserRole();
        $rootScope.overlayMessage = null;


        // Data
        vm.categoryId = paymentInfo.categoryId;
        vm.categoryHourlyPrice = paymentInfo.categoryHourlyPrice;
        vm.totalHours = paymentInfo.totalHours;
        vm.totalPrice = vm.categoryHourlyPrice * vm.totalHours;
        vm.useHours = 0;
        vm.useBalance = 0;
        vm.courseRequestInfo = courseRequestInfo;

        //init
        init();

        // Methods
        vm.closeDialog = closeDialog;
        vm.confirmPayment = confirmPayment;
        vm.canSubmit = canSubmit;

        // Functions
        function init() {
            getAvailablePackage();
            getWalletBalance().then(function(response) {
                vm.walletBalance = response.data;
            }, _errorHandler);
        }

        function getWalletBalance(){
            return apiResolver.resolve("wallet.getBalance@get");
        }

        function getAvailablePackage() {
            var params = {
                token: $auth.getToken(),
                id: vm.categoryId
            };
            api.packages.remain.get(params, function (response, status) {
                if (response['data'] == null) {
                    return;
                }
                vm.remainingHours = response['data']['remaining_hours'];
                vm.packageName = response['data']['package_name'];
            }, _errorHandler);
        }

        function canSubmit() {
            // Combined payment method
            // if (!vm.usePackage && !vm.useWallet && !vm.useCreditCard && vm.totalPrice) {
            //     return false;
            // }
            // if (vm.usePackage && !vm.useHours) {
            //     return false;
            // }
            // if (vm.useWallet && !vm.useBalance) {
            //     return false;
            // }
            // if (!vm.usePackage) {
            //     vm.useHours = 0;
            // }
            // if (!vm.useWallet) {
            //     vm.useBalance = 0;
            // }
            // if ((vm.totalHours - vm.useHours) * vm.categoryHourlyPrice > vm.useBalance && vm.useCreditCard) {
            //     return true;
            // }
            // else if ((vm.totalHours - vm.useHours) * vm.categoryHourlyPrice == vm.useBalance && !vm.useCreditCard) {
            //     return true;
            // }
            // else return false;

            // only allow one payment method
            if (vm.totalPrice) {
                if (vm.usePackage && !vm.useWallet && !vm.useCreditCard && vm.useHours == vm.totalHours) {
                    return true;
                }
                if (!vm.usePackage && vm.useWallet && !vm.useCreditCard && vm.useBalance == vm.totalPrice) {
                    return true;
                }
                if (!vm.usePackage && !vm.useWallet && vm.useCreditCard) {
                    return true;
                }
                return false;
            } else {
                if (!vm.usePackage && !vm.useWallet && !vm.useCreditCard) {
                    return true;
                }
                return false;
            }
        }

        function confirmPayment() {
            $mdDialog.hide();
            vm.creditCardAmount = vm.categoryHourlyPrice * (vm.totalHours - vm.useHours) - vm.useBalance;
            if (vm.useCreditCard) {
                var start = (new moment(moment(_getDatetimeStr(vm.courseRequestInfo.lesson.startDate, vm.courseRequestInfo.lesson.startTime)).utc().format())).format('MMM DD, YYYY hh:mm a');
                var end = (new moment(moment(_getDatetimeStr(vm.courseRequestInfo.lesson.endDate, vm.courseRequestInfo.lesson.endTime)).utc().format())).format('hh:mm a');
                StripeService.openPopup({
                    name: vm.courseRequestInfo.teacher.name,
                    description: start + ' ~ ' + end,
                    amount: vm.creditCardAmount * 100,
                    currency: 'usd'
                }, function (token) {
                    waitForResponse();
                    var params = {
                        token: token.id,
                        email: token.email,
                        useHours: vm.useHours,
                        useBalance: vm.useBalance,
                        creditCardAmount: vm.creditCardAmount,
                        teacherId: vm.courseRequestInfo.teacher.id,
                        categoryId: vm.courseRequestInfo.categoryId,
                        message: vm.courseRequestInfo.message,
                        price: vm.courseRequestInfo.price,
                        hours: vm.courseRequestInfo.hours,
                        times: vm.courseRequestInfo.times,
                        paymentMethod: "combined payment"
                    };
                    console.log(params);
                    api.courseRequest._save.post(params, _successCreateRequestCallback, _errorHandler);
                });
            } else {
                waitForResponse();
                var params = {
                    useHours: vm.useHours,
                    useBalance: vm.useBalance,
                    creditCardAmount: vm.creditCardAmount,
                    teacherId: vm.courseRequestInfo.teacher.id,
                    categoryId: vm.courseRequestInfo.categoryId,
                    message: vm.courseRequestInfo.message,
                    price: vm.courseRequestInfo.price,
                    hours: vm.courseRequestInfo.hours,
                    times: vm.courseRequestInfo.times,
                    paymentMethod: "combined payment"
                };
                console.log(params);
                api.courseRequest._save.post(params, _successCreateRequestCallback, _errorHandler);
            }
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Lesson Request Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function _getDatetimeStr(dateObj, timeObj) {
            return dateObj.toDateString() + ' ' + moment(timeObj).format('HH:mm:ss'); // may be improved by adding timezone.
        }

        function _successCreateRequestCallback() {
            $rootScope.isCreateRequest = true;
            $mdDialog.hide();
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Your lesson request has been sent!')
                .textContent('')
                .ariaLabel('')
                .ok('OK')
            );
        }

        function _errorHandler(response) {
            $mdDialog.hide();
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.message', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/message');
    }

})();
(function ()
{
    'use strict';

    angular.module('app.dialogs.message')
        .controller('MessageController', MessageController);

    /** @ngInject */
    function MessageController($mdDialog, api, studentUserId, studentName, defaultMessage)
    {
        var vm = this;

        // Data
        vm.message = {
            content: defaultMessage,
            receiverId: studentUserId,
        };
        vm.studentName = studentName;

        // Methods
        vm.closeDialog = closeDialog;
        vm.sendMessage = sendMessage;


        // Functions
        function closeDialog() {
            $mdDialog.hide();
        }

        function sendMessage() {
            $mdDialog.hide();
            waitForResponse();
            api.messages.list.post(vm.message, function (response) {
                $mdDialog.hide();
                alert('Successfully sent!');
            }, function (response) {
                $mdDialog.hide();
                console.log('error: ', response);
            })
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Sending the message...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.makeup-payment', ['ngMessages','ui.select2'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/makeup-payment');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.makeup-payment')
        .controller('MakeupPaymentController', MakeupPaymentController);

    /** @ngInject */
    function MakeupPaymentController($q, $mdDialog, $auth, api, teacher, calendarEvent, constPHPDateTimeFormat, $filter, $rootScope, apiResolver, StripeService, $compile, $scope)
    {
        var vm = this;
        var payload = $auth.getPayload();
        $rootScope.userRole = getUserRole();
        vm.isNewStudent = false;
        vm.students = [];
        var tokenId;
        var tokenEmail;
        $rootScope.overlayMessage = null;


        // Data
        if($rootScope.userRole == 'teacher') {
            vm.teacher = teacher;
        } else {
            vm.teacher = teacher.info;
        }
        vm.lesson = {
            startDate: calendarEvent.start.toDate(),
            startTime: calendarEvent.start.toDate(),
        }
        vm.today = moment().toDate();

        vm.timePickerOptions = {
            step: 30,
            timeFormat: constPHPDateTimeFormat.GENERAL_TIME,
        };
        vm.categories = [];
        vm.lessonCounter = 0;
        vm.times = [];
        vm.totalHours = 0;
        vm.totalPrice;
        vm.singlePrice;
        vm.description = [];
        vm.durations = [0.5, 1, 1.5, 2, 2.5, 3];
        vm.duration = 0;
        vm.lessonConfirmed = false;

        //init
        init();

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeStudent = changeStudent;
        vm.showOrHide = showOrHide;
        vm.confirmTime = confirmTime;
        vm.addTimes = addTimes;
        vm.sendMakeUpRequest = sendMakeUpRequest;
        vm.calculatePrice = calculatePrice;
        vm.changeDisplayTimeString = changeDisplayTimeString;

        // Functions
        function init() {

            getCategories().then(function(response) {
                vm.categories = response.data;
            },_errorHandler);

            if($rootScope.userRole == 'teacher')
                getStudents()
                .then(function(response) {
                    vm.students = response.data;
                },_errorHandler);
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function changeStudent() {
            vm.categoryHourlyPrice = null;
            getCustomPrices().then(function(response) {
                if(response.data.length>0) {
                    angular.forEach(response.data, function(student, key) {
                        if(student.studentEmail == vm.email) {
                            vm.categories = student.customPrices;
                        }
                    });

                }
            },_errorHandler);
        }

        function changeDisplayTimeString() {
            console.log('changeDisplayTimeString');
            vm.description = [];
            var start_local;
            var end_local;
            var timeString;
            for (var i = 0; i < vm.times.length; ++i) {
                var startTime = moment(vm.times[i].startTime).utc();
                var endTime = moment(startTime).add(vm.duration, 'hours').utc();
                vm.times[i].endTime = endTime.format();
                start_local = startTime.local();
                end_local = endTime.local();
                timeString = start_local.format('MMM DD  hh:mm a') + ' ~ ' + end_local.format('hh:mm a');
                vm.description.push(timeString);
            }
            vm.totalHours = vm.lessonCounter * vm.duration;
            calculatePrice();
        }

        function calculatePrice() {
            if(vm.category) {
                vm.categoryHourlyPrice = vm.category.hourlyPrice;
                if(vm.categoryHourlyPrice >= 0) {
                    vm.singlePrice = vm.categoryHourlyPrice * vm.duration;
                    vm.totalPrice = precisionRound(vm.categoryHourlyPrice * vm.totalHours, 2);
                }
            }
        }

        function precisionRound(number, precision) {
            var factor = Math.pow(10, precision);
            return Math.round(number * factor) / factor;

        }

        function addTimes() {
            var addTimesContent =
            '\
            <section id="makeup_content">\
                <!-- START DATE & TIME -->\
                <div layout="row" layout-xs="column" class="date-row">\
                    <md-datepicker ng-model="vm.lesson.startDate" md-max-date="vm.today" md-placeholder="{{ \'MAKEUP_PAYMENT.START_DATE\' | translate }}"></md-datepicker>\
                    <md-input-container class="no-errors-spacer" flex md-no-float>\
                        <input ng-model="vm.lesson.startTime" \
                                placeholder="{{ \'MAKEUP_PAYMENT.START_TIME\' | translate }}" \
                                ui-timepicker="vm.timePickerOptions">\
                        </md-input-container>\
                </div>\
                <!-- / START DATE & TIME -->\
            </section>\
            ';
            var makeUpPayment = angular.element(document.querySelector('#makeup_payment'));
            makeUpPayment.append($compile(addTimesContent)($scope));
            vm.lessonConfirmed = false;
        }

        function confirmTime() {
            var start_local = moment(_getDatetimeStr(vm.lesson.startDate, vm.lesson.startTime)).local();
            var end_local = moment(start_local).add(vm.duration, 'hours').local();
            var timeString = start_local.format('MMM DD  hh:mm a') + ' ~ ' + end_local.format('hh:mm a');
            if (vm.description.indexOf(timeString) != -1) {
                alert('Cannot add the same time period!');
            } else {
                vm.lessonConfirmed = true;
                vm.lessonCounter += 1;
                vm.totalHours = vm.duration * vm.lessonCounter;
                var start = moment(start_local).utc();
                var end = moment(end_local).utc();
                vm.times.push({
                    startTime: start.format(),
                    endTime: end.format()
                });
                vm.description.push(timeString);
                calculatePrice();
                var makeUpPaymentContent = angular.element(document.querySelector('#makeup_content'));
                makeUpPaymentContent.remove();
            }
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }


        function _getDatetimeStr(dateObj, timeObj) {
            return dateObj.toDateString() + ' ' + timeObj.toTimeString();
        }

        function _errorHandler(response) {
            console.error(response);
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }

        function showOrHide() {
            vm.isNewStudent = !vm.isNewStudent;
        }

        function sendMakeUpRequest() {
            $mdDialog.hide();
            var params = {
                email: vm.email,
                categoryId: vm.category.id,
                price: vm.singlePrice,
                times: vm.times,
            };
            console.log(params);
            paymentMakeUp(params);
        }

        function getStudents() {
            return apiResolver.resolve('student.getAllLinked@get');
        }

        function getCategories() {
            return apiResolver.resolve('priceCategories.byTeacher@get', { teacherId: vm.teacher.id });
        }

        function getCustomPrices() {
            return apiResolver.resolve('customPrices.list@get');
        }

        function paymentMakeUp(params) {
            console.log(params);
            api.paymentMakeUp.teacher.post(params, _successCreateRequestCallbackTeacher, _errorAcceptCallback);
            waitForResponse();
        }

        function _successCreateRequestCallbackTeacher() {
            $mdDialog.hide();
            $rootScope.isCreateRequestTeacher = true;
            $rootScope.overlayMessage = null;
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Your payment make up request has been sent!')
                .textContent('')
                .ariaLabel('')
                .ok('OK')
            );
        }

        function _errorCallback(response) {
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

        function _errorAcceptCallback(response) {
            $mdDialog.hide();
            _errorCallback(response);
            $rootScope.overlayMessage = null;
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.mailchimp', [])
        .config(config);

    /** @ngInject */
    function config()
    {

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dialogs.mailchimp')
        .controller('MailchimpController', MailchimpController);

    /** @ngInject */
    function MailchimpController($mdDialog, $cookies)
    {
        var vm = this;

        // Data
        vm.mailchimp = {
            username: 'nesuku',
            dc: 'us16',
            u: '0c246efbb4f39e8bbdc280c4f',
            id: 'ec50e951c1'
        }

        // Methods
        vm.closeDialog = closeDialog;

        _init();

        // Functions
        function _init(){
            // (function($) { window.fnames = new Array();
            //     window.ftypes = new Array();
            //     fnames[0] = 'EMAIL';
            //     ftypes[0] = 'email';
            //     fnames[1] = 'FNAME';
            //     ftypes[1] = 'text'; }(jQuery));
            // var $mcj = jQuery.noConflict(true);
        }


        function closeDialog() {
            $mdDialog.hide();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.lesson-request', ['ngMessages','ui.select2','app.dialogs.payment','app.dialogs.register-student',])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/lesson-request');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.lesson-request')
        .controller('LessonRequestController', LessonRequestController);

    /** @ngInject */
    function LessonRequestController($q, $document, $mdDialog, $auth, api, teacher, calendarEvent, constPHPDateTimeFormat, $filter, $rootScope, apiResolver, StripeService)
    {
        var vm = this;
        var payload = $auth.getPayload();
        $rootScope.userRole = getUserRole();
        vm.isNewStudent = false;
        vm.students = [];
        vm.numChangeDate = 0;
        var standardTimeZone='';
        var timeZoneLabel='';
        var tokenId;
        var tokenEmail;
        $rootScope.overlayMessage = null;


        // Data
        if($rootScope.userRole == 'teacher') {
            vm.teacher = teacher;
        } else {
            vm.teacher = teacher.info;
        }
        vm.lesson = {
            startDate: calendarEvent.start.toDate(),
            startTime: calendarEvent.start.toDate(),
            endDate: calendarEvent.end.toDate(),
            endTime: calendarEvent.end.toDate(),
        };
        vm.today = moment().toDate();

        vm.timePickerOptions = {
            step: 30,
            timeFormat: constPHPDateTimeFormat.GENERAL_TIME,
        };
        // vm.isSending = false;
        vm.categories = [];
        vm.price = teacher.defaultPrice ? teacher.defaultPrice : (teacher.defaultPrice == 0 ) ? 0 : 10;
        vm.user = {};
        vm.statusOpt = {
            allowClear : true
        }
        vm.weeks = [];
        vm.times = [];
        vm.totalHours;
        vm.totalPrice;
        vm.singlehours;
        vm.singlePrice;
        vm.hours = 1;

        //init
        init();

        // Methods
        vm.closeDialog = closeDialog;
        vm.changeStudent = changeStudent;
        vm.changeStartDate = changeStartDate;
        vm.changeDateTimes = changeDateTimes;
        // vm.sendLessonRequest = sendLessonRequest;
        vm.choosePay = choosePay;
        vm.showOrHide = showOrHide;
        vm.enterPaymentInfo = enterPaymentInfo;
        vm.calculatePrice = calculatePrice;
        vm.checkPolicy = checkPolicy;
        vm.selectCategory = selectCategory;

        // Functions
        function init() {
            // _getTeacher()
            //     .then(function(response) {
            //         vm.teacher = response.data;
            //     },_errorHandler);
            getCategories().then(function(response) {
                vm.categories = response.data;
            },_errorHandler);

            // if($rootScope.userRole == 'student')
            // getCustomPricesByTeacher().then(function(response) {
            //     if(response.data.length>0) {
            //         vm.categories = response.data;
            //     }
            // },_errorHandler);

            if($rootScope.userRole == 'teacher') {
                getStudents()
                .then(function(response) {
                    vm.students = response.data;
                },_errorHandler);
            }

        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function changeStudent() {
            vm.categoryHourlyPrice = null;
            // getCategories().then(function(response) {
            //     vm.categories = response.data;
            // },_errorHandler);
            getCustomPrices().then(function(response) {
                if(response.data.length>0) {
                    angular.forEach(response.data, function(student, key) {
                        if(student.studentEmail == vm.email) {
                            vm.categories = student.customPrices;
                        }
                    });

                }
            },_errorHandler);
        }

        function changeStartDate() {
            vm.lesson.endDate = angular.copy(vm.lesson.startDate);
            changeDateTimes();
        }

        function changeDateTimes() {
            var start = moment(_getDatetimeStr(vm.lesson.startDate, vm.lesson.startTime)).utc();
            var end = moment(_getDatetimeStr(vm.lesson.endDate, vm.lesson.endTime)).utc();
            vm.numChangeDate = vm.numChangeDate + 1;
            vm.singlehours = end.diff(start, 'hours', true);
            if(vm.isRepeatWeekly) {
                vm.totalHours = vm.singlehours * vm.repeatWeeks;
            } else {
                vm.totalHours = vm.singlehours;
            }
            // check negative time - yuanchen
            if (vm.singlehours < 0) {
                console.log('vm.lesson.startDate');
                console.log(vm.lesson.startDate);
                console.log('changeDateTimes: negative time');
                console.log(vm.singlehours);
                alert('End time must be later than start time!');
                // $mdDialog.cancel();
                return false;
            } else {
                console.log('changeDateTimes: positive time');
                console.log(vm.singlehours);
            }

            vm.weeks = [];
            vm.times = [];
            if(vm.isRepeatWeekly) {
                for(var i=0;i<vm.repeatWeeks;i++) {
                    vm.weeks.push({
                        startDate: start.clone().add(i, 'weeks').toDate(),
                    });
                    vm.times.push({
                        startTime: start.clone().add(i, 'weeks').format(),
                        endTime: end.clone().add(i, 'weeks').format()
                    });
                }
            } else {
                vm.times = [{
                    startTime: start.format(),
                    endTime: end.format()
                }];
            }
            calculatePrice();
        }

        function arrayToString(array, index) {
            var result = '';
            for(var i = 0; i < index; i++) {
                result = result + array[i] + ' ';
            }
            return result;
        }

        function selectCategory() {
            calculatePrice();
        }

        function calculatePrice() {
            if(vm.category) {
                vm.categoryHourlyPrice = vm.category.hourlyPrice;
                if(vm.categoryHourlyPrice >= 0) {
                    vm.singlePrice = vm.categoryHourlyPrice * vm.singlehours;
                    // vm.totalPrice = vm.categoryHourlyPrice * vm.totalHours;
                    vm.totalPrice = precisionRound(vm.categoryHourlyPrice * vm.totalHours, 2);
                }
            }
        }

        function precisionRound(number, precision) {
            var factor = Math.pow(10, precision);
            return Math.round(number * factor) / factor;

        }

        function registerStudent(){
            $mdDialog.show({
                controller         : 'RegisterStudentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/register-student/register-student.html',
                parent             : angular.element($document.body),
                fullscreen: true,
            });
        }

        function checkPolicy() {
            if (!payload) {
                registerStudent();
            }
            else {
                var requestTime = moment(vm.times[0].startTime);
                var policyHours = vm.teacher.schedulePolicy;
                var fromNowHours = requestTime.diff(moment(), 'hours', true);
                if(fromNowHours > policyHours) {
                    console.log('PASS checkPolicy');
                    if($rootScope.userRole == 'student') {
                        choosePay();
                    } else if($rootScope.userRole == 'teacher') {
                        // this should never be entered
                        enterPaymentInfo();
                    }
                } else {
                    console.log('FAIL checkPolicy');
                    alert('Student must book ' + policyHours + ' hours before the lesson start time');
                }
            }
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Lesson Request Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function choosePay() {
            if (vm.totalPrice > 0) {
                $mdDialog.show({
                    controller         : 'PaymentController',
                    controllerAs       : 'vm',
                    templateUrl        : 'app/main/dialogs/payment/payment.html',
                    parent             : angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: true,
                    locals             : {
                        paymentInfo: {
                            totalHours: vm.totalHours,
                            categoryHourlyPrice: vm.categoryHourlyPrice,
                            categoryId: vm.category.id,
                        },
                        courseRequestInfo: {
                            lesson: vm.lesson,
                            teacher: vm.teacher,
                            categoryId: vm.category.id,
                            message: vm.message,
                            price: vm.singlePrice,
                            hours: vm.hours,
                            times: vm.times,
                        }
                    },
                });
            } else {
                console.log('vm.totalPrice=====>');
                console.log(vm.totalPrice);
                console.log('free request');
                _requestFreeLesson();
            }
        }

        function _requestFreeLesson() {
            console.log('student enter free request');
            var params = {
                    email: vm.email,
                    teacherId: vm.teacher.id,
                    categoryId: vm.category.id,
                    message: vm.message,
                    hours: vm.hours,
                    price: vm.singlePrice,
                    times: vm.times,
                    paymentMethod: "free"
            };
            console.log(params);
            waitForResponse();
            api.courseRequest._save.post(params, _successCreateRequestCallback, _errorAcceptCallback);
        }

        function _getDatetimeStr(dateObj, timeObj) {
            return dateObj.toDateString() + ' ' + moment(timeObj).format('HH:mm:ss'); // may be improved by adding timezone.
        }

        function _errorHandler(response) {
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }

        function showOrHide() {
            vm.isNewStudent = !vm.isNewStudent;
        }

        function enterPaymentInfo() {
            $mdDialog.hide();
            if(vm.totalPrice > 0) {
                var start = (new moment(moment(_getDatetimeStr(vm.lesson.startDate, vm.lesson.startTime)).utc().format())).format('MMM DD, YYYY hh:mm a');
                var end = (new moment(moment(_getDatetimeStr(vm.lesson.endDate, vm.lesson.endTime)).utc().format())).format('hh:mm a');
                StripeService.openPopup({
                    name: vm.teacher.name,
                    description: start + ' ~ ' + end,
                    amount: vm.totalPrice * 100,
                    email: vm.email,
                    currency: 'usd'
                }, function (token) {
                    var params = {
                        token: token.id,
                        email: token.email,
                        name: vm.name,
                        hours: vm.hours,
                        categoryId: vm.category.id,
                        teacherId: vm.teacher.id,
                        price: vm.singlePrice,
                        times: vm.times,
                    };

                    tokenId = token.id;
                    tokenEmail = token.email;
                    teacherPayForLesson(params);
                    $rootScope.overlayMessage = $filter('translate')('STUDENT_DASHBOARD.OVERLAY_MESSAGE');
                });
            }
            else {
                var params = {
                    email: vm.email,
                    name: vm.name,
                    categoryId: vm.category.id,
                    teacherId: vm.teacher.id,
                    price: vm.singlePrice,
                    times: vm.times,
                };
                waitForResponse();
                teacherPayForLesson(params);
            }
        }

        function getStudents() {
            return apiResolver.resolve('student.getAllLinked@get');
        }

        function getCategories() {
            return apiResolver.resolve('priceCategories.byTeacher@get', { teacherId: vm.teacher.id });
        }

        function getCustomPricesByTeacher() {
            return apiResolver.resolve('customPrices.byTeacher@get', { teacherId: vm.teacher.id });
        }

        function getCustomPrices() {
            return apiResolver.resolve('customPrices.list@get');
        }

        function teacherPayForLesson(params) {
            api.courseRequest.byTeacher.post(params, _successCreateRequestCallbackTeacher, _errorAcceptCallback);
        }

        function _successCreateRequestCallback() {
            $mdDialog.hide();
            $rootScope.isCreateRequest = true;
            $rootScope.overlayMessage = null;
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Your lesson request has been sent!')
                .textContent('')
                .ariaLabel('')
                .ok('OK')

                .title($filter('translate')('LESSON_REQUEST.REQUEST_SENT'))
                .textContent('')
                .ariaLabel('')
                .ok($filter('translate')('LESSON_REQUEST.OK'))
            );
        }

        function _successCreateRequestCallbackTeacher() {
            $mdDialog.hide();
            $rootScope.isCreateRequestTeacher = true;
            $rootScope.overlayMessage = null;
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))
                .title('Your lesson has been created!')
                .textContent('')
                .ariaLabel('')
                .ok('OK')
            );
        }

        function _errorCallback(response) {
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

        function _errorAcceptCallback(response) {
            $mdDialog.hide();
            _errorCallback(response);
            $rootScope.overlayMessage = null;
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.essay-payment', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/essay-payment');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.essay-payment')
        .controller('EssayPaymentController', EssayPaymentController);

    /** @ngInject */
    function EssayPaymentController($q, $mdDialog, $auth, $http, api, essayInfo, constPHPDateTimeFormat, $filter, $rootScope, apiResolver, StripeService, $state)
    {
        var vm = this;
        var payload = $auth.getPayload();
        var db = new AWS.DynamoDB.DocumentClient({accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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', region: 'us-east-1'});
        $rootScope.userRole = getUserRole();
        $rootScope.overlayMessage = null;

        // Data
        vm.wordCount = essayInfo.wordCount;
        vm.teacherInfo = essayInfo.teacherInfo;
        vm.essayType = essayInfo.essayType;
        vm.docs = essayInfo.docs;
        vm.totalPrice = (essayInfo.price).toFixed(2);
        vm.useBalance = 0;
        vm.user = essayInfo.user;
        vm.essayUploadCounter = 0;

        if (vm.essayType == 5) {
            vm.currency = 'usd';
        } else{
            vm.currency = 'cny';
        } 

        //init
        init();

        // Methods
        vm.closeDialog = closeDialog;
        vm.confirmPayment = confirmPayment;
        vm.canSubmit = canSubmit;

        // Functions
        function init() {
            console.log("INIT ESSAY PAYMENT");
            console.log(essayInfo);
            getWalletBalance().then(function(response) {
                vm.walletBalance = response.data;
            }, _errorHandler);
        }

        function getWalletBalance(){
            return apiResolver.resolve("wallet.getBalance@get");
        }

        function canSubmit() {

            // only allow one payment method
            if (vm.totalPrice) {
                if (!vm.useWallet && !vm.useCreditCard) {
                    return true;
                }
                if (vm.useWallet && !vm.useCreditCard) {
                    return true;
                }
                if (!vm.useWallet && vm.useCreditCard) {
                    return true;
                }
                return false;
            } else {
                if (!vm.useWallet && !vm.useCreditCard) {
                    return true;
                }
                return false;
            }
        }

        function confirmPayment() {
            $mdDialog.hide();
            vm.creditCardAmount = vm.totalPrice;
            console.log(vm.currency);
            if (vm.useCreditCard) {
                StripeService.openPopup({
                    name: vm.teacherInfo.name,
                    description: 'Essay Submission',
                    amount: vm.creditCardAmount * 100,
                    currency: vm.currency

                }, function (token) {
                    waitForResponse();
                    var params = {
                        token: token.id,
                        email: token.email,
                        useBalance: vm.useBalance,
                        creditCardAmount: vm.creditCardAmount,
                        teacherId: vm.teacherInfo.id,
                        docs: vm.docs,
                        essayType: vm.essayType,
                        price: vm.totalPrice,
                        submitTime: moment().utc().format('MMM DD, YYYY hh:mm a'),
                        paymentMethod: 'credit card',
                        currency: vm.currency
                    };
                    console.log(params);
                    upload(params);

                });
            } else {
                waitForResponse();
                var params = {
                    token: token.id,
                    email: token.email,
                    useBalance: vm.useBalance,
                    creditCardAmount: vm.creditCardAmount,
                    teacherId: vm.teacherInfo.id,
                    essayType: vm.essayType,
                    docs: vm.docs,
                    paymentMethod: 'credit card'
                };
                console.log(params);
                api.essayRequest.save.post(params, _successCreateRequestCallback, _errorHandler);
            }
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Essay Request Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

        function _successCreateRequestCallback() {
            $rootScope.isCreateRequest = true;
            $mdDialog.hide();
            $mdDialog.show(
              $mdDialog.confirm()
                .title('Your essay request has been sent!')
                .textContent('')
                .ariaLabel('essay request')
                .ok('HOME DASHBOARD')
                .cancel('TEACHER PROFILE')
                .parent(angular.element(document.body))
            ).then(function() {
                $state.go('app.pages_student-dashboard');
            }, function() {
                $state.go('app.pages_teacher', { id: vm.teacherInfo.id });
            });
            
        }

        function _errorHandler(response) {
            $mdDialog.hide();
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }

        function _createFileID() {
            var d = new Date();
            var n = d.getTime();
            console.log("Get a file at time: " + n);
            var newFileName =  n.toString();
            return newFileName;
        }

        function _uploadS3AndDynamoDB(apiParams, category, extension, file, index) {
            var bucket = new AWS.S3({ params: { Bucket: 'testdb-userfiles-mobilehub-864203888/public/user_' + vm.user.id + '/Files'} });
            var fileId = _createFileID();
            var uniqueFileName = fileId + extension;
            console.log("uploadS3");
            console.log(apiParams);
            console.log(index);
            apiParams.docs[index + 1].awsKey = uniqueFileName;
            var params = { Key: uniqueFileName, ContentDisposition: 'attachment; filename=' + file.name, ContentType: file.type, Body: file, ServerSideEncryption: 'AES256' };
            console.log(params);
            bucket.putObject(params, function(err, data) {
                if(err) {
                    $rootScope.overlayMessage = null;
                    _errorHandler(err.code);
                    return false;
                } else {
                    var item = {};
                    // update in the database;
                    item.ownerId = vm.user.id;
                    item.ownerName = vm.user.name;
                    item.location = 'public/user_' + vm.user.id + '/Files/' + fileId + extension;
                    item.accessId = vm.user.id.toString();
                    item.created = (new Date().getTime() / 1000);
                    item.updated = item.created;
                    item.access = 'rw';
                    item.fileId = fileId;
                    item.extension = extension;
                    item.fileName = file.name;
                    
                    AWS.config.update({region:'us-east-1'});
                    db.put({
                        'TableName': 'testdb-mobilehub-864203888-FileDB',
                        'Item': item,
                        'ConditionExpression': 'attribute_not_exists(id)'
                    }).promise().then(function(data) {
                        // Upload Successfully Finished
                        vm.essayUploadCounter += 1;
                        console.log(vm.essayUploadCounter);
                        console.log(index);
                        if (vm.essayUploadCounter == 3) {
                            api.essayRequest.save.post(apiParams, _successCreateRequestCallback, _errorHandler);
                        }
                        console.log(data);
                    }).catch(function(err)  {
                        console.log("ERROR: " + err);
                    });
                }
            });
        }

        function upload(params) {
            console.log("upload");
            AWS.config.update({ accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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'});
            AWS.config.region = 'us-east-1';

            if(essayInfo.files) {
                console.log(essayInfo.files);
                for (var i = 0; i <= essayInfo.files.length - 1; i++) {
                    if (essayInfo.files[i].type == 'application/msword' && essayInfo.files[i].name.endsWith('.doc')) {
                        _uploadS3AndDynamoDB(params, 'document', '.doc', essayInfo.files[i], i);
                    } else if(essayInfo.files[i].type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && essayInfo.files[i].name.endsWith('.docx') ) {
                        _uploadS3AndDynamoDB(params, 'document', '.docx', essayInfo.files[i], i);
                    } else if(essayInfo.files[i].type == 'text/plain' && essayInfo.files[i].name.endsWith('.txt') ) {
                        _uploadS3AndDynamoDB(params, 'document', '.txt', essayInfo.files[i], i);
                    } else {
                        $rootScope.overlayMessage = null;
                        alert('Please select a doc, docx, txt, file to upload');
                    }
                }
            } else {
                if (vm.essayType == 2) {
                    alert('Please select a file to upload');
                }
                else {
                    api.essayRequest.save.post(params, _successCreateRequestCallback, _errorHandler);
                }
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.edit-profile-pic', [
            'angularFileUpload',
        ])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/edit-profile-pic');
    }

})();
(function ()
{
    'use strict';

    angular.module('app.dialogs.edit-profile-pic')
        .controller('EditProfilePicController', EditProfilePicController);

    /** @ngInject */
    function EditProfilePicController($filter, $mdDialog, $auth, FileUploader, teacher)
    {
        var vm = this;
        var uploaderConfig = {
            url: '/api/avatar',
            headers: {
                "Authorization": 'Bearer ' + $auth.getToken(),
            },
            removeAfterUpload: true,
            onSuccessItem: function (item, response, status, headers) {
                $mdDialog.hide();
                vm.teacher.avatar = response.data.url;
            },
        };
        var uploader = new FileUploader(uploaderConfig);

        // Data
        vm.teacher = teacher;
        vm.uploader = uploader;
        vm.defaultAvatar = '/assets/images/avatars/profile.jpg';

        // Methods
        vm.closeDialog = closeDialog;
        vm.uploadAvatar = uploadAvatar;
        vm.notImplement = notImplement;

        function closeDialog() {
            $mdDialog.hide();
        }

        function uploadAvatar() {
            uploader.uploadAll();
        }

        function notImplement() {
            alert('Not Implement');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.edit-file', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/edit-file');
    }

})();
(function ()
{
    'use strict';

    angular.module('app.dialogs.edit-file')
        .controller('EditFileController', EditFileController);

    /** @ngInject */
    function EditFileController($rootScope, $scope, $filter, $mdDialog, $auth, api, user)
    {
        var db = new AWS.DynamoDB.DocumentClient({accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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', region: 'us-east-1'});
        var vm = this;

        // Data
        vm.user = user;

        // Methods
        vm.upload = upload;
        vm.closeDialog = closeDialog;

        function _init() {
            api.option.language.get(function(response) {
                console.log(response);
                vm.languageOption = response.data;
            },_errorCallback);
            console.log("WHERE");
            console.log(vm.user);
        }

        function _createFileID() {
            var d = new Date();
            var n = d.getTime();
            console.log("Get a file at time: " + n);
            var newFileName =  n.toString();
            return newFileName;
        }

        function _uploadS3AndDynamoDB(category, extension) {
            if(category == 'document') {
                var bucket = new AWS.S3({ params: { Bucket: 'testdb-userfiles-mobilehub-864203888/public/user_' + vm.user.id + '/Files'} });
            } else if(category == 'musical-note') {
                var bucket = new AWS.S3({ params: { Bucket: 'testdb-userfiles-mobilehub-864203888/public/user_' + vm.user.id + '/Recordings'} });
            }
            var fileId = _createFileID();
            var uniqueFileName = fileId + extension;
            console.log(extension);
            console.log($scope.item);
            var params = { Key: uniqueFileName, ContentDisposition: 'attachment; filename=' + $scope.item.name + extension, ContentType: $scope.file.type, Body: $scope.file, ServerSideEncryption: 'AES256' };
            console.log(params);
            console.log(vm.user);
            bucket.putObject(params, function(err, data) {
                if(err) {
                    $rootScope.overlayMessage = null;
                    console.error(err.message,err.code);
                    return false;
                } else {
                    var item = {};
                    // update in the database;
                    console.log(vm.user);
                    item.ownerId = vm.user.id;
                    item.ownerName = vm.user.name;
                    if(category == 'document') {
                        item.location = 'public/user_' + vm.user.id + '/Files/' + fileId + extension;
                    } else if(category == 'musical-note') {
                        item.location = 'public/user_' + vm.user.id + '/Recordings/' + fileId + extension;
                    }
                    item.accessId = vm.user.id.toString();
                    item.created = (new Date().getTime() / 1000);
                    item.updated = item.created;
                    item.access = 'rw';

                    item.fileId = fileId;
                    item.extension = extension;
                    item.fileName = $scope.item.name;
                    
                    AWS.config.update({region:'us-east-1'});
                    console.log(AWS.config);
                    db.put({
                        'TableName': 'testdb-mobilehub-864203888-FileDB',
                        'Item': item,
                        'ConditionExpression': 'attribute_not_exists(id)'
                    }).promise().then(function(data) {
                        // Upload Successfully Finished
                        $rootScope.overlayMessage = null;
                        alert('File Uploaded Successfully', 'Done');
                        console.log(data);
                        $mdDialog.hide();
                    }).catch(function(err)  {
                        console.log("ERROR: " + err);
                    });
                }
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function _errorCallback(response) {
            console.error(response);
        }

        _init();

        function upload() {
            console.log("upload")
            $rootScope.overlayMessage = 'File uploading, please wait.';
            AWS.config.update({ accessKeyId: 'AKIAJ62QIBPI42R7CHEA', secretAccessKey: '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'});
            AWS.config.region = 'us-east-1';
            console.log("BEST TEAM");
            console.log(AWS.config);
            
            if($scope.file) {
                console.log('$scope.file ====>');
                console.log($scope.file);
                
                // Prepend Unique String To Prevent Overwrites
                if($scope.file.type == 'application/msword' && $scope.file.name.endsWith('.doc') ) {
                    _uploadS3AndDynamoDB('document', '.doc');
                } else if($scope.file.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' && $scope.file.name.endsWith('.docx') ) {
                    _uploadS3AndDynamoDB('document', '.docx');
                } else if($scope.file.type == 'text/plain' && $scope.file.name.endsWith('.txt') ) {
                    _uploadS3AndDynamoDB('document', '.txt');
                } else if( ($scope.file.type == 'audio/mpeg' || $scope.file.type == 'audio/mp3') && $scope.file.name.endsWith('.mp3') ) {
                    _uploadS3AndDynamoDB('musical-note', '.mp3');
                } else {
                    // Can not upload other than txt file or mp3 file
                    $rootScope.overlayMessage = null;
                    alert('Please select a doc, docx, txt, mp3 file to upload');
                }
            } else {
                // No File Selected
                $rootScope.overlayMessage = null;
                alert('Please select a file to upload');
            }
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.create-package', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/create-package');
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.create-package')
        .controller('CreatePackageController', CreatePackageController);

    /** @ngInject */
    function CreatePackageController($q, $mdDialog, $auth, api, teacher, $filter, $rootScope, apiResolver)
    {
        var vm = this;
        var payload = $auth.getPayload();

        //data
        vm.categories = [];
        vm.teacher = teacher;

        //init
        init();

        //methods
        vm.closeDialog = closeDialog;
        vm.createPackage = createPackage;

        //functions
        function init() {
            getCategories().then(function(response) {
                vm.categories = response.data;
            },_errorHandler);
        }

        function closeDialog() {
            $mdDialog.cancel();
        }

        function getCategories() {
            return apiResolver.resolve('priceCategories.byTeacher@get', { teacherId: vm.teacher.id });
        }

        function _errorHandler(response) {
            $mdDialog.hide();
            alert('Oh! Something unexpected happened!');
            console.error(response);
        }

        function createPackage() {
            $mdDialog.hide();
            var params = {
                token: $auth.getToken(),
                teacher_id: vm.teacher.id,
                hours: vm.packageHours,
                price: vm.packagePrice,
                category_id: vm.category.id,
                package_name: vm.packageName,
            };
            console.log(params);
            api.packages.create.post(params,
                function(response) {
                    $mdDialog.hide();
                    $mdDialog.show(
                      $mdDialog.alert()
                        .clickOutsideToClose(true)
                        .parent(angular.element(document.body))
                        .title('Your package has been created!')
                        .textContent('')
                        .ariaLabel('')
                        .ok('OK')
                    );
                },
                function(response) {
                    _errorHandler(response);
                }
            );
            waitForResponse();
        }

        function waitForResponse() {
            var waitForResponseContent =
            ' \
                <md-dialog class="event-detail-dialog" style="width:480px;max-width:480px; padding-top: 20px;" aria-label=""> \
                    <md-dialog-content layout="row" layout-align="space-between" class="md-toolbar-tools"> \
                        <span class="dialog-title" style="color:black;font-weight:bold;">Processing...</span>\
                        <md-progress-circular id="toolbar-progress" class="md-accent"\
                              md-mode="indeterminate" md-diameter="32">\
                        </md-progress-circular>\
                    </md-dialog-content> \
                </md-dialog> \
            ';
            $mdDialog.show({
                template            : waitForResponseContent,
                clickOutsideToClose : false,
                parent              : angular.element(document.body),
                controller          : WaitForResponceController,
            });

            function WaitForResponceController($scope, $mdDialog) {
                $scope.closeDialog = function() {
                    $mdDialog.hide();
                }
            }
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.covid-popup', ['ngCookies'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/covid-popup');
    }

})();
(function ()
{
    'use strict';

    angular.module('app.dialogs.covid-popup')
        .controller('CovidPopupController', CovidPopupController);

    /** @ngInject */
    function CovidPopupController($state, $mdDialog, api, $cookies)
    {
        var vm = this;

        // Data

        // Methods
        vm.closeDialog = closeDialog;
        vm.goToCovid = goToCovid;

        // Functions
        function closeDialog() {
            $mdDialog.hide();
            $cookies.put("exited-covid-popup", true);
        }

        function goToCovid() {
            $mdDialog.hide();
            $state.go('app.pages_covid');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.change-password', [
            'ngPassword',
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/change-password');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dialogs.change-password')
        .controller('ChangePasswordController', ChangePasswordController);

    /** @ngInject */
    function ChangePasswordController($filter, $mdDialog, $auth, api)
    {
        var vm = this;

        // Data
        vm.password = {
            new: '',
            confirm: ''
        };
        vm.isError = false;
        vm.errorMessage = {};

        // Methods
        vm.closeDialog = closeDialog;
        vm.submit = submit;
        vm.notImplement = notImplement;

        function submit() {
            var data = {
                password: vm.password.new,
                passwordConfirmation: vm.password.confirm
            };

            api.auth.changePassword.update(data, _successHandler, _errorHandler);
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function notImplement() {
            alert('Not Implement');
        }

        function _successHandler(response) {
            $mdDialog.hide();
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))

                .title($filter('translate')('CHANGE_PASSWORD.PASSWORD_SAVE_TITLE'))
                .textContent($filter('translate')('CHANGE_PASSWORD.PASSWORD_SAVE_CONTENT'))
                .ariaLabel($filter('translate')('CHANGE_PASSWORD.PASSWORD_SAVE_OK'))
                .ok($filter('translate')('CHANGE_PASSWORD.PASSWORD_SAVE_OK'))
            );
        }

        function _errorHandler(response) {
            $mdDialog.hide();
            $mdDialog.show(
              $mdDialog.alert()
                .clickOutsideToClose(true)
                .parent(angular.element(document.body))

                .title($filter('translate')('CHANGE_PASSWORD.PASSWORD_SAVE_TITLE'))
                .textContent($filter('translate')('CHANGE_PASSWORD.PASSWORD_SAVE_CONTENT_FAIL'))
                .ariaLabel($filter('translate')('CHANGE_PASSWORD.PASSWORD_SAVE_OK'))
                .ok($filter('translate')('CHANGE_PASSWORD.PASSWORD_SAVE_OK'))
            );
            console.error(response);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.calendar-dialog', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dialogs/calendar-dialog');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dialogs.calendar-dialog')
        .controller('CalendarDialogController', CalendarDialogController);

    /** @ngInject */
    function CalendarDialogController($mdDialog, api, calendarEvent)
    {
        var vm = this;

        // Data
        vm.form = {};
        vm.today = moment().toDate();
        vm.actionType = calendarEvent.actionType;
        vm.isdelete = (vm.actionType != 'drop');

        // Methods
        vm.closeDialog = closeDialog;
        vm.sumbit = sumbit;
        vm.delete = _delete;
        vm.cancel = cancel;
        vm.changeStartDate = changeStartDate;


        // Functions
        function closeDialog() {
            $mdDialog.cancel();
        }

        function sumbit() {
            var start = getDatetime(vm.form.startDate, vm.form.startTime);
            var end = getDatetime(vm.form.endDate, vm.form.endTime);
            calendarEvent.start = moment(start).utc();
            calendarEvent.end = moment(end).utc();
            $mdDialog.hide(calendarEvent);
        }

        function _delete() {
            calendarEvent.actionType = 'destroy';
            $mdDialog.hide(calendarEvent);
        }

        function cancel() {
            calendarEvent.actionType = 'cancel';
            $mdDialog.hide(calendarEvent);
        }

        function changeStartDate() {
            vm.form.endDate = angular.copy(vm.form.startDate);
        }

        function getDatetime(date, time) {
            var year = date.getFullYear();
            var month = getMonth(date.getMonth());
            var day = date.getDate();
            var datetime = new Date(year + '/' + month + '/' + day + ' ' + time);

            return datetime;
        }

        function getMonth(month) {
            var monthMap = {
                0: '01',
                1: '02',
                2: '03',
                3: '04',
                4: '05',
                5: '06',
                6: '07',
                7: '08',
                8: '09',
                9: '10',
                10: '11',
                11: '12',
            };

            return monthMap[month];
        }

        function init() {
            vm.form.startDate = (typeof calendarEvent.start) == 'string' ? moment(calendarEvent.start).toDate() : calendarEvent.start.toDate();
            vm.form.startTime = (typeof calendarEvent.start) == 'string' ? moment(calendarEvent.start).format('HH:mm') : calendarEvent.start.format('HH:mm');
            vm.form.endDate = (typeof calendarEvent.end) == 'string' ? moment(calendarEvent.end).toDate() : calendarEvent.end.toDate();
            vm.form.endTime = (typeof calendarEvent.end) == 'string' ? moment(calendarEvent.end).format('HH:mm') : calendarEvent.end.format('HH:mm');
        }

        init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.footer', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/common/templates/footer');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.footer')
        .controller('FooterController', FooterController);

    /** @ngInject */
    function FooterController($state, constNesukuEmail)
    {
        var vm = this;

        // Data


        // // Methods
        vm.applyToTeach = applyToTeach;
        vm.findATeacher = findATeacher;
        vm.contactNesuku = contactNesuku;
        vm.goToMobile = goToMobile;
        vm.privacyPolicy = privacyPolicy;


        // // // Functions

        function applyToTeach() {
            $state.go('app.pages_apply-to-teach');
        }

        function findATeacher() {
            $state.go('app.pages_teacher-list');
        }

        function contactNesuku() {
            location.href = constNesukuEmail;
        }

        function goToMobile() {
            window.location.replace("http://m.nesuku.com");
        }

        function privacyPolicy() {
            $state.go('app.pages_privacy-policy');
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.covid-header', ['ngCookies'])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/common/templates/covid-header');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.covid-header')
        .controller('CovidHeaderController', CovidHeaderController);

    /** @ngInject */
    function CovidHeaderController($state, $cookies)
    {
        var vm = this;

        // init

        // Data
        if ($cookies.get("exited-covid-header")) {
            vm.headerExited = true;
        } else {
            vm.headerExited = false;
        }

        // // Methods
        vm.goToConversation = goToConversation;
        vm.closeHeader = closeHeader;


        // // // Functions
        function goToConversation() {
            $state.go('app.pages_conversation-partners');
        }

        function closeHeader() {
            vm.headerExited = true;
            $cookies.put("exited-covid-header", true);
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.auth-nav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/common/templates/auth-nav');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.auth-nav')
        .controller('AuthNavController', AuthNavController);

    /** @ngInject */
    function AuthNavController($state, $auth, $rootScope, $mdSidenav, $translate, $mdDialog, $document, $timeout)
    {
        var vm = this;
        var payload = $auth.getPayload();

        $rootScope.isAuthenticated = $auth.isAuthenticated();
        $rootScope.userRole = getUserRole();

        // Data
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'short'      : 'TOOLBAR.ENG',
                'flag'       : 'us'
            },
            zh: {
                'title'      : 'Mandarin',
                'translation': 'TOOLBAR.MANDARIN',
                'code'       : 'zh',
                'short'      : 'TOOLBAR.CHN',
                'flag'       : 'cn'
            }
        };

        // init
        init();

        // Data
        vm.openAboutUs = false;
        vm.openTeachers = false;

        // // Methods
        vm.goToHomepage = goToHomepage;
        vm.applyToTeach = applyToTeach;
        vm.logIn = logIn;
        vm.goToSignUp = goToSignUp;
        vm.goToStudentHelp = goToStudentHelp;
        vm.goToTeacherList = goToTeacherList;
        vm.changeLanguage = changeLanguage;
        vm.openRightMenu = toggleMenu;
        vm.aboutUs = aboutUs;
        vm.meetOurTeachers = meetOurTeachers;
        vm.blog = blog;
        vm.beComeATeacher = beComeATeacher;
        vm.goToConversation = goToConversation;
        vm.privacyPolicy = privacyPolicy;

        // // // Functions
        function init() {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.use()];

            if (vm.selectedLanguage == undefined) {
                vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            }
        }

        function goToTeacherList() {
            if ($rootScope.isAuthenticated) {
                api.auth.switchRole.post({token:$auth.getToken(),role:'student'},function(response) {
                    $auth.setToken(response.token);
                    var payload = $auth.getPayload();
                    $rootScope.isAuthenticated = $auth.isAuthenticated();
                    $rootScope.userRole = 'student';

                    $state.go('app.pages_teacher-list', {is_conversation_partner: 'teacher'});
                });
            }
            else {
                $state.go('app.pages_teacher-list', {is_conversation_partner: 'teacher'});
            }
        }

        function goToHomepage() {
            if ($rootScope.isAuthenticated) {
                switch ($rootScope.userRole) {
                    case 'admin':
                        $state.go('app.pages_admin-dashboard');
                        break;

                    case 'teacher':
                        $state.go('app.pages_teacher-dashboard');
                        break;

                    case 'student':
                        $state.go('app.pages_student-dashboard');
                        break;

                    default:
                        $state.go('app.pages_auth_login');
                        break;
                }
            }
            else {
                $state.go('app.pages_landing');
            }
        }

        function toggleMenu() {
            $mdSidenav('right').toggle();
        }

        function applyToTeach() {
            $state.go('app.pages_landing-teach');
        }

        function logIn() {
            $state.go('app.pages_auth_login');
        }

        function goToSignUp() {
            $state.go('app.pages_auth_register');
        }

        function goToStudentHelp() {
            $state.go('app.pages_help-center');
        }

        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */

            $translate.use(lang.code);

            return;
            // Change the language
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }

        function openDialog() {
            $mdDialog.show({
                controller         : 'TermsConditionsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/terms-n-conditions/terms-n-conditions.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            });
        }

        function aboutUs() {
            $state.go('app.pages_about_us');
        }

        function meetOurTeachers() {
            $state.go('app.pages_meet_teachers');
        }

        function blog() {
            $state.go('app.pages_blog');
        }

        function beComeATeacher() {
            $state.go('app.pages_apply-to-teach');
        }

        function goToConversation() {
            $state.go('app.pages_conversation-partners');
        }

        function privacyPolicy() {
            $state.go('app.pages_privacy-policy');
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.stripe-connect', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,
                    $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.pages_stripe-connect', {
            url      : '/stripe-connect',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/stripe-connect/stripe-connect.html',
                    controller : 'StripeConnectController as vm'
                }
            },
            bodyClass: 'stripe-connect',
            requireLogin: true,
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/stripe-connect');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.stripe-connect')
        .controller('StripeConnectController', StripeConnectController);

    /** @ngInject */
    function StripeConnectController($filter, $rootScope, $location, $state, api)
    {
        var vm = this;
        var code = $location.search().code;

        // Data

        // Methods

        $rootScope.overlayMessage = $filter('translate')('STRIPE_CONNECT.OVERLAY_MESSAGE');



        api.connectStripe.list.post({
            code: code,
        }, function (response) {
            $state.go('app.pages_edit-teacher');
            $rootScope.overlayMessage = null;
        }, function (response) {
            console.error(response);
            alert(response.data.error);
            $rootScope.overlayMessage = null;
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dev-mode', ['ui.router'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider)
    {
        // State
        $stateProvider.state('app.dev-mode', {
            url      : '/dev-mode',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/dev-mode/dev-mode.html',
                    controller : 'DevModeController as vm'
                }
            }
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dev-mode')
        .controller('DevModeController', DevModeController);

    /** @ngInject */
    function DevModeController()
    {
        var vm = this;

        // Data

        // Methods

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('specificAvailabilityMapper', specificAvailabilityMapperService);

    /** @ngInject */
    function specificAvailabilityMapperService($q, $log, api)
    {
        var service = {
            mapForTeacher: mapForTeacher,
        };
        var replaceRegularHours = [];
        // var crossUTCRegularHours = [];
        return service;


        //////////
        /**
         * Map api
         * @param specificHours
         * @param regularHours
         * @param isSpecificSchedule
         */
        function mapForTeacher(specificHours, regularHours, isSpecificSchedule)
        {
            return _pipeSpecificHours(specificHours)
            .concat(_pipeRegularHours(regularHours, isSpecificSchedule));
        }

        function _pipeSpecificHours(specificHours) {
            if ( ! specificHours || ! specificHours instanceof Array) return [];

            specificHours.forEach(function(specificHour) {
                var date = moment(specificHour.start).format("YYYY-MM-DD");
                replaceRegularHours.push({
                    id: specificHour.regularHoursId,
                    date: date
                });
                // specificHour.className = 'reserved';
                specificHour.stick = true;
            });

            function isAvailable(specificHour, index, array) {
                return specificHour.isAvailable;
            }
            specificHours = specificHours.filter(isAvailable);

            return specificHours;
        }

        function _pipeRegularHours(regularHours, isSpecificSchedule) {
            if ( ! regularHours || ! regularHours instanceof Array) return [];

            // cross UTC+00 events
            // function isCrossUTCEarlyRegular(regularHour, index, array) {
            //     var notCross = true;
            //     var regularHourTime = moment(regularHour.end).utc().format("HH:mm:ss");
            //     if(regularHourTime == '23:59:59' || regularHourTime == '23:59:00') {
            //         crossUTCRegularHours.push({
            //             early: regularHour
            //         });
            //         notCross = false;
            //     }
            //     return notCross;
            // }
            // function isCrossUTCLateRegular(regularHour, index, array) {
            //     var notCross = true;
            //     var regularHourDate = moment(regularHour.start).utc().format("YYYY-MM-DD");
            //     var regularHourTime = moment(regularHour.start).utc().format("HH:mm:ss");
            //     crossUTCRegularHours.forEach(function(crossUTCRegularHour) {
            //         var crossUTCEarlyRegularHourDate = moment(crossUTCRegularHour.early.end).add(1, 'days').utc().format("YYYY-MM-DD");
            //         if(regularHourTime == '00:00:00' && regularHourDate == crossUTCEarlyRegularHourDate) {
            //             crossUTCRegularHour.late = regularHour;
            //             notCross = false;
            //         }
            //     });
            //     return notCross;
            // }
            // regularHours = regularHours.filter(isCrossUTCEarlyRegular);
            // regularHours = regularHours.filter(isCrossUTCLateRegular);
            // crossUTCRegularHours.forEach(function(crossUTCRegularHour) {
            //     if(crossUTCRegularHour.late) {
            //         regularHours.push({
            //             id          : crossUTCRegularHour.early.id,
            //             teacherId   : crossUTCRegularHour.early.teacherId,
            //             start       : crossUTCRegularHour.early.start,
            //             end         : crossUTCRegularHour.late.end,
            //             isCrossUTC  : true,
            //             early       : crossUTCRegularHour.early,
            //             late        : crossUTCRegularHour.late,
            //             color       : crossUTCRegularHour.early.color
            //         });
            //     }
            // });
            // crossUTCRegularHours = [];

            if (isSpecificSchedule) {
                function isReplaced(regularHour, index, array) {
                    var regularHourDate = moment(regularHour.start).format("YYYY-MM-DD");
                    var notReplaced = true;
                    replaceRegularHours.forEach(function(replaceRegularHour) {
                        if( replaceRegularHour.id==regularHour.id && replaceRegularHour.date==regularHourDate ) {
                            notReplaced = false;
                        }
                    });
                    return notReplaced;
                }
                regularHours = regularHours.filter(isReplaced);

                regularHours.forEach(function(regularHour) {
                    // regularHour.className = 'regular';
                    regularHour.color = '#FFE0B2';
                    regularHour.stick = true;
                });
            }
            replaceRegularHours = [];

            return regularHours;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('scheduleMapper', scheduleMapperService);

    /** @ngInject */
    function scheduleMapperService($q, $log, api)
    {
        var service = {
            mapForStudent: mapForStudent,
            mapForTeacher: mapForTeacher,
            mapForGuest: mapForGuest
        };
        var replaceRegularHours = [];
        // var crossUTCRegularHours = [];
        return service;

        //////////
        /**
         * Map api
         * @param reservedEvents
         * @param pendingEvents
         * @param availabilities
         */
        function mapForStudent(reservedEvents, pendingEvents, specificHours, regularHours)
        {
            return _pipeReservedForStudent(reservedEvents)
            .concat(_pipePendingForStudent(pendingEvents), _pipeSpecificHours(specificHours), _pipeRegularHours(regularHours));
        }

        /**
         * Map api
         * @param reservedEvents
         * @param pendingEvents
         * @param availabilities
         */
        function mapForTeacher(reservedEvents, pendingEvents, specificHours, regularHours)
        {
            return _pipeReservedForTeacher(reservedEvents)
            .concat(_pipePendingForTeacher(pendingEvents), _pipeSpecificHours(specificHours), _pipeRegularHours(regularHours));
        }

        /**
         * Map api
         * @param reservedEvents
         * @param pendingEvents
         * @param availabilities
         */
        function mapForGuest(reservedEvents, pendingEvents, specificHours, regularHours)
        {
            return _pipeReservedForGuest(reservedEvents)
            .concat(_pipePendingForGuest(pendingEvents), _pipeSpecificHours(specificHours), _pipeRegularHours(regularHours));
        }

        function _pipeReservedForStudent(events) {
            if ( ! events || ! events instanceof Array) return [];

            events.forEach(function(event) {
                event.className = 'reserved';
                event.title = event.teacherName;
                event.stick = true;
            });

            return events;
        }

        function _pipeReservedForTeacher(events) {
            if ( ! events || ! events instanceof Array) return [];

            events.forEach(function(event) {
                event.className = 'reserved';
                event.title = event.studentName;
                event.stick = true;
            });

            return events;
        }

        function _pipeReservedForGuest(events) {
            if ( ! events || ! events instanceof Array) return [];

            events.forEach(function(event) {
                event.className = 'reserved';
                event.title = 'Reserved';
                event.stick = true;
            });

            return events;
        }

        function _pipePendingForStudent(events) {
            if ( ! events || ! events instanceof Array) return [];

            events.forEach(function(event) {
                event.className = 'pending';
                event.title = event.teacherName;
                event.stick = true;
            });

            return events;
        }

        function _pipePendingForTeacher(events) {
            if ( ! events || ! events instanceof Array) return [];

            events.forEach(function(event) {
                event.className = 'pending';
                event.title = event.studentName;
                event.stick = true;
            });

            return events;
        }

        function _pipePendingForGuest(events) {
            if ( ! events || ! events instanceof Array) return [];

            events.forEach(function(event) {
                event.className = 'pending';
                event.title = 'Pending';
                event.stick = true;
            });

            return events;
        }

        function _pipeSpecificHours(specificHours) {
            if ( ! specificHours || ! specificHours instanceof Array) return [];

            specificHours.forEach(function(specificHour) {
                var date = moment(specificHour.start).format("YYYY-MM-DD");
                replaceRegularHours.push({
                    id: specificHour.regularHoursId,
                    date: date
                });
            });

            function isAvailable(specificHour, index, array) {
                return specificHour.isAvailable;
            }
            specificHours = specificHours.filter(isAvailable);

            specificHours.forEach(function(specificHour) {
                specificHour.rendering = 'background';
            });

            return specificHours;
        }
        function _pipeRegularHours(regularHours) {
            if ( ! regularHours || ! regularHours instanceof Array) return [];

            // cross UTC+00 events
            // function isCrossUTCEarlyRegular(regularHour, index, array) {
            //     var notCross = true;
            //     var regularHourTime = moment(regularHour.end).utc().format("HH:mm:ss");
            //     if(regularHourTime == '23:59:59' || regularHourTime == '23:59:00') {
            //         crossUTCRegularHours.push({
            //             early: regularHour
            //         });
            //         notCross = false;
            //     }
            //     return notCross;
            // }
            // function isCrossUTCLateRegular(regularHour, index, array) {
            //     var notCross = true;
            //     var regularHourDate = moment(regularHour.start).utc().format("YYYY-MM-DD");
            //     var regularHourTime = moment(regularHour.start).utc().format("HH:mm:ss");
            //     crossUTCRegularHours.forEach(function(crossUTCRegularHour) {
            //         var crossUTCEarlyRegularHourDate = moment(crossUTCRegularHour.early.end).add(1, 'days').utc().format("YYYY-MM-DD");
            //         if(regularHourTime == '00:00:00' && regularHourDate == crossUTCEarlyRegularHourDate) {
            //             crossUTCRegularHour.late = regularHour;
            //             notCross = false;
            //         }
            //     });
            //     return notCross;
            // }
            // regularHours = regularHours.filter(isCrossUTCEarlyRegular);
            // regularHours = regularHours.filter(isCrossUTCLateRegular);
            // crossUTCRegularHours.forEach(function(crossUTCRegularHour) {
            //     if(crossUTCRegularHour.late) {
            //         regularHours.push({
            //             id          : crossUTCRegularHour.early.id,
            //             teacherId   : crossUTCRegularHour.early.teacherId,
            //             start       : crossUTCRegularHour.early.start,
            //             end         : crossUTCRegularHour.late.end,
            //             isCrossUTC  : true,
            //             early       : crossUTCRegularHour.early,
            //             late        : crossUTCRegularHour.late,
            //             color       : crossUTCRegularHour.early.color
            //         });
            //     }
            // });
            // crossUTCRegularHours = [];

            function isReplaced(regularHour, index, array) {
                var regularHourDate = moment(regularHour.start).format("YYYY-MM-DD");
                var notReplaced = true;
                replaceRegularHours.forEach(function(replaceRegularHour) {
                    if( replaceRegularHour.id==regularHour.id && replaceRegularHour.date==regularHourDate ) {
                        notReplaced = false;
                    } 
                });
                return notReplaced;
            }
            regularHours = regularHours.filter(isReplaced);

            regularHours.forEach(function(regularHour) {
                regularHour.rendering = 'background';
            });
            replaceRegularHours = [];

            return regularHours;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function () {
    'use strict';

    angular.module('app.core')
    .filter('standardDropdownFilter', ['$filter', function($filter) {
        return function(item) {
            if (!item) {
                return '';
            }
            
            if(item.name || item.email) {
                return (item.name ? item.name : '') + ' ' + (item.email ? '[' + item.email + '] ' : '');
            }

            if(item.first_name || item.email) {
                return (item.first_name ? item.first_name : '') + ' ' + (item.last_name ? item.last_name : '') + ' ' + (item.email ? '[' + item.email + '] ' : '');    
            }
            else if(item.categoryName || item.hourlyPrice) {
                return (item.categoryName ? item.categoryName : '') + ' ' + (item.hourlyPrice ? '[' + '$' + item.hourlyPrice + '/hour' + '] ' : '');    
            } else {
                return '';
            }
        };        
    }]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('mailchimp', mailchimpDirective);

    /** @ngInject */
    function mailchimpDirective() {
        return {
            restrict: 'AE',
            link: function(scope, el, attrs){
                var scriptElem = angular.element(document.createElement('script'));
                scriptElem.attr("src", '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js'); // set var appropriately
                el.append(scriptElem);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('file', fileDirective);

    /** @ngInject */
    function fileDirective() {
        return {
            restrict: 'AE',
            scope: {
                file: '='
            },
            link: function(scope, el, attrs){
                el.bind('change', function(event){
                    var files = event.target.files;
                    var file = files[0];
                    scope.file = file;
                    scope.$parent.file = file;
                    console.log(file);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [

            // Core
            'app.core',

            // Config file
            'app.config',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Pages
            'app.pages',

            // Footer
            'app.footer',

            // Auth Nav Bar
            'app.auth-nav',

            // Covid Header
            'app.covid-header',

            // Stripe Connet
            'app.pages.stripe-connect',

            // Developer Mode
            'app.dev-mode',

            // Quick Panel
            'app.quick-panel',

            // 3rd-party modules
            'angular-loading-bar',
            'ngAnimate',
            'angular-google-analytics',
            'ui.timepicker',
        ]);
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('StripeService', StripeService);

    /** @ngInject */
    function StripeService(stripe)
    {
        /**
         * callback should like something like below:
         *
         * function (token) {
         *     You can access the token ID with `token.id`.
         *     Get the token ID to your server-side code for use.
         * }
         */
        function openPopup(config, callback) {
            // Key for production mode
            // var key = 'pk_live_d1qxExs8EHUAQo7uLKZzG6mG';

            // Key for alpha mode
            // var key = 'pk_live_gYXIfMHP6wx5hm0xmMjLrF4s';

            // Key for dev mode
            //var key = 'pk_test_FCca8UhZsQtknQSJor14zoMV';
            var key = stripe.productionKey;

            // StripeCheckout is embeded to index.html
            var handler = StripeCheckout.configure({
                key: key,
                image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
                locale: 'en',
                token: callback,
                currency: config.currency
            });

            handler.open(config);
        }

        /**
         * callback should like something like below:
         *
         * function (token) {
         *     You can access the token ID with `token.id`.
         *     Get the token ID to your server-side code for use.
         * }
         */
        function alipay(config) {
            // Key for production mode
            var key = 'pk_live_d1qxExs8EHUAQo7uLKZzG6mG';

            // Key for alpha mode
            // var key = 'pk_live_gYXIfMHP6wx5hm0xmMjLrF4s';

            // Key for dev mode
            // var key = 'pk_test_FCca8UhZsQtknQSJor14zoMV';

            var stripe = Stripe(key)
            // Stripe is embeded to index.html
            var handler = stripe.createSource({
                type: 'alipay',
                amount: config.amount,
                currency: config.currency,
                redirect: {
                    return_url: config.url,
                }
            }).then(function (result) {
                if (result && result.source && result.source.redirect && result.source.redirect['url']) {
                    location.href = result.source.redirect['url'];
                } else {
                    console.log('launch alipay error, refresh page');
                }
            });
        }

        function wechat(config) {
            // Key for production mode
            var key = 'pk_live_d1qxExs8EHUAQo7uLKZzG6mG';

            // Key for alpha mode
            // var key = 'pk_live_gYXIfMHP6wx5hm0xmMjLrF4s';

            // Key for dev mode
            // var key = 'pk_test_FCca8UhZsQtknQSJor14zoMV';

            // secret keys
            // sk_test_acT7PQjdfWLyyRYv28c8Yec5

            var stripe = Stripe(key)
            // Stripe is embeded to index.html
            var handler = stripe.createSource({
                type: 'wechat',
                amount: config.amount,
                currency: config.currency
            }).then(function (result) {
                if (result && result.source && result.source.wechat && result.source.wechat['qr_code_url']) {
                    window.open(result.source.wechat['qr_code_url'], '_blank');
                    console.log(result.source);

                    var MAX_POLL_COUNT = 300;
                    var pollCount = 0;
                    var source_id = result.source['id'];
                    var secret = result.source['client_secret'];
                    pollForSourceStatus();

                    // After some amount of time, we should stop trying to resolve the order synchronously:


                    function pollForSourceStatus() {
                      stripe.retrieveSource({id: source_id, client_secret: secret}).then(function(result) {
                        var source = result.source;
                        if (source.status === 'chargeable') {
                          // Make a request to your server to charge the Source.
                          // Depending on the Charge status, show your customer the relevant message.
                          location.href = config.url + '/' + source_id;

                        } else if (source.status === 'pending' && pollCount < MAX_POLL_COUNT) {
                          // Try again in a second, if the Source is still `pending`:
                          pollCount += 1;
                          setTimeout(pollForSourceStatus, 1000);
                        } else {
                          // Depending on the Source status, show your customer the relevant message.
                        }
                      });
                    }

                    // setTimeout(function(){console.log(result.source.chargeable);}, 15000)

                } else {
                    console.log('launch wechat pay error, refresh page');
                }
            });

        }

        return {
            openPopup: openPopup,
            alipay: alipay,
            wechat: wechat,
        };
    }

})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .filter('range', range);

  function range() {
    return function(input, total) {
      total = parseInt(total);
      for (var i = 0; i < total; i++) input.push(i);
      return input;
    };
  };

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', ['app.dialogs.register-teacher',
        						'app.dialogs.mailchimp'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController(
        $rootScope,
        $filter,
        $q,
        $state,
        $timeout,
        $interval,
        $mdSidenav,
        $translate,
        $document,
        $mdToast,
        $mdDialog,
        $auth,
        $cookies,
        msNavigationService,
        constRoles,
        api,
        apiResolver)
    {
        var vm = this;
        var payload = $auth.getPayload();

        $rootScope.isAuthenticated = $auth.isAuthenticated();
        $rootScope.userRole = getUserRole();
        $rootScope.notifications = {};

        if ($rootScope.isAuthenticated) {
            $rootScope.canSwitch = $auth.getPayload().canSwitch;
            $rootScope.isConversationPartner = $auth.getPayload().isConversationPartner;
        }

        // Data
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'short'      : 'TOOLBAR.ENG',
                'code'       : 'en',
                'flag'       : 'us'
            },
            zh: {
                'title'      : 'Mandarin',
                'translation': 'TOOLBAR.MANDARIN',
                'short'      : 'TOOLBAR.CHN',
                'code'       : 'zh',
                'flag'       : 'cn'
            }
        };


        // Methods
        vm.applyToTeach = applyToTeach;
        vm.logIn = logIn;
        vm.logOut = logOut;
        vm.signUp = signUp;
        vm.goToHomepage = goToHomepage;
        vm.goToTeacherList = goToTeacherList;
        vm.goToAdminDashboard = goToAdminDashboard;
        vm.goToAppDashboard = goToAppDashboard;
        vm.goToTeacherDashboard = goToTeacherDashboard;
        vm.goToStudentDashboard = goToStudentDashboard;
        vm.goToMessage = goToMessage;
        vm.goToTeacherHelp= goToTeacherHelp;
        vm.goToStudentHelp = goToStudentHelp;
        vm.changeLanguage = changeLanguage;
        vm.toggleSidenav = toggleSidenav;
        vm.aboutUs = aboutUs;
        vm.meetOurTeachers = meetOurTeachers;
        vm.blog = blog;
        vm.beComeATeacher = beComeATeacher;
        vm.goToConversation = goToConversation;
        vm.swicthRole = swicthRole;
        vm.goToConversationNotLog = goToConversationNotLog;
        vm.privacyPolicy = privacyPolicy;
        vm.goToSignUp = goToSignUp;
        vm.registerTeacher = registerTeacher;

        // Init
        init();

        // Get notificaition every minute
        $interval(getNotifications, 1000 * 60);

        /**
         * Initialize
         */
        function init()
        {
            // Get the selected language directly from angular-translate module setting

            vm.selectedLanguage = vm.languages[$translate.use()];
            if (vm.selectedLanguage == undefined) {
                vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            }

            if (!$cookies.get("viewed-mailchimp") && !$rootScope.isAuthenticated) {
                $timeout(openMailchimp, 10000);
            }

            getNotifications();

        }

        /**
         * Logout Function
         */
        function logOut()
        {
            alert($filter('translate')('TOOLBAR.LOGOUT_SUCCESS'));
            $auth.logout()
                .then(function(response) {
                    $rootScope.isAuthenticated = $auth.isAuthenticated();
                    $rootScope.userRole = '';
                    sessionStorage.removeItem("backUrl");
                    $state.reload('app.pages_auth_login');
                }, function(response){
                    console.log('Logout failed.', response);
                });
        }

        function openMailchimp() {
            $mdDialog.show({
                controller         : 'MailchimpController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/mailchimp/mailchimp.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            });
            $cookies.put("viewed-mailchimp", true);
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */

            $translate.use(lang.code);

            return;
            // Change the language
        }

        function goToTeacherList() {
            if ($rootScope.isAuthenticated) {
                api.auth.switchRole.post({token:$auth.getToken(),role:'student'},function(response) {
                    $auth.setToken(response.token);
                    var payload = $auth.getPayload();
                    $rootScope.isAuthenticated = $auth.isAuthenticated();
                    $rootScope.userRole = 'student';

                    $state.go('app.pages_teacher-list', {is_conversation_partner: 'teacher'});
                });
            }
            else {
                $state.go('app.pages_teacher-list', {is_conversation_partner: 'teacher'});
            }
        }

        function registerTeacher() {
            $mdDialog.show({
                controller         : 'RegisterTeacherController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/dialogs/register-teacher/register-teacher.html',
                parent             : angular.element($document.body),
                clickOutsideToClose: true,
            }).then(function() {
                
            });
        }

        function goToAdminDashboard() {
            var state = 'app.pages_admin-dashboard';

            goToState(state);
        }

        function goToAppDashboard() {
            var state = 'app.pages_app-dashboard';

            goToState(state);
        }

        function goToTeacherDashboard() {
            swicthRole('teacher');
        }

        function goToStudentDashboard() {
            swicthRole('student');
        }

        function goToMessage() {
            var state = 'app.pages_message';

            goToState(state);
        }

        function goToStudentHelp() {
            var state = 'app.pages_help-center';

            goToState(state);
        }

        function goToTeacherHelp() {
            var state = 'app.pages_help-center-teacher';

            goToState(state);
        }

        function goToState(state) {
            if( $state.current.name === state) {
                $state.reload();
            }
            else {
                $state.go(state);
            }
        }

        function getNotifications() {
            if ($rootScope.isAuthenticated && $rootScope.userRole !== 'admin'){
                $q.all([
                    _getNotifications(),
                ]).then(successCallback, errorCallback);
            }
        }

        function _getNotifications() {
            if ($rootScope.isAuthenticated) {
                return apiResolver.resolve('notifications.list@get');
            }

            return {};
        }

        function successCallback(response) {
            $rootScope.notifications = response[0].data;

            if ($rootScope.notifications.message){
                $rootScope.$broadcast('newMessage');
            }

            if ($rootScope.notifications.dashboard){
                $rootScope.$broadcast('newRequest');
            }
        }

        function errorCallback(response) {
            console.error(response);
        }

        function applyToTeach() {
            var signupFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSc2GrVzQnAMX4K_ckZKMyZbGNV7_FaGtssCLHdiv763qawaOw/viewform";
            window.open(signupFormUrl, '_blank');
        }

        function logIn() {
            $state.go('app.pages_auth_login');
        }

        function signUp() {
            $state.go('app.pages_auth_register');
        }

        function goToHomepage() {
            if ($rootScope.isAuthenticated) {
                switch ($rootScope.userRole) {
                    case 'admin':
                        $state.go('app.pages_admin-dashboard');
                        break;

                    case 'teacher':
                        $state.go('app.pages_teacher-dashboard');
                        break;

                    case 'student':
                        $state.go('app.pages_student-dashboard');
                        break;

                    default:
                        $state.go('app.pages_auth_login');
                        break;
                }
            }
            else {
                $state.go('app.pages_landing');
            }
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        function aboutUs() {
            $state.go('app.pages_about_us');
        }

        function meetOurTeachers() {
            $state.go('app.pages_meet_teachers');
        }

        function blog() {
            $state.go('app.pages_blog');
        }

        function beComeATeacher() {
            $state.go('app.pages_landing-teach');
        }

        function goToConversation() {
            $state.go('app.pages_conversation-partners');
        }

        function swicthRole(role) {
            api.auth.switchRole.post({token:$auth.getToken(),role:role},function(response) {
                $auth.setToken(response.token);
                var payload = $auth.getPayload();
                $rootScope.isAuthenticated = $auth.isAuthenticated();
                switch(payload.role) {
                    case 0:
                        $rootScope.userRole = 'admin';
                        $state.go('app.pages_admin-dashboard');
                        break;

                    case 1:
                        $rootScope.userRole = 'teacher';
                        $state.go('app.pages_teacher-dashboard');
                        break;

                    case 2:
                        $rootScope.userRole = 'student';
                        $state.go('app.pages_student-dashboard');
                        break;

                    default:
                        console.error("Invalid Role");
                        break;
                }

            });
        }

        function goToConversationNotLog() {
            $state.go('app.pages_teacher-list', {is_conversation_partner: 'cp' });
        }

        function privacyPolicy() {
            $state.go('app.pages_privacy-policy');
        }

        function goToSignUp() {
            $state.go('app.pages_auth_register');
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController($filter, $state, $rootScope, $auth)
    {
        var vm = this;
        var payload = $auth.getPayload();

        $rootScope.isAuthenticated = $auth.isAuthenticated();
        $rootScope.userRole = getUserRole();

        // Data
        vm.openAboutUs = false;
        vm.openTeachers = false;
        vm.openDashboard = false;
        vm.openBrowse = false;

        // Methods
        vm.applyToTeach = applyToTeach;
        vm.logIn = logIn;
        vm.logOut = logOut;
        vm.goToSignUp = goToSignUp;
        vm.goToTeacherList = goToTeacherList;
        vm.goToCCList = goToCCList;
        vm.goToAdminDashboard = goToAdminDashboard;
        vm.goToTeacherDashboard = goToTeacherDashboard;
        vm.goToStudentDashboard = goToStudentDashboard;
        vm.goToMessage = goToMessage;
        vm.goToTeacherHelp= goToTeacherHelp;
        vm.goToStudentHelp = goToStudentHelp;
        vm.aboutUs = aboutUs;
        vm.meetOurTeachers = meetOurTeachers;
        vm.blog = blog;
        vm.beComeATeacher = beComeATeacher;
        vm.goToConversation = goToConversation;

        // Functions

        function applyToTeach() {
            var signupFormUrl = "https://docs.google.com/forms/d/e/1FAIpQLSc2GrVzQnAMX4K_ckZKMyZbGNV7_FaGtssCLHdiv763qawaOw/viewform";
            window.open(signupFormUrl, '_blank');
        }

        function logIn() {
            $state.go('app.pages_auth_login');
        }

        function logOut()
        {
            alert($filter('translate')('TOOLBAR.LOGOUT_SUCCESS'));
            $auth.logout()
                .then(function(response) {
                    $rootScope.isAuthenticated = $auth.isAuthenticated();
                    $rootScope.userRole = '';
                    $state.reload('app.pages_auth_login');
                }, function(response){
                    console.log('Logout failed.', response);
                });
        }

        function goToSignUp() {
            $state.go('app.pages_auth_register');   
        }

        function goToTeacherList() {
            var state = 'app.pages_teacher-list';

            $state.go('app.pages_teacher-list', {is_conversation_partner: 'teacher' });
        }

        function goToCCList() {
            var state = 'app.pages_teacher-list';

            $state.go('app.pages_teacher-list', {is_conversation_partner: 'cp' });
        }

        function goToAdminDashboard() {
            var state = 'app.pages_admin-dashboard';

            goToState(state);
        }

        function goToTeacherDashboard() {
            var state = 'app.pages_teacher-dashboard';

            goToState(state);
        }

        function goToStudentDashboard() {
            var state = 'app.pages_student-dashboard';

            goToState(state);
        }

        function goToStudentHelp() {
            var state = 'app.pages_help-center';

            goToState(state);
        }

        function goToTeacherHelp() {
            var state = 'app.pages_help-center-teacher';

            goToState(state);
        }

        function goToMessage() {
            var state = 'app.pages_message';

            goToState(state);
        }

        function goToState(state) {
            if( $state.current.name === state) {
                $state.reload();
            } 
            else {
                $state.go(state);
            }
        }

        function aboutUs() {
            $state.go('app.pages_about_us');
        }

        function meetOurTeachers() {
            $state.go('app.pages_meet_teachers');
        }

        function blog() {
            $state.go('app.pages_blog');
        }

        function beComeATeacher() {
            $state.go('app.pages_apply-to-teach');
        }
        
        function goToConversation() {
            $state.go('app.pages_conversation-partners');
        }

        function getUserRole() {
            if (payload) {
                switch(payload.role) {
                    case 0:
                        return 'admin';

                    case 1:
                        return 'teacher';

                    case 2:
                        return 'student';

                    default:
                        console.error("Invalid Role");
                        return '';
                        break;
                }
            }
            else {
                return '';
            }
        }

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar-dialog', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/calendar-dialog');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.calendar-dialog')
        .controller('CalendarDialogController', CalendarDialogController);

    /** @ngInject */
    function CalendarDialogController($mdDialog, api, calendarEvent)
    {
        var vm = this;

        // Data
        vm.form = {};
        vm.today = moment().toDate();
        vm.actionType = calendarEvent.actionType;

        // Methods
        vm.closeDialog = closeDialog;
        vm.sumbit = sumbit;
        vm.cancel = cancel;
        vm.changeStartDate = changeStartDate;


        // Functions
        function closeDialog() {
            $mdDialog.cancel();
        }

        function sumbit() {
            var start = getDatetime(vm.form.startDate, vm.form.startTime);
            var end = getDatetime(vm.form.endDate, vm.form.endTime);
            calendarEvent.start = moment.utc(new moment(start)).format('YYYY-MM-DDTHH:mm:ssZ');
            calendarEvent.end = moment.utc(new moment(end)).format('YYYY-MM-DDTHH:mm:ssZ');
            $mdDialog.hide(calendarEvent);
        }

        function cancel() {
            calendarEvent.actionType = 'destroy';
            $mdDialog.hide(calendarEvent);
        }

        function changeStartDate() {
            vm.form.endDate = angular.copy(vm.form.startDate);
        }

        function getDatetime(date, time) {
            var year = date.getFullYear();
            var month = getMonth(date.getMonth());
            var day = date.getDate();
            var datetime = new Date(year + '/' + month + '/' + day + ' ' + time);

            return datetime;
        }

        function getMonth(month) {
            var monthMap = {
                0: '01',
                1: '02',
                2: '03',
                3: '04',
                4: '05',
                5: '06',
                6: '07',
                7: '08',
                8: '09',
                9: '10',
                10: '11',
                11: '12',
            };

            return monthMap[month];
        }

        function init() {
            vm.form.startDate = (typeof calendarEvent.start) == 'string' ? moment(calendarEvent.start).toDate() : calendarEvent.start.toDate();
            vm.form.startTime = (typeof calendarEvent.start) == 'string' ? moment(calendarEvent.start).format('HH:mm') : calendarEvent.start.format('HH:mm');
            vm.form.endDate = (typeof calendarEvent.end) == 'string' ? moment(calendarEvent.end).toDate() : calendarEvent.end.toDate();
            vm.form.endTime = (typeof calendarEvent.end) == 'string' ? moment(calendarEvent.end).format('HH:mm') : calendarEvent.end.format('HH:mm');
        }

        init();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock)
        .run(['Analytics', function(Analytics) {} ]);

    /** @ngInject */
    function runBlock($location, $rootScope, $timeout, $state, $auth)
    {
        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
            $rootScope.isPreviewMode = false;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', 
            function (event, toState, toParams, fromState,fromParams) {
                $timeout(function ()
                {
                    $rootScope.loadingProgress = false;
                });

                // Detect the page name which user come from
                $rootScope.previousPageName =
                    (fromState.name === 'app.pages_teacher-dashboard' || fromState.name === 'app.pages_student-dashboard') ?
                    'Dashboard':
                    'Search';

                // Detect the state name which user come from
                $rootScope.previousState =
                    (fromState.name === 'app.pages_teacher-dashboard' || fromState.name === 'app.pages_student-dashboard') ?
                    fromState.name:
                    'app.pages_teacher-list';

		// New add:detect previousState for register

                $rootScope.previousState_register = 
                    (fromState.name === 'app.pages_teacher') ? 
                    fromState.name:
                    'app.pages_student-dashboard';
                    console.log($rootScope.previousState_register);


		// New add:detect previousStatepar for register

                $rootScope.previousState_params = fromParams;


        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });

        var postLogInRoute = null;
        var next = null;

        // Check login status
        $rootScope.$on('$stateChangeStart', function (event, toState) {
            if (toState.requireLogin && ! $auth.isAuthenticated()) {
                console.log("@@@");
                postLogInRoute = $location.path();
                next = toState.useGuestMenu;
                event.preventDefault();
                $auth.logout();
                $rootScope.useGuestMenu = true;
                $state.go('app.pages_auth_login');
                console.log(postLogInRoute);
            } else if (postLogInRoute && $auth.isAuthenticated()) {
                console.log("!!!");
                $rootScope.useGuestMenu = next;
                console.log(postLogInRoute);
                $location.path(postLogInRoute).replace();
                postLogInRoute = null;
                next = null;
            } else {
                $rootScope.useGuestMenu = toState.useGuestMenu;
            }

        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        $locationProvider.html5Mode(true);

        $urlRouterProvider.otherwise('/login');

        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'contentWithToolbar';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .constant('constDefaultAvatar', '/assets/images/avatars/profile.jpg')
        .constant('constRoles', {
            ADMIN: 0,
        	TEACHER: 1,
        	STUDENT: 2,
        })
        .constant('constSchedule', {
            TYPE_AVAILABLE: 1,
            TYPE_CLASS: 2,
        })
        .constant('constNesukuEmail', 'mailto:andy.hsiao@nesuku.com')
        .constant('constDatetimeFormat', {
			'GENERAL_DATE': 'MMM d',
			'GENERAL_TIME': 'hh:mm a',
			'GENERAL_DATETIME': 'MMM d hh:mm a',
            'STANDARD_DATE': 'MM/DD/YYYY',
        })
        .constant('constPHPDateTimeFormat', {
            'GENERAL_TIME': 'g:i a'
        })
        .constant('constPackageTransaction', {
            FREE: 0,
            CREDIT_CARD_PURCHASE: 1,
            RETURN_HOURS: 2,
            SCHEDULE_LESSON: 3,
            WALLET_PURCHASE: 4,
        })
        //.constant('constTestStripeClientId', 'ca_9rnt2giGCY3jvOFm9GJgLupFKJdhBTua');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $mdThemingProvider, cfpLoadingBarProvider, AnalyticsProvider)
    {
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        //$translateProvider.useSanitizeValueStrategy('sanitize');

        $mdThemingProvider.theme('default').primaryPalette('orange').accentPalette('orange');

        // Angular Loading Bar
        cfpLoadingBarProvider.includeSpinner = false;

        // angular-google-analytics
        AnalyticsProvider.setAccount('UA-89600421-1');
        AnalyticsProvider.setPageEvent('$stateChangeSuccess');
    }

})();
(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, apiUrl) {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        // Local API end point
        api.baseUrl = '/api/';
        api.baseUrl = apiUrl;
        // api.baseUrl = 'http://localhost/api/';

        api.user = {
            list: $resource(api.baseUrl + 'users'),
        };

        api.teacher = {
            byToken: $resource(api.baseUrl + 'teachers/token', null, {
                put: {
                    method: 'PUT',
                },
            }),
            list: $resource(api.baseUrl + 'teachers'),
            byId: $resource(api.baseUrl + 'teachers/:id'),

        };

        api.student = {
            introMessage: $resource(api.baseUrl + 'students/intro-message', null, {
                put: {
                    method: 'PUT',
                }
            }),
            byToken: $resource(api.baseUrl + 'students/token', null, {
                put: {
                    method: 'PUT',
                }
            }),
            getAllLinked: $resource(api.baseUrl + 'students/linked-student'),
            remindStudent: $resource(api.baseUrl + 'students/remind-student', null, {
                get: {
                    method: 'GET',
                }
            }),
        };

        api.review = {
            list: $resource(api.baseUrl + 'course-reviews'),
            byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/course-reviews'),
        };

        api.schedule = {
            list: $resource(api.baseUrl + 'schedule'),
            byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/schedule'),
        };

        api.lessonRequest = {
            list: $resource(api.baseUrl + 'lesson-requests'),
            byId: $resource(api.baseUrl + 'lesson-requests/:id'),
            byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/lesson-requests'),
            price: $resource(api.baseUrl + 'lesson-requests/:id/price', {
                id: '@id',
            }, {
                post: {
                    method: 'POST',
                },
            }),
            free: $resource(api.baseUrl + 'lesson-requests/:id/free', {
                id: '@id',
            }, {
                post: {
                    method: 'POST',
                },
            }),
            save: $resource(api.baseUrl + 'lesson-requests', null, {
                post: {
                    method: "POST"
                },
            }),
            teacherRequest: $resource(api.baseUrl + 'teacher-lesson-requests', null, {
                post: {
                    method: "POST"
                },
            }),

        };

        api.courseRequest = {
            save: $resource(api.baseUrl + 'course-requests', null, {
                post: {
                    method: "POST"
                },
            }),
            _save: $resource(api.baseUrl + '_course-requests', null, {
                post: {
                    method: "POST"
                },
            }),
            byTeacher: $resource(api.baseUrl + 'teacher-course-requests', null, {
                post: {
                    method: "POST"
                },
            }),
            byId: $resource(api.baseUrl + 'course-requests/:id', {
                id: '@id',
            }, {
                get: {
                    method: "GET"
                },
            }),
            confirm: $resource(api.baseUrl + 'course-requests-confirm/:id', {
                id: '@id',
            }, {
                put: {
                    method: "put"
                },
            }),
            cancel: $resource(api.baseUrl + 'course-requests-cancel/:id', {
                id: '@id',
            }, {
                put: {
                    method: "put"
                },
            }),
            _cancel: $resource(api.baseUrl + '_course-requests-cancel/:id', {
                id: '@id',
            }, {
                put: {
                    method: "put"
                },
            }),
        };

        api.courseTimes = {
            cancel: $resource(api.baseUrl + 'course-time-cancel/:id', {
                id: '@id',
            }, {
                put: {
                    method: "put"
                },
            }),
            _cancel: $resource(api.baseUrl + '_course-time-cancel/:id', {
                id: '@id',
            }, {
                put: {
                    method: "put"
                },
            }),
            edit: $resource(api.baseUrl + 'course-time-edit/:id', {
                id: '@id',
            }, {
                put: {
                    method: "put"
                },
            }),
        };

        api.statusCourseRequest = {
            list: $resource(api.baseUrl + 'status-course-requests?number=:number&status=:status', {
                number: '@number',
                status: '@status',
            }, {
                get: {
                    method: 'GET',
                },
            }),
        };

        api.statusCourseTimes = {
            list: $resource(api.baseUrl + 'status-course-times?endDate=:endDate&startDate=:startDate&status=:status', {
                startDate: '@startDate',
                endDate: '@endDate',
                status: '@status',
            }, {
                get: {
                    method: 'GET',
                },
            }),
        };

        api.adminCourseTimes = {
            list: $resource(api.baseUrl + 'admin-course-times')
        };

        api.publicCourseTimes = {
            byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/public-course-times?endDate=:endDate&startDate=:startDate&status=:status', {
                startDate: '@startDate',
                endDate: '@endDate',
                status: '@status',
            })
        };

        api.course = {
            list: $resource(api.baseUrl + 'courses'),
            byId: $resource(api.baseUrl + 'courses/:id'),
        };

        api.option = {
            language: $resource(api.baseUrl + 'options/language'),
            level: $resource(api.baseUrl + 'options/level'),
            timezone: $resource(api.baseUrl + 'options/timezone'),
        };

        // api.availableHours = {
        //     list: $resource(api.baseUrl + 'available-hours', null, {
        //         get: {
        //             method: 'GET',
        //         },
        //         post: {
        //             method: 'POST',
        //         },
        //     }),
        //     byId: $resource(api.baseUrl + 'available-hours/:id', {
        //         id: '@id',
        //     }, {
        //         put: {
        //             method: 'PUT',
        //         },
        //         delete: {
        //             method: 'DELETE',
        //         },
        //     }),
        //     byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/available-hours'),
        // };

        api.regularHours = {
            list: $resource(api.baseUrl + 'regular-hours?endDate=:endDate&startDate=:startDate', {
                startDate: '@startDate',
                endDate: '@endDate',
            }, {
                get: {
                    method: 'GET',
                },
                post: {
                    method: 'POST',
                },
            }),
            byId: $resource(api.baseUrl + 'regular-hours/:id', {
                id: '@id',
            }, {
                put: {
                    method: 'PUT',
                },
                delete: {
                    method: 'DELETE',
                },
            }),
            byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/regular-hours'),
        };

        api.specificHours = {
            list: $resource(api.baseUrl + 'available-hours?endDate=:endDate&startDate=:startDate', {
                startDate: '@startDate',
                endDate: '@endDate',
            }, {
                get: {
                    method: 'GET',
                },
                post: {
                    method: 'POST',
                },
            }),
            byId: $resource(api.baseUrl + 'available-hours/:id', {
                id: '@id',
            }, {
                put: {
                    method: 'PUT',
                },
                delete: {
                    method: 'DELETE',
                },
            }),
            byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/available-hours'),
        };

        api.messages = {
            list: $resource(api.baseUrl + 'messages', null, {
                post: {
                    method: 'POST',
                },
            }),
        };

        api.confirmLessonRequest = {
            list: $resource(api.baseUrl + 'confirm-lesson-request', null, {
                post: {
                    method: 'POST',
                },
            }),
        };

        api.confirmFreeLesson = {
            list: $resource(api.baseUrl + 'confirm-free-lesson-request', null, {
                post: {
                    method: 'POST',
                },
            }),
        };

        api.connectStripe = {
            list: $resource(api.baseUrl + 'connect-stripe', null, {
                post: {
                    method: 'POST',
                },
            }),
        };

        // api.stripeAlipay = {
        //     list: $resource(api.baseUrl + 'stripe-alipay/pay', {
        //       // TODO
        //     }, {
        //         post: {
        //             method: 'POST',
        //         },
        //     }),
        // };


        api.remittance = {
            byCourseId: $resource(api.baseUrl + 'remittance/:courseId', {
                courseId: '@courseId',
            }, {
                post: {
                    method: 'POST',
                },
            }),
        };

        api.unpaidCourse = {
            list: $resource(api.baseUrl + 'unpaid-course-times'),
        };

        api.paymentMakeUp = {
            teacher: $resource(api.baseUrl + 'payment-make-up/teacher', null, {
                post: {
                    method: "POST"
                },
            }),
            student: $resource(api.baseUrl + 'payment-make-up/student', null, {
                get: {
                    method: "GET"
                },
                post: {
                    method: "POST"
                },
            }),
        };

        api.notifications = {
            list: $resource(api.baseUrl + 'notifications', null, {
                get: {
                    method: 'GET',
                },
                post: {
                    method: 'POST',
                },
            }),
        };

        api.auth = {
            forgotPassword: $resource(api.baseUrl + 'auth/forgot-password'),
            resetPassword: $resource(api.baseUrl + 'auth/reset-password'),
            changePassword: $resource(api.baseUrl + 'auth/change-password', {}, {
                'update': {method: 'PUT'}
            }),
            switchRole: $resource(api.baseUrl + 'auth/switch-role', null, {
                post: {
                    method: 'POST',
                },
            }),
        };

        api.pendingEvents = {
            list: $resource(api.baseUrl + 'pending-events'),
            byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/pending-events'),
        };

        api.admin = {
            teacherList: $resource(api.baseUrl + 'admin/teacher-list'),
            studentList: $resource(api.baseUrl + 'admin/student-list'),
            revenue: $resource(api.baseUrl + 'admin/revenue'),
        };

        api.timezone = {
            setTimezone: $resource(api.baseUrl + 'timezone', null, {
                post: {
                    method: 'POST',
                }
            }),
        };

        api.priceCategories = {
            list: $resource(api.baseUrl + 'price-categories', null, {
                get: {
                    method: 'GET',
                },
                post: {
                    method: 'POST',
                },
            }),
            byId: $resource(api.baseUrl + 'price-categories/:id', {
                id: '@id',
            }, {
                put: {
                    method: 'PUT',
                },
            }),
            byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/price-categories'),
        };

        api.customPrices = {
            list: $resource(api.baseUrl + 'custom-prices', null, {
                get: {
                    method: 'GET',
                },
                post: {
                    method: 'POST',
                },
                put: {
                    method: 'PUT',
                },
            }),
            byTeacher: $resource(api.baseUrl + 'teachers/:teacherId/custom-prices'),
        };

        api.app = {
            create: $resource(api.baseUrl + 'apps/create', null, {
                post: {
                    method: 'POST',
                },
            }),
            byId: $resource(api.baseUrl + 'apps/:id'),
            update: $resource(api.baseUrl + 'apps/update/:id', {
                id: '@id',
            }, {
                put: {
                    method: 'PUT',
                }
            }),
        };

        api.packages = {
            list: $resource(api.baseUrl + 'packages', null, {
                get: {
                    method: 'GET',
                }
            }),
            remain: $resource(api.baseUrl + 'packages/remaining', null, {
                get: {
                    method: 'GET',
                },
            }),
            teacher_remain: $resource(api.baseUrl + 'packages/teacher-remaining', null, {
                get: {
                    method: 'GET',
                },
            }),
            purchase: $resource(api.baseUrl + 'packages/purchase', null, {
                post: {
                    method: 'POST',
                },
            }),
            create: $resource(api.baseUrl + 'packages/create', null, {
                post: {
                    method: 'POST',
                },
            }),
            destroy: $resource(api.baseUrl + 'packages/:id', null, {
                delete: {
                    method: 'DELETE',
                },
            }),
            check: $resource(api.baseUrl + 'packages/:id/packageInfo', null, {
                get: {
                    method: 'GET',
                },
            }),
        };

        //wallet implementation
        api.wallet = {
            list: $resource(api.baseUrl + 'wallet/:userId', {
                id: '@userId'
            }, {
                get: {
                    method: 'GET'
                },
                post: {
                    method: 'POST'
                },
                put: {
                    method: 'PUT'
                }
            }),
            getBalance: $resource(api.baseUrl + 'wallet/balance', null, {
                get: {
                    method: 'GET'
                }
            }),
            deposit: $resource(api.baseUrl + 'wallet/deposit', null, {
                post: {
                    method: 'POST'
                }
            }),
            // depositThroughStripe: $resource(api.baseUrl + 'wallet/:userId/deposit', {
            //     userId: '@userId'
            // }, {
            //     post:{
            //         method: 'POST',
            //     }
            // })
        }

        api.essayRequest = {
            save: $resource(api.baseUrl + 'essay-requests', null, {
                post: {
                    method: "POST"
                },
            }),
            byId: $resource(api.baseUrl + 'essay-requests/:id', {
                id: '@id',
            }, {
                get: {
                    method: "GET"
                },
            }),
            review: $resource(api.baseUrl + 'essay-requests-review/:id', {
                id: '@id',
            }, {
                put: {
                    method: "put"
                },
            })
        };

        api.statusEssayRequest = {
            list: $resource(api.baseUrl + 'status-essay-requests?number=:number&status=:status', {
                number: '@number',
                status: '@status',
            }, {
                get: {
                    method: 'GET',
                },
            })
        };

        api.subject = {
            list: $resource(api.baseUrl + 'subjects?isCovid=:isCovid', {
                isCovid: '@isCovid',
            }, {
                get: {
                    method: 'GET',
                },
            })
        };

        api.hwRequest = {
            save: $resource(api.baseUrl + 'hw-requests', null, {
                post: {
                    method: "POST"
                },
            }),
            accept: $resource(api.baseUrl + 'hw-requests/:id', {
                id: '@id',
            }, {
                put: {
                    method: "PUT"
                },
            }),
            list: $resource(api.baseUrl + 'hw-requests')
        };

        api.register = {
            teacher: $resource(api.baseUrl + 'auth/register/teacher', null, {
                post: {
                    method: "POST"
                },
            })
        };


        // Use local json files
        // Using local json files by uncommenting lines below
        // api.localBaseUrl = '/app/data/';

        // api.teacher = {
        //     byToken: $resource(api.localBaseUrl + 'teacher/teacher.json'),
        //     byId: $resource(api.localBaseUrl + 'teacher/teacher.json'),
        //     list: $resource(api.localBaseUrl + 'teachers.json'),
        // };

        // api.review = {
        //     list: $resource(api.localBaseUrl + 'teacher/reviews.json'),
        //     byTeacher: $resource(api.localBaseUrl + 'teacher/reviews.json'),
        // };

        // api.schedule = {
        //     list: $resource(api.localBaseUrl + 'teacher/schedule.json'),
        //     byTeacher: $resource(api.localBaseUrl + 'teacher/schedule.json'),
        // };

        // api.lessonRequest = {
        //     list: $resource(api.localBaseUrl + 'lesson-requests.json'),
        //     byTeacher: $resource(api.localBaseUrl + 'lesson-requests.json'),
        // };

        // api.course = {
        //     list: $resource(api.localBaseUrl + 'upcoming-classes.json'),
        // };

        // api.upcomingClass = {
        //     list: $resource(api.localBaseUrl + 'upcoming-classes.json'),
        // };

        // api.previousClass = {
        //     list: $resource(api.localBaseUrl + 'previous-classes.json'),
        // };

        // api.option = {
        //     language: $resource(api.localBaseUrl + 'languages.json'),
        //     level: $resource(api.localBaseUrl + 'levels.json'),
        //     timezone: $resource(api.localBaseUrl + 'timezones.json'),
        // };

        // api.auth = {
        //     forgotPassword: $resource('http://localhost:8088/api/auth/forgot-password'),
        //     resetPassword: $resource('http://localhost:8088/api/auth/reset-password'),
        // };

        return api;
    }

})();

angular.module("app.config", [])
.constant("apiUrl", "https://www.nesuku.com/api/")
.constant("stripe", {"clientId":"ca_9u9cuaqMEmlem8z3hPJ3n0IrdgfxWd89","productionKey":"pk_live_d1qxExs8EHUAQo7uLKZzG6mG"});

(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.config',
            'app.pages.auth.login',
            'app.pages.auth.register',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.error-404',
            'app.pages.error-500',
            'app.pages.teacher-list',
            'app.pages.landing',
            'app.pages.teacher-dashboard',
            'app.pages.teacher',
            'app.pages.edit-teacher',
            'app.pages.student-dashboard',
            'app.pages.message',
            'app.pages.admin-dashboard',
            'app.pages.app-dashboard',
            'app.pages.help-center',
            'app.pages.help-center-teacher',
            'app.pages.free',
            'app.pages.apply-to-teach',
            'app.pages.about-us',
            'app.pages.privacy-policy',
            'app.pages.meet-teachers',
            'app.pages.blog',
            'app.pages.conversation-partners',
            'app.pages.teach-form',
            'app.pages.become-cp-form',
            'app.pages.find-cp-form',
            'app.pages.find-teacher-form',
            'app.pages.payment-make-up',
            'app.pages.essay-review',
            'app.pages.review-essay',
            'app.pages.view-essay',
            'app.pages.account-settings',
            'app.pages.find-a-tutor',
            'app.pages.hw-help',
            'app.pages.hw-list',
            'app.pages.covid',
            'app.pages.landing-teach',
            'app.pages.tzuchi'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('pages', {
            title : 'PAGES',
            group : true,
            weight: 2
        });
    }
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/calendar-dialog/calendar-dialog.html","<md-dialog class=\"dialog-available-hours\" aria-label=\"Available Hours\"><form name=\"eventForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CALENDAR_DIALOG.TITLE\" \nng-if=\"vm.actionType==\'create\'\"></span> <span class=\"title\" translate=\"CALENDAR_DIALOG.UPDATE_TITLE\" \nng-if=\"vm.actionType==\'update\'\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"row\" class=\"date-row\"><md-datepicker ng-model=\"vm.form.startDate\" \nmd-placeholder=\"Start Date\" md-min-date=\"vm.today\" ng-change=\"vm.changeStartDate()\"></md-datepicker><md-input-container\n class=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.form.startTime\" placeholder=\"Start Time\" \ntranslate-attr-placeholder=\"CALENDAR_DIALOG.START_TIME\"></md-input-container></div><div layout=\"row\" class=\"date-row\">\n<md-datepicker ng-model=\"vm.form.endDate\" md-placeholder=\"End Date\" md-min-date=\"vm.form.startDate\"></md-datepicker>\n<md-input-container class=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.form.endTime\" placeholder=\"End Time\" \ntranslate-attr-placeholder=\"CALENDAR_DIALOG.END_TIME\"></md-input-container></div></md-dialog-content><md-dialog-actions\n layout=\"row\" layout-align=\"end center\"><md-button aria-label=\"Delete\" translate=\"CALENDAR_DIALOG.DELETE\" \ntranslate-attr-aria-label=\"CALENDAR_DIALOG.DELETE\" ng-click=\"vm.cancel()\"></md-button><md-button \nclass=\"md-raised md-primary btn-submit\" aria-label=\"Save Event\" translate=\"CALENDAR_DIALOG.SUBMIT\" \ntranslate-attr-aria-label=\"CALENDAR_DIALOG.SUBMIT\" ng-click=\"vm.sumbit()\">SUBMIT</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><div ng-if=\"$root.useGuestMenu || !$root.isAuthenticated\" layout=\"column\" layout-align=\"start end\">\n<md-list><md-divider></md-divider><md-list-item class=\"color-dg\"><div class=\"sidenav-links inner\" \nng-click=\"vm.goToTeacherList()\" layout=\"row\" layout-align=\"space-between center\"><span>FIND A TUTOR</span></div>\n</md-list-item><md-divider></md-divider><md-list-item class=\"color-dg\"><div class=\"sidenav-links inner\" \nng-click=\"vm.applyToTeach()\" layout=\"row\" layout-align=\"space-between center\"><span>TEACH</span></div></md-list-item>\n<md-divider></md-divider><md-list-item><div class=\"sidenav-links\" ng-click=\"vm.logIn()\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"LANDING.LOGIN\"></span></div></md-list-item><md-divider>\n</md-divider><md-list-item><div class=\"sidenav-links\" ng-click=\"vm.goToSignUp()\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"LANDING.SIGN_UP\"></span></div></md-list-item><md-divider>\n</md-divider></md-list></div><div aria-label=\"navigation links\" layout=\"column\" layout-align=\"start end\" \nng-if=\"!$root.useGuestMenu && $root.isAuthenticated\"><md-list><md-list-item ng-if=\"$root.userRole === \'admin\'\"><div \nclass=\"sidenav-links\" ng-click=\"vm.goToAdminDashboard()\" layout=\"row\" layout-align=\"space-between center\"><span>\nADMIN DASHBOARD</span></div></md-list-item><md-divider></md-divider><md-list-item><div class=\"sidenav-links\" \nng-click=\"vm.openDashboard = !vm.openDashboard\" layout=\"row\" layout-align=\"space-between center\"><span>DASHBOARD</span>\n <i class=\"icon-chevron-right\" ng-class=\"{rotate: vm.openDashboard}\"></i></div></md-list-item><md-divider></md-divider>\n<md-list-item ng-if=\"vm.openDashboard\" class=\"color-dg\" ng-if=\"vm.openDashboard\"><div class=\"sidenav-links inner\" \nng-click=\"vm.goToStudentDashboard()\" layout=\"row\" layout-align=\"space-between center\"><span>STUDENT</span></div>\n</md-list-item><md-divider ng-if=\"vm.openDashboard\"></md-divider><md-list-item class=\"color-dg\" \nng-if=\"vm.openDashboard && ($root.canSwitch == true) && ($root.isConversationPartner == false)\"><div \nclass=\"sidenav-links inner\" ng-click=\"vm.goToTeacherDashboard()\" layout=\"row\" layout-align=\"space-between center\">\n<span>TEACHER</span></div></md-list-item><md-divider ng-if=\"vm.openDashboard\"></md-divider><md-list-item \nclass=\"color-dg\" ng-if=\"vm.openDashboard && ($root.canSwitch == true) && ($root.isConversationPartner == true)\"><div \nclass=\"sidenav-links inner\" ng-click=\"vm.goToTeacherDashboard()\" layout=\"row\" layout-align=\"space-between center\">\n<span>CONVERSATION COACH</span></div></md-list-item><md-divider ng-if=\"vm.openDashboard\"></md-divider><md-list-item>\n<div class=\"sidenav-links\" ng-click=\"vm.openBrowse = !vm.openBrowse\" layout=\"row\" layout-align=\"space-between center\">\n<span>BROWSE</span> <i class=\"icon-chevron-right\" ng-class=\"{rotate: vm.openBrowse}\"></i></div></md-list-item>\n<md-divider ng-if=\"vm.openBrowse\"></md-divider><md-list-item class=\"color-dg\" ng-if=\"vm.openBrowse\"><div \nclass=\"sidenav-links inner\" ng-click=\"vm.goToTeacherList()\" layout=\"row\" layout-align=\"space-between center\"><span>\nTEACHERS</span></div></md-list-item><md-divider ng-if=\"vm.openBrowse\"></md-divider><md-list-item class=\"color-dg\" \nng-if=\"vm.openBrowse\"><div class=\"sidenav-links inner\" ng-click=\"vm.goToCCList()\" layout=\"row\" \nlayout-align=\"space-between center\"><span>CONVERSATION COACHES</span></div></md-list-item><md-divider></md-divider>\n<md-list-item><div class=\"sidenav-links\" ng-click=\"vm.goToMessage()\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"button-text\">MESSAGES</span></div></md-list-item><md-divider></md-divider><md-list-item \nng-if=\"$root.userRole === \'teacher\'\"><div class=\"sidenav-links\" ng-click=\"vm.goToTeacherHelp()\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"button-text\">HELP</span></div></md-list-item><md-divider></md-divider>\n<md-list-item ng-if=\"$root.userRole === \'student\'\"><div class=\"sidenav-links\" ng-click=\"vm.goToStudentHelp()\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"button-text\">HELP</span></div></md-list-item><md-divider>\n</md-divider><md-list-item><div class=\"sidenav-links\" ui-sref=\"app.pages_auth_login\" ng-click=\"vm.logOut()\" \nlayout=\"row\" layout-align=\"space-between center\"><span>LOG OUT</span></div></md-list-item><md-divider></md-divider>\n</md-list></div></md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/dev-mode/dev-mode.html","<h4>Authentication</h4><ul><li><a ui-sref=\"app.pages_auth_login\">Log In</a></li><li><a \nui-sref=\"app.pages_auth_register\">Sign Up</a></li><li><a ui-sref=\"app.pages_auth_forgot-password\">Forgot Password</a>\n</li><li><a ui-sref=\"app.pages_auth_reset-password\">Reset Password</a></li></ul><h4>Teacher</h4><ul><li><a \nui-sref=\"app.pages_teacher-list\">Teacher List</a></li><li><a ui-sref=\"app.pages_teacher({ id: 1 })\">Teacher Intro Page\n</a></li><li><a ui-sref=\"app.pages_teacher-dashboard\">Teacher Dashboard</a></li></ul><h4>Other</h4><ul><li><a \nui-sref=\"app.pages_landing\">Landing Page</a></li><li><a ui-sref=\"app.pages_message\">Message</a></li></ul>");
$templateCache.put("app/main/states/loading-balance.html","<div class=\"widget__content\" ng-repeat=\"_ in [] | range: 2\" layout=\"row\" layout-align=\"space-between center\"><span \nflex=\"100\"><div class=\"loading__content shining-effect\"></div></span></div>");
$templateCache.put("app/main/states/loading-introductory.html","<div class=\"widget__content\" ng-repeat=\"_ in [] | range: 1\" layout=\"column\" layout-align=\"center start\"><section \nng-repeat=\"_ in [] | range: 7\"><div class=\"loading__content shining-effect\"></div></section></div>");
$templateCache.put("app/main/states/loading-lesson-requests.html","<div class=\"widget__content\" ng-repeat=\"_ in [] | range: 3\" layout=\"column\" layout-align=\"center start\"><section><div \nclass=\"loading__avatar\"></div><div class=\"loading__name shining-effect\"></div></section><section><div \nclass=\"loading__content shining-effect\"></div></section><section><div class=\"loading__content shining-effect\"></div>\n</section></div>");
$templateCache.put("app/main/states/loading-lessons.html","<div class=\"widget__content\" ng-repeat=\"_ in [] | range: 3\" layout=\"row\" layout-align=\"space-between center\"><span \nflex=\"30\"><div class=\"loading__avatar\"></div><div class=\"loading__name shining-effect\"></div></span><span flex=\"30\">\n<div class=\"loading__content shining-effect\"></div></span><span flex=\"30\"><div class=\"loading__content shining-effect\">\n</div></span></div>");
$templateCache.put("app/main/states/loading-teacher-list.html","<div class=\"ms-card teacher\" layout=\"row\" ng-repeat=\"_ in [] | range: 7\"><div flex=\"15\"><div \nclass=\"loading__avatar--l\"></div></div><div flex=\"85\"><div class=\"loading__name--l shining-effect\"></div><div \nclass=\"loading__content shining-effect mb-15\"></div><div class=\"loading__content shining-effect mb-15\"></div></div>\n</div>");
$templateCache.put("app/main/stripe-connect/stripe-connect.html","");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/common/templates/auth-nav/auth-nav.html","<div id=\"common-auth-nav\" ng-controller=\"AuthNavController as vm\"><md-toolbar class=\"landing-toolbar\"><div \nclass=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><a href=\"\" ng-click=\"vm.goToHomepage()\"><img class=\"toolbar-logo toolbar-logo--black\" \nsrc=\"assets/images/logos/logo.jpg\" alt=\"Nesuku logo\"> <img class=\"toolbar-logo toolbar-logo--white\" \nsrc=\"assets/images/landing-page/img-logo-navibar@3x.jpg\" alt=\"Nesuku logo\"> <img \nclass=\"toolbar-logo toolbar-logo--color\" src=\"assets/images/logos/logo-horizontal.png\" alt=\"Nesuku logo\"></a></div><div\n layout=\"row\" layout-align=\"start center\"><span class=\"toolbar-button-container\"><md-button \nclass=\"toolbar-text-button\" ng-click=\"vm.goToTeacherList()\">FIND A TUTOR</md-button><md-button \nclass=\"toolbar-text-button\" ng-click=\"vm.applyToTeach()\">TEACH</md-button><md-button class=\"toolbar-text-button\" \nng-click=\"vm.logIn()\" translate=\"LANDING.LOGIN\">LOG IN</md-button><md-button id=\"btn-signup\" \nclass=\"md-raised md-primary\" ng-click=\"vm.goToSignUp()\" translate=\"LANDING.SIGN_UP\">SIGN UP</md-button></span>\n<md-button class=\"md-icon-button nav-button\" ng-click=\"vm.openRightMenu()\" aria-label=\"Settings\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"sidenav-button\"></md-icon></md-button></div></div></md-toolbar><md-sidenav \nclass=\"md-sidenav-right\" md-component-id=\"right\"><md-list><md-list-item class=\"color-dg\"><div \nclass=\"sidenav-links inner\" ng-click=\"vm.goToTeacherList()\" layout=\"row\" layout-align=\"space-between center\"><span>\nFIND A TUTOR</span></div></md-list-item><md-list-item class=\"color-dg\"><div class=\"sidenav-links inner\" \nng-click=\"vm.applyToTeach()\" layout=\"row\" layout-align=\"space-between center\"><span>TEACH</span></div></md-list-item>\n<md-divider></md-divider><md-list-item><div class=\"sidenav-links\" ng-click=\"vm.logIn()\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"LANDING.LOGIN\"></span></div></md-list-item><md-divider>\n</md-divider><md-list-item><div class=\"sidenav-links\" ng-click=\"vm.goToSignUp()\" layout=\"row\" \nlayout-align=\"space-between center\"><span translate=\"LANDING.SIGN_UP\"></span></div></md-list-item><md-divider>\n</md-divider></md-list></md-sidenav></div>");
$templateCache.put("app/common/templates/covid-header/covid-header.html","<div ng-show=\"!vm.headerExited\" id=\"covid-header\" ng-controller=\"CovidHeaderController as vm\"><md-toolbar \nclass=\"covid-toolbar\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span><a \nhref=\"https://www.nesuku.com/covid\">\nOur COVID Response: Offering free homework help to students and donating service fees to tutors. Learn More</a>.</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeHeader()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar></div>");
$templateCache.put("app/common/templates/footer/footer.html","<div id=\"common-footer\" layout=\"row\" layout-align=\"space-around center\" ng-controller=\"FooterController as vm\" \nlayout-wrap><div class=\"footer-middle\" layout=\"column\" layout-align=\"center center\"><img \nsrc=\"assets/images/logos/img-logo-footer@3x.png\"> <span>Copyright © 2020</span></div><div class=\"footer-right\" \nlayout=\"column\" layout-align=\"center start\"><span ng-click=\"vm.goToMobile()\">Mobile Site</span> <span \nng-click=\"vm.applyToTeach()\" translate=\"FOOTER.APPLY_TO_TEACH\">Apply to be a teacher</span> <span \nng-click=\"vm.findATeacher()\" translate=\"FOOTER.FIND_A_TEACHER\">Find a teacher</span> <span \nng-click=\"vm.privacyPolicy()\" translate=\"FOOTER.PRIVACY_POLICY\">Privacy Policy</span> <span \nng-click=\"vm.contactNesuku()\" translate=\"FOOTER.CONTACT_US\">Contact us</span></div></div><div class=\"social-media\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"fb-like\" \ndata-href=\"https://www.facebook.com/nesukumarketplace\" data-layout=\"button_count\" data-action=\"like\" data-size=\"large\" \ndata-show-faces=\"true\" data-share=\"true\" data-colorscheme=\"light\"></div><div class=\"linkedin\"><script \nsrc=\"//platform.linkedin.com/in.js\" type=\"text/javascript\">lang: en_US</script><script type=\"IN/FollowCompany\" \ndata-id=\"22342326\" data-counter=\"right\"></script></div></div><div id=\"fb-root\"></div><script>\n(function(d, s, id) {\n  var js, fjs = d.getElementsByTagName(s)[0];\n  if (d.getElementById(id)) return;\n  js = d.createElement(s); js.id = id;\n  js.src = \"//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.10\";\n  fjs.parentNode.insertBefore(js, fjs);\n}(document, \'script\', \'facebook-jssdk\'));\n</script>");
$templateCache.put("app/main/dialogs/calendar-dialog/calendar-dialog.html","<md-dialog class=\"dialog-available-hours\" aria-label=\"Available Hours\"><form name=\"eventForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"CALENDAR_DIALOG.TITLE\" \nng-if=\"vm.actionType==\'create\'\"></span> <span class=\"title\" translate=\"CALENDAR_DIALOG.UPDATE_TITLE\" \nng-if=\"vm.actionType==\'update\'||vm.actionType==\'drop\'\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" class=\"date-row\"><md-datepicker \nng-model=\"vm.form.startDate\" md-placeholder=\"Start Date\" md-min-date=\"vm.today\" ng-change=\"vm.changeStartDate()\">\n</md-datepicker><md-input-container class=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.form.startTime\" \nplaceholder=\"Start Time\" translate-attr-placeholder=\"CALENDAR_DIALOG.START_TIME\"></md-input-container></div><div \nlayout=\"row\" class=\"date-row\"><md-datepicker ng-model=\"vm.form.endDate\" md-placeholder=\"End Date\" \nmd-min-date=\"vm.form.startDate\"></md-datepicker><md-input-container class=\"no-errors-spacer\" flex md-no-float><input \nng-model=\"vm.form.endTime\" placeholder=\"End Time\" translate-attr-placeholder=\"CALENDAR_DIALOG.END_TIME\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nng_if=\"vm.isdelete\" aria-label=\"Delete\" translate=\"CALENDAR_DIALOG.DELETE\" \ntranslate-attr-aria-label=\"CALENDAR_DIALOG.DELETE\" ng-click=\"vm.delete()\"></md-button><md-button ng_if=\"!vm.isdelete\" \naria-label=\"Delete\" translate=\"CALENDAR_DIALOG.CANCEL\" translate-attr-aria-label=\"CALENDAR_DIALOG.CANCEL\" \nng-click=\"vm.cancel()\"></md-button><md-button class=\"md-raised md-primary btn-submit\" aria-label=\"Save Event\" \ntranslate=\"CALENDAR_DIALOG.SUBMIT\" translate-attr-aria-label=\"CALENDAR_DIALOG.SUBMIT\" ng-click=\"vm.sumbit()\">SUBMIT\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/dialogs/change-password/change-password.html","<md-dialog class=\"dialog-change-password\" aria-label=\"Change Password\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"CHANGE_PASSWORD.CHANGE_PW\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><form name=\"changePasswordForm\" ng-if=\"!vm.isSentResetLink\" novalidate><md-input-container\n class=\"md-block\"><label class=\"input__label\" translate=\"CHANGE_PASSWORD.NEW_PASSWORD\">New Password</label><input \ntype=\"password\" name=\"newPassword\" ng-model=\"vm.password.new\" ng-minlength=\"6\" required><div \nng-messages=\"changePasswordForm.newPassword.$error\" \nng-if=\"changePasswordForm.$submitted || changePasswordForm.newPassword.$dirty\" \nng-messages-multiple=\"ng-messages-multiple\" class=\"error-messages slide-right\"><div ng-message=\"required\" \nclass=\"message slide-left\" translate=\"CHANGE_PASSWORD.ERRORS.REQUIRED\"></div><div ng-message=\"minlength\" \nclass=\"message slide-left\" translate=\"CHANGE_PASSWORD.ERRORS.MINLENGTH\"></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"input__label\" translate=\"CHANGE_PASSWORD.RE-TYPE_NEW_PASSWORD\">\nConfirm New Password</label><input type=\"password\" name=\"confirmPassword\" ng-model=\"vm.password.confirm\" \nmatch-password=\"newPassword\" ng-minlength=\"6\" required><div ng-messages=\"changePasswordForm.confirmPassword.$error\" \nng-if=\"changePasswordForm.$submitted || changePasswordForm.confirmPassword.$dirty\" \nng-messages-multiple=\"ng-messages-multiple\" class=\"error-messages slide-right\"><div ng-message=\"required\" \nclass=\"message slide-left\" translate=\"CHANGE_PASSWORD.ERRORS.RE\"></div><div ng-message=\"passwordMatch\" \nclass=\"message slide-left\" translate=\"CHANGE_PASSWORD.ERRORS.PASSWORD_MATCH\"></div><div ng-message=\"minlength\" \nclass=\"message slide-left\" translate=\"CHANGE_PASSWORD.ERRORS.MINLENGTH\"></div></div><span class=\"form-error-message\" \nng-show=\"vm.isError\">{{ vm.errorMessage }}</span></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-primary btn-submit\" aria-label=\"CHANGE_PASSWORD.SAVE\" \nng-disabled=\"changePasswordForm.$invalid || changePasswordForm.$pristine\" translate=\"CHANGE_PASSWORD.SAVE\" \ntranslate-attr-aria-label=\"CHANGE_PASSWORD.SAVE\" ng-click=\"vm.submit()\"></md-button></form></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/dialogs/covid-popup/covid-popup.html","<md-dialog class=\"covid-popup\" class=\"event-detail-dialog\" aria-label=\"Message Student\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"video-container\" flex=\"100\"><div class=\"intrinsic-container intrinsic-container-16x9\"><iframe \nng-src=\"https://www.youtube.com/embed/PBnEAKGh6uc/?controls=1&amp;enablejsapi=1&amp;modestbranding=1&amp;showinfo=0&amp;origin=https%3A%2F%2Fwww.nesuku.com&amp;iv_load_policy=3&amp;html5=1&amp;fs=1&amp;rel=0&amp;hl=en&amp;cc_lang_pref=en&amp;cc_load_policy=1&amp;start=0\" \nframeborder=\"0\" allowfullscreen></iframe></div></div><section class=\"section\"><span class=\"section__title\">\nSchools are closed. Small businesses are struggling. We want to help you keep things going.</span></section><section \nclass=\"pt-10 pb-10\" layout-gt-sm=\"row\" layout=\"column\" layout-align-gt-sm=\"center start\"><div flex-gt-sm=\"30\" \nflex=\"100\" layout=\"column\" layout-align=\"center center\"><i class=\"icon-bank section__icon s50\"></i> <a href=\"\" \nng-click=\"vm.goToCovid()\" class=\"section__title--m\"><u>Tutoring centers</u></a> <span class=\"pt-10 message\">\nHelp to migrate your services online and free usage of our platform (no service fees). <a href=\"\" \nng-click=\"vm.goToCovid()\">Learn more</a>.</span></div><div flex-gt-sm=\"30\" flex=\"100\" layout=\"column\" \nlayout-align=\"center center\"><i class=\"icon-human section__icon s50\"></i> <a href=\"\" ng-click=\"vm.goToCovid()\" \nclass=\"section__title--m\"><u>Tutors</u></a> <span class=\"pt-10 message\">\nDonation of our service fees to you. You receive 100% of the earnings. <a href=\"\" ng-click=\"vm.goToCovid()\">Learn more\n</a>.</span></div><div flex-gt-sm=\"30\" flex=\"100\" layout=\"column\" layout-align=\"center center\"><i \nclass=\"icon-human-child section__icon s50\"></i> <a href=\"\" ng-click=\"vm.goToCovid()\" class=\"section__title--m\"><u>\nStudents</u></a> <span class=\"pt-10 message\">Free homework help from our tutor community. <a href=\"\" \nng-click=\"vm.goToCovid()\">Learn more</a>.</span></div></section></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/create-package/create-package.html","<md-dialog class=\"dialog-create-package\" aria-label=\"Create a Package\"><form name=\"createPackageForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"Create a Package\">Create a Package</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><section class=\"section\" \nstyle=\"margin-top: 20px\"><i class=\"icon-clipboard-text section__icon\"></i><h3 class=\"section__title\">Package Name</h3>\n</section><section class=\"section\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"packageName\" \nng-model=\"vm.packageName\" placeholder=\"Enter a package name\"></md-input-container></section><section class=\"section\"><i\n class=\"icon-view-list section__icon\"></i><h3 class=\"section__title\" translate=\"Category\"></h3></section><section \nclass=\"section\"><md-input-container style=\"width:100%;margin:0 0 23px 0\"><md-select name=\"category\" \nng-model=\"vm.category\" placeholder=\"Select a category\"><md-option ng-value=\"category\" ng-model=\"vm.category\" \nng-repeat=\"category in vm.categories\" ng-if=\"category.isActive\">{{ category | standardDropdownFilter }}</md-option>\n</md-select></md-input-container></section><section class=\"section\" style=\"margin-top: 20px\"><i \nclass=\"icon-timetable section__icon\"></i><h3 class=\"section__title\">Total Lesson Hours</h3></section><section \nclass=\"section\"><md-input-container class=\"md-block\"><input type=\"number\" name=\"packageHours\" \nng-model=\"vm.packageHours\" min=\"1\" placeholder=\"Enter total lesson hours\"></md-input-container></section><section \nclass=\"section\" style=\"margin-top: 20px\"><i class=\"icon-credit-card section__icon\"></i><h3 class=\"section__title\">\nTotal Price</h3></section><section class=\"section\"><md-input-container class=\"md-block\"><input type=\"number\" \nname=\"packagePrice\" ng-model=\"vm.packagePrice\" min=\"1\" placeholder=\"Enter a total price\"></md-input-container>\n</section><section><md-button class=\"md-raised md-primary btn-submit\" translate=\"Create\" ng-click=\"vm.createPackage()\" \nng-disabled=\"!vm.category||!vm.packageName||!vm.packageHours||!vm.packagePrice\"></md-button></section>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/dialogs/edit-file/edit-file.html","<md-dialog class=\"dialog-edit-file\" aria-label=\"Edit Profile Picture\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"EDIT_FILE.TITLE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div ng-click=\"vm.testButton()\">fdsa</div><md-input-container><label>Name</label><input \nng-model=\"item.name\"></md-input-container><md-input-container><label>File</label><input class=\"file\" type=\"file\" \nname=\"file\" file ng-model=\"$scope.file\"></md-input-container><md-button \nclass=\"md-raised md-primary eidtFile__uploadBtn--float-r\" ng-click=\"vm.upload()\">Upload</md-button></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/dialogs/edit-profile-pic/edit-profile-pic.html","<md-dialog class=\"dialog-edit-avatar\" aria-label=\"Edit Profile Picture\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"EDIT_PROFILE_PIC.TITLE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"center center\" layout-wrap><div><img class=\"avatar__img\" \nng-src=\"{{ vm.teacher.avatar ? vm.teacher.avatar : vm.defaultAvatar }}\"></div><div flex-offset=\"5\"><input \nclass=\"avatar__input\" type=\"file\" uploader=\"vm.uploader\" translate=\"EDIT_PROFILE_PIC.UPLOAD\" nv-file-select><p \nclass=\"avatar__hint\" translate=\"EDIT_PROFILE_PIC.SIZE_HINT\">Image file size cannot exceed 2MB</p></div></div><md-button\n class=\"md-raised md-primary btn-submit\" translate=\"EDIT_PROFILE_PIC.SAVE\" ng-click=\"vm.uploadAvatar()\"></md-button>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/essay-payment/essay-payment.html","<md-dialog class=\"dialog-essay-payment\" aria-label=\"Essay-payment\"><form name=\"paymentForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"Payment\">Essay Payment</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><section class=\"section\"><div \nstyle=\"display:inline-block;font-size: 16px;color: #ffa726;margin: 20px 8px 0 0\">$</div><h3 class=\"section__title\" \ntranslate=\"Price\"></h3><h3>{{ vm.wordCount }} words = ¥{{ vm.totalPrice }}</h3></section><section class=\"section\" \nstyle=\"margin-top: 20px\"><i class=\"icon-credit-card-multiple section__icon\"></i><h3 class=\"section__title\">\nChoose ONE payment method:</h3></section><section class=\"section\" layout=\"column\"><md-checkbox class=\"section__title\" \nng-model=\"vm.useWallet\" ng-disabled=\"!vm.walletBalance || vm.walletBalance < vm.totalPrice\" aria-label=\"My Wallet\">\nMy Wallet</md-checkbox><div class=\"section__text\"><p ng-if=\"vm.walletBalance >= vm.totalPrice\">\nRemaining balance: ${{ vm.walletBalance }}</p><p ng-if=\"vm.walletBalance < vm.totalPrice\">\nRemaining balance: ${{ vm.walletBalance }} (Insufficient)</p></div><div class=\"section__text\" ng-if=\"vm.useWallet\" \nlayout=\"row\">Use $ <input type=\"number\" ng-model=\"vm.useBalance\" min=\"0\" max=\"{{vm.walletBalance}}\">\n of ${{ vm.walletBalance }} remaining balance</div><md-checkbox class=\"section__title\" ng-model=\"vm.useCreditCard\" \naria-label=\"Credit Card\">Credit Card</md-checkbox></section><section><md-button \nclass=\"md-raised md-primary btn-submit\" translate=\"Confirm\" ng-click=\"vm.confirmPayment()\" \nng-disabled=\"!vm.canSubmit()\"></md-button></section></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/dialogs/lesson-request/lesson-request.html","<md-dialog class=\"dialog-lesson-request\" aria-label=\"Request a Lesson\"><form name=\"lessonRequestForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"LESSON_REQUEST.TITLE\">Schedule a Lesson</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><section \nclass=\"section\" style=\"width:100%;display:inline-block\" ng-if=\"$root.userRole == \'teacher\' \"><i \nclass=\"icon-email section__icon\"></i><h3 class=\"section__title\" translate=\"LESSON_REQUEST.EMAIL\"></h3></section>\n<section class=\"section\" style=\"width:100%;display:inline-block\" ng-if=\"$root.userRole == \'teacher\'\"><select \nui-select2=\"vm.statusOpt\" name=\"status\" ng-model=\"vm.email\" ng-change=\"vm.changeStudent()\" \nng-if=\"$root.userRole == \'teacher\' && !vm.isNewStudent \" style=\"width:100%;margin-bottom:20px\"><option value=\"\">\nChoose a student</option><option ng-repeat=\"target in vm.students\" ng-value=\"target.email\">\n{{ target | standardDropdownFilter }}</option></select><md-input-container class=\"md-block\" \nng-if=\"$root.userRole == \'teacher\' && vm.isNewStudent \" style=\"margin:0\"><input type=\"email\" name=\"email\" \nng-model=\"vm.email\" ng-change=\"vm.changeStudent()\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"lessonRequestForm.email.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LESSON_REQUEST.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LESSON_REQUEST.ERRORS.EMAIL_MUST_VALID\">Email must be a valid email address</span></div></div>\n</md-input-container></section><section class=\"section\" ng-if=\"$root.userRole == \'teacher\' && vm.isNewStudent \"><i \nclass=\"icon-account section__icon\"></i><h3 class=\"section__title\" translate=\"LESSON_REQUEST.NAME\"></h3></section>\n<section class=\"section\" ng-if=\"$root.userRole == \'teacher\' && vm.isNewStudent \"><md-input-container class=\"md-block\" \nstyle=\"margin:0\"><input type=\"text\" name=\"name\" ng-model=\"vm.name\" required><div \nng-messages=\"lessonRequestForm.email.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LESSON_REQUEST.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div></md-input-container>\n</section><section class=\"section\"><h3 class=\"section__title\" translate=\"LESSON_REQUEST.CATEGORY\"></h3></section>\n<section class=\"section\"><md-input-container style=\"width:100%;margin:0 0 23px 0\"><md-select name=\"category\" \nng-model=\"vm.category\" ng-change=\"vm.selectCategory()\" placeholder=\"Select a category\"><md-option ng-value=\"category\" \nng-model=\"vm.category\" ng-repeat=\"category in vm.categories\" ng-if=\"category.isActive\">\n{{ category | standardDropdownFilter }}</md-option></md-select></md-input-container></section><section class=\"section\">\n<i class=\"icon-calendar-clock section__icon\"></i><h3 class=\"section__title\" translate=\"LESSON_REQUEST.DATE_AND_TIME\">\n</h3></section><section class=\"section\"><div layout=\"row\" layout-xs=\"column\" class=\"date-row\"><md-datepicker \nng-model=\"vm.lesson.startDate\" md-min-date=\"vm.today\" ng-change=\"vm.changeStartDate()\" \nmd-placeholder=\"{{ \'LESSON_REQUEST.START_DATE\' | translate }}\"></md-datepicker><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.lesson.startTime\" ng-change=\"vm.changeDateTimes()\" \nplaceholder=\"{{ \'LESSON_REQUEST.START_TIME\' | translate }}\" ui-timepicker=\"vm.timePickerOptions\"></md-input-container>\n</div><div layout=\"row\" layout-xs=\"column\" class=\"date-row mb-24\" layout-wrap><md-datepicker \nng-model=\"vm.lesson.endDate\" md-min-date=\"vm.lesson.startDate\" ng-change=\"vm.changeDateTimes()\" \nmd-placeholder=\"{{ \'LESSON_REQUEST.END_DATE\' | translate }}\"></md-datepicker><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.lesson.endTime\" ng-change=\"vm.changeDateTimes()\" \nplaceholder=\"{{ \'LESSON_REQUEST.END_TIME\' | translate }}\" ui-timepicker=\"vm.timePickerOptions\"></md-input-container>\n</div></section><section class=\"section\"><md-checkbox class=\"section__title\" ng-model=\"vm.isRepeatWeekly\" \nng-change=\"vm.changeDateTimes()\" aria-label=\"Repeat Weekly\">Repeat Weekly</md-checkbox></section><section \nclass=\"section\" ng-show=\"vm.isRepeatWeekly\"><div><span>For</span><md-input-container style=\"margin:0\"><md-select \nng-model=\"vm.repeatWeeks\" ng-change=\"vm.changeDateTimes()\"><md-option ng-value=\"2\" selected=\"selected\">2</md-option>\n<md-option ng-value=\"3\">3</md-option><md-option ng-value=\"4\">4</md-option><md-option ng-value=\"5\">5</md-option>\n<md-option ng-value=\"6\">6</md-option><md-option ng-value=\"7\">7</md-option><md-option ng-value=\"8\">8</md-option>\n<md-option ng-value=\"9\">9</md-option><md-option ng-value=\"10\">10</md-option><md-option ng-value=\"11\">11</md-option>\n<md-option ng-value=\"12\">12</md-option><md-option ng-value=\"13\">13</md-option><md-option ng-value=\"14\">14</md-option>\n<md-option ng-value=\"15\">15</md-option></md-select></md-input-container><span>weeks</span></div><div \nng-repeat=\"week in vm.weeks\"><div layout=\"row\" layout-xs=\"column\" class=\"date-row\"><md-datepicker \nng-model=\"week.startDate\" ng-disabled=\"true\"></md-datepicker></div></div></section><section class=\"section\" \nng-if=\"$root.userRole == \'student\' \" style=\"margin-top: 20px\"><i class=\"icon-message section__icon\"></i><h3 \nclass=\"section__title\">Message (optional)</h3></section><section class=\"section\" ng-if=\"$root.userRole == \'student\' \">\n<md-input-container class=\"md-block\"><input type=\"text\" name=\"message\" ng-model=\"vm.message\"></md-input-container>\n</section><section class=\"section\"><div \nstyle=\"display:inline-block;font-size: 16px;color: #ffa726;margin: 20px 8px 0 0\">$</div><h3 class=\"section__title\" \ntranslate=\"LESSON_REQUEST.PRICE\"></h3><h3 ng-if=\"vm.categoryHourlyPrice >= 0\">\n${{ vm.categoryHourlyPrice }} x {{ vm.totalHours }} hour(s) = $ {{ vm.totalPrice }}</h3></section><section \nng-if=\"$root.userRole == \'teacher\' && !vm.isNewStudent\" style=\"display:inline-block\"><md-button class=\"md-default\" \nstyle=\"color:#ffb74d\" translate=\"LESSON_REQUEST.NEW_STUDENT\" ng-click=\"vm.showOrHide()\"></md-button></section><section \nng-if=\"$root.userRole == \'teacher\' && vm.isNewStudent\" style=\"display:inline-block\"><md-button class=\"md-default\" \nstyle=\"color:#ffb74d\" translate=\"LESSON_REQUEST.EXIST_STUDENT\" ng-click=\"vm.showOrHide()\"></md-button></section>\n<section ng-if=\"$root.userRole == \'teacher\'\" style=\"float:right\"><md-button class=\"md-raised md-primary btn-submit\" \ntranslate=\"LESSON_REQUEST.ENTER_PAY\" ng-click=\"vm.enterPaymentInfo()\" \nng-disabled=\"!vm.categoryHourlyPrice || !vm.email || (!vm.name && vm.isNewStudent)||!vm.lesson.startTime||!vm.lesson.endTime||(vm.singlehours<0)\">\n</md-button></section><section ng-if=\"$root.userRole != \'teacher\'\"><md-button class=\"md-raised md-primary btn-submit\" \ntranslate=\"LESSON_REQUEST.SEND\" ng-click=\"vm.checkPolicy()\" \nng-disabled=\"!vm.categoryHourlyPrice||!vm.lesson.startTime||!vm.lesson.endTime||(vm.singlehours<0)\"></md-button>\n</section></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/dialogs/mailchimp/mailchimp.html","<md-dialog class=\"dialog-mailchimp\" aria-label=\"mailchimp\"><md-dialog-content ms-scroll><div layout=\"row\" \nlayout-align=\"center start\"><div class=\"left-img hide-xs\"><img class=\"full-width\" \nsrc=\"assets/images/landing-page/mailchimp-cover.jpg\"></div><div layout=\"column\" class=\"right-signup full-width\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div></div><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n<div mailchimp id=\"mc_embed_signup\"><form \naction=\"https://nesuku.us16.list-manage.com/subscribe/post?u=0c246efbb4f39e8bbdc280c4f&amp;id=ec50e951c1\" \nmethod=\"post\" id=\"mc-embedded-subscribe-form\" name=\"mc-embedded-subscribe-form\" class=\"validate\" target=\"_blank\" \nnovalidate><div id=\"mc_embed_signup_scroll\"><h2>Join the Nesuku Community!</h2><p>\nReceive exclusive newsletters, teacher highlights, and special updates.</p><br><div class=\"mc-field-group\"><label \nfor=\"mce-FNAME\">Name</label><input type=\"text\" value=\"\" name=\"FNAME\" class=\"\" id=\"mce-FNAME\"></div><div \nclass=\"mc-field-group\"><label for=\"mce-EMAIL\">Email Address <span class=\"asterisk\">*</span></label><input type=\"email\" \nvalue=\"\" name=\"EMAIL\" class=\"required email\" id=\"mce-EMAIL\"></div><div layout=\"column\" layout-align=\"center center\"><p>\n<a href=\"https://us16.campaign-archive.com/home/?u=0c246efbb4f39e8bbdc280c4f&id=ec50e951c1\" target=\"_blank\" \ntitle=\"View previous campaigns\">View previous campaigns.</a></p><div id=\"mce-responses\" class=\"clear\"><div \nclass=\"response\" id=\"mce-error-response\" style=\"display:none\"></div><div class=\"response\" id=\"mce-success-response\" \nstyle=\"display:none\"></div></div><div style=\"position: absolute; left: -5000px\" aria-hidden=\"true\"><input type=\"text\" \nname=\"b_0c246efbb4f39e8bbdc280c4f_ec50e951c1\" tabindex=\"-1\" value=\"\"></div><div class=\"clear\"><input type=\"submit\" \nvalue=\"Subscribe\" name=\"subscribe\" id=\"mc-embedded-subscribe\" class=\"button\"></div></div></div></form></div></div>\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/makeup-payment/makeup-payment.html","<md-dialog class=\"dialog-makeup-payment\" aria-label=\"Request a Lesson\"><form name=\"lessonRequestForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"MAKEUP_PAYMENT.TITLE\">Payment Request</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><section \nclass=\"section\" style=\"width:100%;display:inline-block\"><i class=\"icon-account section__icon\"></i><h3 \nclass=\"section__title\">Student</h3><a class=\"links\" href=\"\" ng-if=\"!vm.isNewStudent\" ng-click=\"vm.showOrHide()\">\n(New student?)</a> <a class=\"links\" href=\"\" ng-if=\"vm.isNewStudent\" ng-click=\"vm.showOrHide()\">(Existing student?)</a>\n</section><section class=\"section\" style=\"width:100%;display:inline-block\"><select ui-select2=\"vm.statusOpt\" \nname=\"status\" ng-model=\"vm.email\" ng-change=\"vm.changeStudent()\" ng-if=\"!vm.isNewStudent \" \nstyle=\"width:100%;margin-bottom:20px\"><option value=\"\">Select the name</option><option \nng-repeat=\"target in vm.students\" ng-value=\"target.email\">{{ target | standardDropdownFilter }}</option></select>\n<md-input-container class=\"md-block\" ng-if=\"vm.isNewStudent \" style=\"margin:0\"><input type=\"email\" name=\"email\" \nng-model=\"vm.email\" ng-change=\"vm.changeStudent()\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"lessonRequestForm.email.$error\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"MAKEUP_PAYMENT.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"MAKEUP_PAYMENT.ERRORS.EMAIL_MUST_VALID\">Email must be a valid email address</span></div></div>\n</md-input-container></section><section class=\"section\" ng-if=\"vm.isNewStudent \"><i class=\"icon-account section__icon\">\n</i><h3 class=\"section__title\" translate=\"MAKEUP_PAYMENT.NAME\"></h3></section><section class=\"section\" \nng-if=\"vm.isNewStudent \"><md-input-container class=\"md-block\" style=\"margin:0\"><input type=\"text\" name=\"name\" \nng-model=\"vm.name\" required><div ng-messages=\"lessonRequestForm.email.$error\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"MAKEUP_PAYMENT.ERRORS.NAME_REQUIRED\">Name field is required</span></div></div>\n</md-input-container></section><section class=\"section\"><md-input-container style=\"width:100%;margin:0 0 23px 0\">\n<md-select name=\"category\" ng-model=\"vm.category\" ng-change=\"vm.calculatePrice()\" placeholder=\"Select the category\">\n<md-option ng-value=\"category\" ng-model=\"vm.category\" ng-repeat=\"category in vm.categories\" ng-if=\"category.isActive\">\n{{ category | standardDropdownFilter }}</md-option></md-select></md-input-container></section><section class=\"section\">\n<md-input-container style=\"width:100%;margin:0 0 23px 0\"><md-select name=\"duration\" ng-model=\"vm.duration\" \nng-change=\"vm.changeDisplayTimeString()\" placeholder=\"Select the duration\"><md-option ng-value=\"duration\" \nng-repeat=\"duration in vm.durations\">{{ duration }} hour(s)</md-option></md-select></md-input-container></section>\n<section class=\"section\"><i class=\"icon-calendar-clock section__icon\"></i><h3 class=\"section__title\" \ntranslate=\"MAKEUP_PAYMENT.DATE_AND_TIME\"></h3></section><section><ul><li ng-repeat=\"time in vm.description\">{{ time }}\n</li></ul></section><section id=\"makeup_payment\"><section id=\"makeup_content\"><div layout=\"row\" layout-xs=\"column\" \nclass=\"date-row\"><md-datepicker ng-model=\"vm.lesson.startDate\" md-max-date=\"vm.today\" \nmd-placeholder=\"{{ \'MAKEUP_PAYMENT.START_DATE\' | translate }}\" onkeydown=\"return false\"></md-datepicker>\n<md-input-container class=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.lesson.startTime\" \nplaceholder=\"{{ \'MAKEUP_PAYMENT.START_TIME\' | translate }}\" ui-timepicker=\"vm.timePickerOptions\" \nonkeydown=\"return false\"></md-input-container></div><hr></section></section><section style=\"display: inline-block\" \nclass=\"ng-scope\"><button class=\"md-raised md-primary btn-submit md-button ng-scope md-default-theme md-ink-ripple\" \ntype=\"button\" ng-click=\"vm.addTimes()\" ng-if=\"vm.lessonConfirmed\">Add Another Time Slot</button></section><section \nstyle=\"display: inline-block\" class=\"ng-scope\"><button \nclass=\"md-raised md-primary btn-submit md-button ng-scope md-default-theme md-ink-ripple\" type=\"button\" \nng-click=\"vm.confirmTime()\" ng-if=\"!vm.lessonConfirmed\" ng-disabled=\"!vm.lesson.startTime||!vm.duration\">\nAdd a Time Slot</button></section><section class=\"section\" ng-if=\"$root.userRole == \'student\' \" \nstyle=\"margin-top: 20px\"><i class=\"icon-message section__icon\"></i><h3 class=\"section__title\">Message (optional)</h3>\n</section><section class=\"section\" ng-if=\"$root.userRole == \'student\' \"><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"message\" ng-model=\"vm.message\"></md-input-container></section><section class=\"section\"><div \nstyle=\"display:inline-block;font-size: 16px;color: #ffa726;margin: 20px 8px 0 0\">$</div><h3 class=\"section__title\" \ntranslate=\"MAKEUP_PAYMENT.PRICE\"></h3><h3 ng-if=\"vm.categoryHourlyPrice >= 0\">\n${{ vm.categoryHourlyPrice }} x {{ vm.totalHours }} hour(s) = $ {{ vm.totalPrice }}</h3></section><section \nstyle=\"float:right\"><md-button class=\"md-raised md-primary btn-submit\" translate=\"MAKEUP_PAYMENT.ENTER_PAY\" \nng-click=\"vm.sendMakeUpRequest()\" \nng-disabled=\"!vm.lessonConfirmed ||!vm.categoryHourlyPrice || !vm.email || (!vm.name && vm.isNewStudent) || !vm.duration\">\n</md-button></section></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/dialogs/message/message.html","<md-dialog class=\"dialog-message\" class=\"event-detail-dialog\" aria-label=\"Message Student\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Message to {{ vm.studentName }}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><section class=\"section\"><i class=\"icon-comment-text section__icon\"></i> <span \nclass=\"section__title\" translate=\"MESSAGE.PLEASE_TYPE\">Please type your message below:</span></section>\n<md-input-container md-no-float class=\"md-block message\"><textarea class=\"message__content\" id=\"message-content\" \nng-model=\"vm.message.content\" md-select-on-focus></textarea></md-input-container><md-button \nclass=\"md-raised md-primary btn-submit\" ng-click=\"vm.sendMessage()\" translate=\"MESSAGE.SEND\">Send</md-button>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/payment/payment.html","<md-dialog class=\"dialog-payment\" aria-label=\"Payment\"><form name=\"paymentForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\" translate=\"Payment\">Payment</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ms-scroll><section class=\"section\"><div \nstyle=\"display:inline-block;font-size: 16px;color: #ffa726;margin: 20px 8px 0 0\">$</div><h3 class=\"section__title\" \ntranslate=\"Price\"></h3><h3>${{ vm.categoryHourlyPrice }} x {{ vm.totalHours }} hour(s) = $ {{ vm.totalPrice }}</h3>\n</section><section class=\"section\" style=\"margin-top: 20px\"><i class=\"icon-credit-card-multiple section__icon\"></i><h3 \nclass=\"section__title\">Choose ONE payment method:</h3></section><section class=\"section\" layout=\"column\"><md-checkbox \nclass=\"section__title\" ng-model=\"vm.usePackage\" \nng-disabled=\"!vm.packageName || !vm.remainingHours || vm.remainingHours < vm.totalHours\" aria-label=\"My Packages\">\nMy Packages</md-checkbox><div class=\"section__text\" ng-if=\"vm.packageName\"><p>Available package: {{ vm.packageName }}\n</p><p ng-if=\"vm.remainingHours >= vm.totalHours\">Remaining hours: {{ vm.remainingHours }}</p><p \nng-if=\"vm.remainingHours < vm.totalHours\">Remaining hours: {{ vm.remainingHours }} (Insufficient)</p></div><div \nclass=\"section__text\" ng-if=\"!vm.packageName\"><p>Available package: None</p></div><div class=\"section__text\" \nng-if=\"vm.usePackage\" layout=\"row\">Use <input type=\"number\" ng-model=\"vm.useHours\" min=\"0\" max=\"{{vm.remainingHours}}\">\n of {{ vm.remainingHours }} available package hours</div><md-checkbox class=\"section__title\" ng-model=\"vm.useWallet\" \nng-disabled=\"!vm.walletBalance || vm.walletBalance < vm.totalPrice\" aria-label=\"My Wallet\">My Wallet</md-checkbox><div \nclass=\"section__text\"><p ng-if=\"vm.walletBalance >= vm.totalPrice\">Remaining balance: ${{ vm.walletBalance }}</p><p \nng-if=\"vm.walletBalance < vm.totalPrice\">Remaining balance: ${{ vm.walletBalance }} (Insufficient)</p></div><div \nclass=\"section__text\" ng-if=\"vm.useWallet\" layout=\"row\">Use $ <input type=\"number\" ng-model=\"vm.useBalance\" min=\"0\" \nmax=\"{{vm.walletBalance}}\"> of ${{ vm.walletBalance }} remaining balance</div><md-checkbox class=\"section__title\" \nng-model=\"vm.useCreditCard\" aria-label=\"Credit Card\">Credit Card</md-checkbox></section><section><md-button \nclass=\"md-raised md-primary btn-submit\" translate=\"Confirm\" ng-click=\"vm.confirmPayment()\" \nng-disabled=\"!vm.canSubmit()\"></md-button></section></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/dialogs/prompt/prompt.html","<md-dialog class=\"event-detail-dialog\" style=\"width:480px;max-width:480px\" aria-label=\"Category saved\"><md-toolbar \nclass=\"md-accent md-hue-2\" style=\"background-color:#fff\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"dialog-title\" style=\"color:black;font-weight:bold\" \ntranslate=\"PROMPT.SAVE_YOUR_CHANGES\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\" style=\"color:black\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-button ng-click=\"vm.yes()\" class=\"md-raised md-primary\" \nstyle=\"margin-top:6px;margin-left:30%\">{{ \"PROMPT.YES\"|translate }}</md-button><md-button ng-click=\"vm.no()\" \nclass=\"md-raised md-primary\">{{ \"PROMPT.NO\"|translate }}</md-button></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/rate/rate.html","<md-dialog id=\"dialog-rating\" class=\"event-detail-dialog\" aria-label=\"Rate the teacher\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"RATE.TITLE\">Rate Your Lesson</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><form name=\"rateForm\" novalidate><md-input-container class=\"md-block\" \nlayout=\"column\" layout-align=\"space-between center\"><section><span class=\"dialog-rating__tip\" translate=\"RATE.INPUT\">\nInput your review below:</span><textarea name=\"comment\" class=\"dialog-rating__comment\" ng-model=\"vm.lesson.comment\" \nmd-maxlength=\"300\" rows=\"5\" md-select-on-focus></textarea><div ng-messages=\"rateForm.comment.$error\" \nng-show=\"rateForm.comment.$dirty\"><div ng-message=\"md-maxlength\" translate=\"RATE.TOO_LONG\">That\'s too long!</div></div>\n</section><section><span uib-rating class=\"dialog-rating__rate\" ng-model=\"vm.lesson.rate\" max=\"5\" \naria-labelledby=\"default-rating\"></span></section><section><md-button ng-click=\"vm.report()\" translate=\"RATE.REPORT\">\nReport</md-button><md-button class=\"md-raised md-primary btn-submit\" ng-click=\"vm.submit()\" \nng-disabled=\"rateForm.$invalid\" translate=\"RATE.SUBMIT\">Submit</md-button></section></md-input-container></form>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/register-student/register-student.html","<md-dialog class=\"dialog-register-student\" aria-label=\"Change Password\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \nng-if=\"vm.state == \'register\'\">Sign up</span> <span class=\"title\" ng-if=\"vm.state == \'login\'\">Log in</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"vm.state == \'register\'\" ms-scroll><form \nname=\"registerForm\" layout=\"column\" layout-align=\"center stretch\" novalidate><md-input-container class=\"md-block\">\n<label class=\"input__label\" translate=\"REGISTER.NAME\">Name</label><input name=\"username\" ng-model=\"vm.form.username\" \nrequired><div ng-messages=\"registerForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"input__label\" translate=\"REGISTER.EMAIL\">Email</label><input \ntype=\"email\" name=\"email\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div><div \nclass=\"error-message\" ng-show=\"vm.emailHasRegister\" translate=\"REGISTER.ERRORS.EMAIL_REGISTERED\"><span>\nEmail has been registered</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \nclass=\"input__label\" translate=\"REGISTER.PASSWORD\">Password</label><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" minlength=\"6\" maxlength=\"255\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required\n</span></div><div ng-message=\"minlength\"><span translate=\"REGISTER.ERRORS.PASSWORD_MINLENGTH\">\nThe password must be more than 6 characters long.</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_MAXLENGTH\">The password must be less than 255 characters long.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label class=\"input__label\" \ntranslate=\"REGISTER.PASSWORD_CONFIRM\">Confirm Password</label><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" minlength=\"6\" maxlength=\"255\" password-confirmation=\"{{ vm.form.password }}\" \nrequired><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Confirm password field is required</span></div><div \nng-message=\"minlength\"><span translate=\"REGISTER.ERRORS.PASSWORD_MINLENGTH\">\nThe Confirm password field must be more than 6 characters long.</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_MAXLENGTH\">The Confirm password field must be less than 255 characters long.</span>\n</div><span class=\"md-input-message-animation\" \nng-show=\"registerForm.passwordConfirm.$error.passwordConfirmation && !registerForm.passwordConfirm.$error.required\" \ntranslate=\"REGISTER.ERRORS.PASSWORD_MISMATCH\">Confirm Password does not match</span></div></md-input-container><div \nclass=\"terms\" layout=\"row\" layout-align=\"start center\"><md-checkbox name=\"terms\" \nng-model=\"vm.form.acceptTermsAndConditions\" aria-label=\"I read and accept\" required></md-checkbox><div><span \ntranslate=\"REGISTER.READ_ACCEPT\">I have read and I accept the</span> <a href=\"#\" class=\"md-accent-color\" \ntranslate=\"REGISTER.TERMS_COND\" ng-click=\"vm.openDialog()\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-primary submit-button\" aria-label=\"Sign Up\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\" ng-click=\"vm.signup()\"></md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"text\">Already have an account?</span> <a class=\"link\" \nng-click=\"vm.switchStates(\'login\')\">Log in</a></div></md-dialog-content><md-dialog-content ng-if=\"vm.state == \'login\'\">\n<form name=\"loginForm\" layout=\"column\" layout-align=\"center stretch\" novalidate><md-input-container class=\"md-block\">\n<label class=\"input__label\" translate=\"LOGIN.EMAIL\">Email</label><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"loginForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required\n</span></div><div ng-message=\"pattern\"><span translate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">\nEmail must be a valid e-mail address</span></div></div></md-input-container><md-input-container class=\"md-block\"><label\n class=\"input__label\" translate=\"LOGIN.PASSWORD\">Password</label><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div>\n<div id=\"invalidLogin\" ng-if=\"vm.invalidLogin\"><span class=\"error-message\" translate=\"LOGIN.ERRORS.INVALID_LOGIN\">\n</span></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-primary submit-button\" \naria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.logIn()\">LOG IN</md-button><div class=\"remember-forgot-password\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><a ui-sref=\"app.pages_auth_forgot-password\" \nclass=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div></form><div \nclass=\"register\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><span class=\"text\" \ntranslate=\"LOGIN.DONT_HAVE_ACCOUNT\">Don\'t have an account?</span> <a class=\"link\" \nng-click=\"vm.switchStates(\'register\')\">Create an account</a></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/register-teacher/register-teacher.html","<md-dialog class=\"dialog-register-teacher\" aria-label=\"Change Password\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Register Teacher</span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><form \nname=\"registerForm\" layout=\"column\" layout-align=\"center stretch\" novalidate><md-input-container class=\"md-block\">\n<label class=\"input__label\" translate=\"REGISTER.NAME\">Name</label><input name=\"username\" ng-model=\"vm.form.username\" \nrequired><div ng-messages=\"registerForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Name field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"input__label\" translate=\"REGISTER.EMAIL\">Email</label><input \ntype=\"email\" name=\"email\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div><div \nclass=\"error-message\" ng-show=\"vm.emailHasRegister\" translate=\"REGISTER.ERRORS.EMAIL_REGISTERED\"><span>\nEmail has been registered</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \nclass=\"input__label\" translate=\"REGISTER.PASSWORD\">Password</label><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" minlength=\"6\" maxlength=\"255\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required\n</span></div><div ng-message=\"minlength\"><span translate=\"REGISTER.ERRORS.PASSWORD_MINLENGTH\">\nThe password must be more than 6 characters long.</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_MAXLENGTH\">The password must be less than 255 characters long.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label class=\"input__label\" \ntranslate=\"REGISTER.PASSWORD_CONFIRM\">Confirm Password</label><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" minlength=\"6\" maxlength=\"255\" password-confirmation=\"{{ vm.form.password }}\" \nrequired><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Confirm password field is required</span></div><div \nng-message=\"minlength\"><span translate=\"REGISTER.ERRORS.PASSWORD_MINLENGTH\">\nThe Confirm password field must be more than 6 characters long.</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_MAXLENGTH\">The Confirm password field must be less than 255 characters long.</span>\n</div><span class=\"md-input-message-animation\" \nng-show=\"registerForm.passwordConfirm.$error.passwordConfirmation && !registerForm.passwordConfirm.$error.required\" \ntranslate=\"REGISTER.ERRORS.PASSWORD_MISMATCH\">Confirm Password does not match</span></div></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-primary submit-button\" aria-label=\"Sign Up\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\" ng-click=\"vm.signup()\"></md-button></form></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/dialogs/set-price/set-price.html","<md-dialog id=\"dialog-set-price\" class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"SET_PRICE.TITLE\">Lesson Request</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"ms-widget-front\" ms-scroll><div class=\"widget__content\" layout=\"column\" \nlayout-align=\"center start\"><form name=\"set_price_form\"><section><img class=\"lesson__student-avatar\" \nng-src=\"{{ vm.lesson.studentAvatar ? vm.lesson.studentAvatar : vm.defaultAvatar }}\" alt=\"student\'s avatar\"> <span \nclass=\"lesson__student-name\">{{ vm.lesson.studentName }}</span></section><section><label class=\"widget__section-title\" \ntranslate=\"SET_PRICE.SCHEDULE_TIME\"></label><span class=\"lesson__timezone\">(GMT {{ vm.timezone }})</span><p \nclass=\"lesson__datetime\">\n{{ vm.lesson.startDatetime | date: vm.datetimeFormat }} - {{ vm.lesson.endDatetime | date: vm.datetimeFormat }}</p>\n</section><section><label class=\"widget__section-title\" translate=\"SET_PRICE.SET_PRICE\"></label><label \nclass=\"widget__section-title\" translate=\"SET_PRICE.PROCESSING_FEE\"></label><md-input-container class=\"md-block\" \nmd-select-on-focus md-no-float><div class=\"lesson__price-container\"><input name=\"price\" type=\"number\" min=\"0\" \nclass=\"lesson__price-input\" ng-model=\"vm.lesson.price\"></div><div ng-messages=\"set_price_form.price.$error\" \nrole=\"alert\"><div ng-message=\"min\" translate=\"SET_PRICE.VALIDATION_MIN\"></div></div></md-input-container></section>\n<section class=\"widget__action-bar\"><md-button class=\"md-raised md-primary btn-submit\" translate=\"SET_PRICE.SEND\" \nng-click=\"vm.send()\"></md-button></section></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/dialogs/terms-n-conditions/terms-n-conditions.html","<md-dialog class=\"dialog-terms-n-conditions\" aria-label=\"Terms and Conditions\"><md-toolbar class=\"md-accent md-hue-2\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">Terms and Conditions\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"column\" \nlayout-align=\"center start\"><ol><li><strong>Introduction</strong></li></ol><p>\nThe Standard Terms and Conditions (or \"Terms\") written on this webpage shall govern your use of www.nesuku.com. These Terms will be applied fully and affect your use of www.nesuku.com. By using www.nesuku.com, you agree to accept the below outlined terms and conditions. Do not use nesuku.com if you disagree with any of the below Terms and Conditions.\n</p><p>Minors or people below 18 years of age are not allowed to use Nesuku.</p><ol start=\"2\"><li><strong>\nIntellectual Property Rights</strong></li></ol><p>\nOther than the content you own, under these Terms, Nesuku and/or its licensors own all the intellectual property rights and materials contained in www.nesuku.com.\n</p><p>You are granted limited license only for purposes of viewing the material contained on www.nesuku.com.</p><ol \nstart=\"3\"><li><strong>Restrictions</strong></li></ol><p>\nYou are specifically restricted from engaging in any of the following activities:</p><ul><li>\npublishing any www.nesuku.com material in any other media;</li><li>\nselling, sublicensing and/or otherwise commercializing any www.nesuku.com material;</li><li>\npublicly performing and/or showing any www.nesuku.com material;</li><li>\nusing www.nesuku.com in any way that is or may be damaging to www.nesuku.com;</li><li>\nusing www.nesuku.com in any way that impacts user access to www.nesuku.com;</li><li>\nusing www.nesuku.com contrary to applicable laws and regulations, or in any way may cause harm to www.nesuku.com, or to any person or business entity;\n</li><li>\nengaging in any data mining, data harvesting, data extracting or any other similar activity in relation to www.nesuku.com;\n</li><li>using www.nesuku.com to engage in any advertising or marketing.</li></ul><p>\nYou are restricted from accessing certain parts of www.nesuku.com and Nesuku retains the right to further restrict access by you to any parts of www.nesuku.com, at any time, in absolute discretion. Any User IDs and passwords you may have for www.nesuku.com are confidential and you must maintain their confidentiality.\n</p><ol start=\"4\"><li><strong>Your Content</strong></li></ol><p>\nUnder our Standard Terms and Conditions, “Your Content” shall refer any audio, video text, images or other material you choose to display on www.nesuku.com. By displaying Your Content, you grant Nesuku a non-exclusive, globally irrevocable, sub-licensable license to use, reproduce, adapt, publish, translate, and distribute Your Contenct in any and all media.\n</p><p>\nYour Content must be your own and must not be invading any third-party’s rights. Nesuku reserves the right to remove any of Your Content from www.nesuku.com at any time without notice.\n</p><ol start=\"5\"><li><strong>No warranties</strong></li></ol><p>\nwww.nesuku.com is provided “as is,”. Nesuku provides no representations or warranties of any kind related to www.nesuku.com or the materials contained on www.nesuku.com. Also, nothing contained on www.nesuku.com shall be interpreted as advice.\n</p><ol start=\"6\"><li><strong>Limitation of liability</strong></li></ol><p>\nIn no event shall Nesuku, nor any of its officers, directors and employees, shall be held liable for anything arising out of or in any way connected with your use of this Website regardless of whether such liability is under contract. Nesuku, including its officers, directors, and employees shall not be held liable for any indirect, consequential, or special liability arising out of or in any way related to your use of www.nesuku.com.\n</p><ol start=\"7\"><li><strong>Indemnification</strong></li></ol><p>\nYou hereby indemnify to the fullest extent Nesuku from and against any and/or all liabilities, costs, demands, causes of action, damages, and expenses arising in any way related to your breach of any of the provisions of these Terms.\n</p><ol start=\"8\"><li><strong>Severability</strong></li></ol><p>\nIf any provision of these Terms is found to be invalid under any applicable law, such provisions shall be deleted without affecting the remaining provisions herein.\n</p><ol start=\"9\"><li><strong>Variation of Terms</strong></li></ol><p>\nNesuku is permitted to revise these Terms at any time as it sees fit, and by using www.nesuku.com you are expected to review these Terms on a regular basis.\n</p><ol start=\"10\"><li><strong>Assignment</strong></li></ol><p>\nNesuku is allowed to assign, transfer, and subcontract its rights and/or obligations under these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any of your rights and/or obligations under these Terms.\n</p><ol start=\"11\"><li><strong>Entire Agreement</strong></li></ol><p>\nThese Terms constitute the entire agreement between Nesuku and you in relation to your use of www.nesuku.com, and supersede all prior agreements and understandings.\n</p><ol start=\"12\"><li><strong>Governing Law &amp; Jurisdiction</strong></li></ol><p>\nThese Terms will be governed by and interpreted in accordance with the laws of the State of Michigan, and you submit to the non-exclusive jurisdiction of the state and federal courts located in Michigan for the resolution of any disputes.\n</p></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/about-us/about-us.html","<div id=\"about-us\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">About Us</span></div></div><div class=\"content-container pt-20 pb-10\"><md-content \nclass=\"md-padding\"><div class=\"text-center\" layout=\"column\" layout-align=\"center center\"><h1 \ntranslate=\"ABOUT_US.MULTICULTURAL\"><b>\nWe are a multicultural group, who came together through a mutual love for learning new languages and exploring the world\n</b></h1><br><br><div class=\"video\" layout=\"row\" layout-align=\"center center\"><iframe width=\"853\" height=\"480\" \nsrc=\"https://www.youtube.com/embed/6vtqGGZpV1E?rel=0\" frameborder=\"0\" allowfullscreen></iframe></div><br><br><h1 \ntranslate=\"ABOUT_US.COFOUNDERS\"><b>\nWatch the story of co-founders Andy and Lars, college roommates who studied abroad together and were frustrated with their options for learning Mandarin\n</b></h1></div></md-content></div><div class=\"content-container section-line\"></div><div \nclass=\"content-container pt-10 pb-10\"><md-content class=\"md-padding\"><div layout=\"column\" layout-align=\"center center\">\n<h1 translate=\"ABOUT_US.OUR_TEAM\"><b>Meet our team</b></h1><br><br><div layout=\"row\" \nlayout-align=\"space-around center\" layout-wrap><div layout=\"column\" layout-align=\"center start\"><md-card \nclass=\"teacher-card\"><div class=\"black-hover\"></div><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/our-team/andy.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><span translate=\"ABOUT_US.ANDY\">Andy Hsiao</span></md-card-content></md-card><span \nclass=\"caption\"><b>CEO & Co-founder</b></span> <span class=\"caption\"><b>Languages:</b> English, Mandarin, Japanese\n</span></div><div layout=\"column\" layout-align=\"center center\"><md-card class=\"teacher-card\"><div class=\"black-hover\">\n</div><div class=\"image_gradient\"></div><img src=\"assets/images/our-team/lars.jpg\"><md-card-content layout=\"column\" \nlayout-align=\"center center\" class=\"teacher-content\"><span translate=\"ABOUT_US.LARS\">Lars Vagnes</span>\n</md-card-content></md-card><span class=\"caption\"><b>CMO & Co-founder</b></span> <span class=\"caption\"><b>Languages:\n</b> English, Mandarin, Norwegian</span></div><div layout=\"column\" layout-align=\"center center\"><md-card \nclass=\"teacher-card\"><div class=\"black-hover\"></div><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/our-team/emily.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><span translate=\"ABOUT_US.EMILY\">Emily Hsiao</span></md-card-content></md-card><span \nclass=\"caption\"><b>COO & Co-founder</b></span> <span class=\"caption\"><b>Languages:</b>\n English, Mandarin, Japanese, Spanish, Italian</span></div></div><div layout=\"row\" layout-align=\"space-around center\" \nlayout-wrap><div layout=\"column\" layout-align=\"center center\"><md-card class=\"teacher-card\"><div class=\"black-hover\">\n</div><div class=\"image_gradient\"></div><img src=\"assets/images/our-team/youssouf.jpg\"><md-card-content \nlayout=\"column\" layout-align=\"center center\" class=\"teacher-content\"><span translate=\"ABOUT_US.YOUSSOUF\">\nYoussouf Camara</span></md-card-content></md-card><span class=\"caption\"><b>Finance & Investor Relations Guide</b>\n</span> <span class=\"caption\"><b>Languages:</b> French, English</span></div><div layout=\"column\" \nlayout-align=\"center center\"><md-card class=\"teacher-card\"><div class=\"black-hover\"></div><div class=\"image_gradient\">\n</div><img src=\"assets/images/our-team/kevin.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><span translate=\"ABOUT_US.KEVIN\">Kevin Hsiao</span></md-card-content></md-card><span \nclass=\"caption\"><b>Data and Growth Investigator</b></span> <span class=\"caption\"><b>Languages:</b>\n English, Mandarin, Japanese</span></div><div layout=\"column\" layout-align=\"center center\"><md-card \nclass=\"teacher-card\"><div class=\"black-hover\"></div><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/our-team/kaori.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><span translate=\"ABOUT_US.KAORI\">Kaori Ohara</span></md-card-content></md-card><span \nclass=\"caption\"><b>Education & Teacher Liason</b></span> <span class=\"caption\"><b>Languages:</b>\n English, Mandarin, Japanese, Taiwanese</span></div><div layout=\"column\" layout-align=\"center center\"><md-card \nclass=\"teacher-card\"><div class=\"black-hover\"></div><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/our-team/jimmy.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><span translate=\"ABOUT_US.JIMMY\">Jimmy Hsiao</span></md-card-content></md-card><span \nclass=\"caption\"><b>Executive Coach</b></span> <span class=\"caption\"><b>Languages:</b> English, Mandarin, Taiwanese\n</span></div></div></div></md-content></div><div class=\"content-container section-line\"></div><div \nclass=\"content-container pt-10 pb-20\"><md-content class=\"md-padding\"><div class=\"\" layout=\"column\" \nlayout-align=\"center center\"><h1 translate=\"ABOUT_US.GET_INVOLVED\"><b>Get Involved</b></h1><br><br><p>\nDo you love languages like we do? We’re always looking for new ideas and partners. <a href=\"\" \nng-click=\"vm.contactNesuku()\">Drop us a line</a><span> or start chatting with us in the chat box to the right!</span>\n</p><p>Want to be a teacher? <a href=\"https://www.nesuku.com/apply-to-teach\">Apply here</a>.</p></div></md-content>\n</div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/admin-dashboard/admin-dashboard.html","<div id=\"admin-dashboard\"><div class=\"content content-container\"><div class=\"md-title mt-32 mb-24\"><h1 \nclass=\"dashboard-title\">Admin Dashboard</h1></div><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"Unpaid Courses\" ng-if=\"$root.userRole == \'admin\'\"><md-content><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\"><span\n class=\"column-title\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Email</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Stripe Connected</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Start Time</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">End Time</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\">Price (USD)</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th></tr></thead><tbody><tr ng-repeat=\"course in vm.unpaidcourses\"><td \nclass=\"avatar\"><img class=\"avatar__img\" ng-src=\"{{ course.teacherAvatar }}\"></td><td>{{ course.teacherName }}</td><td>\n{{ course.teacherEmail }}</td><td>{{ course.isConnected ? \'Yes\' : \'No\' }}</td><td>{{ course.start }}</td><td>\n{{ course.end }}</td><td>{{ course.price * 0.85 | currency: \'$\' }}</td><td><md-button ng-if=\"course.price\" \nclass=\"md-raised md-primary btn-pay-teacher\" ng-disabled=\"!course.canTransfer\" ng-click=\"vm.payTeacher(course)\">\nPay Teacher</md-button></td></tr><tr ng-if=\"vm.isLoading\" ng-repeat=\"_ in [] | range: 8\"><td><div \nclass=\"loading__avatar shining-effect\"></div></td><td ng-repeat=\"_ in [] | range: 7\"><div ng-if=\"$index !== 6\" \nclass=\"loading__content shining-effect\"></div></td></tr><tr ng-if=\"vm.courses.length === 0\"><td valign=\"top\" \ncolspan=\"8\" class=\"dataTables_empty\"><p class=\"empty-state-text\">We don\'t have any unpaid course.</p></td></tr></tbody>\n</table></div></md-content></md-tab><md-tab label=\"teacher List\" ng-if=\"$root.userRole == \'admin\'\"><md-content><div \nclass=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Registered Time</span></div></th></tr>\n</thead><tbody><tr ng-repeat=\"teacher in vm.teachers\"><td class=\"avatar\"><img class=\"avatar__img\" \nng-src=\"{{ teacher.avatar }}\"></td><td>{{ teacher.name }}</td><td>{{ teacher.email }}</td><td>{{ teacher.createdAt }}\n</td></tr><tr ng-if=\"vm.isLoading\" ng-repeat=\"_ in [] | range: 8\"><td><div class=\"loading__avatar shining-effect\">\n</div></td><td ng-repeat=\"_ in [] | range: 7\"><div ng-if=\"$index !== 6\" class=\"loading__content shining-effect\"></div>\n</td></tr><tr ng-if=\"vm.teachers.length === 0\"><td valign=\"top\" colspan=\"8\" class=\"dataTables_empty\"><p \nclass=\"empty-state-text\">We don\'t have any teacher in database.</p></td></tr></tbody></table><div layout=\"row\" \nlayout-align=\"center center\"><ul uib-pagination class=\"pagination-sm pager\" \ntotal-items=\"vm.teacherPagination.totalItems\" ng-model=\"vm.teacherPagination.currentPage\" \nitems-per-page=\"vm.teacherPagination.itemsPerPage\" max-size=\"5\" rotate=\"false\" previous-text=\"&lsaquo;\" \nnext-text=\"&rsaquo;\" ng-change=\"vm.getTeacherList()\" ng-hide=\"vm.teachers.length === 0\"></ul></div></div></md-content>\n</md-tab><md-tab label=\"Student List\" ng-if=\"$root.userRole == \'teacher\' || $root.userRole == \'admin\'\"><md-content><div\n class=\"white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\" datatable=\"ng\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Email</span></div></th><th \nclass=\"secondary-text\" ng-if=\"$root.userRole == \'admin\'\"><div class=\"table-header\"><span class=\"column-title\">\nRegistered Time</span></div></th></tr></thead><tbody><tr ng-repeat=\"student in vm.students\"><td class=\"avatar\"><img \nclass=\"avatar__img\" ng-src=\"{{ student.avatar }}\"></td><td>{{ student.name }}</td><td>{{ student.email }}</td><td \nng-if=\"$root.userRole == \'admin\'\">{{ student.createdAt }}</td><td ng-if=\"$root.userRole == \'teacher\'\"><md-button \nclass=\"md-raised md-primary btn-pay-teacher\" ng-disabled=\"\" ng-click=\"vm.remindStudent(student)\">Send Reminder\n</md-button></td></tr><tr ng-if=\"vm.isLoading\" ng-repeat=\"_ in [] | range: 8\"><td><div \nclass=\"loading__avatar shining-effect\"></div></td><td ng-repeat=\"_ in [] | range: 7\"><div ng-if=\"$index !== 6\" \nclass=\"loading__content shining-effect\"></div></td></tr><tr ng-if=\"vm.students.length === 0\"><td valign=\"top\" \ncolspan=\"8\" class=\"dataTables_empty\"><p class=\"empty-state-text\">We don\'t have any student in database.</p></td></tr>\n</tbody></table><div layout=\"row\" layout-align=\"center center\"><ul uib-pagination class=\"pagination-sm pager\" \ntotal-items=\"vm.studentPagination.totalItems\" ng-model=\"vm.studentPagination.currentPage\" \nitems-per-page=\"vm.studentPagination.itemsPerPage\" max-size=\"5\" rotate=\"false\" previous-text=\"&lsaquo;\" \nnext-text=\"&rsaquo;\" ng-change=\"vm.getStudentList()\" ng-hide=\"vm.students.length === 0\"></ul></div></div></md-content>\n</md-tab><md-tab label=\"Course List\"><md-content><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\"><thead><tr><th class=\"secondary-text\" \nng-if=\"$root.userRole == \'student\' || $root.userRole == \'teacher\'\"><div class=\"table-header\"><span \nclass=\"column-title\"></span></div></th><th class=\"secondary-text\" \nng-if=\"$root.userRole == \'student\' || $root.userRole == \'admin\'\"><div class=\"table-header\"><span class=\"column-title\">\nTeacher Name</span></div></th><th class=\"secondary-text\" \nng-if=\"$root.userRole == \'teacher\' || $root.userRole == \'admin\'\"><div class=\"table-header\"><span class=\"column-title\">\nStudent Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Status\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">Start</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\">End</span></div></th></tr></thead>\n<tbody><tr ng-repeat=\"course in vm.courses\"><td class=\"avatar\" ng-if=\"$root.userRole == \'student\'\"><img \nclass=\"avatar__img\" ng-src=\"{{ course.teacherAvatar }}\"></td><td \nng-if=\"$root.userRole == \'student\' || $root.userRole == \'admin\'\">{{ course.teacherName }}</td><td class=\"avatar\" \nng-if=\"$root.userRole == \'teacher\'\"><img class=\"avatar__img\" ng-src=\"{{ course.studentAvatar }}\"></td><td \nng-if=\"$root.userRole == \'teacher\' || $root.userRole == \'admin\'\">{{ course.studentName }}</td><td>\n{{ course.status.name }}</td><td>{{ course.start }}</td><td>{{ course.end }}</td></tr><tr ng-if=\"vm.isLoading\" \nng-repeat=\"_ in [] | range: 8\"><td><div class=\"loading__avatar shining-effect\"></div></td><td \nng-repeat=\"_ in [] | range: 7\"><div ng-if=\"$index !== 6\" class=\"loading__content shining-effect\"></div></td></tr><tr \nng-if=\"vm.courses.length === 0\"><td valign=\"top\" colspan=\"8\" class=\"dataTables_empty\"><p class=\"empty-state-text\">\nWe don\'t have any course in database.</p></td></tr></tbody></table><div layout=\"row\" layout-align=\"center center\"><ul \nuib-pagination class=\"pagination-sm pager\" total-items=\"vm.coursePagination.totalItems\" \nng-model=\"vm.coursePagination.currentPage\" items-per-page=\"vm.coursePagination.itemsPerPage\" max-size=\"5\" \nrotate=\"false\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" ng-change=\"vm.getCourseList()\" \nng-hide=\"vm.courses.length === 0\"></ul></div></div></md-content></md-tab><md-tab label=\"Dashboard\" \nng-click=\"vm.refreshDashboard()\" ng-if=\"$root.isAuthenticated\"><md-content class=\"md-padding\"><div layout=\"column\" \nflex=\"70\" flex-xs=\"100\"><ms-widget class=\"no-padding mb-20\" ng-if=\"$root.userRole == \'admin\'\"><ms-widget-front \nclass=\"white-bg\"><div class=\"p-8 border-bottom widget__header\"><div class=\"widget__title\">Dashboard: Revenue</div>\n</div><div layout=\"column\" layout-align=\"center start\"><button class=\"return__btn\" ng-if=\"vm.dashboard1.level != 1\" \nng-click=\"vm.previousLevel(vm.dashboard1)\">Previous level</button><div id=\"revenueChart\" class=\"admin__chart\"></div>\n</div></ms-widget-front></ms-widget><ms-widget class=\"no-padding mb-20\" ng-if=\"$root.userRole == \'teacher\'\">\n<ms-widget-front class=\"white-bg\"><div class=\"p-8 border-bottom widget__header\"><div class=\"widget__title\">\nDashboard: Income</div></div><div layout=\"column\" layout-align=\"center start\"><button class=\"return__btn\" \nng-if=\"vm.dashboard2.level != 1\" ng-click=\"vm.previousLevel(vm.dashboard2)\">Previous level</button><div \nid=\"incomeChart\" class=\"admin__chart\"></div></div></ms-widget-front></ms-widget><ms-widget class=\"no-padding mb-20\" \nng-if=\"$root.userRole == \'teacher\'\"><ms-widget-front class=\"white-bg\"><div class=\"p-8 border-bottom widget__header\">\n<div class=\"widget__title\">Dashboard: Hour</div></div><div layout=\"column\" layout-align=\"center start\"><button \nclass=\"return__btn\" ng-if=\"vm.dashboard4.level != 1\" ng-click=\"vm.previousLevel(vm.dashboard4)\">Previous level</button>\n<div id=\"courseChart\" class=\"admin__chart\"></div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"no-padding mb-20\" ng-if=\"$root.userRole == \'student\'\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-8 border-bottom widget__header\"><div class=\"widget__title\">Dashboard: Hour</div></div><div layout=\"column\" \nlayout-align=\"center start\"><button class=\"return__btn\" ng-if=\"vm.dashboard3.level != 1\" \nng-click=\"vm.previousLevel(vm.dashboard3)\">Previous level</button><div id=\"hourChart\" class=\"admin__chart\"></div></div>\n</ms-widget-front></ms-widget></div></md-content></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/pages/app-dashboard/app-dashboard.html","<div id=\"app-dashboard\" class=\"page-layout simple\"><div class=\"content-container pt-40 pb-40\" layout=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div flex=\"70\" flex-xs=\"100\"><md-content class=\"md-padding\"><section \nlayout=\"column\" layout-wrap><form name=\"teacherProfileForm\" novalidate><section class=\"section\"><h3 \nclass=\"section__title\">Name</h3></section><md-input-container md-no-float class=\"md-block\" flex-gt-sm><input \ntype=\"text\" class=\"input-content\" ng-model=\"vm.name\" placeholder=\"{{ \'Please enter name of the tool\' | translate}}\" \nrequired></md-input-container><section class=\"section\"><h3 class=\"section__title\">Tool Link</h3></section>\n<md-input-container md-no-float class=\"md-block\" flex-gt-sm><input type=\"text\" class=\"input-content\" ng-model=\"vm.url\" \nplaceholder=\"{{ \'Please enter the link to the tool\' | translate}}\" required></md-input-container><section \nclass=\"section\"><h3 class=\"section__title\">Icon Link</h3></section><md-input-container md-no-float class=\"md-block\" \nflex-gt-sm><input type=\"text\" class=\"input-content\" ng-model=\"vm.picUrl\" \nplaceholder=\"{{ \'Please enter the link to the icon url\' | translate}}\" required></md-input-container><section \nclass=\"section\"><h3 class=\"section__title\">Description</h3></section><md-input-container class=\"md-block\"><textarea \nname=\"bio\" class=\"input-content\" ng-model=\"vm.description\" ng-maxlength=\"1000\" rows=\"7\" md-select-on-focus \naria-label=\"app description\" required></textarea><span ng-show=\"teacherProfileForm.bio.$error.maxlength\" \ntranslate=\"EDIT_TEACHER.BIO_TOO_LONG\"></span></md-input-container><section class=\"section\"><h3 class=\"section__title\">\nPrice</h3></section><md-input-container md-no-float class=\"md-block\" flex-gt-sm><input type=\"number\" \nclass=\"input-content\" step=\"0.01\" min=\"0\" pattern=\"\\d+\\.\\d{1,2}\" ng-model=\"vm.price\" \nplaceholder=\"{{ \'Enter the price of the tool\' | translate}}\" required></md-input-container><section class=\"section\"><h3\n class=\"section__title\">Youtube Video</h3></section><md-input-container md-no-float class=\"md-block\" flex-gt-sm><input \ntype=\"text\" class=\"input-content\" ng-model=\"vm.youtube\" placeholder=\"{{ \'Enter the Youtube link\' | translate}}\">\n</md-input-container></form></section></md-content><div flex=\"25\" flex-offset=\"5\" flex-xs=\"100\"><md-button \nclass=\"md-raised md-primary btn-save\" translate=\"EDIT_TEACHER.SAVE\" ng-click=\"vm.submit()\" \naria-label=\"Save profile changes\" ng-disabled=\"teacherProfileForm.$invalid\"></md-button></div></div></div></div>");
$templateCache.put("app/main/pages/apply-to-teach/apply-to-teach.html","<div id=\"apply-to-teach\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">Join our community of tutors</span></div></div><div class=\"content-container pt-20 pb-10\">\n<md-content class=\"md-padding\"><div class=\"\" layout=\"column\" layout-align=\"center center\"><h1><b>\nDo you love education as much as we do? Join our team!</b></h1><p>\nWe are always looking for more tutors to join our team and teach. Whether you\'re an experienced teaching professional or someone who wants to earn supplemental income while teaching your favorite subject, we want you on our team.\n</p></div></md-content></div><div class=\"content-container section-line\"></div><div \nclass=\"content-container pt-10 pb-20\"><md-content class=\"md-padding\"><div class=\"\" layout=\"column\" \nlayout-align=\"center center\"><p><b>How it works:</b></p><div class=\"icon-container\" layout=\"column\" \nlayout-align=\"space-around center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"space-around start\"><img \nclass=\"numbers\" src=\"assets/images/landing-page/img-landing-page-step-1-number@3x.jpg\"> <img class=\"numbers\" \nsrc=\"assets/images/landing-page/img-landing-page-step-2-number@3x.jpg\"> <img class=\"numbers\" \nsrc=\"assets/images/landing-page/img-landing-page-step-3-number@3x.jpg\"></div><br><br><div class=\"icon-container\" \nlayout=\"row\" layout-align=\"space-around center\"><md-icon class=\"icon md-accent\" md-font-icon=\"icon-account\"></md-icon>\n<br><br><md-icon class=\"icon md-accent\" md-font-icon=\"icon-calendar-text\"></md-icon><br><br><md-icon \nclass=\"icon md-accent\" md-font-icon=\"icon-cash\"></md-icon><br><br></div><br><br><div class=\"icon-container\" \nlayout=\"row\" layout-align=\"space-around start\"><p>\nTell us what you\'d like to teach and your availability, and we\'ll set up a profile for you!</p><p>\nInterested students can book lessons and pay through Nesuku - you can teach online if your student is remote.</p><p>\nNesuku will charge a transaction and commission fee - the rest will be deposited in your bank account immediately after your lesson is complete!\n</p></div></div><md-button class=\"signup md-raised md-primary md-button\" ng-click=\"vm.goToApplyForm()\">Apply to teach\n</md-button></div></md-content></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/become-cp-form/become-cp-form.html","<div id=\"become-cp-form\" class=\"page-layout simple\"><div class=\"content-container pt-20 pb-10\" layout=\"row\" \nlayout-align=\"center center\"><iframe \nsrc=\"https://docs.google.com/forms/d/e/1FAIpQLSdwXGWKLS2biMFvLg4k2Wj13PbIb7jY_AazHRTfBCtIYPjFWA/viewform?embedded=true\" \nwidth=\"1280\" height=\"2500\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\">Loading...</iframe></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/blog/blog.html","<div id=\"blog\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"center center\">\n<div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span class=\"intro-message\">Blog</span>\n</div></div><div class=\"content-container pt-20 pb-10\"><iframe src=\"https://nesuku.wordpress.com/\" width=\"960px\" \nheight=\"1500px\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\"></iframe></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/chat/chat.html","<div id=\"chat-app\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\"><div\n class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/pages/chat/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"!vm.chat\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\" layout=\"row\" layout-align=\"center center\"><md-icon class=\"s128 md-accent\" \nmd-font-icon=\"icon-hangouts\"></md-icon></div><span class=\"app-title\" translate=\"CHAT.APP_TITLE\">Message</span> <span \nclass=\"hide show-gt-sm secondary-text\" translate=\"CHAT.START_MESSAGE\">Select contact to start the chat</span><md-button\n class=\"md-raised hide-gt-md\" ng-click=\"vm.toggleSidenav(\'left-sidenav\')\" translate=\"CHAT.START_MESSAGE\">\nSelect contact to start the chat!..</md-button></div><div ng-if=\"vm.chat\" class=\"chat\" layout=\"column\" flex><md-toolbar\n class=\"chat-toolbar\"><div class=\"md-toolbar-tools\"><md-button \nclass=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-hangouts s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"avatar-wrapper\"><img ng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" \nclass=\"avatar\" alt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"></div><div class=\"chat-contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div></div></md-toolbar><md-content id=\"chat-content\" flex \nms-scroll><div class=\"chat-messages\" ng-if=\"vm.chat\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat\" \nclass=\"md-padding message-row\" ng-class=\"dialog.who\"><img ng-if=\"dialog.who ===\'contact\'\" \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" \nng-src=\"{{vm.user.avatar}}\"><div class=\"bubble\"><div class=\"message\">{{dialog.message}}</div><div \nclass=\"time secondary-text\">{{dialog.time | altDate}}</div></div></div></div></md-content><div \nclass=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\"><form ng-submit=\"vm.reply()\" flex \nclass=\"reply-form\" layout=\"row\" layout-align=\"start center\"><md-input-container flex md-no-float><textarea \nng-keyup=\"vm.reply($event)\" md-no-autogrow ng-model=\"vm.replyMessage\" ng-class=\"{\'grow\': vm.textareaGrow}\" \nplaceholder=\"{{ \'CHAT.REPLY_PLACEHOLDER\' | translate }}\">\n                            </textarea></md-input-container>\n<md-button class=\"md-fab\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"CHAT.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form></div>\n</div><md-sidenav class=\"sidenav right-sidenav md-sidenav-right\" layout=\"column\" md-component-id=\"right-sidenav\" \nms-sidenav-helper ng-include=\"\'app/main/pages/chat/sidenavs/right/right-sidenav.html\'\"></md-sidenav></div></div></div>");
$templateCache.put("app/main/pages/conversation-partners/conversation-partners.html","<div id=\"conversation-partners\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">Practice speaking with a Conversation Coach</span></div></div><div \nclass=\"content-container pt-20 pb-10\"><md-content class=\"md-padding\"><div class=\"\" layout=\"column\" \nlayout-align=\"center center\"><h1><b>\nReady to take your learning to the next level through practice with native speakers?</b></h1><br><br><p>\nWhether your goal is fluency or to be conversational in a new language, regular practice of listening and speaking is critical for language learning. Now you can practice with native speakers in a convenient and casual environment through Nesuku.\n</p><p>In addition to the structured and personalized lessons offered through Nesuku’s tutors, we have launched <b>\n<ins>Conversation coaches</ins></b>, a way for you to practice speaking with native speakers in their language in a <i>\n<b>convenient</b> and <b>casual environment</b></i>.<br></p><div class=\"icon-container\" layout=\"column\" \nlayout-align=\"space-around center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"space-around start\"><img \nclass=\"numbers\" src=\"assets/images/landing-page/img-landing-page-step-1-number@3x.jpg\"> <img class=\"numbers\" \nsrc=\"assets/images/landing-page/img-landing-page-step-2-number@3x.jpg\"></div><br><br><div class=\"icon-container\" \nlayout=\"row\" layout-align=\"space-around center\"><md-icon class=\"icon md-accent\" md-font-icon=\"icon-account\"></md-icon>\n<br><br><md-icon class=\"icon md-accent\" md-font-icon=\"icon-calendar-text\"></md-icon><br><br></div><br><br><div \nclass=\"icon-container\" layout=\"row\" layout-align=\"space-around start\"><p>Tell us your which <b>\nlanguage you want to learn</b> and <b>availability</b>, and we’ll find a conversation partner for you!</p><p>\nInterested students can <b>book lessons and pay</b> through Nesuku at a set rate of <b>US$10 / hour</b></p></div></div>\n<md-button class=\"signup md-raised md-primary md-button\" ng-click=\"vm.goToCPForm()\">Find a conversation coach\n</md-button><p><br><i>\nThrough Conversation coaches, you will be able to schedule time, pay, and meet with language coaches across the world using Nesuku.\n<br><br>Interested in becoming a conversation coach?<br>\nConversation coaches enjoy meeting new people while earning on a flexible schedule.</i></p><md-button \nclass=\"signup md-raised md-primary md-button\" ng-click=\"vm.goToBecomeCPForm()\">Become a conversation coach</md-button>\n</div></md-content></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/covid/covid.html","<div id=\"covid\" class=\"page-layout simple\"><section style=\"background-color: #000\" layout=\"row\"><div flex=\"25\" \nflex-xs=\"0\"></div><div flex=\"50\" flex-xs=\"100\"><div class=\"intrinsic-container intrinsic-container-16x9\"><iframe \nng-src=\"https://www.youtube.com/embed/PBnEAKGh6uc/?controls=1&amp;enablejsapi=1&amp;modestbranding=1&amp;showinfo=0&amp;origin=https%3A%2F%2Fwww.nesuku.com&amp;iv_load_policy=3&amp;html5=1&amp;fs=1&amp;rel=0&amp;hl=en&amp;cc_lang_pref=en&amp;cc_load_policy=1&amp;start=0\" \nframeborder=\"0\" allowfullscreen></iframe></div></div><div flex></div></section><div \nclass=\"content-container pt-20 pb-10\"><md-content class=\"md-padding\"><div class=\"section-title pt-10\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"title-text\">\nSchools are closed. Small businesses and hourly workers are hurting.</span></div><div layout=\"column\" \nlayout-align=\"center start\"><p class=\"pt-20\">\nAs a tutoring marketplace and online learning platform, we know our students and tutors are some of those most impacted by the COVID-19 pandemic. At the same time, we feel it is our responsibility to help our communities continue learning and thriving.\n</p><br><br><p>\nTherefore, for the next month (Until May 15th), we have decided to offer the following services to our communities:</p>\n</div></md-content></div><div class=\"content-container pt-20 pb-10\"><md-content class=\"md-padding\"><div \nclass=\"section-title\" layout=\"row\" layout-align=\"center center\"><img class=\"numbers pr-10\" \nsrc=\"assets/images/landing-page/img-landing-page-step-1-number@3x.jpg\"> <span class=\"title-text\">Current and new tutors\n</span></div><div layout=\"column\" layout-align=\"center start\"><p class=\"pt-20\">\nFor our current tutors, we are here for you. We know that things are likely harder on your families, and we want to give you a break. Therefore, we are \n<span class=\"special-text\">waiving all of our commission and platform usage fees for the next month</span>\n - 100% of the earnings during this month will go to you. We hope this will make things a bit easier for you.</p><br>\n<br><p>\nFor new tutors, we want to make tutoring an option for you to earn supplemental income during these hard times. Therefore, we will offer you \n<span class=\"special-text\">free usage of our platform</span>\n. Teach online at Nesuku to maintain students you can no longer teach in person. Use Nesuku to find new students. We want to help you, and 100% of the earnings will go to you.\n</p></div><div class=\"icon-container\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-primary md-button\" ng-click=\"vm.goToApplyForm()\">Sign up for more info</md-button></div>\n</md-content></div><div class=\"content-container section-line\"></div><div class=\"content-container pt-20 pb-10\">\n<md-content class=\"md-padding\"><div class=\"section-title\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"numbers pr-10\" src=\"assets/images/landing-page/img-landing-page-step-2-number@3x.jpg\"> <span class=\"title-text\">\nStudents and parents</span></div><div layout=\"column\" layout-align=\"center start\"><p class=\"pt-20\">\nWe know that with schools closed, learning will get harder. That’s why we, along with our community of tutors specialized in school subjects, standardized exams, and school applications, have decided to donate our time to get you through this. \n<span class=\"special-text\">Our tutors will be offering free \"20-minute Homework Help\" sessions for the next month.\n</span>\n This means that when you are stuck or don\'t understand what you are reading, you can reach out and we will help. We hope this will ease your mind & help you continue learning.\n</p></div><div class=\"icon-container\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-primary md-button\" ng-click=\"vm.goToHwHelp()\">Try it</md-button></div></md-content></div><div \nclass=\"content-container section-line\"></div><div class=\"content-container pt-20 pb-10\"><md-content class=\"md-padding\">\n<div class=\"section-title\" layout=\"row\" layout-align=\"center center\"><img class=\"numbers pr-10\" \nsrc=\"assets/images/landing-page/img-landing-page-step-3-number@3x.jpg\"> <span class=\"title-text\">Tutoring centers\n</span></div><div layout=\"column\" layout-align=\"center start\"><p class=\"pt-20\">\nWe know small businesses have been hit the hardest. If you need help migrating online, we have a platform to help you schedule, accept payments, & teach online. \n<span class=\"special-text\">We will offer you the platform and guidance to migrate online for free for the next month.\n</span></p></div><div class=\"icon-container\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-primary md-button\" ng-click=\"vm.contactNesuku()\">Email us</md-button></div></md-content></div><div \nclass=\"content-container section-line\"></div><div class=\"content-container pt-20 pb-10\"><div layout=\"column\" \nlayout-align=\"center start\"><p class=\"pt-20\">\nWe are committed to helping you. Our hearts go out to you during this crisis, and we hope to do our part.</p><br><br>\n</div><div layout=\"column\" layout-align=\"center start\"><p>Best,<br>Andy Hsiao</p></div></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/edit-teacher/edit-teacher.html","<div id=\"teacher-edit\" class=\"page-layout simple\"><div class=\"content-container pt-40 pb-40\" layout=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div flex=\"70\" flex-xs=\"100\"><md-tabs md-dynamic-height \nmd-border-bottom><md-tab label=\"description\"><md-content class=\"md-padding\"><section layout=\"column\" layout-wrap><form \nname=\"teacherProfileForm\" novalidate><section class=\"section\"><i class=\"icon-lock-unlocked section__icon\"></i><h3 \nclass=\"section__title\" translate=\"EDIT_TEACHER.PUBLIC\"></h3><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"i_icon\" uib-tooltip=\"{{ \'EDIT_TEACHER.PUBLIC_TIP\' | translate }}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></section><md-input-container md-no-float class=\"md-block\" flex-gt-sm><span \nclass=\"switch-text switch-text--l\" translate=\"EDIT_TEACHER.NO\"></span><md-switch class=\"isPublicProfile\" \nng-model=\"vm.teacher.isPublic\" aria-label=\"Private or public profile?\"></md-switch><span \nclass=\"switch-text switch-text--r\" translate=\"EDIT_TEACHER.YES\">Yes</span><div flex=\"35\" flex-offset=\"5\" flex-xs=\"100\" \nclass=\"btn-sharable\" ng-show=\"!vm.teacher.isPublic\"><md-button class=\"md-raised md-primary\" \ntranslate=\"EDIT_TEACHER.SHARABLE_LINK\" ng-click=\"vm.getSharableLink()\"></md-button><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"i_icon\" \nuib-tooltip=\"{{ \'EDIT_TEACHER.SHARABLE_LINK_TIP\' | translate }}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></div></md-input-container><section class=\"section\"><i \nclass=\"icon-earth section__icon\"></i><h3 class=\"section__title\">Subject</h3></section><section layout=\"row\">\n<md-input-container md-no-float flex=\"50\" flex-xs=\"100\"><md-select ng-model=\"vm.teacher.subjects\" class=\"\" \nplaceholder=\"What subjects can you teach?\" aria-label=\"teach language\" md-no-float=\"true\" multiple=\"multiple\">\n<md-select-header><input type=\"search\" placeholder=\"Search for subjects\" ng-keydown=\"$event.stopPropagation()\" \nng-model=\"vm.searchTerm\" class=\"md-text\"></md-select-header><md-option \nng-repeat=\"subject in vm.subjects |\n              filter:vm.searchTerm\" ng-value=\"subject.id\">{{ subject.name }}\n</md-option></md-select></md-input-container></section><section class=\"section\"><i \nclass=\"icon-square-inc-cash section__icon\"></i><h3 class=\"section__title\">Average hourly price</h3><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"i_icon\" \nuib-tooltip=\"{{ \'EDIT_TEACHER.DEFAULT_PRICE_TIP\' | translate }}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></section><md-input-container md-no-float class=\"md-block\" flex-gt-sm><input \ntype=\"text\" class=\"input-content\" ng-model=\"vm.teacher.defaultPrice\" \nplaceholder=\"Please enter your default hourly price here.\"></md-input-container><section class=\"section\"><i \nclass=\"icon-clipboard-check section__icon\"></i><h3 class=\"section__title\" translate=\"EDIT_TEACHER.POLICY\"></h3><md-icon\n md-font-icon=\"icon-information-outline\" class=\"i_icon\" uib-tooltip=\"{{ \'EDIT_TEACHER.POLICY_TIP\' | translate }}\" \ntooltip-placement=\"right\" tooltip-append-to-body=\"true\"></md-icon></section><label class=\"title\" \ntranslate=\"EDIT_TEACHER.POLICY_Q1\"></label><md-input-container md-no-float class=\"md-block\" flex-gt-sm><input \ntype=\"number\" name=\"schedulePolicy\" class=\"input-content\" step=\"1\" min=\"0\" pattern=\"\\d+\" \nng-model=\"vm.teacher.schedulePolicy\" placeholder=\"{{ \'EDIT_TEACHER.POLICY_PLACEHOLDER\' | translate}}\" \nrequired=\"required\"><div class=\"error-msg\" ng-show=\"vm.teacher.scheduleisNull\" \ntranslate=\"EDIT_TEACHER.POLICY_Q1_REQUIRED\"></div></md-input-container><label class=\"title\" \ntranslate=\"EDIT_TEACHER.POLICY_Q2\"></label><md-input-container md-no-float class=\"md-block\" flex-gt-sm><input \ntype=\"number\" name=\"cancelPolicy\" class=\"input-content\" step=\"1\" min=\"0\" pattern=\"\\d+\" \nng-model=\"vm.teacher.cancelPolicy\" placeholder=\"{{ \'EDIT_TEACHER.POLICY_PLACEHOLDER\' | translate}}\" \nrequired=\"required\"><div class=\"error-msg\" ng-show=\"vm.teacher.cancelisNull\" \ntranslate=\"EDIT_TEACHER.POLICY_Q2_REQUIRED\"></div></md-input-container><section class=\"section\"><i \nclass=\"icon-presentation-play section__icon\"></i><h3 class=\"section__title\" translate=\"EDIT_TEACHER.VIDEO\"></h3>\n<md-icon md-font-icon=\"icon-information-outline\" class=\"i_icon\" \nuib-tooltip=\"{{ \'EDIT_TEACHER.VIDEO_TIP\' | translate }}\" tooltip-placement=\"right\" tooltip-append-to-body=\"true\">\n</md-icon></section><md-input-container md-no-float class=\"md-block\" flex-gt-sm><input type=\"text\" \nclass=\"input-content\" ng-model=\"vm.teacher.introVideo\" placeholder=\"{{ \'EDIT_TEACHER.VIDEO_PLACEHOLDER\' | translate}}\">\n</md-input-container><section class=\"section\"><i class=\"icon-presentation-play section__icon\"></i><h3 \nclass=\"section__title\" translate=\"EDIT_TEACHER.VIDEO_YOUKU\"></h3><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"i_icon\" uib-tooltip=\"{{ \'EDIT_TEACHER.VIDEO_YOUKU_TIP\' | translate }}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></section><md-input-container md-no-float class=\"md-block\" flex-gt-sm><input \ntype=\"text\" class=\"input-content\" ng-model=\"vm.teacher.introVideoYouku\" \nplaceholder=\"{{ \'EDIT_TEACHER.VIDEO_YOUKU_PLACEHOLDER\' | translate}}\"></md-input-container><section class=\"section\"><i \nclass=\"icon-video section__icon\"></i><h3 class=\"section__title\" translate=\"EDIT_TEACHER.SKYPE_ID\"></h3><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"i_icon\" uib-tooltip=\"{{ \'EDIT_TEACHER.SKYPE_ID_TIP\' | translate }}\" \ntooltip-placement=\"right\" tooltip-append-to-body=\"true\"></md-icon></section><p class=\"title no-margin\">\nInput your Zoom personal link here. This will allow students to call you when the lesson time begins. If you haven\'t created an account, pleaese create one at \n<a href=\"https://zoom.us/signup\">Zoom Sign Up</a> and locate your Zoom personal link using <a \nhref=\"https://support.zoom.us/hc/en-us/articles/201362843-What-is-Personal-Meeting-ID-PMI-and-Personal-Link-\">\nthis guide</a>. The link should similar to this format: https://zoom.us/j/XXXXXXXX</p><br><md-input-container \nmd-no-float class=\"md-block\" flex-gt-sm><input type=\"text\" name=\"skype\" class=\"input-content\" \nng-model=\"vm.teacher.videoLink\" placeholder=\"{{ \'EDIT_TEACHER.SKYPE_PLACEHOLDER\' | translate}}\" \nng-required=\"vm.teacher.isPublic\"><div class=\"error-msg\" ng-show=\"teacherProfileForm.skype.$error.required \" \ntranslate=\"EDIT_TEACHER.SKYPE_REQUIRED\"></div></md-input-container><section class=\"section\"><i \nclass=\"icon-human section__icon\"></i><h3 class=\"section__title\" translate=\"EDIT_TEACHER.INTRO\"></h3></section><p \nclass=\"title no-margin\" translate=\"EDIT_TEACHER.INTRO_STATEMENT_1\"></p><p class=\"title no-margin\" \ntranslate=\"EDIT_TEACHER.INTRO_STATEMENT_2\"></p><p class=\"title\" translate=\"EDIT_TEACHER.INTRO_STATEMENT_3\"></p>\n<md-input-container class=\"md-block\"><textarea name=\"bio\" class=\"input-content\" ng-model=\"vm.teacher.bio\" \nng-maxlength=\"1000\" rows=\"7\" md-select-on-focus aria-label=\"Teacher\'s Biography\"></textarea><span \nng-show=\"teacherProfileForm.bio.$error.maxlength\" translate=\"EDIT_TEACHER.BIO_TOO_LONG\"></span></md-input-container>\n</form></section></md-content></md-tab><md-tab label=\"categories & pricing\"><md-content class=\"md-padding\"><section \nlayout=\"column\" layout-wrap><section class=\"section\"><h3 class=\"section__title\" translate=\"EDIT_TEACHER.CATEGORIES\">\n</h3></section><section class=\"section\" layout=\"row\"><table class=\"categoryTable\"><thead><tr><th width=\"10%\">Active\n</th><th width=\"60%\">Category</th><th width=\"20%\">Hourly Price</th><th width=\"10%\">Action</th></tr></thead><tbody><tr \nng-repeat=\"category in vm.categories\"><td><md-checkbox ng-model=\"category.isActive\"></md-checkbox></td><td>\n<md-input-container class=\"md-block\"><input name=\"categoryName\" ng-model=\"category.categoryName\" required>\n</md-input-container></td><td><md-input-container class=\"md-block\"><input name=\"hourlyPrice\" \nng-model=\"category.hourlyPrice\" required></md-input-container></td><td><md-button \nclass=\"md-raised md-primary categoryTable__button\" ng-click=\"vm.updateCategory(category)\">Update</md-button></td></tr>\n<tr><td class=\"orange-bottom\" colspan=\"4\"><md-button class=\"md-fab md-primary categoryTable__button\" \naria-label=\"Add new category\" ng-click=\"vm.createCategory()\"><md-icon md-font-icon=\"icon-plus\" class=\"s24\"></md-icon>\n</md-button><span class=\"title-bold\">Add new category</span></td></tr></tbody></table></section><section \nclass=\"section\"><h3 class=\"section__title\" translate=\"EDIT_TEACHER.CUSTOMIZED_PRICING\"></h3></section><section \nclass=\"section\" layout=\"row\"><table class=\"categoryTable\"><thead><tr><th width=\"20%\">Student Name</th><th \nwidth=\"{{ 70 / vm.categories.length }}%\" ng-repeat=\"category in vm.categories\">{{category.categoryName}}</th><th \nwidth=\"10%\">Action</th></tr></thead><tbody><tr ng-repeat=\" student in vm.customPrices\"><td>{{student.studentName}}</td>\n<td ng-repeat=\"customPrice in student.customPrices\"><md-input-container class=\"md-block\"><input name=\"customPrice\" \nng-model=\"customPrice.hourlyPrice\" required></md-input-container></td><td><md-button \nclass=\"md-raised md-primary categoryTable__button\" ng-click=\"vm.updateCustomPrices(student)\">Update</md-button></td>\n</tr><tr><td class=\"orange-bottom\" colspan=\"{{vm.categories.length+2}}\"><md-button \nclass=\"md-fab md-primary categoryTable__button\" aria-label=\"Add new category\" ng-if=\"!vm.showAddNewStudent\" \nng-click=\"vm.showAddNewStudent = true\"><md-icon md-font-icon=\"icon-plus\" class=\"s24\"></md-icon></md-button><span \nclass=\"title-bold\">Add new student</span></td></tr><tr ng-if=\"vm.showAddNewStudent\"><td \ncolspan=\"{{vm.categories.length+2}}\" ng-if=\"true\"><br><section ng-if=\"vm.isNewStudent\" class=\"section\">\n<md-input-container class=\"md-block\" ng-if=\"vm.isNewStudent\"><input type=\"email\" name=\"email\" ng-model=\"vm.email\" \nng-pattern=\"/^.+@.+\\..+$/\" required></md-input-container><i class=\"icon-email section__icon\"></i><h3 \nclass=\"section__title\" translate=\"LESSON_REQUEST.EMAIL\"></h3></section><select ui-select2=\"vm.statusOpt\" \nname=\"studentEmail\" ng-if=\"!vm.isNewStudent\" ng-model=\"vm.email\" style=\"width:100%\"><option value=\"\">Choose a student\n</option><option ng-repeat=\"student in vm.students\" ng-value=\"student.email\">{{ student | standardDropdownFilter }}\n</option></select><section class=\"section\" ng-if=\"vm.isNewStudent\"><md-input-container class=\"md-block\"><input \ntype=\"text\" name=\"name\" ng-model=\"vm.name\" required></md-input-container><i class=\"icon-account section__icon\"></i><h3 \nclass=\"section__title\" translate=\"LESSON_REQUEST.NAME\"></h3></section><md-button class=\"md-default\" \nstyle=\"color:#ffb74d\" translate=\"LESSON_REQUEST.NEW_STUDENT\" ng-if=\"!vm.isNewStudent\" \nng-click=\"vm.showOrHideExistStudent()\"></md-button><md-button class=\"md-default\" style=\"color:#ffb74d\" \ntranslate=\"LESSON_REQUEST.EXIST_STUDENT\" ng-if=\"vm.isNewStudent\" ng-click=\"vm.showOrHideExistStudent()\"></md-button>\n<section style=\"float:right\"><md-button class=\"md-raised md-primary btn-submit\" translate=\"EDIT_TEACHER.ADD\" \nng-click=\"vm.createCustomPrices(vm.email, vm.name)\" \nng-disabled=\"!vm.email || (!vm.email && !vm.name && vm.isNewStudent)\"></md-button></section></td></tr></tbody></table>\n</section></section></md-content></md-tab><md-tab label=\"account settings\"><md-content class=\"md-padding\"><section \nlayout=\"column\" layout-wrap><section class=\"section\"><i class=\"icon-account-circle section__icon\"></i><h3 \nclass=\"section__title\" translate=\"TEACHER_DASHBOARD.EDIT_PROFILE_PICTURE\"></h3></section><div \nclass=\"accountSetting__btn\"><md-button class=\"md-raised md-primary btn-save\" \ntranslate=\"TEACHER_DASHBOARD.EDIT_PROFILE_PICTURE\" ng-click=\"vm.editProfilePic()\"></md-button></div><br><br><section \nclass=\"section\"><i class=\"icon-lock section__icon\"></i><h3 class=\"section__title\" \ntranslate=\"TEACHER_DASHBOARD.CHANGE_PASSWORD\"></h3></section><div class=\"accountSetting__btn\"><md-button \nclass=\"md-raised md-primary btn-save\" translate=\"TEACHER_DASHBOARD.CHANGE_PASSWORD\" ng-click=\"vm.changePassword()\">\n</md-button></div><br><br><section class=\"section\"><i class=\"icon-lock section__icon\"></i><h3 class=\"section__title\">\nBank Account</h3></section><div class=\"accountSetting__btn\"><a ng-if=\"!vm.teacher.hasConnectedStripe\" \nng-href=\"https://connect.stripe.com/oauth/authorize?response_type=code&client_id={{ vm.stripeClientId }}&scope=read_write\">\n<md-button class=\"md-raised md-primary btn-save\" translate=\"EDIT_TEACHER.STRIPE_CONNECT\" aria-label=\"Connect Stripe\" \ntitle=\"This will connect you to our payment system, Stripe, to allow you to get paid through our website.  Please contact us if you have further questions.\">\n</md-button></a><a ng-if=\"vm.teacher.hasConnectedStripe\" ng-href=\"https://dashboard.stripe.com\"><md-button \nclass=\"md-raised md-primary btn-save\" translate=\"EDIT_TEACHER.STRIPE_DASHBOARD\" aria-label=\"Stripe Dashboard\">\n</md-button></a></div></section></md-content></md-tab></md-tabs></div><div flex=\"25\" flex-offset=\"5\" flex-xs=\"100\">\n<md-button class=\"md-raised md-primary btn-save\" translate=\"EDIT_TEACHER.SAVE\" ng-click=\"vm.submit()\" \naria-label=\"Save profile changes\" \nng-disabled=\"teacherProfileForm.$invalid || vm.teacher.scheduleisNull || vm.teacher.cancelisNull\"></md-button></div>\n</div></div>");
$templateCache.put("app/main/pages/essay-review/essay-review.html","<div id=\"essay-review\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">Essay Review</span></div></div><div class=\"content-container pt-20 pb-10\"><md-content \nclass=\"md-padding\"><div class=\"\" layout=\"column\" layout-align=\"center center\"><h1><b>1. Chosen Essay Reviewer</b></h1>\n<div layout=\"column\" layout-align=\"center center\" class=\"pt-10 safari-height\"><img class=\"header__avatar\" \nng-src=\"{{ vm.teacherInfo.avatar ? vm.teacherInfo.avatar : \'assets/images/avatars/profile.jpg\' }}\" \nalt=\"Teacher\'s Avatar\"> <span class=\"teacher-name pt-5\">{{ vm.teacherInfo.name }}</span></div></div></md-content></div>\n<div class=\"content-container pt-10 pb-10\"><md-content class=\"md-padding\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><h1><b>2. Select a service</b></h1><div class=\"checkbox\" layout=\"column\" \nlayout-align=\"center start\"><md-checkbox ng-model=\"vm.essayType\" ng-true-value=\"1\">\nCollege Essay Final Review (2RMB / word)</md-checkbox><md-checkbox ng-model=\"vm.essayType\" ng-true-value=\"2\">\nCollege Essay Package (7000RMB / set)</md-checkbox><md-checkbox ng-model=\"vm.essayType\" ng-true-value=\"3\">\nTOEFL/IELTS Essay (2RMB / word)</md-checkbox><md-checkbox ng-model=\"vm.essayType\" ng-true-value=\"4\">SAT Essay (200RMB)\n</md-checkbox><md-checkbox ng-model=\"vm.essayType\" ng-true-value=\"5\">Academic Writing Essay (1USD /10 words)\n</md-checkbox></div></div></md-content></div><div class=\"content-container pt-10 pb-20\"><md-content class=\"md-padding\">\n<div class=\"content\" layout=\"column\" layout-align=\"center center\"><h1><b>3. Submit your essay(s)</b></h1><div \nclass=\"full-width\" layout=\"column\" layout-align=\"start start\"><md-input-container \nclass=\"md-block full-width essay-text mt-30\"><label ng-if=\"vm.essayType == 1 || vm.essayType == 2\">Personal Essay\n</label><label ng-if=\"vm.essayType == 3\">TOEFL/IELTS Essay</label><label ng-if=\"vm.essayType == 4\">SAT Essay</label>\n<label ng-if=\"vm.essayType == 5\">Academic Essay</label><textarea class=\"full-width\" ng-model=\"vm.essayText\" rows=\"10\" \nmd-select-on-focus></textarea><div class=\"align-right pt-10\">Word Count: <span ng-bind=\"vm.countOf(vm.essayText)\">\n</span></div></md-input-container></div><div ng-if=\"vm.essayType == 2\" class=\"full-width\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container md-no-float=\"\" class=\"md-block full-width essay-text mt-30\"><label>File\n</label><input placeholder=\"Non-Floating Label\" class=\"file\" type=\"file\" name=\"file\" file=\"vm.rec1File\">\n</md-input-container></div><div ng-if=\"vm.essayType == 2\" class=\"full-width\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container md-no-float=\"\" class=\"md-block full-width essay-text mt-30\"><label>\nRecommendation Letter 2</label><input placeholder=\"Non-Floating Label\" class=\"file\" type=\"file\" name=\"file\" \nfile=\"vm.rec2File\"></md-input-container></div><div ng-if=\"vm.essayType == 2\" class=\"full-width\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container md-no-float=\"\" class=\"md-block full-width essay-text mt-30\"><label>CV\n</label><input placeholder=\"Non-Floating Label\" class=\"file\" type=\"file\" name=\"file\" file=\"vm.cvFile\">\n</md-input-container></div></div></md-content></div><div class=\"pb-10\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-raised md-primary btn-begin-session\" ng-click=\"vm.goToPayment()\">Submit</md-button></div></div>\n<div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/essays/essays.html","<div id=\"essays\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"center center\">\n<div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span class=\"intro-message\">\nEssay Review</span></div></div><div class=\"content-container pt-20 pb-10\"><md-content class=\"md-padding\"><div \nclass=\"text-center\" layout=\"column\" layout-align=\"center center\"><h1><b>Get your essay reviewed by experts</b></h1><br>\n<br><p>Our reviewers have the experience to help you put your thoughts onto paper.</p></div></md-content></div><div \nclass=\"content-container section-line\"></div><md-content class=\"content-container md-padding\"><div class=\"text-center\" \nlayout=\"column\" layout-align=\"center center\"><h1><b>Our services</b></h1><br><br><div class=\"widget-group width-full\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">A</div><div class=\"h3 secondary-text font-weight-500\" \nlayout=\"column\" layout-align=\"center center\"><span class=\"mb-5\">College App Essay</span> <span>Full Package</span>\n</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"center center\" ng-click=\"flipWidget()\">\n<span class=\"h4 secondary-text text-truncate\">Details</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"text-start\"><p>2hr+ training</p><p>Brainstorming draft</p><p>\nReview/Revise x3 times</p><p>Professional english review</p><p>Review by Admissions Officer</p></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n</div><div class=\"pt-8 pb-32 ph-30\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"red-fg font-size-72 line-height-72\">B</div><div class=\"h3 secondary-text font-weight-500\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"mb-5\">College App Essay</span> <span>Step by Step</span></div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"center center\" ng-click=\"flipWidget()\"><span \nclass=\"h4 secondary-text text-truncate\">Details</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div layout=\"column\" layout-align=\"center start\"><div\n class=\"text-start\"><p>2hr+ training</p><p>Brainstorming draft</p><p>Review/Revise x3 times</p></div></div>\n</ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n<ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\">\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"orange-fg font-size-72 line-height-72\">C</div><div class=\"h3 secondary-text font-weight-500\" layout=\"column\" \nlayout-align=\"center center\"><span class=\"mb-5\">College App Essay</span> <span>Pro English Review</span></div></div>\n<div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"center center\" ng-click=\"flipWidget()\"><span \nclass=\"h4 secondary-text text-truncate\">Details</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div layout=\"column\" layout-align=\"center start\"><div\n class=\"text-start\"><p>Review by professional english writer</p></div></div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"></div><div class=\"pt-8 pb-32\" \nlayout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">D</div><div \nclass=\"h3 secondary-text font-weight-500\" layout=\"column\" layout-align=\"center center\"><span class=\"mb-5\">SAT Exam\n</span> <span>Essay review</span></div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"center center\" ng-click=\"flipWidget()\"><span class=\"h4 secondary-text text-truncate\">Details</span></div>\n</ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div layout=\"column\" layout-align=\"center start\"><div class=\"text-start\"><p>Review practice essays</p><p>\nReceive professional advice</p></div></div></ms-widget-back></ms-widget></div></div></md-content><div \nclass=\"content-container pt-10 pb-10\"></div><div class=\"content-container section-line\"></div><div \nclass=\"content-container pt-10 pb-60\"><md-content class=\"md-padding\"><div class=\"text-center\" layout=\"column\" \nlayout-align=\"center center\"><h1><b>Meet our reviewers</b></h1><br><br></div><div class=\"language-container\" ng-cloak>\n<md-tabs class=\"tabbed-lang\" md-dynamic-height md-center-tabs=\"true\"><md-tab><md-tab-label><span>Service A</span>\n</md-tab-label><md-tab-body><div class=\"teacher-card-container\" ng-model=\"vm.teacher\" layout=\"row\" \nlayout-align=\"center center\" layout-align-xs=\"start center\"><md-card class=\"teacher-card\" \nng-click=\"vm.goToTeacher(159)\"><div class=\"image_gradient\"></div><img src=\"assets/images/landing-page/vmeng.jpg\">\n<md-card-content layout=\"column\" layout-align=\"center center\" class=\"teacher-content\"><h2>Victoria Meng</h2><div \nclass=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" \nclass=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" \nclass=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card>\n<md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(161)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/dgu.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Donna Gu</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Service B</span>\n</md-tab-label><md-tab-body><div class=\"teacher-card-container\" ng-model=\"vm.teacher\" layout=\"row\" \nlayout-align=\"center center\" layout-align-xs=\"start center\"><md-card class=\"teacher-card\" \nng-click=\"vm.goToTeacher(159)\"><div class=\"image_gradient\"></div><img src=\"assets/images/landing-page/vmeng.jpg\">\n<md-card-content layout=\"column\" layout-align=\"center center\" class=\"teacher-content\"><h2>Victoria Meng</h2><div \nclass=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" \nclass=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" \nclass=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card>\n<md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(161)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/dgu.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Donna Gu</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(160)\"><div \nclass=\"image_gradient\"></div><img src=\"assets/images/landing-page/vwang.jpg\"><md-card-content layout=\"column\" \nlayout-align=\"center center\" class=\"teacher-content\"><h2>Victoria Wang</h2><div class=\"star-row\"><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span>Service C</span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" layout=\"row\" \nlayout-align=\"center center\"><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(160)\"><div class=\"image_gradient\">\n</div><img src=\"assets/images/landing-page/vwang.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Victoria Wang</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab><md-tab-label><span>Service D</span>\n</md-tab-label><md-tab-body><div class=\"teacher-card-container\" layout=\"row\" layout-align=\"center center\"><md-card \nclass=\"teacher-card\" ng-click=\"vm.goToTeacher(159)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/vmeng.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Victoria Meng</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(161)\"><div \nclass=\"image_gradient\"></div><img src=\"assets/images/landing-page/dgu.jpg\"><md-card-content layout=\"column\" \nlayout-align=\"center center\" class=\"teacher-content\"><h2>Donna Gu</h2><div class=\"star-row\"><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab>\n</md-tabs></div></md-content></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/find-a-tutor/find-a-tutor.html","<div id=\"find-a-tutor\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">{{ vm.categoryTitle }}</span></div></div><div class=\"content-container main-content pt-20 pb-10\">\n<div ng-if=\"vm.category == \'academic\'\"><div layout=\"row\" layout-align=\"center center\"><h2 class=\"hide-xs\">\nMeet some of our tutors</h2></div><div class=\"card-container\" layout-align=\"start center\" \nlayout-align-gt-xs=\"center center\"><md-card class=\"hide-gt-xs\"><a class=\"undo-underline undo-hover\" \nhref=\"https://www.nesuku.com/teacher-list/teacher\"><md-card-content class=\"mt-100\"><h2>Meet some of our tutors</h2>\n</md-card-content></a></md-card><md-card><a href=\"https://www.nesuku.com/teacher/58\"><div class=\"md-card-image emily\">\n</div><md-card-title><md-card-title-text><span class=\"md-headline\">Emily H.</span> <span class=\"md-headline\"><b>\nHarvard, MIT, UPenn</b></span></md-card-title-text></md-card-title><md-card-content><p>\nTeaches math, statistics, SAT, GRE, economics, writing, & advises college and MBA applications.</p></md-card-content>\n</a></md-card><md-card><a href=\"https://www.nesuku.com/teacher/32\"><div class=\"md-card-image tim\"></div><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Tim C.</span> <span class=\"md-headline\"><b>U-Michigan, Arizona</b></span>\n</md-card-title-text></md-card-title><md-card-content><p>\nFormer high school teacher and current college lecturer who teaches math, physics, Tai Chi, & music!</p>\n</md-card-content></a></md-card><md-card><a href=\"https://www.nesuku.com/teacher/164\"><div \nclass=\"md-card-image rachel\"></div><md-card-title><md-card-title-text><span class=\"md-headline\">Rachel H.</span> <span \nclass=\"md-headline\"><b>Harvard and MIT</b></span></md-card-title-text></md-card-title><md-card-content><p>\nTeaches math, biology, biochem, genetics, physics, SAT, GRE, fitness, & advises college and MBA applications.</p>\n</md-card-content></a></md-card><md-card><a class=\"undo-underline\" href=\"https://www.nesuku.com/teacher-list/teacher\">\n<md-card-content class=\"mt-100\"><h2>Explore more tutors<md-icon class=\"arrow\" md-font-icon=\"icon-arrow-right\">\n</md-icon></h2></md-card-content></a></md-card></div><div layout=\"row\" layout-align=\"center center\"><p \nclass=\"sentence\">\nLooking to connect with a tutor, but don’t where to start? We can help. Answer a few quick questions, and we will contact you with a match within 24 hours!\n</p></div><div layout=\"row\" layout-align=\"center center\"><a class=\"typeform-share button mt-20 mb-20\" \nhref=\"https://support929016.typeform.com/to/brSA36\" data-mode=\"popup\" \nstyle=\"display:inline-block;text-decoration:none;background-color:#267DDD;color:white;cursor:pointer;font-family:Helvetica,Arial,sans-serif;font-size:20px;line-height:50px;text-align:center;height:50px;padding:0px 33px;border-radius:25px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale\" \ntarget=\"_blank\">Get Matched</a></div></div><div ng-if=\"vm.category == \'lifestyle\'\"><div layout=\"row\" \nlayout-align=\"center center\"><h2 class=\"hide-xs\">Meet some of our instructors</h2></div><div class=\"card-container\" \nlayout-align=\"start center\" layout-align-gt-xs=\"center center\"><md-card class=\"hide-gt-xs\"><a \nclass=\"undo-underline undo-hover\" href=\"https://www.nesuku.com/teacher-list/teacher\"><md-card-content class=\"mt-100\">\n<h2>Meet some of our instructors</h2></md-card-content></a></md-card><md-card><a \nhref=\"https://www.nesuku.com/teacher/183\"><div class=\"md-card-image miwa\"></div><md-card-title><md-card-title-text>\n<span class=\"md-headline\">Miwa K.</span> <span class=\"md-headline\"><b>Japanese Cooking</b></span></md-card-title-text>\n</md-card-title><md-card-content><p>Instructs Japanese homemade dishes, okonomiyaki, & sushi roll courses.</p>\n</md-card-content></a></md-card><md-card><a href=\"https://www.nesuku.com/teacher/176\"><div \nclass=\"md-card-image tracey\"></div><md-card-title><md-card-title-text><span class=\"md-headline\">Tracey J.</span> <span \nclass=\"md-headline\"><b>Art & Drawing</b></span></md-card-title-text></md-card-title><md-card-content><p>\nTeaches art, painting, identity and culture, & more!</p></md-card-content></a></md-card><md-card><a \nhref=\"https://www.nesuku.com/teacher/177\"><div class=\"md-card-image michelle\"></div><md-card-title><md-card-title-text>\n<span class=\"md-headline\">Michelle C.</span> <span class=\"md-headline\"><b>Ceramics</b></span></md-card-title-text>\n</md-card-title><md-card-content><p>Instructs with clay and walks through the basics fundamentals of hand building.</p>\n</md-card-content></a></md-card><md-card><a class=\"undo-underline\" href=\"https://www.nesuku.com/teacher-list/teacher\">\n<md-card-content class=\"mt-100\"><h2>Explore more instructors<md-icon class=\"arrow\" md-font-icon=\"icon-arrow-right\">\n</md-icon></h2></md-card-content></a></md-card></div><div layout=\"row\" layout-align=\"center center\"><a \nclass=\"typeform-share button mt-20 mb-20\" href=\"https://support929016.typeform.com/to/guAMPl\" data-mode=\"popup\" \nstyle=\"display:inline-block;text-decoration:none;background-color:#267DDD;color:white;cursor:pointer;font-family:Helvetica,Arial,sans-serif;font-size:20px;line-height:50px;text-align:center;height:50px;padding:0px 33px;border-radius:25px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale\" \ntarget=\"_blank\">Get Matched</a></div></div><div ng-if=\"vm.category == \'college\'\"><div layout=\"row\" \nlayout-align=\"center center\"><h2 class=\"hide-xs\">Meet some of our advisors</h2></div><div class=\"card-container\" \nlayout-align=\"start center\" layout-align-gt-xs=\"center center\"><md-card class=\"hide-gt-xs\"><a \nclass=\"undo-underline undo-hover\" href=\"https://www.nesuku.com/teacher-list/teacher\"><md-card-content class=\"mt-100\">\n<h2>Meet some of our tutors</h2></md-card-content></a></md-card><md-card><a href=\"https://www.nesuku.com/teacher/32\">\n<div class=\"md-card-image tim\"></div><md-card-title><md-card-title-text><span class=\"md-headline\">Tim C.</span> <span \nclass=\"md-headline\"><b>U-Michigan, Arizona</b></span></md-card-title-text></md-card-title><md-card-content><p>\nCurrent college lecturer who specializes in STEM applications.</p></md-card-content></a></md-card><md-card><a \nhref=\"https://www.nesuku.com/teacher/185\"><div class=\"md-card-image sam\"></div><md-card-title><md-card-title-text><span\n class=\"md-headline\">Sam S.</span> <span class=\"md-headline\"><b>Lewis & Clark</b></span></md-card-title-text>\n</md-card-title><md-card-content><p>Guides students in brainstorming, writing, and editing college essays.</p>\n</md-card-content></a></md-card><md-card><a href=\"https://www.nesuku.com/teacher/61\"><div \nclass=\"md-card-image youssouf\"></div><md-card-title><md-card-title-text><span class=\"md-headline\">Youssouf C.</span> \n<span class=\"md-headline\"><b>Harvard & UPenn</b></span></md-card-title-text></md-card-title><md-card-content><p>\nConducts mock interviews and resume building workshops.</p></md-card-content></a></md-card><md-card><a \nclass=\"undo-underline\" href=\"https://www.nesuku.com/teacher-list/teacher\"><md-card-content class=\"mt-100\"><h2>\nExplore more advisors<md-icon class=\"arrow\" md-font-icon=\"icon-arrow-right\"></md-icon></h2></md-card-content></a>\n</md-card></div><div layout=\"row\" layout-align=\"center center\"><a class=\"typeform-share button mt-20 mb-20\" \nhref=\"https://support929016.typeform.com/to/miTvzx\" data-mode=\"popup\" \nstyle=\"display:inline-block;text-decoration:none;background-color:#267DDD;color:white;cursor:pointer;font-family:Helvetica,Arial,sans-serif;font-size:20px;line-height:50px;text-align:center;height:50px;padding:0px 33px;border-radius:25px;max-width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:bold;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale\" \ntarget=\"_blank\">Get Matched</a></div></div></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\">\n</div>");
$templateCache.put("app/main/pages/find-cp-form/find-cp-form.html","<div id=\"find-cp-form\" class=\"page-layout simple\"><div class=\"content-container pt-20 pb-10\" layout=\"row\" \nlayout-align=\"center center\"><iframe \nsrc=\"https://docs.google.com/forms/d/e/1FAIpQLSc08F0Qv7RVheQ4urhJIjVfQShbMl1_mwuALc0mPLyIvS-8pA/viewform?embedded=true\" \nwidth=\"1280\" height=\"2500\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\">Loading...</iframe></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/find-teacher-form/find-teacher-form.html","<div id=\"find-teacher-form\" class=\"page-layout simple\"><div class=\"content-container pt-20 pb-10\" layout=\"row\" \nlayout-align=\"center center\"><iframe \nsrc=\"https://docs.google.com/forms/d/e/1FAIpQLSd6JC7Pxt5BYOnhdVoRinw2ir84URmyqi5cHl0q_nQxVZuvhw/viewform?embedded=true\" \nwidth=\"1280\" height=\"3000\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\">Loading...</iframe></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/free/free.html","<div id=\"free\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"center center\">\n<div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span class=\"intro-message\">\nFree Consultations and Trial Lessons</span></div></div><div class=\"content-container pt-20 pb-10\"><md-content \nclass=\"md-padding\"><div class=\"\" layout=\"column\" layout-align=\"center center\"><h1><b>\nWe know it’s hard to find the ‘right’ teacher.</b></h1><p>\nWe also know that in order to learn effectively, you need good ‘teacher-student’ fit. That’s why <b>\nwe are here to help you.</b></p></div></md-content></div><div class=\"content-container pt-10 pb-10\"><md-content \nclass=\"md-padding\"><div class=\"\" layout=\"column\" layout-align=\"center center\"><img \nng-src=\"assets/images/free/free-consultation.jpeg\"><p class=\"ng-scope\"><br>For every student, we offer a <b>\nfree consultation service</b>\n to recommend you a teacher that fits your needs (Are you learning for business, travel, school, or do you have another goal? Do you need a teacher who specializes in teaching children? Do you need teacher who specializes in a language proficiency exams, such as TOEFL or the HSK?). Just check the box when you \n<a href=\"https://www.nesuku.com/register\">sign up</a>, <a href=\"\" ng-click=\"vm.contactNesuku_freeConsultation()\">\ndrop us a line</a> or speak with us through our chat box below (to the right)!</p></div></md-content></div><div \nclass=\"content-container pt-10 pb-20\"><md-content class=\"md-padding\"><div class=\"\" layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"assets/images/free/free-trials.jpeg\"><p class=\"ng-scope\"><br>\nWe know, however, that just because we feel that the teacher is right for you, you may not. That’s why we offer a free 30-min trial lesson for all of our students. Feel free to message any of our teachers by clicking the\n<md-button class=\"md-raised btn-action btn-send-message\">Message Teacher</md-button>\nbutton on any teacher profile, or we would be happy to arrange it for you if you check the box when you <a \nhref=\"https://www.nesuku.com/register\">sign up</a>, <a href=\"\" ng-click=\"vm.contactNesuku_freeTrial()\">send us an email\n</a>, or speak with us through our chat box!</p></div></md-content></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/help-center/help-center.html","<div id=\"help-center\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\" translate=\"HELP_CENTER.TITLE\">Student Support Center</span> <span \nng-click=\"vm.goToTeacherView()\" class=\"switch\" layout=\"row\" layout-align=\"center center\"><text \ntranslate=\"HELP_CENTER.GO_TO_TEACHER\">Go to teacher support center</text><md-icon md-font-icon=\"icon-arrow-right\" \nclass=\"arrow\"></md-icon></span></div></div><div class=\"content-container pt-20 pb-20\"><div layout=\"row\" \nclass=\"centent-title\" translate=\"HELP_CENTER.WHAT_CAN_WE_HELP\">What can we help you with?</div><md-content \nclass=\"md-padding\"><div layout=\"row\" layout-align=\"space-between start\"><div flex=\"25\" flex-xs=\"100\" \nclass=\"column-left\"><md-list flex ng-cloak><md-list-item ng-click=\"vm.setArticleContent(\'whyNesuku\')\"><p \ntranslate=\"HELP_CENTER.WHY_NESUKU\">Why Nesuku</p></md-list-item><md-list-item \nng-click=\"vm.setArticleContent(\'gettingStarted\')\"><p translate=\"HELP_CENTER.GETTING_STARTED\">Getting Started</p>\n</md-list-item><md-list-item ng-click=\"vm.setArticleContent(\'findATeacher\')\"><p translate=\"HELP_CENTER.FIND_A_TEACHER\">\nFind a Teacher</p></md-list-item><md-list-item ng-click=\"vm.setArticleContent(\'scheduleALesson\')\"><p \ntranslate=\"HELP_CENTER.SCHEDULE_A_LESSON\">Schedule a Lesson</p></md-list-item><md-list-item \nng-click=\"vm.setArticleContent(\'payForALesson\')\"><p translate=\"HELP_CENTER.PAY_FOR_A_LESSON\">Pay for a Lesson</p>\n</md-list-item><md-list-item ng-click=\"vm.setArticleContent(\'takeALesson\')\"><p translate=\"HELP_CENTER.TAKE_A_LESSON\">\nTake a Lesson</p></md-list-item><md-list-item ng-click=\"vm.setArticleContent(\'reviews\')\"><p \ntranslate=\"HELP_CENTER.REVIEWS\">Reviews</p></md-list-item></md-list></div><div flex=\"70\" flex-xs=\"100\" \nclass=\"column-right\"><div ng-if=\"vm.currentArticle == \'whyNesuku\' \"><h1 class=\"article-title\" \ntranslate=\"HELP_CENTER.WHY_NESUKU\">Why Nesuku</h1><h2 class=\"article-subtitle\" translate=\"HELP_CENTER.1\">Convenience\n</h2><p translate=\"HELP_CENTER.2\"><b>No more long commutes</b>\n to lessons or making sure you and your teacher have an optimal place to meet. Take a lesson from the comfort of your own home.\n</p><h2 class=\"article-subtitle\" translate=\"HELP_CENTER.3\">Flexibility</h2><p translate=\"HELP_CENTER.4\">Nesuku is <b>\nwherever you want, whenever you want.</b>\n Schedule a lesson at your own convenience with the teacher that works best for you.</p><h2 class=\"article-subtitle\" \ntranslate=\"HELP_CENTER.5\">Global Connection</h2><p translate=\"HELP_CENTER.6\">\nNesuku\'s teachers and students span multiple continents and countries. Opening a door to Nesuku means opening <b>\na door to a truly international world.</b></p><h2 class=\"article-subtitle\" translate=\"HELP_CENTER.7\">Customization</h2>\n<p translate=\"HELP_CENTER.8\">All of our teachers will <b>personalize the lessons</b>\n towards your goals and your learning style.</p></div><div ng-if=\"vm.currentArticle == \'gettingStarted\' \"><h1 \nclass=\"article-title\" translate=\"HELP_CENTER.GETTING_STARTED\">Getting Started</h1><p></p><p translate=\"HELP_CENTER.9\">\nAfter signing up, you will be redirecting to your home page, the teacher dashboard. In order to set up your profile, you can start by \n<b>setting your profile picture</b> by clicking the <b>\"edit profile picture\"</b>\n button and choosing the image you would like to use from your device.</p><br><br><img \nng-src=\"assets/images/help-center/student_edit_profile.jpeg\" style=\"display:block; border: 1px #efeaea solid\"><p></p>\n</div><div ng-if=\"vm.currentArticle == \'findATeacher\' \"><h1 class=\"article-title\" \ntranslate=\"HELP_CENTER.FIND_A_TEACHER\">Find a Teacher</h1><p></p><p translate=\"HELP_CENTER.10\">\nTo find a teacher, click the <b>\"Browse Teachers\"</b> button on the top navigation toolbar.</p><br><br><img \nng-src=\"assets/images/help-center/browse_teacher_nav.jpeg\" style=\"display:block; border: 1px #efeaea solid\"><br><br><p \ntranslate=\"HELP_CENTER.11\">Next, <b>choose the language</b> you would like to learn on the left column and <b>\nclick on the teacher that you are interested in.</b></p><br><br><img \nng-src=\"assets/images/help-center/teacher_list.jpeg\" style=\"display:block; border: 1px #efeaea solid\"><br><br><p></p>\n<h2 class=\"article-subtitle\" translate=\"HELP_CENTER.12\">Get a Free Trial Lesson</h2><p></p><p \ntranslate=\"HELP_CENTER.13\">To get a free trial lesson, click on the <b>\"Message Teacher\" button</b> at the top and <b>\nwrite a message explaining your background and goals.</b>\n Make sure to let that teacher know you would like a free trial lesson.</p><img \nng-src=\"assets/images/help-center/message.jpeg\" style=\"display:block; margin:auto; border: 1px #efeaea solid\"><p></p>\n</div><div ng-if=\"vm.currentArticle == \'scheduleALesson\' \"><h1 class=\"article-title\" \ntranslate=\"HELP_CENTER.SCHEDULE_A_LESSON\">Schedule a Lesson</h1><p></p><p translate=\"HELP_CENTER.14\">\nTo schedule a lesson with a teacher, first <b>go to the teacher\'s profile page.</b>\n Scroll down to their calendar and click and drag a time slot. Be aware of the color representations.</p><br><br><br><b\n style=\"text-align: center; font-size: 20px; display:block; margin:auto\" translate=\"HELP_CENTER.15\">\nClick and drag to schedule a lesson</b><br><br><img ng-src=\"assets/images/help-center/legend.jpeg\" \nstyle=\"display:block; margin:auto; width:60%\"><br><br><img ng-src=\"assets/images/help-center/schedule_lesson.gif\" \nstyle=\"display:block; margin:auto; border: 1px #efeaea solid\"><p></p></div><div \nng-if=\"vm.currentArticle == \'payForALesson\' \"><h1 class=\"article-title\" translate=\"HELP_CENTER.PAY_FOR_A_LESSON\">\nPay for a Lesson</h1><p></p><p translate=\"HELP_CENTER.16\"><b>After you have received a notification</b>\n that the teacher has accepted your lesson request time, <b>go to your dashboard and click \"Accept\"</b></p><br><br><img\n ng-src=\"assets/images/help-center/accept_price.jpeg\" style=\"display:block; margin:auto; border: 1px #efeaea solid\">\n<br><br><p translate=\"HELP_CENTER.17\">A Stripe pop-up should appear. You can then <b>input your payment information</b>\n here and click \"Pay\".</p><br><br><img ng-src=\"assets/images/help-center/stripe_pay.jpeg\" \nstyle=\"display:block; margin:auto; border: 1px #efeaea solid\"><p></p></div><div \nng-if=\"vm.currentArticle == \'takeALesson\' \"><h1 class=\"article-title\" translate=\"HELP_CENTER.TAKE_A_LESSON\">\nTake a Lesson</h1><p></p><p translate=\"HELP_CENTER.18\">To begin the lesson, go to your dashboard and <b>\nfind the upcoming lessons list.</b> Once you find the lesson, <b>click \"Begin\"</b>\n and it will open your Skype and will <b>automatically call your teacher.</b></p><br><br><img \nng-src=\"assets/images/help-center/begin_lesson.jpeg\" style=\"display:block; margin:auto; border: 1px #efeaea solid\"><br>\n<br><img ng-src=\"assets/images/help-center/skype_call.jpeg\" \nstyle=\"display:block; margin:auto; border: 1px #efeaea solid\"><p></p></div><div \nng-if=\"vm.currentArticle == \'reviews\' \"><h1 class=\"article-title\" translate=\"HELP_CENTER.REVIEWS\">Reviews</h1><p></p><p\n translate=\"HELP_CENTER.19\">\nAfter the lesson, you can give the teacher a review and rating. If you go to your dashboard and <b>\nfind the \"Previous Lessons\" list, click the \"Rate your lesson\" button</b> on the right side.</p><br><br><img \nng-src=\"assets/images/help-center/previous_lessons.jpeg\" style=\"display:block; margin:auto; border: 1px #efeaea solid\">\n<br><br><img ng-src=\"assets/images/help-center/rate_lesson.jpeg\" \nstyle=\"display:block; margin:auto; border: 1px #efeaea solid\"><p></p></div></div></div></md-content></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/help-center-teacher/help-center-teacher.html","<div id=\"help-center-teacher\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\" translate=\"HELP_CENTER_TEACHER.TITLE\">Teacher Support Center</span> <span \nng-click=\"vm.goToStudentView()\" class=\"switch\" layout=\"row\" layout-align=\"center center\"><text \ntranslate=\"HELP_CENTER_TEACHER.GO_TO_STUDENT\">Go to student support center</text><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"arrow\"></md-icon></span></div></div><div class=\"content-container pt-20 pb-20\">\n<div layout=\"row\" class=\"centent-title\" translate=\"HELP_CENTER_TEACHER.WHAT_CAN_WE_HELP\">What can we help you with?\n</div><md-content class=\"md-padding\"><div layout=\"row\" layout-align=\"space-between start\"><div flex=\"25\" flex-xs=\"100\" \nclass=\"column-left\"><md-list flex ng-cloak><md-list-item ng-click=\"vm.setArticleContent(\'whyNesuku\')\"><p \ntranslate=\"HELP_CENTER_TEACHER.WHY_NESUKU\">Why Nesuku</p></md-list-item><md-list-item \nng-click=\"vm.setArticleContent(\'availabilities\')\"><p>Setting your availabilities</p></md-list-item><md-list-item \nng-click=\"vm.setArticleContent(\'description\')\"><p>Description Setup</p></md-list-item><md-list-item \nng-click=\"vm.setArticleContent(\'pricing\')\"><p>Categories & Pricing</p></md-list-item><md-list-item \nng-click=\"vm.setArticleContent(\'account\')\"><p>Account Settings</p></md-list-item><md-list-item \nng-click=\"vm.setArticleContent(\'handleLessonRequests\')\"><p translate=\"HELP_CENTER_TEACHER.LESSON_REQUESTS\">\nLesson Requests</p></md-list-item><md-list-item ng-click=\"vm.setArticleContent(\'conductALesson\')\"><p \ntranslate=\"HELP_CENTER_TEACHER.CONDUCT_A_LESSON\">Conduct a Lesson</p></md-list-item><md-list-item \nng-click=\"vm.setArticleContent(\'getPaid\')\"><p translate=\"HELP_CENTER_TEACHER.GET_PAID\">Get Paid</p></md-list-item>\n</md-list></div><div flex=\"70\" flex-xs=\"100\" class=\"column-right\"><div ng-if=\"vm.currentArticle == \'whyNesuku\' \"><h1 \nclass=\"article-title\" translate=\"HELP_CENTER_TEACHER.WHY_NESUKU\">Why Nesuku?</h1><h2 class=\"article-subtitle\" \ntranslate=\"HELP_CENTER_TEACHER.1\">Convenience</h2><p translate=\"HELP_CENTER_TEACHER.2\"><b>No more long commutes</b>\n to lessons or making sure you and your student have an optimal place to meet. Conduct a lesson from the comfort of your own home.\n</p><h2 class=\"article-subtitle\" translate=\"HELP_CENTER_TEACHER.3\">Flexibility</h2><p \ntranslate=\"HELP_CENTER_TEACHER.4\">Nesuku is <b>wherever you want, whenever you want.</b>\n Set your own schedule and conducts lessons at your own convenience with students that fit your schedule.</p><h2 \nclass=\"article-subtitle\" translate=\"HELP_CENTER_TEACHER.5\">Global Connection</h2><p translate=\"HELP_CENTER_TEACHER.6\">\nNesuku\'s teachers and students span multiple continents and countries. Opening a door to Nesuku means opening <b>\na door to a truly international world.</b></p><h2 class=\"article-subtitle\" translate=\"HELP_CENTER_TEACHER.7\">\nCustomization</h2><p translate=\"HELP_CENTER_TEACHER.8\">You have <b>\nfull control over your own teaching style and methodology.</b> Show off your own way of teaching.</p></div><div \nng-if=\"vm.currentArticle == \'availabilities\' \"><h1 class=\"article-title\">Setting your availabilities</h1><p>\nOn your teacher dashboard, locate the calendar on the right and <b>click on the \"Edit Availabilities\" button</b></p>\n<br><br><img ng-src=\"assets/images/help-center/edit_availabilities.jpeg\"><br><br><p>Use the calendar to <b>\nclick and drag your weekly default available times.</b>\n This will show students which times you are available to teach lessons.</p><br><br><img \nng-src=\"assets/images/help-center/schedule.gif\"><br><br><p>\nIf you have any specific dates where your availabilities differ from your default times, you may toggle this button and update specific dates\n</p><br><br><img ng-src=\"assets/images/help-center/default.jpeg\" \nstyle=\"margin: auto; display:block; width:60%; border-bottom: 2px #efeaea solid\"> <img \nng-src=\"assets/images/help-center/specific.jpeg\" \nstyle=\"margin: auto; display:block; width:60%; border-bottom: 2px #efeaea solid\"></div><div \nng-if=\"vm.currentArticle == \'description\' \"><h1 class=\"article-title\">Description setup</h1><p></p><p>\nIn order to set up your profile, you can start by clicking <b>\"edit profile\" button.</b>\n This is where the majority of your profile management takes place.</p><br><br><img \nng-src=\"assets/images/help-center/edit_profile.jpeg\"><br><br><p><b>Subjects:</b>\n Select the subjects you would like to teach.</p><img ng-src=\"assets/images/help-center/subject.jpeg\"><br><br><p><b>\nPrice:</b> Input your average hourly price here. This will be displayed in your profile.</p><img \nng-src=\"assets/images/help-center/price.jpeg\"><br><br><p><b>Policies:</b>\n Choose the number of hours of notice for cancellation you require your students to book and to cancel lessons.</p><img\n ng-src=\"assets/images/help-center/policies.jpeg\"><br><br><p><b>Video:</b>\n This is where you input the link of your introduction video.</p><img ng-src=\"assets/images/help-center/video.jpeg\">\n<br><br><p><b>Zoom Link:</b>\n Input your Zoom personal link here. This will allow students to call you when the lesson time begins. If you haven\'t created an account, pleaese create one at \n<a href=\"https://zoom.us/signup\">Zoom Sign Up</a> and locate your Zoom personal link using <a \nhref=\"https://support.zoom.us/hc/en-us/articles/201362843-What-is-Personal-Meeting-ID-PMI-and-Personal-Link-\">\nthis guide</a>. The link should similar to this format: https://zoom.us/j/XXXXXXXX</p><img \nng-src=\"assets/images/help-center/video_conferencing.jpeg\"><br><br><p translate=\"HELP_CENTER_TEACHER.17\"><b>\nIntroduction:</b>\n In this area, you can type your \"elevator pitch\" here for students to read when they look at your profile. Try to emphasize your unique skills and passion for teaching.\n</p><img ng-src=\"assets/images/help-center/intro.jpeg\"><br><br><p></p></div><div \nng-if=\"vm.currentArticle == \'pricing\' \"><h1 class=\"article-title\">Categories & Pricing</h1><p>\nClick \"Add\" to add a price category for your lessons. If you\'re unsure what to set, we generally suggest to create a basic \"1-on-1\" category with your hourly price.\n</p><br><br><img ng-src=\"assets/images/help-center/add_cat.jpeg\"><br><br><img \nng-src=\"assets/images/help-center/edit_cat.jpeg\"></div><div ng-if=\"vm.currentArticle == \'account\' \"><h1 \nclass=\"article-title\">Account Settings</h1><p>\nIn this section, you may edit your profile, connect your bank account, and change your password.</p><img \nng-src=\"assets/images/help-center/account.jpeg\"></div><div ng-if=\"vm.currentArticle == \'handleLessonRequests\' \"><h1 \nclass=\"article-title\" translate=\"HELP_CENTER_TEACHER.LESSON_REQUESTS\">Lesson Requests</h1><p></p><p \ntranslate=\"HELP_CENTER_TEACHER.19\">When you <b>receive a lesson request</b> from a student, you will <b>\nreceive an email notification.</b> You can then check your dashboard, and either <b>accept</b> or <b>decline</b>\n the request.</p><br><br><img ng-src=\"assets/images/help-center/lesson_request_1.jpeg\" \nstyle=\"margin: auto; display:block; width:60%; border-bottom: 2px #efeaea solid\"><p></p></div><div \nng-if=\"vm.currentArticle == \'getPaid\' \"><h1 class=\"article-title\" translate=\"HELP_CENTER_TEACHER.GET_PAID\">Get Paid\n</h1><p></p><p>To get paid, please <b>go to your \"edit profile\" page</b> and click <b>\"Account Settings\"</b> and <b>\n\"Connect Bank Account\"</b></p><br><br><img ng-src=\"assets/images/help-center/account_bank.jpeg\" \nstyle=\"display:block; border: 2px #efeaea solid\"><br><br><p translate=\"HELP_CENTER_TEACHER.22\">\nThis will redirect to our payment partner, Stripe, where you can <b>fill out your bank information:</b></p><br><br><img\n ng-src=\"assets/images/help-center/stripe.jpeg\" style=\"display:block; border: 2px #efeaea solid\"><br><br><p \ntranslate=\"HELP_CENTER_TEACHER.23\">\nAfter you set-up your account, we can begin transferring each lesson\'s revenue to you 2-3 days after each lesson. You can check your \n<b>Stripe dashboard</b> to see your revenue analytics.</p><br><br><img \nng-src=\"assets/images/help-center/stripe_dashboard.jpeg\" style=\"display:block; border: 1px #efeaea solid\"><p></p></div>\n<div ng-if=\"vm.currentArticle == \'conductALesson\' \"><h1 class=\"article-title\" \ntranslate=\"HELP_CENTER_TEACHER.CONDUCT_A_LESSON\">Conduct a Lesson</h1><p></p><p>\nTo conduct your lesson, you may directly open your Skype application or <b>click on our convenient \"Begin\" button</b>\n that will open your Skype or Zoom application for you. <b>The student will call your Skype or Zoom account</b>\n at the time of the lesson.</p><br><br><img ng-src=\"assets/images/help-center/teacher_start.jpeg\" \nstyle=\"margin: auto; display:block; width:60%; border: 2px #efeaea solid\"><br><br><p></p></div></div></div>\n</md-content></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/hw-help/hw-help.html","<div id=\"hw-help\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">Free tutoring help with homework, learning, academic advice, and more</span></div></div><div \nclass=\"content-container pt-20 pb-40\"><md-content class=\"md-padding\"><section class=\"pt-10 pb-10\"><p>\nNesuku is a tutoring marketplace specialized in online teaching. At a time when many of our students and their peers cannot go to school and are self-learning at home, we want to help ease their and their parents\' burden. Therefore, we--along with our amazing tutor community comprised of graduates of top schools such as Harvard, Yale, MIT, and the University of Michigan--will \n<b>\ndonate our time to offer free tutoring: whether it\'s a problem you\'re stuck on, a concept you are having trouble explaining to your kids (or don\'t have time to), an area where you want more guidance or practice problems, or you just have a question about your academic future... we are here for you. Feel free to ask for help.\n</b>.</p><br><br><img class=\"md-card-image\" src=\"assets/images/landing-page/tutors.jpg\"><br><br><p><b>\nFill out this form to ask for help or general questions.</b>\n Whether you or your child is in elementary school or college, we are happy to help. One of our tutors will come back to you within 24 hours to help you, for free. They are well-equipped to teach online and are volunteering their time during this pandemic.\n</p><br><br><p>\nTo learn more about Nesuku\'s COVID response, please click here. To learn more about Nesuku and our other offerings, please \n<span ng-click=\"vm.goToCovid()\">click here</span>.</p></section><section layout=\"column\" layout-wrap><form \nname=\"HWRequestForm\" novalidate><section class=\"section\"><i class=\"icon-human section__icon\"></i><h3 \nclass=\"section__title\">What can we help you with?</h3></section><br><p class=\"title\">\nAre you stuck on a homework problem? Studying for a standardized exam? Applying to school? Applying for jobs? Let us know!\n</p><md-input-container class=\"md-block\"><textarea name=\"bio\" class=\"input-content\" ng-model=\"vm.form.description\" \nmd-maxlength=\"1500\" rows=\"7\" md-select-on-focus aria-label=\"Teacher\'s Biography\" required></textarea><span \nng-show=\"HWRequestForm.description.$error.maxlength\">Too many characters</span></md-input-container><section \nclass=\"section\"><i class=\"icon-earth section__icon\"></i><h3 class=\"section__title\">Subject</h3></section><div \nlayout=\"row\" layout-align=\"start start\"><md-input-container md-no-float flex=\"25\" flex-xs=\"50\"><md-select \nng-model=\"vm.form.subject\" class=\"\" placeholder=\"Choose a subject\" aria-label=\"learn subject\" md-no-float=\"true\" \nrequired><md-select-header><input type=\"search\" placeholder=\"Search for subjects\" \nng-keydown=\"$event.stopPropagation()\" ng-model=\"vm.searchTerm\" class=\"md-text\"></md-select-header><md-option \nng-repeat=\"subject in vm.subjects |\n    filter:vm.searchTerm\" ng-value=\"subject.id\">{{ subject.name }}</md-option>\n</md-select></md-input-container><md-input-container ng-if=\"vm.form.subject == 0\" md-no-float flex=\"25\" flex-xs=\"50\">\n<input name=\"otherSubject\" ng-model=\"vm.form.otherSubject\" placeholder=\"Subject Name\" \nng-required=\"vm.form.subject == 0 && vm.form.otherSubject == null\"><div \nng-messages=\"HWRequestForm.otherSubject.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required\n</span></div></div></md-input-container></div><section class=\"section\"><i class=\"icon-earth section__icon\"></i><h3 \nclass=\"section__title\">Grade</h3></section><md-input-container md-no-float flex=\"50\" flex-xs=\"100\"><md-select \nng-model=\"vm.form.grade\" class=\"\" placeholder=\"Choose a grade\" aria-label=\"Choose a grade\" md-no-float=\"true\" required>\n<md-option ng-repeat=\"grade in vm.grades\" ng-value=\"grade\">{{ grade }}</md-option></md-select></md-input-container>\n<section class=\"section\"><i class=\"icon-file-document section__icon\"></i><h3 class=\"section__title\">File Upload</h3>\n</section><br><p class=\"title\">Attach a picture or document of what you\'re looking at if it helps!</p><input \nstyle=\"margin: 18px 0\" placeholder=\"Non-Floating Label\" class=\"file\" type=\"file\" name=\"file\" file=\"vm.file\" required>\n<section class=\"section\"><i class=\"icon-account-circle section__icon\"></i><h3 class=\"section__title\">\nContact Information</h3></section><md-input-container md-no-float class=\"md-block\" flex=\"50\" flex-xs=\"100\"><input \nname=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" required><div \nng-messages=\"HWRequestForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span>Name field is required</span>\n</div></div></md-input-container><md-input-container md-no-float class=\"md-block\" flex=\"50\" flex-xs=\"100\"><input \ntype=\"email\" name=\"email\" placeholder=\"Email\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"HWRequestForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><div layout=\"row\" layout-align=\"center center\"><md-button type=\"submit\" \nclass=\"md-raised md-primary submit-button\" aria-label=\"Sign Up\" \nng-disabled=\"HWRequestForm.$invalid || HWRequestForm.$pristine\" ng-click=\"vm.submit()\">SUBMIT</md-button></div></form>\n</section></md-content></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/hw-list/hw-list.html","<div id=\"hw-list\" class=\"page-layout simple\"><div class=\"header md-accent-bg\"><div class=\"content-container\" \nng-if=\"!vm.is_conversation_partner\" layout=\"row\" layout-align=\"center center\" layout-align-gt-sm=\"start center\"><span \nclass=\"intro-message\">Homework Help Requests</span></div></div><div class=\"content-container pt-40 pb-40\"><div \nclass=\"widget-group\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\" layout-align=\"space-between start\">\n<div class=\"column\" flex-gt-sm=\"33\" flex=\"100\"><ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\">\n<div><div class=\"widget__content\" layout=\"column\" layout-align=\"center start\"><section><p class=\"filter__title\">\nWhich subject would you like to help with?</p><md-select class=\"filter__select\" ng-change=\"vm.refreshHwList()\" \nng-model=\"vm.subject\" placeholder=\"All\"><md-option ng-repeat=\"subject in vm.subjects\" ng-value=\"subject.id\">\n{{ subject.name }}</md-option></md-select></section></div></div></ms-widget-front></ms-widget></div><div \nflex-gt-sm=\"65\" flex=\"100\" ng-if=\"!vm.isLoading\"><section class=\"teacher-container\"><div class=\"ms-card teacher\" \nlayout=\"row\" layout-align=\"center center\" \nng-repeat=\"hw in vm.hwList | filter:search | limitTo : vm.pagination.itemsPerPage : vm.pagination.begin\"><div \nflex=\"100\" layout=\"column\" layout-align=\"center start\" class=\"safari-height\"><h4 class=\"student__name\" flex=\"noshrink\">\nAge: {{ hw.grade }} Subject: {{ hw.subjectName }}</h4><p class=\"description\">{{ hw.description }}</p><div \nclass=\"full-width\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"hw.awsKey\"><md-button \nhref=\"{{vm.keyToLink(hw.awsKey)}}\" class=\"download md-raised\">Download Homework File<md-icon class=\"icon-download\">\n</md-icon></md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.goToApplyForm(hw.id)\">Volunteer</md-button>\n</div><div class=\"full-width\" layout=\"row\" layout-align=\"end center\" ng-if=\"!hw.awsKey\"><md-button \nhref=\"{{vm.keyToLink(hw.awsKey)}}\" class=\"download md-raised\" ng-if=\"hw.awsKey\">Download Homework File<md-icon \nclass=\"icon-download\"></md-icon></md-button><md-button class=\"md-raised md-primary\" ng-click=\"vm.goToApplyForm(hw.id)\">\nVolunteer</md-button></div></div></div><div class=\"ms-card\" ng-show=\"vm.hwList.length === 0\"><p \nclass=\"message-no-teacher\">Currently no requests. Check back later!</p></div></section><ul uib-pagination \nclass=\"pagination-sm teacher__pager\" total-items=\"vm.pagination.totalItems\" ng-model=\"vm.pagination.currentPage\" \nmax-size=\"vm.pagination.maxSize\" items-per-page=\"vm.pagination.itemsPerPage\" rotate=\"false\" previous-text=\"&lsaquo;\" \nnext-text=\"&rsaquo;\" ng-change=\"vm.refreshHwList()\" ng-hide=\"vm.hwList.length === 0\"></ul></div><div flex-gt-sm=\"65\" \nflex=\"100\" ng-if=\"vm.isLoading\"><section class=\"teacher-container\"><div \nng-include=\"\'app/main/states/loading-teacher-list.html\'\"></div></section></div></div></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/landing/landing.html","<div id=\"landing-page\" class=\"page-layout simple overview\"><div class=\"topsec\"><div \nng-include=\"\'app/common/templates/auth-nav/auth-nav.html\'\"></div><div class=\"tagline\" layout-align=\"center center\">\n<span>Feeling inspired to learn something new?</span></div></div><div class=\"categories\" layout=\"row\" \nlayout-align=\"start center\" layout-align-gt-md=\"center center\"><div class=\"card-container\"><md-card \nng-click=\"vm.goToFindATutor(\'academic\')\"><div class=\"image_gradient\"></div><div class=\"category-image academic-bg\">\n</div><md-card-content><div><span class=\"card-title\">Academic Tutors<md-icon class=\"arrow\" \nmd-font-icon=\"icon-arrow-right\"></md-icon></span></div><div class=\"pt-5\"><span class=\"card-subtext\">\nInterested in learning a subject? Let us match you with the right tutor.</span></div></md-card-content></md-card>\n<md-card ng-click=\"vm.goToFindATutor(\'lifestyle\')\"><div class=\"image_gradient\"></div><div \nclass=\"category-image lifestyle-bg\"></div><md-card-content><div><span class=\"card-title\">Lifestyle Instructors<md-icon \nclass=\"arrow\" md-font-icon=\"icon-arrow-right\"></md-icon></span></div><div class=\"pt-5\"><span class=\"card-subtext\">\nFrom drawing to Japanese cooking, we’ve got you covered at home.</span></div></md-card-content></md-card><md-card \nng-click=\"vm.goToFindATutor(\'college\')\"><div class=\"image_gradient\"></div><div class=\"category-image hw-help-bg\"></div>\n<md-card-content><div><span class=\"card-title\">College Advising<md-icon class=\"arrow\" md-font-icon=\"icon-arrow-right\">\n</md-icon></span></div><div class=\"pt-5\"><span class=\"card-subtext\">\nNeed help with your college application? Let us match you with an advisor.</span></div></md-card-content></md-card>\n</div></div><div class=\"featured\"><div layout=\"row\" layout-align=\"center center\"><span class=\"featured-text\">\nFEATURED IN</span></div><div layout=\"row\" layout-align=\"space-between center\" layout-wrap><a flex=\"30\" flex-gt-sm=\"15\" \nclass=\"featured-logo\" ng-href=\"https://innovationlabs.harvard.edu/current-team/nesuku/\"><img \nsrc=\"assets/images/landing-page/harvard-ilab.png\"> </a><a flex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo mlive\" \nng-href=\"https://www.mlive.com/news/erry-201they_now_past_young.html\"><img src=\"assets/images/landing-page/mlive.png\"> \n</a><a flex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo\" ng-href=\"http://sandbox.mit.edu/\"><img \nsrc=\"assets/images/landing-page/mit.png\"> </a><a flex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo\" \nng-href=\"https://web.shobserver.com/wx/detail.do?id=153902\"><img \nsrc=\"assets/images/landing-page/shanghai-observer.png\"> </a><a flex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo cen\" \nng-href=\"http://www.cenmichigan.com/finalists.html\"><img src=\"assets/images/landing-page/cen.png\"> </a><a \nng-href=\"https://www.facebook.com/nesukumarketplace/posts/were-excited-to-announce-that-we-are-one-of-10-finalists-in-the-hive-harvard-gse/2114636972092262/\" \nflex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo\"><img src=\"assets/images/landing-page/hive.png\"></a></div></div><div>\n<div class=\"image-text thin-grey\"><section layout=\"column\" layout-gt-sm=\"row\" layout-align=\"center center\"><p \nflex-gt-sm=\"45\">Specialized in <span class=\"special-text\">intensive, last-minute preparations.</span>\n We have tutors available to teach you within 24 hours.</p><md-card flex-gt-sm=\"45\"><img class=\"md-card-image\" \nsrc=\"assets/images/landing-page/last-min.jpg\"></md-card></section><section layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"center center\"><div class=\"sub-text\" flex-gt-sm=\"45\" flex-order=\"1\" flex-order-gt-sm=\"2\"><span \nclass=\"special-text\">Personalized learning in your subject:</span><br><div class=\"sub-link-group\" layout=\"row\" \nlayout-wrap><div class=\"link-container\"><a href=\"\" ng-click=\"vm.goToLanguage()\">SAT</a></div><div \nclass=\"link-container\"><a href=\"\" ng-click=\"vm.goToLanguage()\">ACT</a></div><div class=\"link-container\"><a href=\"\" \nng-click=\"vm.goToLanguage()\">HSK</a></div><div class=\"link-container\"><a href=\"\" ng-click=\"vm.goToLanguage()\">JLPT</a>\n</div><div class=\"link-container\"><a href=\"\" ng-click=\"vm.goToLanguage()\">MATH</a></div><div class=\"link-container\"><a \nhref=\"\" ng-click=\"vm.goToLanguage()\">More...</a></div></div></div><md-card flex-gt-sm=\"45\" flex-order=\"2\" \nflex-order-gt-sm=\"1\"><img class=\"md-card-image\" src=\"assets/images/landing-page/tutors.jpg\"></md-card><br><br>\n</section><section layout=\"row\" layout-align=\"center center\"><p>Can\'t find the subject you need? <a href=\"\" \nng-click=\"vm.goToFindATutor()\">Let us know</a> and we\'ll find one.</p></section></div><div class=\"begin\"><div \nclass=\"begin-container content-container\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between start\" layout=\"column\" \nlayout-align=\"center center\"><md-card><img class=\"md-card-image\" src=\"assets/images/landing-page/kaori_video.jpg\" \nclass=\"md-card-image\" alt=\"image caption\"></md-card><div class=\"reviews-container\" layout=\"column\" \nlayout-align=\"start end\"><span class=\"reviews\">\n\"She is very good at customizing the learning topics to our interests and keeping us engaged through class. <span \nclass=\"special-text\">She makes learning feel easy</span>.\"</span> <span class=\"reviews\">- Jenny Li<br><br></span><span \nclass=\"reviews\">\"Tried the Spanish class, great teacher with <span class=\"special-text\">\nhigh quality personalized class.</span> Thank you nesuku!\"</span> <span class=\"reviews\">- Keiko Uehara</span></div>\n</div></div><div class=\"numbers\"><div class=\"section-title\" layout=\"row\" layout-align=\"center center\" \nlayout-align-xs=\"center start\"><span class=\"title-text\"><span class=\"special-text\">5000</span> lessons & counting\n</span></div><div layout=\"row\" layout-align=\"center center\"><div flex-gt-sm=\"25\"></div><md-card flex-gt-sm=\"50\"><img \nclass=\"md-card-image\" src=\"assets/images/landing-page/maps.jpg\"></md-card><div flex-gt-sm=\"25\"></div></div><div \nclass=\"content-container\" layout=\"row\" layout-align=\"center center\"><p>Start learning from <span class=\"special-text\">\nwherever you are</span></p></div><div layout=\"row\" layout-align=\"center center\"><div class=\"btn-container\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary btn\" ng-click=\"vm.goToLanguage()\">\nStart now</md-button></div></div></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div></div>");
$templateCache.put("app/main/pages/landing-teach/landing-teach.html","<div id=\"landing-page-teach\" class=\"page-layout simple overview\"><div class=\"topsec\"><div \nng-include=\"\'app/common/templates/auth-nav/auth-nav.html\'\"></div><div class=\"big-thinfont\" \nlayout-align=\"center center\"><span>Get paid to help someone</span></div><div class=\"small-thinfont\" \nlayout-align=\"center center\"><span>Teach whenever, wherever, whenever. Tutor online.</span></div><div \nclass=\"btn-container\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary btn\" \nng-click=\"vm.goToTeach()\">Start now</md-button></div></div><div class=\"featured\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"featured-text\">FEATURED IN</span></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><a flex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo\" \nng-href=\"https://innovationlabs.harvard.edu/current-team/nesuku/\"><img \nsrc=\"assets/images/landing-page/harvard-ilab.png\"> </a><a flex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo mlive\" \nng-href=\"https://www.mlive.com/news/erry-201they_now_past_young.html\"><img src=\"assets/images/landing-page/mlive.png\"> \n</a><a flex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo\" ng-href=\"http://sandbox.mit.edu/\"><img \nsrc=\"assets/images/landing-page/mit.png\"> </a><a flex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo\" \nng-href=\"https://web.shobserver.com/wx/detail.do?id=153902\"><img \nsrc=\"assets/images/landing-page/shanghai-observer.png\"> </a><a flex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo cen\" \nng-href=\"http://www.cenmichigan.com/finalists.html\"><img src=\"assets/images/landing-page/cen.png\"> </a><a \nng-href=\"https://www.facebook.com/nesukumarketplace/posts/were-excited-to-announce-that-we-are-one-of-10-finalists-in-the-hive-harvard-gse/2114636972092262/\" \nflex=\"30\" flex-gt-sm=\"15\" class=\"featured-logo\"><img src=\"assets/images/landing-page/hive.png\"></a></div></div><div>\n<div class=\"image-text thin-grey\"><section layout=\"column\" layout-gt-sm=\"row\" layout-align=\"center center\"><p \nflex-gt-sm=\"45\">Be <span class=\"special-text\">your own boss.</span>\n Set your own rates and schedule to fit your own needs.</p><md-card flex-gt-sm=\"45\"><img class=\"md-card-image\" \nsrc=\"assets/images/landing-page/boss.jpg\"></md-card></section><section layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"center center\"><p flex-gt-sm=\"45\" flex-order=\"1\" flex-order-gt-sm=\"2\">Harness <span class=\"special-text\">\nyour knowledge for others.</span> Teach what you know.</p><md-card flex-gt-sm=\"45\" flex-order=\"2\" flex-order-gt-sm=\"1\">\n<img class=\"md-card-image\" src=\"assets/images/landing-page/knowledge.jpg\"></md-card></section><section layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"center center\"><p flex-gt-sm=\"45\">Get <span class=\"special-text\">paid. Immediately.\n</span> Students pay when they schedule.</p><md-card flex-gt-sm=\"45\"><img class=\"md-card-image\" \nsrc=\"assets/images/landing-page/paid.jpg\"></md-card></section><section layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"center center\"><p flex-gt-sm=\"45\" flex-order=\"1\" flex-order-gt-sm=\"2\">It\'s <span class=\"special-text\">\neasy,</span> but you <span class=\"special-text\">don\'t have to do it alone.</span>\n Our team is here to consult and share knowledge.</p><md-card flex-gt-sm=\"45\" flex-order=\"2\" flex-order-gt-sm=\"1\"><img \nclass=\"md-card-image\" src=\"assets/images/landing-page/team.jpg\"></md-card></section></div><div class=\"numbers\"><div \nclass=\"section-title\" layout=\"row\" layout-align=\"center center\" layout-align-xs=\"center start\"><span \nclass=\"title-text\"><span class=\"special-text\">5000</span> lessons & counting</span></div><div layout=\"row\" \nlayout-align=\"center center\"><div flex-gt-sm=\"25\"></div><md-card flex-gt-sm=\"50\"><img class=\"md-card-image\" \nsrc=\"assets/images/landing-page/maps.jpg\"></md-card><div flex-gt-sm=\"25\"></div></div><div class=\"content-container\" \nlayout=\"row\" layout-align=\"center center\"><p>Start teaching from <span class=\"special-text\">wherever you are</span></p>\n</div><div layout=\"row\" layout-align=\"center center\"><div class=\"btn-container\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-raised md-primary btn\" ng-click=\"vm.goToTeach()\">Get started\n</md-button></div></div></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div></div>");
$templateCache.put("app/main/pages/meet-teachers/meet-teachers.html","<div id=\"meet-teachers\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">Meet our teachers</span></div></div><div class=\"content-container pt-20 pb-10\"><md-content \nclass=\"md-padding\"><div class=\"text-center\" layout=\"column\" layout-align=\"center center\"><h1><b>\nOur teachers are the heart of Nesuku.</b></h1><br><br><p>\nOur teachers are highly experienced educators who are located in various countries, speak multiple languages, and are passionate about teaching their language to interested students.\n</p></div></md-content></div><div class=\"content-container section-line\"></div><div \nclass=\"content-container pt-10 pb-10\"><md-content class=\"md-padding\"><div class=\"text-center\" layout=\"column\" \nlayout-align=\"center center\"><h1><b>Meet our teachers</b></h1><br><br></div><div class=\"language-container\" ng-cloak>\n<md-tabs class=\"tabbed-lang\" md-dynamic-height md-center-tabs=\"true\"><md-tab><md-tab-label><span \ntranslate=\"LANDING.ENGLISH\"></span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" \nng-model=\"vm.teacher\" layout=\"row\" layout-align=\"center center\" layout-align-xs=\"start center\"><md-card \nclass=\"teacher-card\" ng-click=\"vm.goToTeacher(14)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/lee_rectangle.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Lee Penhey</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(24)\"><div \nclass=\"image_gradient\"></div><img src=\"assets/images/landing-page/chihiro_rectangle.jpg\"><md-card-content \nlayout=\"column\" layout-align=\"center center\" class=\"teacher-content\"><h2>Chihiro Kakishima</h2><div class=\"star-row\">\n<md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon>\n<md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon>\n<md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card><md-card \nclass=\"teacher-card\" ng-click=\"vm.goToTeacher(30)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/david_rectangle.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>David Phillips</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(18)\"><div \nclass=\"image_gradient\"></div><img src=\"assets/images/landing-page/kevin_rectangle.jpg\"><md-card-content \nlayout=\"column\" layout-align=\"center center\" class=\"teacher-content\"><h2>Kevin Dean</h2><div class=\"star-row\"><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card><md-card class=\"teacher-card\" \nng-click=\"vm.goToTeacher(2)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/Christina_rectangle.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Christina Polietaieva</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" \nclass=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" \nclass=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" \nclass=\"star\"></md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"LANDING.JAPANESE\"></span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" layout=\"row\" \nlayout-align=\"center center\"><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(1)\"><div class=\"image_gradient\">\n</div><img src=\"assets/images/landing-page/kaori_rectangle.jpg\"><md-card-content layout=\"column\" \nlayout-align=\"center center\" class=\"teacher-content\"><h2>Kaori Ohara</h2><div class=\"star-row\"><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card><md-card class=\"teacher-card\" \nng-click=\"vm.goToTeacher(16)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/marie_rectangle.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Marie Arao</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"LANDING.MANDARIN\"></span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" layout=\"row\" \nlayout-align=\"center center\"><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(26)\"><div class=\"image_gradient\">\n</div><img src=\"assets/images/landing-page/yu_rectangle.jpg\"><md-card-content layout=\"column\" \nlayout-align=\"center center\" class=\"teacher-content\"><h2>Yu Cuir</h2><div class=\"star-row\"><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card><md-card class=\"teacher-card\" \nng-click=\"vm.goToTeacher(13)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/wanghui_rectangle.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Wang Hui</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"LANDING.SPANISH\"></span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" layout=\"row\" \nlayout-align=\"center center\"><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(104)\"><div class=\"image_gradient\">\n</div><img src=\"assets/images/landing-page/silvia_rectangle.jpg\"><md-card-content layout=\"column\" \nlayout-align=\"center center\" class=\"teacher-content\"><h2>Silvia Garcia</h2><div class=\"star-row\"><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"LANDING.ITALIAN\"></span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" \nlayout=\"row\" layout-align=\"center center\"><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(3)\"><div \nclass=\"image_gradient\"></div><img src=\"assets/images/landing-page/rosaria_rectangle.jpg\"><md-card-content \nlayout=\"column\" layout-align=\"center center\" class=\"teacher-content\"><h2>Rosaria Guerra</h2><div class=\"star-row\">\n<md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon>\n<md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon>\n<md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card></div></md-tab-body>\n</md-tab><md-tab><md-tab-label><span translate=\"LANDING.FRENCH\"></span></md-tab-label><md-tab-body><div \nclass=\"teacher-card-container\" layout=\"row\" layout-align=\"center center\"><md-card class=\"teacher-card\" \nng-click=\"vm.goToTeacher(20)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/celine_rectangle.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Céline Crucifix</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"LANDING.NORWEGIAN\">Norwegian</span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" \nng-model=\"vm.teacher\" layout=\"row\" layout-align=\"center center\"><md-card class=\"teacher-card\" \nng-click=\"vm.goToTeacher(31)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/silje_rectangle.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Silje</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon>\n<md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon>\n<md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon>\n</div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"LANDING.PORTUGUESE\"></span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" layout=\"row\" \nlayout-align=\"center center\"><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(21)\"><div class=\"image_gradient\">\n</div><img src=\"assets/images/landing-page/erica_rectangle.jpg\"><md-card-content layout=\"column\" \nlayout-align=\"center center\" class=\"teacher-content\"><h2>Erica Santos</h2><div class=\"star-row\"><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card><md-card class=\"teacher-card\" \nng-click=\"vm.goToTeacher(22)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/veronica_rectangle.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Veronica Afonso</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"LANDING.RUSSIAN\"></span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" layout=\"row\" \nlayout-align=\"center center\"><md-card class=\"teacher-card\" ng-click=\"vm.goToTeacher(28)\"><div class=\"image_gradient\">\n</div><img src=\"assets/images/landing-page/victoria_rectangle.jpg\"><md-card-content layout=\"column\" \nlayout-align=\"center center\" class=\"teacher-content\"><h2>Victoria Bust</h2><div class=\"star-row\"><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon \nmd-font-icon=\"icon-star\" class=\"star\"></md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"LANDING.GERMAN\"></span></md-tab-label><md-tab-body><div class=\"teacher-card-container\" \nng-model=\"vm.teacher\" layout=\"row\" layout-align=\"center center\"><md-card class=\"teacher-card\" \nng-click=\"vm.goToTeacher(29)\"><div class=\"image_gradient\"></div><img \nsrc=\"assets/images/landing-page/gerhard_rectangle.jpg\"><md-card-content layout=\"column\" layout-align=\"center center\" \nclass=\"teacher-content\"><h2>Gerhard Weber</h2><div class=\"star-row\"><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon><md-icon md-font-icon=\"icon-star\" class=\"star\">\n</md-icon></div></md-card-content></md-card></div></md-tab-body></md-tab></md-tabs></div></md-content></div><div \nclass=\"content-container section-line\"></div><div class=\"content-container pt-10 pb-20\"><md-content class=\"md-padding\">\n<div class=\"text-center\" layout=\"column\" layout-align=\"center center\"><h1><b>Where our teachers are located</b></h1>\n<br><br></div><div layout=\"row\" layout-align=\"center center\"><img src=\"assets/images/landing-page/maps.jpg\"></div>\n</md-content></div><div class=\"content-container section-line\"></div><div class=\"content-container pt-10 pb-20\">\n<md-content class=\"md-padding\"><div class=\"text-center\" layout=\"column\" layout-align=\"center center\"><h1><b>\nJoin the team</b></h1><br><p>Are you interested in teaching on Nesuku? <a href=\"\" ng-click=\"vm.goToApplyToTeach()\">\nFind out more.</a></p></div></md-content></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/payment-make-up/payment-make-up.html","<div id=\"payment-make-up\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">Payment make-up request from {{ vm.teacher.name }}</span></div></div><div \nclass=\"content-container pt-20 pb-20\"><md-content class=\"md-padding\"><div ng-repeat=\"dateTime in vm.description\"><div \nlayout=\"row\" layout-xs=\"column\" layout-align-xs=\"center start\" layout-align=\"space-between center\" layout-wrap>\n<section><i class=\"icon-calendar-clock section__icon\"></i> <span class=\"section__title\">{{ dateTime.start }}</span>\n</section><section><i class=\"icon-clipboard-outline section__icon\"></i> <span class=\"section__title\">\n{{vm.category.name}}</span></section><section><i class=\"icon-cash section__icon money-icon\"></i> <span \nclass=\"section__title\">${{dateTime.cost}}</span></section></div><hr></div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><section class=\"section__title section__final\"><span>Total: </span>\n<span>$ {{ vm.totalPrice }}</span></section><md-button class=\"md-raised md-primary btn-submit section__final\" \nng-click=\"vm.choosePay()\">Confirm & Pay</md-button></div></md-content></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/privacy-policy/privacy-policy.html","<div id=\"privacy-policy\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">Privacy Policy</span></div></div><div class=\"content-container pt-10 pb-20\"><md-content \nclass=\"md-padding\"><div class=\"\" layout=\"column\" layout-align=\"center start\"><p>\nEffective January 1, 2017 (last updated June 7, 2019)</p><hr><p>\nNesuku LLC operates the www.nesuku.com website and the Nesuku mobile application (hereinafter referred to as the \"Service\").\n</p><p>\nThis page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data.\n</p><p>\nWe use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, the terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.\n</p><h1>Information Collection And Use</h1><p>\nWe collect several different types of information for various purposes to provide and improve our Service to you.</p>\n<h2>Types of Data Collected</h2><h3>Personal Data</h3><p>\nWhile using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (\"Personal Data\"). Personally identifiable information may include, but is not limited to:\n</p><ul><li>Email address</li><li>First name and last name</li><li>Cookies and Usage Data</li></ul><h3>Usage Data</h3>\n<p>\nWe may also collect information that your browser sends whenever you visit our Service or when you access the Service by or through a mobile device (\"Usage Data\").\n</p><p>\nThis Usage Data may include information such as your computer\'s Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data.\n</p><p>\nWhen you access the Service with a mobile device, this Usage Data may include information such as the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.\n</p><h3>Tracking & Cookies Data</h3><p>\nWe use cookies and similar tracking technologies to track the activity on our Service and hold certain information.</p>\n<p>\nCookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service.\n</p><p>\nYou can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service.\n</p><p>Examples of Cookies we use:</p><ul><li><strong>Session Cookies.</strong>\n We use Session Cookies to operate our Service.</li><li><strong>Preference Cookies.</strong>\n We use Preference Cookies to remember your preferences and various settings.</li><li><strong>Security Cookies.\n</strong> We use Security Cookies for security purposes.</li></ul><h1>Use of Data</h1><p>\nNesuku uses the collected data for various purposes:</p><ul><li>To provide and maintain the Service</li><li>\nTo notify you about changes to our Service</li><li>\nTo allow you to participate in interactive features of our Service when you choose to do so</li><li>\nTo provide customer care and support</li><li>\nTo provide analysis or valuable information so that we can improve the Service</li><li>\nTo monitor the usage of the Service</li><li>To detect, prevent and address technical issues</li></ul><h1>\nTransfer Of Data</h1><p>\nYour information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction.\n</p><p>\nIf you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there.\n</p><p>\nYour consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer.\n</p><p>\nNesuku will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information.\n</p><h1>Disclosure Of Data</h1><h2>Legal Requirements</h2><p>\nNesuku may disclose your Personal Data in the good faith belief that such action is necessary to:</p><ul><li>\nTo comply with a legal obligation</li><li>To protect and defend the rights or property of Nesuku</li><li>\nTo prevent or investigate possible wrongdoing in connection with the Service</li><li>\nTo protect the personal safety of users of the Service or the public</li><li>To protect against legal liability</li>\n</ul><h1>Security Of Data</h1><p>\nThe security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security.\n</p><h1>Service Providers</h1><p>\nWe may employ third party companies and individuals to facilitate our Service (\"Service Providers\"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.\n</p><p>\nThese third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.\n</p><h1>Links To Other Sites</h1><p>\nOur Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party\'s site. We strongly advise you to review the Privacy Policy of every site you visit.\n</p><p>\nWe have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.\n</p><h1>Children\'s Privacy</h1><p>\nWe do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers.\n</p><h1>Your Rights</h1><p>\nIf you are a European resident, you have the right to access personal information we hold about you and to ask that your personal information be corrected, updated, or deleted. If you would like to exercise this right, please contact us through the contact information below.\n</p><p>\nAdditionally, if you are a European resident we note that we are processing your information in order to fulfill the Service we might provide you, or otherwise to pursue our legitimate business interests listed above. Additionally, please note that your information will be transferred outside of Europe, including to Canada and the United States.\n</p><h1>Changes To This Privacy Policy</h1><p>\nWe may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.\n</p><p>\nWe will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the \"effective date\" at the top of this Privacy Policy.\n</p><p>\nYou are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.\n</p><h1>Contact Us</h1><p>If you have any questions about this Privacy Policy, please contact us:</p><ul><li>\nBy email: andy.hsiao@nesuku.com</li><li>By visiting our website: www.nesuku.com</li><li>\nBy mail: 1010 Belmont Rd, Ann Arbor, MI 48104, United States</li></ul></div></md-content></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/review-essay/review-essay.html","<div id=\"review-essay\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">Review Essay</span></div></div><div class=\"content-container pt-20 pb-10\"><md-content \nclass=\"md-padding\"><div class=\"\" layout=\"column\" layout-align=\"center center\"><h1><b>Student Name</b></h1><div \nlayout=\"column\" layout-align=\"center center\" class=\"pt-10 safari-height\"><img class=\"header__avatar\" \nng-src=\"/assets/images/avatars/profile.jpg\" alt=\"avatar\"> <span class=\"teacher-name pt-5\">Johnny Appleseed</span></div>\n</div></md-content></div><div class=\"content-container pt-10 pb-20\"><md-content class=\"md-padding\"><div \nclass=\"content\" layout=\"column\" layout-align=\"center center\"><h1><b>Student\'s Essay(s)</b></h1><div class=\"full-width\" \nlayout=\"column\" layout-align=\"start start\"><md-input-container class=\"md-block full-width essay-text mt-30\"><label>\nCollege Essay</label><textarea class=\"full-width\" ng-model=\"vm.essayText\" rows=\"10\" md-select-on-focus></textarea><div \nclass=\"align-right pt-10\">Word Count: <span ng-bind=\"vm.countOf(vm.essayText)\"></span></div></md-input-container></div>\n</div></md-content></div><div class=\"content-container pt-10 pb-10\"><md-content class=\"md-padding\"><div \nclass=\"content\" layout=\"column\" layout-align=\"center center\"><h1><b>Upload Revised Essay</b></h1><div \nclass=\"mr-10 pt-10 pb-10\" style=\"font-size:13px\"><input type=\"file\" file-model=\"myFile\"></div></div></md-content></div>\n<div class=\"pb-10\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-primary btn-begin-session\" \nng-click=\"\">Submit</md-button></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/student-dashboard/student-dashboard.html","<div id=\"student-dashboard\" class=\"page-layout simple\"><div class=\"header md-accent-bg\"><div \nclass=\"content-container safari-height\" layout=\"row\" layout-align=\"space-around center\" layout-xs=\"column\" \nlayout-align-xs=\"space-between none\"><div flex=\"15\" flex-xs=\"100\" class=\"safari-height\"><img class=\"header__avatar\" \nng-src=\"{{ vm.user.avatar ? vm.user.avatar : vm.defaultAvatar }}\" alt=\"avatar\"></div><div \nclass=\"header__content safari-height\" flex=\"85\" flex-xs=\"100\" layout-xs=\"column\" layout-align-xs=\"space-around center\">\n<h1 flex-xs=\"100\" class=\"header__heading safari-height\"><span class=\"header__welcome-msg\" \ntranslate=\"STUDENT_DASHBOARD.WELCOME\"></span> <span class=\"header__name\">{{ vm.user.name ? vm.user.name : \'student\' }}.\n</span></h1><section flex-xs=\"100\" layout-xs=\"column\" layout-align-xs=\"space-between none\" class=\"safari-height\"><span \nclass=\"header__btn safari-height\" flex-xs=\"100\"><i class=\"icon-account-circle\"></i> <button \nng-click=\"vm.goToAccountSettings()\"><span>Account Settings</span></button> </span><span \nclass=\"header__btn safari-height\" flex-xs=\"100\"><i class=\"icon-email\"></i> <button ng-click=\"vm.contactNesuku()\"><span \ntranslate=\"STUDENT_DASHBOARD.CONTACT_NESUKU\"></span></button></span></section></div></div></div><div \nclass=\"content-container pt-40 pb-40\" ng-if=\"!vm.isLoading\"><div class=\"widget-group\" layout=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div layout=\"column\" flex=\"33\" flex-xs=\"100\"><ms-widget \nclass=\"no-padding mb-20\" ng-if=\"vm.essayRequests.length != 0\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-clipboard-text widget__icon\"></i><div class=\"widget__title\">Essay Review</div><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"i_icon\" uib-tooltip=\"Display essay review requests\" \ntooltip-placement=\"right\" tooltip-append-to-body=\"true\"></md-icon></div><div><div class=\"widget__content\" \nng-repeat=\"request in vm.essayRequests\" layout=\"column\" layout-align=\"center start\"><section><img \nclass=\"lesson__teacher-avatar\" ng-src=\"{{ request.teacherAvatar ? request.teacherAvatar : vm.defaultAvatar }}\" \nalt=\"teacher’s avatar\"> <span><a class=\"lesson__teacher-name\" ui-sref=\"app.pages_teacher({ id: request.teacherId })\">\n{{ request.teacherName }}</a></span></section><section><label class=\"widget__section-title\">Submission Date</label>\n<span class=\"lesson__timezone\">(GMT {{ vm.timezone }})</span><p class=\"lesson__datetime\">\n{{ request.submitTime | date: vm.dayDateFormat }} {{ request.submitTime | date: vm.timeFormat }}</p><label \nclass=\"widget__section-title\" ng-if=\"request.reviewTime\">Review Date</label><p class=\"lesson__datetime\" \nng-if=\"request.reviewTime\">\n{{ request.reviewTime | date: vm.dayDateFormat }} {{ request.reviewTime | date: vm.timeFormat }}</p></section><section \nclass=\"widget__action-bar\"><md-button class=\"md-raised md-primary btn-set-price\" ng-click=\"vm.goToEssay(request.id)\" \nng-if=\"request.status == 2\">View</md-button></section></div><div style=\"text-align:center\"><md-button \nclass=\"md-raised btn-action btn-send-message\" style=\"margin:20px\" translate=\"STUDENT_DASHBOARD.SHOW_MORE\" \nng-if=\"vm.hasMoreEssayRequest\" ng-click=\"vm.showMore(\'essayRequest\')\"></md-button></div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-account-check widget__icon\"></i><div class=\"widget__title\" translate=\"STUDENT_DASHBOARD.LESSON_REQUEST\">\n</div><md-icon md-font-icon=\"icon-information-outline\" class=\"i_icon\" \nuib-tooltip=\"{{ \'STUDENT_DASHBOARD.LESSON_REQUEST_TIP\' | translate }}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></div><div><div class=\"widget__content\" ng-if=\"vm.courseRequests.length === 0\">\n<p class=\"empty-state-text\" translate=\"STUDENT_DASHBOARD.YOUR_LESSON_REQUESTS\"></p></div><div class=\"widget__content\" \nng-repeat=\"lesson in vm.courseRequests\" layout=\"column\" layout-align=\"center start\"><section><img \nclass=\"lesson__teacher-avatar\" ng-src=\"{{ lesson.teacherAvatar ? lesson.teacherAvatar : vm.defaultAvatar }}\" \nalt=\"teacher’s avatar\"> <span><a class=\"lesson__teacher-name\" ui-sref=\"app.pages_teacher({ id: lesson.teacherId })\">\n{{ lesson.teacherName }}</a> <span class=\"lesson__status\">(Pending)</span></span></section><section><label \nclass=\"widget__section-title\" translate=\"STUDENT_DASHBOARD.LESSON_TIME\"></label><span class=\"lesson__timezone\">\n(GMT {{ vm.timezone }})</span><p class=\"lesson__datetime\">\n{{ lesson.times[0].start | date: vm.dayDateFormat }} {{ lesson.times[0].start | date: vm.timeFormat }} - {{ lesson.times[0].end | date: vm.timeFormat }}\n</p></section><section ng-if=\"lesson.times.length > 1\"><label class=\"widget__section-title\" \ntranslate=\"STUDENT_DASHBOARD.REPEAT_WEEKLY\"></label><p class=\"lesson__repeatweekly\">For {{ lesson.times.length }} weeks\n</p></section><section ng-if=\"lesson.price || lesson.price === 0\"><label class=\"widget__section-title\" \ntranslate=\"STUDENT_DASHBOARD.PRICE\"></label><p class=\"lesson__price\">$ {{ lesson.price }}</p></section><section \nclass=\"widget__action-bar\"><md-button class=\"btn-cancel-request\" translate=\"STUDENT_DASHBOARD.CANCEL\" \naria-label=\"Cancel\" ng-click=\"vm.cancelRequest($index, lesson)\"></md-button></section></div><div \nstyle=\"text-align:center\"><md-button class=\"md-raised btn-action btn-send-message\" style=\"margin:20px\" \ntranslate=\"STUDENT_DASHBOARD.SHOW_MORE\" ng-if=\"vm.hasMoreCourseRequest\" ng-click=\"vm.showMore(\'courseRequest\')\">\n</md-button></div></div></ms-widget-front></ms-widget></div><div layout=\"column\" flex=\"65\" flex-xs=\"100\"><ms-widget \nclass=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div class=\"p-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-message-video widget__icon\"></i><div class=\"widget__title\" \ntranslate=\"STUDENT_DASHBOARD.UPCOMING_CLASSES\"></div><md-icon md-font-icon=\"icon-information-outline\" class=\"i_icon\" \nuib-tooltip=\"{{ \'STUDENT_DASHBOARD.UPCOMING_TIP\' | translate}}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></div><div><div class=\"widget__content\" \nng-if=\"vm.upcomingClasses.length === 0\"><p class=\"empty-state-text\" \ntranslate=\"STUDENT_DASHBOARD.YOUR_UPCOMING_LESSONS\"></p></div><div class=\"widget__content\" \nng-repeat=\"class in vm.upcomingClasses\" layout=\"row\" layout-align=\"start center\"><div layout=\"column\" flex=\"grow\"><p \nclass=\"lesson__time\">{{ class.startsIn }}</p><div layout=\"row\" layout-align=\"space-between center\"><span \nlayout-xs=\"column\" layout-align-xs=\"center start\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"start center\"><img\n class=\"lesson__teacher-avatar\" ng-src=\"{{ class.teacherAvatar ? class.teacherAvatar : vm.defaultAvatar }}\" \nalt=\"Teacher\'s avatar\"> <a class=\"lesson__teacher-name\" ui-sref=\"app.pages_teacher({ id: class.teacherId })\">\n{{ class.teacherName }}</a></div></span><span><p class=\"lesson__time\">\n{{ class.start | date: vm.dayDateFormat }} {{ class.start | date: vm.timeFormat }} - {{ class.end | date: vm.timeFormat }}\n</p></span><span class=\"widget__action-bar\"><md-button translate=\"STUDENT_DASHBOARD.CANCEL\" \nng-click=\"vm.checkPolicy(class, $index)\"></md-button><md-button class=\"md-raised md-primary btn-begin-session\" \ntranslate=\"STUDENT_DASHBOARD.BEGIN\" ng-click=\"vm.beginLesson(class.videoLink)\"></md-button></span></div></div></div>\n<div style=\"text-align:center\"><md-button class=\"md-raised btn-action btn-send-message\" style=\"margin:20px\" \ntranslate=\"STUDENT_DASHBOARD.SHOW_MORE\" ng-if=\"vm.hasMoreUpcoming\" ng-click=\"vm.showMore(\'upcoming\')\"></md-button>\n</div></div></ms-widget-front></ms-widget><ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-check-circle widget__icon\"></i><div class=\"widget__title\" translate=\"STUDENT_DASHBOARD.HISTORY\"></div>\n<md-icon md-font-icon=\"icon-information-outline\" class=\"i_icon\" \nuib-tooltip=\"{{ \'STUDENT_DASHBOARD.PREVIOUS_TIP\' | translate}}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></div><div><div class=\"widget__content\" \nng-if=\"vm.previousClasses.length === 0\"><p class=\"empty-state-text\" \ntranslate=\"STUDENT_DASHBOARD.YOUR_PREVIOUS_LESSONS\"></p></div><div class=\"widget__content\" \nng-repeat=\"class in vm.previousClasses\" layout=\"row\" layout-align=\"start center\"><div layout=\"column\" \nlayout=\"start center\" flex=\"grow\"><div layout=\"row\" layout-align=\"start center\" layout-align=\"start center\"><span \nclass=\"lesson__history--status\" ng-if=\"class.status.id == 2\">Completed</span> <span class=\"lesson__history--status\" \nng-if=\"class.status.id == 3\">Cancelled</span> <span class=\"lesson__history--status\" ng-if=\"class.status.id == 4\">\nExpired</span> <time class=\"lesson__time\">{{ class.startedAt }}</time></div><div layout=\"row\" \nlayout-align=\"space-between center\"><span layout-xs=\"column\" layout-align-xs=\"center start\"><div layout=\"row\" \nlayout-xs=\"column\" layout-align=\"start center\"><img class=\"lesson__teacher-avatar\" \nng-src=\"{{ class.teacherAvatar ? class.teacherAvatar : vm.defaultAvatar }}\" alt=\"Teacher\'s avatar\"> <a \nclass=\"lesson__teacher-name\" ui-sref=\"app.pages_teacher({ id: class.teacherId })\">{{ class.teacherName }}</a></div>\n</span><span><p class=\"lesson__time\">\n{{ class.start | date: vm.dayDateFormat }} {{ class.start | date: vm.timeFormat }} - {{ class.end | date: vm.timeFormat }}\n</p></span><span class=\"widget__action-bar\" layout=\"column\"><md-button class=\"widget__rate__text md-raised btn-rate\" \nng-click=\"vm.rebook(class.teacherId)\" translate=\"STUDENT_DASHBOARD.REBOOK\"></md-button><md-button \nclass=\"widget__rate__text md-raised btn-rate\" ng-disabled=\"class.isReviewed\" ng-click=\"vm.openRateDialog($index)\" \ntranslate=\"STUDENT_DASHBOARD.RATE_SHORT\"><md-icon md-font-icon=\"icon-star\" class=\"star\"></md-icon></md-button></span>\n</div></div></div><div style=\"text-align:center\"><md-button class=\"md-raised btn-action btn-send-message\" \nstyle=\"margin:20px\" translate=\"STUDENT_DASHBOARD.SHOW_MORE\" ng-if=\"vm.hasMorePrevious\" \nng-click=\"vm.showMore(\'previous\')\"></md-button></div></div></ms-widget-front></ms-widget></div></div></div><div \nclass=\"loading content-container pt-40 pb-40\" ng-if=\"vm.isLoading\"><div class=\"widget-group\" layout=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div layout=\"column\" flex=\"33\" flex-xs=\"100\"><ms-widget \nclass=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div class=\"p-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-account-check widget__icon\"></i><div class=\"widget__title\" \ntranslate=\"STUDENT_DASHBOARD.LESSON_REQUEST\"></div></div><div><div \nng-include=\"\'app/main/states/loading-lesson-requests.html\'\"></div></div></ms-widget-front></ms-widget></div><div \nlayout=\"column\" flex=\"65\" flex-xs=\"100\"><ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-message-video widget__icon\"></i><div class=\"widget__title\" translate=\"STUDENT_DASHBOARD.UPCOMING_CLASSES\">\n</div></div><div><div ng-include=\"\'app/main/states/loading-lessons.html\'\"></div></div></ms-widget-front></ms-widget>\n<ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div class=\"p-8 border-bottom widget__header\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-check-circle widget__icon\"></i><div class=\"widget__title\" \ntranslate=\"STUDENT_DASHBOARD.PREVIOUS_CLASSES\"></div></div><div><div \nng-include=\"\'app/main/states/loading-lessons.html\'\"></div></div></ms-widget-front></ms-widget></div></div></div></div>\n<div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/teach-form/teach-form.html","<div id=\"teach-form\" class=\"page-layout simple\"><div class=\"content-container pt-20 pb-10\" layout=\"row\" \nlayout-align=\"center center\"><iframe \nsrc=\"https://docs.google.com/forms/d/e/1FAIpQLScDi__hrzw4UkhGEfcK5hGEndRxuXPZ4HpFs6oir37bRLNS2g/viewform?embedded=true\" \nwidth=\"1280\" height=\"2500\" frameborder=\"0\" marginheight=\"0\" marginwidth=\"0\">Loading...</iframe></div></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/teacher/teacher-info.html","<md-card id=\"teacher-info\" layout=\"column\"><div class=\"p-32\" layout=\"row\" layout-align=\"space-around center\" \nlayout-wrap><div flex=\"30\" flex-sm=\"25\" flex-xs=\"50\" layout=\"row\" layout-align=\"center center\"><img \nclass=\"teacher-avatar\" \nng-src=\"{{ vm.teacher.info.avatar ? vm.teacher.info.avatar : \'assets/images/avatars/profile.jpg\' }}\" \nalt=\"Teacher\'s Avatar\"></div><div flex=\"70\" flex-sm=\"75\" flex-xs=\"100\" style=\"width: 100%\"><h2 layout=\"row\" \nlayout-align=\"start center\" layout-align-xs=\"center center\" class=\"teacher-name\">{{ vm.teacher.info.name }}</h2><div \nlayout=\"row\" layout-align=\"start center\" layout-align-xs=\"space-around center\"><span uib-rating class=\"teacher-rating\" \nng-model=\"vm.teacher.info.rate\" max=\"5\" read-only=\"true\" aria-labelledby=\"default-rating\"></span> <span \nclass=\"teacher-price\" ng-if=\"vm.teacher.info.defaultPrice\"><text translate=\"TEACHER.PRICE\"></text>\n${{ vm.teacher.info.defaultPrice }}<text translate=\"TEACHER.PER_HOUR\"></text></span></div><div \nng-if=\"! $root.isPreviewMode\"><div ng-if=\"!vm.isGuest() && vm.isTeacher()\" layout=\"row\" layout-align=\"start center\" \nlayout-align-xs=\"space-around center\"><md-button class=\"md-raised btn-action btn-send-message\" \ntranslate=\"TEACHER.MESSAGE_TEACHER\" disabled=\"disabled\"></md-button><md-button \nclass=\"md-raised md-primary btn-action btn-schedule\" translate=\"TEACHER.SCHEDULE_A_SESSION\" disabled=\"disabled\">\n</md-button></div><div ng-if=\"!vm.isGuest() && !vm.isTeacher()\" layout=\"row\" layout-align=\"start center\" \nlayout-align-xs=\"space-around center\"><md-button class=\"md-raised btn-action btn-send-message\" \ntranslate=\"TEACHER.MESSAGE_TEACHER\" ng-click=\"vm.openMessageDialog()\"></md-button><md-button \nclass=\"md-raised md-primary btn-action btn-schedule\" translate=\"TEACHER.SCHEDULE_A_SESSION\" \nng-click=\"vm.goToSchedule()\"></md-button></div><div ng-if=\"vm.isGuest()\" layout=\"row\" layout-align=\"start center\" \nlayout-align-xs=\"space-around center\"><md-button class=\"md-raised btn-action btn-send-message\" \ntranslate=\"TEACHER.MESSAGE_TEACHER\" ng-click=\"vm.registerStudent()\"></md-button><md-button \nclass=\"md-raised md-primary btn-action btn-schedule\" translate=\"TEACHER.SCHEDULE_A_SESSION\" \nng-click=\"vm.registerStudent()\"></md-button></div></div><div ng-if=\"$root.isPreviewMode\" layout=\"row\" \nlayout-align=\"start center\" layout-align-xs=\"space-around center\"><md-button \nclass=\"md-raised btn-action btn-send-message\" translate=\"TEACHER.MESSAGE_TEACHER\"></md-button><md-button \nclass=\"md-raised md-primary btn-action btn-schedule\" translate=\"TEACHER.SCHEDULE_A_SESSION\"></md-button></div></div>\n<div class=\"text mt-35 teacher-bio\" flex=\"100\"><b>Teaches:</b> <span \nng-repeat=\"subjectName in vm.teacher.info.subjectNames\">\n{{ subjectName }} {{$last ? \'\' : ($index==vm.teacher.info.subjectNames.length-2) ? \' and \' : \', \'}}</span></div><div \nclass=\"text mt-35 teacher-bio\" flex=\"100\">{{ vm.teacher.info.bio }}</div></div></md-card>");
$templateCache.put("app/main/pages/teacher/teacher.html","<div id=\"teacher-intro-page\" class=\"page-layout simple\"><div ng-cloak ng-if=\"vm.teacher.info.introVideo\"><md-content>\n<md-tabs md-dynamic-height md-border-bottom md-no-ink-bar md-align-tabs=\"bottom\" md-center-tabs md-selected=\"1\"><md-tab\n label=\"{{ \'TEACHER.SOURCE\' | translate }}\" ng-disabled=\"1\"><md-content class=\"md-padding\"></md-content></md-tab>\n<md-tab label=\"YouTube\"><md-content class=\"md-padding\"><section class=\"teacher-header\" layout=\"row\"><div flex=\"25\" \nflex-xs=\"0\"></div><div flex=\"50\" flex-xs=\"100\"><div ng-if=\"vm.teacher.info.introVideo\" \nclass=\"intrinsic-container intrinsic-container-16x9\"><iframe ng-src=\"{{ vm.teacher.info.introVideo }}\" frameborder=\"0\" \nallowfullscreen></iframe></div></div><div flex></div></section></md-content></md-tab><md-tab \nlabel=\"{{ \'TEACHER.YOUKU\' | translate }}\"><md-content class=\"md-padding\"><section \nng-if=\"vm.teacher.info.introVideoYouku\" class=\"teacher-header\" layout=\"row\"><div flex=\"25\"></div><div flex=\"50\"><div \nng-if=\"vm.teacher.info.introVideoYouku\" class=\"intrinsic-container intrinsic-container-16x9\"><iframe \nng-src=\"{{ vm.teacher.info.introVideoYouku }}\" frameborder=\"0\" allowfullscreen></iframe></div></div><div flex></div>\n</section></md-content></md-tab></md-tabs></md-content></div><section class=\"teacher-content content-container\" \nlayout=\"row\" layout-align=\"center start\"><div flex-gt-sm=\"70\"><section class=\"teacher-content__info\"><h2 \nclass=\"headline\"><i class=\"icon icon-account-box s24 headline__icon\"></i> <span class=\"headline__title\" \ntranslate=\"TEACHER.INTRODUCTION\">Introduction</span></h2><div ng-include=\"\'app/main/pages/teacher/teacher-info.html\'\">\n</div></section><section class=\"teacher-content__policy\" \nng-if=\"(vm.teacher.info.cancelPolicy != 0) || (!vm.teacher.info.cancelPolicy)\"><h2 class=\"headline\"><i \nclass=\"icon icon-account-box s24 headline__icon\"></i> <span class=\"headline__title\" translate=\"TEACHER.POLICY\">Policy\n</span></h2><md-card><h3>Scheduling In Advance</h3><p>Student must book <b>{{ vm.teacher.info.schedulePolicy }} hours\n</b> before the lesson start time.</p><h3>Cancellation</h3><p>Student must cancel <b>\n{{ vm.teacher.info.cancelPolicy }} hours</b> before the lesson start time in order to receive a full refund.</p>\n</md-card></section><section class=\"essay__review\" ng-if=\"vm.teacher.info.isEssayReview\"><h2 class=\"headline\"><i \nclass=\"icon-clipboard-text s24 headline__icon\"></i> <span class=\"headline__title\">Essay Review</span></h2><md-card><div\n class=\"p-32 layout-wrap layout-align-space-around-center layout-row\"><div class=\"text\" flex=\"100\"><h3>\nThe following are a few of the different essay review services that are offered:</h3></div><ul class=\"text\" \nlayout=\"column\" layout-align=\"start start\" flex=\"100\"><li>College Essay Review</li><li>College Essay Package</li><li>\nTOEFL/IELTS Essay</li><li>SAT Essay</li><li>Academic Writing Essay</li></ul><div layout=\"row\" flex=\"100\" \nlayout-align=\"end center\" layout-align-xs=\"space-around center\"><md-button \nclass=\"md-raised md-primary btn-action btn-schedule\" ng-click=\"vm.goToEssayReview()\">Submit an essay</md-button></div>\n</div></md-card></section><section class=\"teacher-content__packages\" ng-if=\"vm.packages.length != 0\"><h2 \nclass=\"headline\"><i class=\"icon-briefcase-download s24 headline__icon\"></i> <span class=\"headline__title\" \ntranslate=\"Packages\"></span></h2><md-card><div class=\"package__section\"><div class=\"package__frame\" \nng-repeat=\"package in vm.packages\"><div class=\"package__card\" layout=\"row\" layout-align=\"space-between start\"><div \nflex=\"90\" flex-xs=\"85\"><div><span class=\"package__name\">{{ package.packageName }}</span> <span class=\"package__info\">\n{{ package.hours }} hours</span> <span class=\"package__info\">$ {{ package.packagePrice }}</span></div><div><span \nclass=\"package__category\">{{ package.categoryName }}</span> <span class=\"package__category\">\n${{ package.hourlyPrice }}/hr</span></div></div><md-button class=\"md-raised md-primary btn-action btn-schedule\" \ntranslate=\"TEACHER.PURCHASE_PACKAGE\" \nng-click=\"vm.purchasePackage(\n                                                package.packageId,\n                                                package.packageName,\n                                                package.packagePrice,\n                                                package.hours)\">\n</md-button></div></div></div></md-card></section><section id=\"anchor-schedule\" class=\"teacher-content__schedule\"><h2 \nclass=\"headline\"><i class=\"icon icon-calendar-check s24 headline__icon\"></i> <span class=\"headline__title\" \ntranslate=\"TEACHER.SCHEDULE\">Schedule</span></h2><div class=\"ms-card\" \nng-include=\"\'app/main/pages/teacher/calendar/calendar.html\'\"></div></section><section class=\"teacher-content__reviews\" \nlayout=\"column\" layout=\"start start\"><h2 class=\"headline\"><i \nclass=\"icon icon-comment-multipe-outline s24 headline__icon\"></i> <span class=\"headline__title\" \ntranslate=\"TEACHER.REVIEWS\">Reviews</span></h2><div class=\"ms-card reviewer\" layout=\"row\" \nng-repeat=\"review in vm.teacher.reviews | limitTo : vm.pagination.itemsPerPage : vm.pagination.begin\"><div flex=\"10\" \nflex-xs=\"20\"><img class=\"reviewer__avatar\" ng-src=\"{{ review.studentAvatar }}\" alt=\"{{ review.studentName }}\"></div>\n<div flex=\"90\" flex-xs=\"80\"><div class=\"reviewer__name\">{{ review.studentName }}</div><div uib-rating \nclass=\"reviewer__rating\" ng-model=\"review.rate\" max=\"5\" read-only=\"true\" aria-labelledby=\"default-rating\"></div><p \nclass=\"reviewer__comment\">{{ review.comment }}</p></div></div><div class=\"ms-card reviewer\" layout=\"row\" \nng-if=\"vm.teacher.reviews.length==0\"><p class=\"reviewer__comment\" translate=\"TEACHER.NO_REVIEW_MESSAGE\"></p></div><div \nclass=\"pager-container\"><ul uib-pagination class=\"pagination-sm reviewer__pager\" \ntotal-items=\"vm.pagination.totalItems\" ng-model=\"vm.pagination.currentPage\" max-size=\"vm.pagination.maxSize\" \nitems-per-page=\"vm.pagination.itemsPerPage\" rotate=\"false\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" \nng-change=\"vm.pagination.setPage()\"></ul></div></section></div></section></div><div \nng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/teacher-dashboard/teacher-dashboard.html","<div id=\"teacher-dashboard\" class=\"page-layout simple\"><div class=\"header md-accent-bg\"><div \nclass=\"content-container safari-height\" layout=\"row\" layout-align=\"space-around center\" layout-xs=\"column\" \nlayout-align-xs=\"space-between none\"><div flex=\"15\" flex-xs=\"100\" class=\"safari-height\"><img class=\"header__avatar\" \nng-src=\"{{ vm.teacher.avatar ? vm.teacher.avatar : vm.defaultAvatar }}\" alt=\"avatar\"></div><div \nclass=\"header__content safari-height\" flex=\"85\" flex-xs=\"100\" layout-xs=\"column\" layout-align-xs=\"space-around center\">\n<h1 flex-xs=\"100\" class=\"header__heading safari-height\"><span class=\"header__welcome-msg\" \ntranslate=\"TEACHER_DASHBOARD.WELCOME\"></span> <span class=\"header__name\">\n{{ vm.teacher.name ? vm.teacher.name : \'teacher\' }}.</span></h1><section flex-xs=\"100\" layout-xs=\"column\" \nlayout-align-xs=\"space-between none\" class=\"safari-height\"><span class=\"header__btn safari-height\" flex-xs=\"100\"><i \nclass=\"icon-clipboard-text\"></i> <button ui-sref=\"app.pages_edit-teacher\"><span \ntranslate=\"TEACHER_DASHBOARD.EDIT_PROFILE\"></span></button> </span><span class=\"header__btn safari-height\" \nflex-xs=\"100\"><i class=\"icon-earth\"></i> <button ng-click=\"vm.viewPublicProfile()\"><span \ntranslate=\"TEACHER_DASHBOARD.VIEW_PUBLIC_PROFILE\"></span></button> </span><span class=\"header__btn safari-height\" \nflex-xs=\"100\"><i class=\"icon-email\"></i> <button ng-click=\"vm.contactNesuku()\"><span \ntranslate=\"TEACHER_DASHBOARD.CONTACT_NESUKU\"></span></button> </span><span class=\"header__btn safari-height\" \nflex-xs=\"100\"><i class=\"icon-cash\"></i> <button ng-click=\"vm.makeupPayment()\"><span>Request Payment</span></button>\n</span></section></div></div></div><div class=\"content-container pt-40 pb-40\" ng-if=\"!vm.isLoading\"><div \nclass=\"widget-group\" layout=\"row\" layout-align=\"space-between start\" layout-wrap><div layout=\"column\" flex=\"33\" \nflex-xs=\"100\"><ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-message-video widget__icon\"></i><div class=\"widget__title\" translate=\"TEACHER_DASHBOARD.UPCOMING\"></div>\n<md-icon md-font-icon=\"icon-information-outline\" class=\"i_icon\" \nuib-tooltip=\"{{ \'TEACHER_DASHBOARD.UPCOMING_TIP\' | translate }}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></div><div><div class=\"widget__content\" \nng-if=\"vm.upcomingClasses.length === 0\"><p class=\"empty-state-text\" \ntranslate=\"TEACHER_DASHBOARD.YOUR_UPCOMING_LESSONS\"></p></div><div class=\"widget__content\" \nng-repeat=\"class in vm.upcomingClasses\" layout=\"column\" layout-align=\"center start\"><section><p class=\"student__time\">\n{{ class.startsIn }}</p><img class=\"student__avatar\" \nng-src=\"{{ class.studentAvatar ? class.studentAvatar : vm.defaultAvatar }}\" alt=\"Student\'s avatar\"> <span \nclass=\"student__name\">{{ class.studentName }}</span></section><section><label class=\"widget__section-title\" \ntranslate=\"TEACHER_DASHBOARD.SCHEDULE_TIME\"></label><span class=\"lesson__timezone\">(GMT {{ vm.timezone }})</span><p \nclass=\"lesson__datetime\">\n{{ class.start | date: vm.dayDateFormat }} {{ class.start | date: vm.timeFormat }} - {{ class.end | date: vm.timeFormat }}\n</p></section><section class=\"widget__action-bar\"><md-button translate=\"TEACHER_DASHBOARD.CANCEL\" \nng-click=\"vm.cancelCourse($index, class)\"></md-button><md-button class=\"md-raised md-primary btn-begin-session\" \ntranslate=\"TEACHER_DASHBOARD.BEGIN\" ng-click=\"vm.beginLesson()\"></md-button></section></div><div \nstyle=\"text-align:center\"><md-button class=\"md-raised btn-action btn-send-message\" style=\"margin:20px\" \ntranslate=\"STUDENT_DASHBOARD.SHOW_MORE\" ng-if=\"vm.hasMoreUpcoming\" ng-click=\"vm.showMore(\'upcoming\')\"></md-button>\n</div></div></ms-widget-front></ms-widget><ms-widget class=\"no-padding mb-20\" ng-if=\"vm.essayRequests.length != 0\">\n<ms-widget-front class=\"white-bg\"><div class=\"p-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-account-check widget__icon\"></i><div class=\"widget__title\">Essay Requests\n</div></div><div><div class=\"widget__content\" ng-repeat=\"request in vm.essayRequests\" layout=\"column\" \nlayout-align=\"center start\"><section><img class=\"lesson__student-avatar\" \nng-src=\"{{ request.studentAvatar ? request.studentAvatar : vm.defaultAvatar }}\" alt=\"student\'s avatar\"> <span><span \nclass=\"lesson__student-name\">{{ request.studentName }}</span></span></section><section><label \nclass=\"widget__section-title\">Submission Date</label><span class=\"lesson__timezone\">(GMT {{ vm.timezone }})</span><div \nlayout=\"column\"><span class=\"lesson__datetime\">\n{{ request.submitTime | date: vm.dayDateFormat }} {{ request.submitTime | date: vm.timeFormat }}</span></div></section>\n<section class=\"widget__action-bar\"><md-button class=\"md-raised md-primary btn-set-price\" \nng-click=\"vm.goToEssay(request.id)\">View</md-button></section></div><div style=\"text-align:center\"><md-button \nclass=\"md-raised btn-action btn-send-message\" style=\"margin:20px\" translate=\"TEACHER_DASHBOARD.SHOW_MORE\" \nng-if=\"vm.hasMoreEssayRequest\" ng-click=\"vm.showMore(\'essayRequest\')\"></md-button></div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-account-check widget__icon\"></i><div class=\"widget__title\" translate=\"TEACHER_DASHBOARD.LESSON_REQUEST\">\n</div><md-icon md-font-icon=\"icon-information-outline\" class=\"i_icon\" \nuib-tooltip=\"{{ \'TEACHER_DASHBOARD.LESSON_REQUEST_TIP\' | translate }}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></div><div><div class=\"widget__content\" ng-if=\"vm.courseRequests.length === 0\">\n<p class=\"empty-state-text\" translate=\"TEACHER_DASHBOARD.YOUR_LESSON_REQUESTS\"></p></div><div class=\"widget__content\" \nng-repeat=\"lesson in vm.courseRequests\" layout=\"column\" layout-align=\"center start\"><section><img \nclass=\"lesson__student-avatar\" ng-src=\"{{ lesson.studentAvatar ? lesson.studentAvatar : vm.defaultAvatar }}\" \nalt=\"student\'s avatar\"> <span><span class=\"lesson__student-name\">{{ lesson.studentName }}</span> <span \nclass=\"lesson__reminder\"></span></span></section><section><label class=\"widget__section-title\" \ntranslate=\"TEACHER_DASHBOARD.SCHEDULE_TIME\"></label><span class=\"lesson__timezone\">(GMT {{ vm.timezone }})</span><div \nlayout=\"column\"><span class=\"lesson__datetime\">\n{{ lesson.times[0].start | date: vm.dayDateFormat }} {{ lesson.times[0].start | date: vm.timeFormat }} - {{ lesson.times[0].end | date: vm.timeFormat }}\n</span></div></section><section ng-if=\"lesson.times.length > 1\"><label class=\"widget__section-title\" \ntranslate=\"TEACHER_DASHBOARD.REPEAT_WEEKLY\"></label><p class=\"lesson__repeatweekly\">For {{ lesson.times.length }} weeks\n</p></section><section ng-if=\"lesson.price || lesson.price === 0\"><label class=\"widget__section-title\" \ntranslate=\"TEACHER_DASHBOARD.PRICE\"></label><p class=\"lesson__price\">$ {{ lesson.price }}</p></section><section \nclass=\"widget__action-bar\"><md-button class=\"btn-decline\" translate=\"TEACHER_DASHBOARD.DECLINE\" \nng-click=\"vm.cancelRequest($index, lesson)\"></md-button><md-button class=\"md-raised md-primary btn-set-price\" \ntranslate=\"TEACHER_DASHBOARD.ACCEPT\" ng-click=\"vm.acceptRequest($index, lesson)\"></md-button></section></div><div \nstyle=\"text-align:center\"><md-button class=\"md-raised btn-action btn-send-message\" style=\"margin:20px\" \ntranslate=\"TEACHER_DASHBOARD.SHOW_MORE\" ng-if=\"vm.hasMoreRequest\" ng-click=\"vm.showMore(\'essayRequest\')\"></md-button>\n</div></div></ms-widget-front></ms-widget><ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-message-video widget__icon\"></i><div class=\"widget__title\" translate=\"TEACHER_DASHBOARD.HISTORY\"></div>\n<md-icon md-font-icon=\"icon-information-outline\" class=\"i_icon\" \nuib-tooltip=\"{{ \'TEACHER_DASHBOARD.PREVIOUS_TIP\' | translate }}\" tooltip-placement=\"right\" \ntooltip-append-to-body=\"true\"></md-icon></div><div><div class=\"widget__content\" \nng-if=\"vm.previousClasses.length === 0\"><p class=\"empty-state-text\" \ntranslate=\"TEACHER_DASHBOARD.YOUR_PREVIOUS_LESSONS\"></p></div><div class=\"widget__content\" \nng-repeat=\"class in vm.previousClasses\" layout=\"column\" layout-align=\"center start\"><section><time \nclass=\"student__time\">{{ class.startedAt }}</time> <img class=\"student__avatar\" \nng-src=\"{{ class.studentAvatar ? class.studentAvatar : vm.defaultAvatar }}\" alt=\"Student\'s avatar\"> <span \nclass=\"student__name\">{{ class.studentName }}</span></section><section><label class=\"widget__section-title\" \ntranslate=\"TEACHER_DASHBOARD.SCHEDULE_TIME\"></label><span class=\"lesson__timezone\">(GMT {{ vm.timezone }})</span><p \nclass=\"lesson__datetime\">\n{{ class.start | date: vm.dayDateFormat }} {{ class.start | date: vm.timeFormat }} - {{ class.end | date: vm.timeFormat }}\n</p></section><section class=\"widget__action-bar\"><span class=\"lesson__history--status\" ng-if=\"class.status.id == 2\">\nCompleted</span> <span class=\"lesson__history--status\" ng-if=\"class.status.id == 3\">Cancelled</span> <span \nclass=\"lesson__history--status\" ng-if=\"class.status.id == 4\">Expired</span></section></div><div \nstyle=\"text-align:center\"><md-button class=\"md-raised btn-action btn-send-message\" style=\"margin:20px\" \ntranslate=\"STUDENT_DASHBOARD.SHOW_MORE\" ng-if=\"vm.hasMorePrevious\" ng-click=\"vm.showMore(\'previous\')\"></md-button>\n</div></div></ms-widget-front></ms-widget></div><div layout=\"column\" flex=\"65\" flex-xs=\"100\"><ms-widget \nclass=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-calendar-check widget__icon\"></i><div class=\"widget__title\" \ntranslate=\"TEACHER_DASHBOARD.WEEKLY_SCHEDULE\" ng-if=\"!vm.isAvailability\"></div><md-switch ng-model=\"vm.switchTitle\" \nng-true-value=\"\'Specific Weekly Schedule\'\" ng-false-value=\"\'Default Weekly Schedule\'\" name=\"switchAvailability\" \naria-label=\"Switch Availability\" ng-if=\"vm.isAvailability\" ng-change=\"vm.toggleSpecific()\" class=\"widget__title\">\n{{ vm.switchTitle }}</md-switch><md-button class=\"md-raised md-primary btn-action calendar__titleButton\" \nng-if=\"!vm.isAvailability\" name=\"availability\" ng-click=\"vm.toggleAvailability($event)\" \ntranslate=\"Edit Availabilities\"></md-button><md-button class=\"md-raised md-primary btn-action calendar__titleButton\" \nng-if=\"vm.isAvailability\" name=\"done\" ng-click=\"vm.toggleAvailability($event)\" translate=\"Done\"></md-button></div><div \nng-include=\"\'app/main/pages/teacher-dashboard/calendar/calendar.html\'\" ng-if=\"!vm.isAvailability\"></div><div \nng-include=\"\'app/main/pages/teacher-dashboard/calendar/regular-calendar.html\'\" \nng-if=\"vm.isAvailability && !vm.isSpecific\"></div><div \nng-include=\"\'app/main/pages/teacher-dashboard/calendar/specific-calendar.html\'\" \nng-if=\"vm.isAvailability && vm.isSpecific\"></div></ms-widget-front></ms-widget><ms-widget class=\"no-padding mb-20\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-briefcase-download widget__icon\"></i> <span class=\"widget__title\" \ntranslate=\"My Packages\"></span><md-button class=\"md-raised md-primary btn-action calendar__titleButton\" \nname=\"createPackage\" ng-click=\"vm.createPackage()\" translate=\"Create a Package\"></md-button></div><div class=\"package\">\n<div class=\"widget__content\" ng-repeat=\"package in vm.packages\"><section class=\"teacher-content__packages\" \nng-click=\"vm.dropDownControl($index)\"><div layout=\"row\" layout-align=\"space-between start\"><div flex=\"90\" flex-xs=\"85\">\n<div><span class=\"package__name\">{{ package.packageName }}</span> <span class=\"package__info\">{{ package.hours }} hours\n</span> <span class=\"package__info\">$ {{ package.packagePrice }}</span></div><div><span class=\"package__category\">\n{{ package.categoryName }}</span> <span class=\"package__category\">${{ package.hourlyPrice }}/hr</span></div><div \nng-if=\"vm.packageIndex.includes($index)\"><span class=\"student__package__title\" \ntranslate=\"TEACHER_DASHBOARD.REMAINING_HOURS\">remaining package hours:</span><md-list-item \nng-repeat=\"studentPackage in vm.packageStudents[package.packageName]\"><section layout-fill flex layout=\"row\"><div \nclass=\"studentPackage__subsubtitle\">{{ studentPackage[0] }}:</div><div class=\"studentPackage__subchevron\">\n{{ studentPackage[1] }} hour(s)</div></section></md-list-item></div></div><md-list-item><section layout=\"row\" \nlayout-fill flex><i class=\"icon-chevron-right balance__chevron\" ng-class=\"{rotate: vm.packageIndex.includes($index)}\">\n</i></section></md-list-item></div></section></div></div></ms-widget-front></ms-widget><ms-widget class=\"no-padding\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-comment-multipe-outline widget__icon\"></i> <span class=\"widget__title\" \ntranslate=\"TEACHER_DASHBOARD.RECENT_REVIEW\"></span></div><div class=\"widget__content\" ng-if=\"vm.reviews.length === 0\">\n<p class=\"empty-state-text\" translate=\"TEACHER_DASHBOARD.NO_REVIEW\"></p></div><div class=\"widget__content\"><section \nclass=\"teacher-content__reviews\"><div class=\"reviewer\" layout=\"row\" layout-align=\"space-between start\" \nng-repeat=\"review in vm.reviews\"><div flex=\"10\" flex-xs=\"20\"><img class=\"reviewer__avatar\" \nng-src=\"{{ review.studentAvatar ? review.studentAvatar : vm.defaultAvatar }}\" alt=\"{{ review.studentName }}\"></div><div\n flex=\"90\" flex-xs=\"85\"><div><span class=\"reviewer__name\">{{ review.studentName }}</span> <span class=\"reviewer__date\">\n{{ review.datetime | date: vm.dateFormat }}</span></div><div uib-rating class=\"reviewer__rating\" \nng-model=\"review.rate\" max=\"5\" read-only=\"true\" aria-labelledby=\"default-rating\"></div><p class=\"reviewer__comment\">\n{{ review.comment }}</p></div></div></section><div style=\"text-align:center\"><md-button \nclass=\"md-raised btn-action btn-send-message\" style=\"margin:20px\" translate=\"TEACHER_DASHBOARD.SHOW_MORE\" \nng-if=\"vm.hasMoreReview\" ng-click=\"vm.showMore(\'reviews\')\"></md-button></div></div></ms-widget-front></ms-widget></div>\n</div></div><div class=\"loading content-container pt-40 pb-40\" ng-if=\"vm.isLoading\"><div class=\"widget-group\" \nlayout=\"row\" layout-align=\"space-between start\" layout-wrap><div layout=\"column\" flex=\"33\" flex-xs=\"100\"><ms-widget \nclass=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div class=\"p-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-message-video widget__icon\"></i><div class=\"widget__title\" \ntranslate=\"TEACHER_DASHBOARD.UPCOMING\"></div></div><div><div \nng-include=\"\'app/main/states/loading-lesson-requests.html\'\"></div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div class=\"p-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-account-check widget__icon\"></i><div class=\"widget__title\" \ntranslate=\"TEACHER_DASHBOARD.LESSON_REQUEST\"></div></div><div><div \nng-include=\"\'app/main/states/loading-lesson-requests.html\'\"></div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div class=\"p-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-message-video widget__icon\"></i><div class=\"widget__title\" \ntranslate=\"TEACHER_DASHBOARD.PREVIOUS\"></div></div><div><div \nng-include=\"\'app/main/states/loading-lesson-requests.html\'\"></div></div></ms-widget-front></ms-widget></div><div \nlayout=\"column\" flex=\"65\" flex-xs=\"100\"><ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-calendar-check widget__icon\"></i><div class=\"widget__title\" translate=\"TEACHER_DASHBOARD.WEEKLY_SCHEDULE\" \nng-if=\"!vm.isAvailability\"></div><md-switch ng-model=\"vm.switchTitle\" ng-true-value=\"\'Specific Weekly Schedule\'\" \nng-false-value=\"\'Default Weekly Schedule\'\" name=\"switchAvailability\" aria-label=\"Switch Availability\" \nng-if=\"vm.isAvailability\" ng-change=\"vm.toggleSpecific()\" class=\"widget__title\">{{ vm.switchTitle }}</md-switch>\n<md-button class=\"md-raised md-primary btn-action calendar__titleButton\" ng-show=\"!vm.isAvailability\" \nname=\"availability\" ng-click=\"vm.toggleAvailability($event)\" translate=\"Edit Availabilities\"></md-button><md-button \nclass=\"md-raised md-primary btn-action calendar__titleButton\" ng-show=\"vm.isAvailability\" name=\"done\" \nng-click=\"vm.toggleAvailability($event)\" translate=\"Done\"></md-button></div><div \nng-include=\"\'app/main/pages/teacher-dashboard/calendar/calendar.html\'\" ng-if=\"!vm.isAvailability\"></div><div \nng-include=\"\'app/main/pages/teacher-dashboard/calendar/regular-calendar.html\'\" \nng-if=\"vm.isAvailability && !vm.isSpecific\"></div><div \nng-include=\"\'app/main/pages/teacher-dashboard/calendar/specific-calendar.html\'\" \nng-if=\"vm.isAvailability && vm.isSpecific\"></div></ms-widget-front></ms-widget><ms-widget class=\"no-padding mb-20\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-8 border-bottom widget__header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-briefcase-download widget__icon\"></i> <span class=\"widget__title\" \ntranslate=\"My Packages\"></span><md-button class=\"md-raised md-primary btn-action calendar__titleButton\" \nname=\"createPackage\" ng-click=\"vm.createPackage()\" translate=\"Create a Package\"></md-button></div><div \nclass=\"widget__content\"><section class=\"teacher-content__reviews\"><div \nng-include=\"\'app/main/states/loading-lesson-requests.html\'\"></div></section></div></ms-widget-front></ms-widget>\n<ms-widget class=\"no-padding\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 border-bottom widget__header\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-comment-multipe-outline widget__icon\"></i> <span \nclass=\"widget__title\" translate=\"TEACHER_DASHBOARD.RECENT_REVIEW\"></span></div><div class=\"widget__content\"><section \nclass=\"teacher-content__reviews\"><div ng-include=\"\'app/main/states/loading-lesson-requests.html\'\"></div></section>\n</div></ms-widget-front></ms-widget></div></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\">\n</div></div>");
$templateCache.put("app/main/pages/teacher-list/teacher-list.html","<div id=\"teacher-list\" class=\"page-layout simple\"><div class=\"header md-accent-bg\"><div class=\"content-container\" \nng-if=\"!vm.is_conversation_partner\" layout=\"row\" layout-align=\"center center\" layout-align-gt-sm=\"start center\"><span \nclass=\"intro-message\">Identify the learning experience that meets your needs</span></div><div \nclass=\"content-container\" ng-if=\"vm.is_conversation_partner\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\" translate=\"TEACHER_LIST.TITLE_PARTNER\">Practice a language with a native speaker.</span> <span \nng-click=\"vm.goToTeachers()\" class=\"switch\" layout=\"row\" layout-align=\"center center\"><text>Browse teachers</text>\n<md-icon md-font-icon=\"icon-arrow-right\" class=\"arrow\"></md-icon></span></div></div><div \nclass=\"content-container pt-40 pb-40\"><div class=\"widget-group\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"space-between start\" layout-align=\"space-between start\"><div class=\"column\" flex-gt-sm=\"33\" \nflex=\"100\"><ms-widget class=\"no-padding mb-20\"><ms-widget-front class=\"white-bg\"><div><div class=\"widget__content\" \nlayout=\"column\" layout-align=\"center start\"><section><p class=\"filter__title\" ng-if=\"!vm.is_conversation_partner\">\nWhich subject would you like to learn?</p><p class=\"filter__title\" ng-if=\"vm.is_conversation_partner\" \ntranslate=\"TEACHER_LIST.LIKE_TO_PRACTICE\">Which language would you like to practice?</p><md-select \nclass=\"filter__select\" ng-change=\"vm.refreshTeacherList()\" ng-model=\"vm.learn\" placeholder=\"All\"><md-option \nng-repeat=\"subject in vm.subjects\" ng-value=\"subject.id\">{{ subject.name }}</md-option></md-select></section><section \nng-if=\"!vm.is_conversation_partner\"></section></div></div></ms-widget-front></ms-widget></div><div flex-gt-sm=\"65\" \nflex=\"100\" ng-if=\"!vm.isLoading\"><section class=\"teacher-container\"><div class=\"ms-card teacher\" layout=\"row\" \nlayout-xs=\"column\" layout-align-xs=\"center center\" \nng-repeat=\"teacher in vm.teacherList | filter:search | limitTo : vm.pagination.itemsPerPage : vm.pagination.begin\" \nui-sref=\"app.pages_teacher({ id: teacher.id })\"><div flex=\"15\" flex-xs=\"30\" class=\"safari-height\"><img \nclass=\"teacher__avatar\" ng-src=\"{{ teacher.avatar }}\" alt=\"{{ teacher.name }}\"></div><div flex=\"85\" flex-xs=\"70\" \nclass=\"safari-height\"><div layout=\"row\" layout-xs=\"column\" layout-align=\"none center\" class=\"safari-height\"><h4 \nclass=\"teacher__name\" flex=\"noshrink\">{{ teacher.name }}</h4><div class=\"rating_price safari-height\" layout=\"row\" \nflex=\"grow\" layout-align=\"space-between center\"><div uib-rating class=\"teacher__rating\" ng-model=\"teacher.rate\" \nmax=\"5\" read-only=\"true\" aria-labelledby=\"default-rating\"></div><h5 class=\"teacher__priceRange\"><text \ntranslate=\"TEACHER_LIST.PRICE\"></text>${{ teacher.defaultPrice||20 }}<text translate=\"TEACHER_LIST.PER_HOUR\"></text>\n</h5></div></div><p class=\"teacher__bio\">{{ teacher.bio }}</p></div></div><div ng-if=\"!vm.is_conversation_partner\" \nclass=\"ms-card\" ng-show=\"vm.teacherList.length === 0\"><p class=\"message-no-teacher\">Fill out <a \nhref=\"https://goo.gl/forms/menPHa8tsr388Cpq1\" target=\"_blank\">this form</a>\n or type in the chat box below so we can find a tutor for you!</p></div><div ng-if=\"vm.is_conversation_partner\" \nclass=\"ms-card\" ng-show=\"vm.teacherList.length === 0\"><p class=\"message-no-teacher\">Fill out <a href=\"\" \nng-click=\"vm.goToFindATutor()\">this form</a>\n or type in the chat box below so we can connect you with our conversation coaches of this language!</p></div>\n</section><ul uib-pagination class=\"pagination-sm teacher__pager\" total-items=\"vm.pagination.totalItems\" \nng-model=\"vm.pagination.currentPage\" max-size=\"vm.pagination.maxSize\" items-per-page=\"vm.pagination.itemsPerPage\" \nrotate=\"false\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" ng-change=\"vm.refreshTeacherList()\" \nng-hide=\"vm.teacherList.length === 0\"></ul></div><div flex-gt-sm=\"65\" flex=\"100\" ng-if=\"vm.isLoading\"><section \nclass=\"teacher-container\"><div ng-include=\"\'app/main/states/loading-teacher-list.html\'\"></div></section></div></div>\n</div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/tzuchi/tzuchi.html","<div id=\"tzuchi\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"center center\">\n<div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span class=\"intro-message\">\n跟在美國的慈少一起學英文!</span></div></div><div class=\"content-container pt-20 pb-40\"><md-content class=\"md-padding\"><img \nclass=\"md-card-image\" src=\"assets/images/landing-page/tzuchi.jpg\"><br><br><section class=\"pt-10 pb-10\"><p>\nNesuku是一個交流學習的網路平台，提供需要課業輔導的學生與家教學習的機會。免費的課程: 因為新冠狀病毒，在居家隔離的這段期間，Nesuku 創造一個單獨的頁面，讓生活在台灣偏遠地區，礙於有限資源，但是有心想要學習英文的學子，可以登錄Zoom會議，和以英文為母語的美國慈少一對一交流學習的機會。課程安排、次數、和時間彈性，取決於慈少和學生的個別情況。請填寫下面的表格。\n</p><br><br></section><section layout=\"column\" layout-align=\"center center\" layout-wrap><form name=\"HWRequestForm\" \nflex=\"50\" flex-xs=\"100\" novalidate><section class=\"section\"><i class=\"icon-account-circle section__icon\"></i><h3 \nclass=\"section__title\">聯繫信息</h3></section><md-input-container md-no-float flex=\"50\" flex-xs=\"100\"><md-select \nng-model=\"vm.form.grade\" class=\"\" placeholder=\"年齡\" aria-label=\"Choose a grade\" md-no-float=\"true\" required><md-option \nng-repeat=\"grade in vm.grades\" ng-value=\"grade\">{{ grade }}</md-option></md-select></md-input-container>\n<md-input-container md-no-float class=\"md-block\" flex=\"100\"><input name=\"username\" ng-model=\"vm.form.username\" \nplaceholder=\"姓名\" required><div ng-messages=\"HWRequestForm.username.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>請輸入姓名</span></div></div></md-input-container><md-input-container md-no-float class=\"md-block\" flex=\"100\"><input \ntype=\"email\" name=\"email\" placeholder=\"電子郵件\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"HWRequestForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>請輸入郵箱地址\n</span></div><div ng-message=\"pattern\"><span>請輸入正確的郵箱地址</span></div></div></md-input-container><div layout=\"row\" \nlayout-align=\"center center\"><md-button type=\"submit\" class=\"md-raised md-primary submit-button\" aria-label=\"Sign Up\" \nng-disabled=\"HWRequestForm.$invalid || HWRequestForm.$pristine\" ng-click=\"vm.submit()\">提交</md-button></div></form>\n</section></md-content></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/view-essay/view-essay.html","<div id=\"view-essay\" class=\"page-layout simple\"><div class=\"header md-accent-bg mb-30\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">View Essay</span></div></div><div ng-if=\"vm.isLoading\" ng-repeat=\"_ in [] | range: 3\" \nclass=\"content-container pt-10 pb-20\"><md-content class=\"md-padding\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"empty-text full-width loading__name shining-effect\"></div></div></md-content>\n</div><div ng-repeat=\"doc in vm.docs\" class=\"content-container pt-10 pb-20\"><md-content class=\"md-padding\"><div \nclass=\"content\" layout=\"column\" layout-align=\"center center\"><div class=\"full-width\" layout=\"column\" \nlayout-align=\"start start\"><md-input-container ng-if=\"doc.essayText\" class=\"md-block full-width essay-text mt-30\">\n<label>{{doc.essayTitle}}</label><textarea class=\"full-width\" rows=\"10\" md-select-on-focus>{{doc.essayText}}</textarea>\n</md-input-container><div class=\"full-width\" ng-if=\"doc.awsKey\" align=\"\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title-name\">{{doc.essayTitle}}</span><md-button \nhref=\"{{vm.keyToLink(doc.awsKey,\'student\')}}\">Download<md-icon class=\"icon-download\"></md-icon></md-button></div><div \nclass=\"full-width\" ng-if=\"doc.reviewAwsKey\" align=\"\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title-name\">Review File</span><md-button href=\"{{vm.keyToLink(doc.reviewAwsKey,\'teacher\')}}\">Download<md-icon \nclass=\"icon-download\"></md-icon></md-button></div><md-input-container \nng-if=\"$root.userRole == \'teacher\' && vm.essayRequestInfo.status == \'1\'\" md-no-float=\"\" \nclass=\"md-block full-width essay-text mt-30\"><label>Upload Review File</label><input placeholder=\"Non-Floating Label\" \nclass=\"file\" type=\"file\" name=\"file\" file=\"vm.files[$index]\"></md-input-container></div></div></md-content></div><div \nclass=\"pb-10\" layout=\"row\" layout-align=\"center center\"><md-button ng-if=\"$root.userRole == \'teacher\'\" \nclass=\"md-raised md-primary btn-begin-session\" ng-click=\"vm.upload()\">Submit {{$rootScope.userRole}}</md-button>\n<md-button ng-if=\"$root.userRole == \'student\'\" class=\"md-raised md-primary btn-begin-session\" \nng-click=\"vm.goToDashboard()\">Done</md-button></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\">\n</div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE\n</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><a href=\"\" ng-click=\"vm.goToHomepage()\"><img class=\"toolbar-logo toolbar-logo--black\" \nsrc=\"assets/images/logos/logo-horizontal.png\" alt=\"Nesuku logo\"> <img class=\"toolbar-logo toolbar-logo--white\" \nsrc=\"assets/images/landing-page/img-logo-navibar@3x.png\" alt=\"Nesuku logo\"></a></div><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><span \nclass=\"toolbar-button-container\" ng-if=\"!$root.useGuestMenu && $root.isAuthenticated\"><div class=\"nav-bar\" \nlayout=\"row\" layout-align=\"start end\"><md-button layout=\"column\" layout-align=\"center center\" \nng-if=\"$root.userRole == \'admin\'\" class=\"toolbar-text-button\" ng-click=\"vm.goToAdminDashboard()\">Admin Dashboard\n</md-button><md-button layout=\"column\" layout-align=\"center center\" ng-if=\"$root.userRole == \'admin\'\" \nclass=\"toolbar-text-button\" ng-click=\"vm.registerTeacher()\">Register Teacher</md-button><md-button layout=\"column\" \nlayout-align=\"center center\" ng-if=\"$root.userRole == \'admin\'\" class=\"toolbar-text-button\" \nng-click=\"vm.goToAppDashboard()\">App Dashboard</md-button><md-button layout=\"column\" layout-align=\"center center\" \nclass=\"toolbar-text-button\" ng-if=\"$root.userRole === \'teacher\' && $root.canSwitch == false\" \ntranslate=\"TOOLBAR.DASHBOARD\" ng-click=\"vm.goToTeacherDashboard()\">Teacher Dashboard <span \nclass=\"notification-reminder\" ng-if=\"$root.notifications.dashboard\"></span></md-button><md-button layout=\"column\" \nlayout-align=\"center center\" class=\"toolbar-text-button\" \nng-if=\"$root.userRole === \'student\' && $root.canSwitch == false\" translate=\"TOOLBAR.DASHBOARD\" \nng-click=\"vm.goToStudentDashboard()\">Student Dashboard <span class=\"notification-reminder\" \nng-if=\"$root.notifications.dashboard\"></span></md-button><md-menu md-offset=\"-15 85\" \nmd-position-mode=\"target-right target\" ng-if=\"$root.canSwitch == true\"><md-button class=\"toolbar-text-button\" \nng-click=\"$mdOpenMenu()\">Dashboard</md-button><md-menu-content><md-button layout=\"column\" layout-align=\"center center\" \nclass=\"toolbar-text-button\" ng-click=\"vm.goToStudentDashboard()\">Student</md-button><md-button layout=\"column\" \nng-if=\"$root.isConversationPartner == false\" layout-align=\"center center\" class=\"toolbar-text-button\" \nng-click=\"vm.goToTeacherDashboard()\">Teacher</md-button><md-button layout=\"column\" \nng-if=\"$root.isConversationPartner == true\" layout-align=\"center center\" class=\"toolbar-text-button\" \nng-click=\"vm.goToTeacherDashboard()\">Conversation Coach</md-button></md-menu-content></md-menu><md-menu \nmd-offset=\"-15 85\" md-position-mode=\"target-right target\" ng-if=\"$root.userRole !== \'admin\'\"><md-button \nclass=\"toolbar-text-button\" ng-click=\"$mdOpenMenu()\">Browse</md-button><md-menu-content><md-button layout=\"column\" \nlayout-align=\"center center\" class=\"toolbar-text-button\" ng-if=\"$root.userRole !== \'admin\'\" \nng-click=\"vm.goToTeacherList()\">Teachers</md-button><md-button layout=\"column\" layout-align=\"center center\" \nclass=\"toolbar-text-button\" ng-if=\"$root.userRole !== \'admin\'\" ng-click=\"vm.goToConversation()\">Conversation Coaches\n</md-button></md-menu-content></md-menu><md-button layout=\"column\" layout-align=\"center center\" \nclass=\"toolbar-text-button\" ng-if=\"$root.userRole !== \'admin\'\" translate=\"TOOLBAR.MESSAGES\" \nng-click=\"vm.goToMessage()\">Messages <span class=\"notification-reminder\" ng-if=\"$root.notifications.message\"></span>\n</md-button><md-button layout=\"column\" layout-align=\"center center\" class=\"toolbar-text-button\" \nng-if=\"$root.userRole === \'teacher\'\" translate=\"TOOLBAR.HELP_CENTER\" ng-click=\"vm.goToTeacherHelp()\">Help</md-button>\n<md-button layout=\"column\" layout-align=\"center center\" class=\"toolbar-text-button\" \nng-if=\"$root.userRole === \'student\'\" translate=\"TOOLBAR.HELP_CENTER\" ng-click=\"vm.goToStudentHelp()\">Help</md-button>\n<md-button layout=\"column\" layout-align=\"center center\" class=\"toolbar-text-button\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"TOOLBAR.LOG_OUT\" ng-click=\"vm.logOut()\">Log out</md-button></div><md-button id=\"quick-panel-toggle\" \nclass=\"md-icon-button toolbar-text-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" \nclass=\"icon\"></md-icon></md-button></span><span class=\"toolbar-button-container\" \nng-if=\"$root.useGuestMenu || !$root.isAuthenticated\" layout=\"row\" layout-align=\"center center\"><div class=\"nav-bar\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"toolbar-text-button\" ng-click=\"vm.goToTeacherList()\">\nFIND A TUTOR</md-button><md-button class=\"toolbar-text-button\" ng-click=\"vm.beComeATeacher()\">TEACH</md-button>\n<md-button class=\"toolbar-text-button\" ng-click=\"vm.logIn()\" translate=\"LANDING.LOGIN\">LOG IN</md-button><md-button \nid=\"btn-signup\" class=\"md-raised md-primary\" ng-click=\"vm.goToSignUp()\" translate=\"LANDING.SIGN_UP\">SIGN UP</md-button>\n</div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button toolbar-text-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></span></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso language-text\" \ntranslate=\"{{vm.selectedLanguage.short}}\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content \nwidth=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\">\n<span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso language-text\" \ntranslate=\"{{vm.selectedLanguage.short}}\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content \nwidth=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\">\n<span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso language-text\" \ntranslate=\"{{vm.selectedLanguage.short}}\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content \nwidth=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\">\n<span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso language-text\" translate=\"{{vm.selectedLanguage.short}}\">{{vm.selectedLanguage.code}}</span></div>\n</md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nng-include=\"\'app/common/templates/auth-nav/auth-nav.html\'\"></div><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\" translate=\"FORGOTPASSWORD.TITLE\" ng-if=\"!vm.isSentResetLink\"></div><p class=\"description\" \nng-if=\"!vm.isSentResetLink\" translate=\"FORGOTPASSWORD.RST\">We’ll send you an email to reset your password.</p><form \nname=\"forgotPasswordForm\" novalidate ng-if=\"!vm.isSentResetLink\"><md-input-container class=\"md-block\" md-no-float>\n<input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"{{ \'FORGOTPASSWORD.EMAIL_ADDRESS\' | translate }}\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div><span \nclass=\"form-error-message\" ng-show=\"vm.isError\">{{ vm.errorMessage }}</span></md-input-container><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"login\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div><md-button type=\"submit\" class=\"md-primary submit-button\" \naria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" \ntranslate=\"FORGOTPASSWORD.SUMBIT\" translate-attr-aria-label=\"FORGOTPASSWORD.SUBMIT\" ng-click=\"vm.sendResetLink()\">\nSUMBIT</md-button></div></form><div ng-if=\"vm.isSentResetLink\"><h2 class=\"title\" translate=\"FORGOTPASSWORD.DONE\">\nWe’ve got you covered!</h2><img class=\"image\" src=\"assets/images/img/reset-password.png\" alt=\"Email successfully sent\">\n<p class=\"description\" translate=\"FORGOTPASSWORD.CHECKEMAIL\">\nCheck your email - we’ve sent you a message for you to reset your password</p><div class=\"mt-8 mb-8\" layout=\"row\" \nlayout-align=\"end center\"><md-button ui-sref=\"app.pages_auth_login\" class=\"md-primary\">GOT IT</md-button></div></div>\n</div></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"page-layout simple overview\"><div class=\"login-main\"><div \nng-include=\"\'app/common/templates/auth-nav/auth-nav.html\'\"></div><div id=\"login-form-wrapper\" layout=\"row\" \nlayout-align=\"center center\" layout-xs=\"column\" class=\"safari-height\"><div flex=\"50\" id=\"login-form\" \nclass=\"md-whiteframe-8dp safari-height\"><form name=\"loginForm\" layout=\"column\" layout-align=\"center stretch\" \nnovalidate><md-input-container class=\"md-block\"><label class=\"input__label\" translate=\"LOGIN.EMAIL\">Email</label><input\n type=\"email\" name=\"email\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label class=\"input__label\" translate=\"LOGIN.PASSWORD\">Password</label><input \ntype=\"password\" name=\"password\" ng-model=\"vm.form.password\" required><div ng-messages=\"loginForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required\n</span></div></div><div id=\"invalidLogin\" ng-if=\"vm.invalidLogin\"><span class=\"error-message\" \ntranslate=\"LOGIN.ERRORS.INVALID_LOGIN\"></span></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-primary submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\" ng-click=\"vm.logIn()\">LOG IN</md-button><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><a \nui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">\nForgot Password?</a></div></form><div class=\"register\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">Don\'t have an account?\n</span> <a class=\"link\" ui-sref=\"app.pages_auth_register\" translate=\"LOGIN.CREATE_ACCOUNT\">Create an account</a></div>\n</div><h2 flex=\"40\" flex-xs=\"50\" flex-offset=\"10\" class=\"welcome-message safari-height\" translate=\"LOGIN.WELCOME\">\nWelcome back!</h2></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\" class=\"page-layout simple overview\"><div class=\"register-main\"><div \nng-include=\"\'app/common/templates/auth-nav/auth-nav.html\'\"></div><div id=\"register-form-wrapper\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center center\" class=\"safari-height\"><div flex=\"40\" id=\"register-form\" \nclass=\"md-whiteframe-8dp safari-height\"><form name=\"registerForm\" layout=\"column\" layout-align=\"center stretch\" \nnovalidate><md-input-container class=\"md-block\"><label class=\"input__label\" translate=\"REGISTER.NAME\">Name</label>\n<input name=\"username\" ng-model=\"vm.form.username\" required><div ng-messages=\"registerForm.username.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Name field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><label class=\"input__label\" \ntranslate=\"REGISTER.EMAIL\">Email</label><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div><div class=\"error-message\" ng-show=\"vm.emailHasRegister\" translate=\"REGISTER.ERRORS.EMAIL_REGISTERED\"><span>\nEmail has been registered</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \nclass=\"input__label\" translate=\"REGISTER.PASSWORD\">Password</label><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" minlength=\"6\" maxlength=\"255\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required\n</span></div><div ng-message=\"minlength\"><span translate=\"REGISTER.ERRORS.PASSWORD_MINLENGTH\">\nThe password must be more than 6 characters long.</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_MAXLENGTH\">The password must be less than 255 characters long.</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label class=\"input__label\" \ntranslate=\"REGISTER.PASSWORD_CONFIRM\">Confirm Password</label><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" minlength=\"6\" maxlength=\"255\" password-confirmation=\"{{ vm.form.password }}\" \nrequired><div ng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Confirm password field is required</span></div><div \nng-message=\"minlength\"><span translate=\"REGISTER.ERRORS.PASSWORD_MINLENGTH\">\nThe Confirm password field must be more than 6 characters long.</span></div><div ng-message=\"maxlength\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_MAXLENGTH\">The Confirm password field must be less than 255 characters long.</span>\n</div><span class=\"md-input-message-animation\" \nng-show=\"registerForm.passwordConfirm.$error.passwordConfirmation && !registerForm.passwordConfirm.$error.required\" \ntranslate=\"REGISTER.ERRORS.PASSWORD_MISMATCH\">Confirm Password does not match</span></div></md-input-container><div \nclass=\"terms\" layout=\"row\" layout-align=\"start center\"><md-checkbox name=\"terms\" \nng-model=\"vm.form.acceptTermsAndConditions\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" \nlayout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">I have read and I accept the\n</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\" ng-click=\"vm.openDialog()\">\nterms and conditions</a></div></div><md-button type=\"submit\" class=\"md-raised md-primary submit-button\" \naria-label=\"Sign Up\" ng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\" ng-click=\"vm.signup()\"></md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"REGISTER.LOGIN\">Log in</a>\n</div></div><h2 flex=\"40\" flex-xs=\"50\" flex-offset=\"10\" class=\"welcome-message safari-height\">\nBegin your learning journey.</h2></div></div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"title\" translate=\"RESET_PASSWORD.TITLE\">Reset your password</div><form name=\"resetPasswordForm\" novalidate>\n<md-input-container class=\"md-block\"><label class=\"input__label\" translate=\"RESET_PASSWORD.EMAIL\">Email</label><input \ntype=\"email\" name=\"email\" ng-model=\"vm.form.email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESET_PASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESET_PASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div><span \nclass=\"form-error-message\" ng-show=\"vm.isError\">{{ vm.errorMessage }}</span></md-input-container><md-input-container \nclass=\"md-block\"><label class=\"input__label\" translate=\"RESET_PASSWORD.PASSWORD\">Password</label><input \ntype=\"password\" name=\"password\" ng-model=\"vm.form.password\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"RESET_PASSWORD.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\"><label \nclass=\"input__label\" translate=\"RESET_PASSWORD.PASSWORD_CONFIRM\">Confirm Password</label><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESET_PASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-primary submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" translate=\"RESET_PASSWORD.SUBMIT\" \ntranslate-attr-aria-label=\"RESETPASSWORD.SUBMIT\" ng-click=\"vm.resetPassword()\">SUMBIT</md-button></form></div></div>\n</div><div ng-include=\"\'app/common/templates/footer/footer.html\'\"></div>");
$templateCache.put("app/main/pages/edit-teacher/calendar/calendar.html","<div id=\"edit-teacher-calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"calender-header\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow btn-switch-calendar\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"TEACHER_DASHBOARD.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><h3 class=\"current-time-period\">{{ vm.calendarView.title }}</h3>\n<md-button class=\"md-icon-button arrow btn-switch-calendar\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"TEACHER_DASHBOARD.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div><h4 class=\"timezone\">GMT {{ vm.timezone }}</h4><h5 class=\"timezone-hint-text\" \ntranslate=\"EDIT_TEACHER.CALENDAR.TIMEZONE\">All times are in your local timezone.</h5><ul class=\"calendar-btn\"><li>\n<md-button class=\"md-raised md-primary btn-action\" ng-show=\"!vm.isExpand\" name=\"expand\" \nng-click=\"vm.showOrHideAllTime($event)\" translate=\"TEACHER_DASHBOARD.EXPAND\"></md-button><md-button \nclass=\"md-raised md-primary btn-action\" ng-show=\"vm.isExpand\" name=\"collapse\" ng-click=\"vm.showOrHideAllTime($event)\" \ntranslate=\"TEACHER_DASHBOARD.COLLAPSE\"></md-button></li><li><md-button class=\"md-raised md-primary btn-action\" \nng-show=\"vm.isAgendaDay\" name=\"weekly\" ng-click=\"vm.DayOrWeekly($event)\" translate=\"TEACHER.WEEKLY\"></md-button>\n<md-button class=\"md-raised md-primary btn-action\" ng-show=\"!vm.isAgendaDay\" name=\"day\" \nng-click=\"vm.DayOrWeekly($event)\" translate=\"TEACHER.DAY\"></md-button></li></ul></div></div><div class=\"content\"><div \nid=\"calendarView\" ui-calendar=\"vm.calendarUiConfig\" ng-model=\"vm.availableHours\" calendar=\"mainCalendar\"></div></div>\n</div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div \nclass=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate \ntranslate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><a class=\"back-link md-accent-color\" href=\"/\" \ntranslate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/pages/student-dashboard/account-settings/account-settings.html","<div id=\"account-settings\" class=\"page-layout simple\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"content-container\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"intro-message\">Account Settings</span></div></div><div class=\"content-container pt-40 pb-40\" layout=\"row\" \nlayout-align=\"space-between start\" layout-wrap><div flex=\"33\" flex-xs=\"100\" class=\"safari-height\" layout=\"row\"><div \nlayout=\"column\" layout-align=\"center center\" class=\"pt-10 safari-height\"><img class=\"header__avatar\" \nng-src=\"{{ vm.teacherInfo.avatar ? vm.teacherInfo.avatar : \'assets/images/avatars/profile.jpg\' }}\" \nalt=\"Teacher\'s Avatar\"> <span class=\"section__title pt-5\">{{ vm.user.name }}</span></div></div><div flex=\"33\" \nflex-xs=\"100\"><section layout=\"column\" layout-wrap><section class=\"section\"><i \nclass=\"icon-account-circle section__icon\"></i><h3 class=\"section__title\" \ntranslate=\"TEACHER_DASHBOARD.EDIT_PROFILE_PICTURE\"></h3></section><div class=\"accountSetting__btn\"><md-button \nclass=\"md-raised md-primary btn-save\" translate=\"TEACHER_DASHBOARD.EDIT_PROFILE_PICTURE\" \nng-click=\"vm.editProfilePic()\"></md-button></div><br><br><section class=\"section\"><i class=\"icon-lock section__icon\">\n</i><h3 class=\"section__title\" translate=\"TEACHER_DASHBOARD.CHANGE_PASSWORD\"></h3></section><div \nclass=\"accountSetting__btn\"><md-button class=\"md-raised md-primary btn-save\" \ntranslate=\"TEACHER_DASHBOARD.CHANGE_PASSWORD\" ng-click=\"vm.changePassword()\"></md-button></div><br><br></section></div>\n<div flex=\"33\" flex-xs=\"100\"><ms-widget class=\"loading no-padding mb-20\" ng-if=\"vm.isLoading\"><ms-widget-front \nclass=\"white-bg\"><div class=\"p-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-coin widget__icon\"></i><div class=\"widget__title\">Balance</div></div><div><div \nng-include=\"\'app/main/states/loading-balance.html\'\"></div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"no-padding mb-20\" ng-if=\"!vm.isLoading\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-8 border-bottom widget__header\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-coin widget__icon\">\n</i><div class=\"widget__title\">Balance</div></div><div layout=\"column\" layout-align=\"center start\"><md-list \nlayout-fill><md-list-item layout-fill flex><section layout=\"row\" ng-click=\"vm.openBalance = !vm.openBalance\" \nlayout-align=\"space-between center\" layout-fill flex><i class=\"icon-credit-card balance__icon\"></i><div \nclass=\"balance__title\">My Wallet</div><span class=\"balance__text\">${{ vm.balance }}</span> <i \nclass=\"icon-chevron-right\" ng-class=\"{rotate: vm.openBalance}\"></i></section></md-list-item><md-divider></md-divider>\n<md-list-item ng-if=\"vm.openBalance\"><section ng-click=\"vm.walletDeposit()\" layout=\"row\" layout-fill flex><div \nclass=\"balance__subtitle\">Deposit</div><i class=\"icon-chevron-right balance__subchevron\"></i></section></md-list-item>\n<md-divider ng-if=\"vm.openBalance\"></md-divider><md-list-item><section layout=\"row\" layout-fill flex \nng-click=\"vm.openPackage = !vm.openPackage\"><i class=\"icon-clipboard-text balance__icon\"></i><div \nclass=\"balance__title\">My Packages</div><i class=\"icon-chevron-right balance__chevron\" \nng-class=\"{rotate: vm.openPackage}\"></i></section></md-list-item><div ng-if=\"vm.openPackage\" \nng-repeat=\"packageTeacher in vm.packageTeachers\"><md-divider></md-divider><md-list-item><section layout-fill flex \nlayout=\"row\" ng-click=\"packageTeacher.openTab = !packageTeacher.openTab\"><div class=\"balance__subtitle\">\n{{ packageTeacher.teacherName }}</div><i class=\"icon-chevron-right balance__subchevron\" \nng-class=\"{rotate: packageTeacher.openTab}\"></i></section></md-list-item><div ng-if=\"packageTeacher.openTab\" \nng-repeat=\"package in packageTeacher.packages\"><md-divider></md-divider><md-list-item><section layout-fill flex \nlayout=\"row\"><div class=\"balance__subsubtitle\">{{ package.packageName }}</div><div class=\"balance__subchevron\">\n{{ package.remainingHours }} h</div></section></md-list-item></div></div></md-list></div></ms-widget-front></ms-widget>\n</div></div></div>");
$templateCache.put("app/main/pages/teacher/calendar/calendar.html","<div id=\"teacher-calendar\" class=\"page-layout simple fullwidth ms-card-content-wrapper\" layout=\"column\"><div \nclass=\"calender-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow btn-switch-calendar\" ng-click=\"vm.prev()\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"TEACHER_DASHBOARD.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<h3 class=\"current-time-period\">{{ vm.calendarView.title }}</h3><md-button \nclass=\"md-icon-button arrow btn-switch-calendar\" ng-click=\"vm.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"TEACHER_DASHBOARD.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div><h4 class=\"timezone\">GMT {{ vm.timezone }}</h4><h5 class=\"timezone-hint-text\" translate=\"TEACHER.CALENDAR_HINT\">\nAll times are in your local timezone.</h5><h6 class=\"calendar-instructions\" translate=\"TEACHER.CALENDAR_INSTRUCTIONS\">\nClick and drag a time slot to schedule a lesson</h6><ol class=\"calendar-legend\"><li><span class=\"today\"></span><p \ntranslate=\"TEACHER.CAL_TODAY\">Today</p></li><li><span class=\"available\"></span><p translate=\"TEACHER.CAL_AVAILABLE\">\nAvailable</p></li><li><span class=\"reserved\"></span><p translate=\"TEACHER.CAL_RESERVED\">Reserved</p></li><li><span \nclass=\"pending\"></span><p translate=\"TEACHER.CAL_PENDING\">Pending</p></li></ol><ul class=\"calendar-btn\"><li><md-button \nclass=\"md-raised md-primary btn-action\" ng-show=\"!vm.isExpand\" name=\"expand\" ng-click=\"vm.showOrHideAllTime($event)\" \ntranslate=\"TEACHER.EXPAND\"></md-button><md-button class=\"md-raised md-primary btn-action\" ng-show=\"vm.isExpand\" \nname=\"collapse\" ng-click=\"vm.showOrHideAllTime($event)\" translate=\"TEACHER.COLLAPSE\"></md-button></li><li><md-button \nclass=\"md-raised md-primary btn-action\" ng-show=\"vm.isAgendaDay\" name=\"weekly\" ng-click=\"vm.DayOrWeekly($event)\" \ntranslate=\"TEACHER.WEEKLY\"></md-button><md-button class=\"md-raised md-primary btn-action\" ng-show=\"!vm.isAgendaDay\" \nname=\"day\" ng-click=\"vm.DayOrWeekly($event)\" translate=\"TEACHER.DAY\"></md-button></li></ul></div></div><div \nclass=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig\" ng-model=\"vm.teacher.schedule\" \ncalendar=\"main\"></div></div></div>");
$templateCache.put("app/main/pages/teacher-dashboard/calendar/calendar.html","<div id=\"teacher-calendar\" class=\"page-layout simple fullwidth ms-card-content-wrapper\" layout=\"column\"><div \nclass=\"calender-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow btn-switch-calendar\" ng-click=\"vm.prev()\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"TEACHER_DASHBOARD.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<h3 class=\"current-time-period\">{{ vm.calendarView.title }}</h3><md-button \nclass=\"md-icon-button arrow btn-switch-calendar\" ng-click=\"vm.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"TEACHER_DASHBOARD.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div><h4 class=\"timezone\">GMT {{ vm.timezone }}</h4><h5 class=\"timezone-hint-text\" \ntranslate=\"TEACHER_DASHBOARD.CALENDAR_HINT\">All times are in your local timezone.</h5><ol class=\"calendar-legend\"><li>\n<span class=\"today\"></span><p translate=\"TEACHER_DASHBOARD.CAL_TODAY\">Today</p></li><li><span class=\"available\"></span>\n<p translate=\"TEACHER_DASHBOARD.CAL_AVAILABLE\">Available</p></li><li><span class=\"reserved\"></span><p \ntranslate=\"TEACHER_DASHBOARD.CAL_RESERVED\">Reserved</p></li><li><span class=\"pending\"></span><p \ntranslate=\"TEACHER_DASHBOARD.CAL_PENDING\">Pending</p></li></ol><ul class=\"calendar-btn\"><li><md-button \nclass=\"md-raised md-primary btn-action\" ng-show=\"!vm.isExpand\" name=\"expand\" ng-click=\"vm.showOrHideAllTime($event)\" \ntranslate=\"TEACHER.EXPAND\"></md-button><md-button class=\"md-raised md-primary btn-action\" ng-show=\"vm.isExpand\" \nname=\"collapse\" ng-click=\"vm.showOrHideAllTime($event)\" translate=\"TEACHER.COLLAPSE\"></md-button></li><li><md-button \nclass=\"md-raised md-primary btn-action\" ng-show=\"vm.isAgendaDay\" name=\"weekly\" ng-click=\"vm.DayOrWeekly($event)\" \ntranslate=\"TEACHER.WEEKLY\"></md-button><md-button class=\"md-raised md-primary btn-action\" ng-show=\"!vm.isAgendaDay\" \nname=\"day\" ng-click=\"vm.DayOrWeekly($event)\" translate=\"TEACHER.DAY\"></md-button></li></ul></div></div><div \nclass=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig\" ng-model=\"vm.schedule\" calendar=\"main\"></div>\n</div></div>");
$templateCache.put("app/main/pages/teacher-dashboard/calendar/regular-calendar.html","<div id=\"teacher-calendar\" class=\"page-layout simple fullwidth ms-card-content-wrapper\" layout=\"column\"><div \nclass=\"calender-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><h3 class=\"current-time-period\">\n{{ vm.calendarView.title }}</h3></div><h4 class=\"timezone\">GMT {{ vm.timezone }}</h4><h5 class=\"timezone-hint-text\" \ntranslate=\"EDIT_TEACHER.CALENDAR.TIMEZONE\">All times are in your local timezone.</h5><ol class=\"calendar-legend\"><li>\n<span class=\"today\"></span><p translate=\"TEACHER_DASHBOARD.CAL_TODAY\">Today</p></li><li><span class=\"default\"></span><p\n translate=\"TEACHER_DASHBOARD.CAL_DEFAULT\">Default</p></li></ol><ul class=\"calendar-btn\"><li><md-button \nclass=\"md-raised md-primary btn-action\" ng-show=\"!vm.isExpand\" name=\"expand\" ng-click=\"vm.showOrHideAllTime($event)\" \ntranslate=\"TEACHER_DASHBOARD.EXPAND\"></md-button><md-button class=\"md-raised md-primary btn-action\" \nng-show=\"vm.isExpand\" name=\"collapse\" ng-click=\"vm.showOrHideAllTime($event)\" translate=\"TEACHER_DASHBOARD.COLLAPSE\">\n</md-button></li><li><md-button class=\"md-raised md-primary btn-action\" ng-show=\"vm.isAgendaDay\" name=\"weekly\" \nng-click=\"vm.DayOrWeekly($event)\" translate=\"TEACHER.WEEKLY\"></md-button><md-button \nclass=\"md-raised md-primary btn-action\" ng-show=\"!vm.isAgendaDay\" name=\"day\" ng-click=\"vm.DayOrWeekly($event)\" \ntranslate=\"TEACHER.DAY\"></md-button></li></ul></div></div><div class=\"content\"><div id=\"calendarView\" \nui-calendar=\"vm.regularCalendarUiConfig\" ng-model=\"vm.regularSchedule\" calendar=\"mainCalendar\"></div></div></div>");
$templateCache.put("app/main/pages/teacher-dashboard/calendar/specific-calendar.html","<div id=\"teacher-calendar\" class=\"page-layout simple fullwidth ms-card-content-wrapper\" layout=\"column\"><div \nclass=\"calender-header\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow btn-switch-calendar\" ng-click=\"vm.prevSpecific()\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"TEACHER_DASHBOARD.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<h3 class=\"current-time-period\">{{ vm.calendarView.title }}</h3><md-button \nclass=\"md-icon-button arrow btn-switch-calendar\" ng-click=\"vm.nextSpecific()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"TEACHER_DASHBOARD.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</div><h4 class=\"timezone\">GMT {{ vm.timezone }}</h4><h5 class=\"timezone-hint-text\" \ntranslate=\"EDIT_TEACHER.CALENDAR.TIMEZONE\">All times are in your local timezone.</h5><ol class=\"calendar-legend\"><li>\n<span class=\"today\"></span><p translate=\"TEACHER_DASHBOARD.CAL_TODAY\">Today</p></li><li><span class=\"available\"></span>\n<p translate=\"TEACHER_DASHBOARD.CAL_DEFAULT\">Default</p></li><li><span class=\"specific\"></span><p \ntranslate=\"TEACHER_DASHBOARD.CAL_SPECIFIC\">Specific</p></li></ol><ul class=\"calendar-btn\"><li><md-button \nclass=\"md-raised md-primary btn-action\" ng-show=\"!vm.isExpand\" name=\"expand\" ng-click=\"vm.showOrHideAllTime($event)\" \ntranslate=\"TEACHER_DASHBOARD.EXPAND\"></md-button><md-button class=\"md-raised md-primary btn-action\" \nng-show=\"vm.isExpand\" name=\"collapse\" ng-click=\"vm.showOrHideAllTime($event)\" translate=\"TEACHER_DASHBOARD.COLLAPSE\">\n</md-button></li><li><md-button class=\"md-raised md-primary btn-action\" ng-show=\"vm.isAgendaDay\" name=\"weekly\" \nng-click=\"vm.DayOrWeekly($event)\" translate=\"TEACHER.WEEKLY\"></md-button><md-button \nclass=\"md-raised md-primary btn-action\" ng-show=\"!vm.isAgendaDay\" name=\"day\" ng-click=\"vm.DayOrWeekly($event)\" \ntranslate=\"TEACHER.DAY\"></md-button></li></ul></div></div><div class=\"content\"><div id=\"calendarView\" \nui-calendar=\"vm.specificCalendarUiConfig\" ng-model=\"vm.specificSchedule\" calendar=\"mainCalendar\"></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/pages/chat/sidenavs/left/left-sidenav.html","<div ng-show=\"vm.leftSidenavView === \'contacts\'\" class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/pages/chat/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex></div><div \nng-show=\"vm.leftSidenavView ===\'user\'\" class=\"view user-view animate-slide-left\" \nng-include=\"\'app/main/pages/chat/sidenavs/left/views/user/user-view.html\'\" layout=\"column\" flex></div><div \nng-hide=\"vm.leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/pages/chat/sidenavs/left/views/chats/chats-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/pages/chat/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/pages/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/main/pages/teacher/dialogs/message/message-dialog.html","<md-dialog class=\"dialog-message\" class=\"event-detail-dialog\" aria-label=\"Message Teacher\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"TEACHER.MESSAGE_TEACHER\">Message Teacher</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><section class=\"section\"><i class=\"icon-comment-text section__icon\"></i> \n<span class=\"section__title\" translate=\"TEACHER.PLEASE_TYPE\">Please type your message below:</span></section>\n<md-input-container md-no-float class=\"md-block message\"><textarea class=\"message__content\" id=\"message-content\" \nng-model=\"vm.message.content\" md-select-on-focus></textarea></md-input-container><md-button \nclass=\"md-raised md-primary btn-submit\" ng-click=\"vm.sendMessage()\" translate=\"TEACHER.SEND\">Send</md-button>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/teacher-list/sidenavs/main/main-sidenav.html","<div class=\"content\"><md-list><md-list-item><p>What language would you like to learn?</p><div><md-select \nng-model=\"search.language\" placeholder=\"Japanese\" class=\"md-no-underline\"><md-option \nng-repeat=\"language in vm.languageOption\" ng-value=\"language\">{{ language }}</md-option></md-select></div>\n</md-list-item><md-list-item><p>At what level would you say you are at?</p><div><md-select ng-model=\"search.level\" \nplaceholder=\"Beginner\" class=\"md-no-underline\"><md-option ng-repeat=\"level in vm.levelOption\" ng-value=\"level\">\n{{ level }}</md-option></md-select></div></md-list-item><md-list-item><p>\nWhich language do you prefer your teacher to know in addittion to the language you are learning?</p><div><md-select \nng-model=\"search.preferToLearn\" placeholder=\"English\" class=\"md-no-underline\"><md-option \nng-repeat=\"target in vm.languageOption\" ng-value=\"target\">{{ target }}</md-option></md-select></div></md-list-item>\n<md-list-item><p>Here ia the message you will send to the teachers you request. Change the message in <a \nui-sref=\"app.dev-mode\">Dashboard</a>.</p><br><p class=\"message-preview\">I would like to learn Japanese.</p>\n</md-list-item></md-list></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/pages/chat/sidenavs/left/views/chats/chats-view.html","<md-toolbar><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar\" alt=\"{{vm.user.name}}\"> <span class=\"user-name\">{{ vm.user.name }}\n</span></div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"chat-list\"><div \nng-show=\"vm.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length + filteredContact.length }\" \ntranslate=\"CHAT.CHATS\">CHATS</div><md-list-item class=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:{}} | filter: {name: vm.chatSearch}  |  orderBy: \'lastMessage.time\' :true | filter:query as filteredChat\" \nng-click=\"vm.getChat(contact.id, true)\" ng-class=\"{\'unread\':contact.unread}\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"></div><div class=\"md-list-item-text\"><h3 \nclass=\"name\">{{contact.name}}</h3><p class=\"last-message text-truncate\">{{contact.lastMessage.message}}</p></div><div \nlayout=\"column\" layout-align=\"start end\"><div class=\"last-message-time\">{{contact.lastMessage.time | altDate}}</div>\n<div ng-if=\"contact.unread\" class=\"md-warn-bg unread-message-count\">{{contact.unreadNum}}</div></div><md-divider>\n</md-divider></md-list-item></md-list><md-list class=\"contact-list\"><div \nng-show=\"vm.chatSearch && filteredContact.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}\" \ntranslate=\"CHAT.CONTACTS\">CONTACTS</div><md-list-item class=\"contact md-3-line\" ng-show=\"vm.chatSearch\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:null} | filter: {name: vm.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-click=\"vm.getChat(contact.id, true)\"><div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"></div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p \nclass=\"mood\">{{contact.mood}}</p></div><md-divider></md-divider></md-list-item></md-list><div \nng-hide=\"filteredChat.length = 0\" class=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">\nYou will receive messages here.</div></md-content>");
$templateCache.put("app/main/pages/chat/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><h3><span translate=\"CHAT.CONTACTS\">CONTACTS</span></h3></div><div\n class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.contactSearch\" type=\"text\" \nplaceholder=\"Search contact\" translate=\"\" translate-attr-placeholder=\"CHAT.CONTACTS_SEARCH_PLACEHOLDER\"></div></div>\n</div></md-toolbar><md-content flex ms-scroll><md-list class=\"contact-list\"><md-list-item class=\"contact md-3-line\" \nng-repeat=\"contact in vm.contacts  | filter: {name: vm.contactSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-click=\"vm.getChat(contact.id, true)\"><div class=\"fist-letter md-accent-fg\" \nng-if=\"vm.contacts[$index].name.charAt(0) !== vm.contacts[$index-1].name.charAt(0)\">{{contact.name.charAt(0)}}</div>\n<div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"></div><div\n class=\"md-list-item-text\"><h3>{{contact.name}}</h3></div></md-list-item></md-list><div \nng-if=\"filteredContact.length <= 0\" class=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div>\n</md-content>");
$templateCache.put("app/main/pages/chat/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll \nms-padding><md-card><md-card-title>Mood</md-card-title><md-card-content><span class=\"mood\" \neditable-textarea=\"vm.user.mood\" e-rows=\"7\" e-cols=\"40\">{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}\n</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/pages/chat/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"><div class=\"contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex \nms-scroll ms-padding><md-card><md-card-title translate=\"CHAT.MOOD\">Mood</md-card-title><md-card-content><span \nclass=\"mood\" ng-if=\"vm.contacts.getById(vm.chatContactId).mood\">{{vm.contacts.getById(vm.chatContactId).mood}}</span>\n</md-card-content></md-card></md-content>");}]);